webpackJsonp([101],{

/***/ "+BSC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.menu-logo-wrapper[data-v-2320244c] {\n  overflow: hidden;\n}\n.menu-logo-wrapper[data-v-2320244c]::after {\n    background-color: transparent;\n}\n.switch-img[data-v-2320244c] {\n  width: 45px;\n  height: 45px;\n  cursor: pointer;\n}\n.menu-logo[data-v-2320244c] {\n  height: 78px;\n  background: #5272e9;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  border-left: none;\n  color: #fff;\n  overflow: hidden;\n  margin-bottom: 4px;\n  position: relative;\n}\n.menu-logo .unipay-div[data-v-2320244c],\n  .menu-logo .mipay-div[data-v-2320244c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #5272e9;\n    padding-left: 14px;\n}\n.menu-logo .logo-img[data-v-2320244c] {\n    float: left;\n    width: 50px;\n    height: 50px;\n    margin: 14px 6px;\n}\n.menu-logo .logo-shrink-img[data-v-2320244c] {\n    margin-right: 27px;\n    margin-left: 10px;\n}\n.menu-logo .divide-line[data-v-2320244c] {\n    float: left;\n    width: 1px;\n    height: 33px;\n    margin: 22px 7px 22px 0px;\n    background-color: #fff;\n}\n.menu-logo .divide-line[data-v-2320244c]::after {\n      background-color: transparent;\n}\n.menu-logo .logo-system[data-v-2320244c] {\n    float: left;\n    font-size: 36px;\n    color: #fff;\n    line-height: 78px;\n}\n.menu-logo .logo-system[data-v-2320244c]::after {\n      background-color: transparent;\n}\n.hide-el[data-v-2320244c] {\n  display: none;\n}\n.clear-margin[data-v-2320244c] {\n  margin: 0;\n}\n.menu-center[data-v-2320244c] {\n  text-align: center;\n}\n.menu-item-width[data-v-2320244c] {\n  min-width: 100px !important;\n}\n.offset-margin[data-v-2320244c] {\n  margin-left: 60px;\n}\n", ""]);

// exports


/***/ }),

/***/ "/uab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__);


var _hint, _mer, _mec, _inputBox, _newcash, _notify;


/* harmony default export */ __webpack_exports__["a"] = ({
  message: 'System Login',
  welecome: 'welecome',
  layer: {
    toggle: 'Are you sure you want to switch the language version?',
    tips: 'Language switching',
    welcome: 'Welcome！'
  },
  button: {
    humilis: 'Saved successfully',
    search: 'Search',
    Reset: 'Clear',
    New: 'New',
    New1: 'New',
    NewMer: 'New',
    NewAgent: 'New',
    NewDevice: 'New',
    NewSalesman: 'New Staff',
    Modify: 'Modify',
    Cancel: 'Cancel',
    Shops: 'Shops',
    Shops1: 'Shop',
    Shops2: 'Shop List',
    Merchant: 'Merchant',
    Enabled: 'Enabled',
    Enabled1: 'Enable',
    Enabled2: 'enable',
    Suspended: 'Suspended',
    Suspended1: 'disable',
    Suspended2: 'Disable',
    Suspended3: 'Disabled',
    OK: 'OK',
    Approval: 'Approval',
    Approve: 'Approve',
    Approve1: 'approve',
    Reject: 'Reject',
    Reject1: 'reject',
    EnterDetail: 'Enter Detail',
    Return: 'Return',
    RefreshStatus: 'Refresh Status',
    SaveResult: 'Save Result',
    delete: 'Del',
    Resubmit: 'Resubmit',
    Manage: 'Manage',
    Refresh: 'Refresh',
    Close: 'Close',

    view: 'view',

    loading: 'loading',
    sending: 'sending',
    colon: ':',
    save: 'Save',
    saveTime: 'Save Time',
    saveMer: 'Saved Merchant',
    cancelMer: 'cancel Merchant',
    edit: 'Edit'
  },

  search: {
    RefNo: 'System trans. no.',
    RefNo1: 'System Trans. No.',
    SubAccountNo: 'Sub-account no.',

    WechatRMBWallet: 'WeChat Pay',
    WechatMOPWallet: 'WeChat Pay MO',
    WechatHKDWallet: 'WeChat Pay HK',
    WeChatPayCatering: 'WeChat Pay(Catering)',
    AlipayHK: 'Alipay HK',
    Alipay: 'Alipay',
    Conditions: 'No results, please reset the criteria to search',
    SubAccountNo3: 'Alipay HK merchant no.',
    SubAccountNo4: 'Alipay merchant no.',
    ServiceChargeRate2: 'Alipay HK Fee Rate (%)',
    ServiceChargeRate3: 'Alipay Fee Rate (%)',
    channelInfo: 'Channel Information',
    channelInfo1: 'Channel information',
    SubAccountNo2: 'WeChat Pay merchant no.',
    HKSubAccountNo: 'WeChat Pay HK merchant no.',
    WalletType: 'Wallet Type',
    RMBWallet: 'RMB Wallet',
    HKDWallet: 'HKD Wallet',
    RMBOrHKD: 'RMB Wallet sub-account or WeChat Pay HK merchant no.',
    Channel: 'Channel',
    PursePain: 'Unipay',
    wherewithal: 'Allinpay',

    CrossBorderWallet: 'Cross-border Wallet',
    HongKongWallet: 'HK Wallet',
    SweepPay: 'Sweep Pay',
    ScanPay: 'Scan Pay',
    Review: "WeChat Review Status",
    wereNot: "unreviewed",
    associates: "Approved",
    Audit: "In review",
    partnership: "Rejected",

    SweepPay1: 'Sweep Pay',

    SubAccountNo1: 'Sub-account',
    AgentName: 'Agent name',
    MerchantName: 'Merchant name',
    MerchantName1: 'Merchant',
    MerchantName2: 'Merchant Name',
    TransactionCompleted: 'Payment success',
    TransactionCompleted1: 'Successful',
    TransactionCompleted2: 'Payment Success',
    Select: 'Select Channel',
    YES: 'Yes',
    NO: 'No',
    Yes: 'Yes',
    No: ' No',
    refunding: 'Pending',
    remarks: 'User Remark',
    Institutional: 'Institutional model',
    TransactionType: 'Transaction type',
    TransactionType1: 'Transaction Type',
    WeChatPaySweep: 'WeChat Quick Pay',
    WeChatPayScan: 'WeChat QR Code Payment',
    OAPayment: 'OA Payment',
    SelectBeginTime: 'Time',
    SelectBeginTime1: 'Order Time',
    SelectEndTime: '',
    TransactionStatus: 'Settled',
    TransactionStatus1: 'Settled',
    SettledDone: 'Yes',
    NotSettled: 'No',

    AgentName1: 'Agent name',
    AgentName2: 'Agent Name',
    AccountStatus: 'Account status',
    Pending: 'Pending',
    Rejected: 'Rejected',
    EstablishmentDate: 'Establishment Date',

    levelID: 'level ID',
    levelID1: 'Agent ID',
    UpperLevel: 'Upper Level',
    UpperLevel1: 'Upper agent',
    UpperLevel2: 'Upper Level',
    Status: 'Status',
    Status1: 'Account status',
    Status2: 'Account Status',

    websitePayment: 'Website Payment',
    PC2Mobile: 'PC2Mobile',
    WAPPayment: 'WAP Payment',
    APPPayment: 'APP Payment',
    bankCardPayment: 'Bank Card Payment',

    Undeclared: 'Undeclared',
    DeclarationSubmit: 'Submitted',
    Reporting: 'Declaring',
    DeclarationSuccess: 'Success',
    DeclarationFail: 'Failure',
    ApiError: 'Abnormal customs interface'
  },
  placeH: {
    All: 'All',
    Please: 'Please select ',
    Required: '(Required)'
  },
  hint: (_hint = {
    supplement: 'Please submit channel merchant No',
    ThePictureSizeMustNotExceed5M: 'The picture size must not exceed 5M',
    MandatoryFieldsAreNotFilledIn: 'Mandatory fields are not filled in',
    usernameDoesNotExist: 'Username does not exist',
    pwdErr: 'Password incorrect, please re-enter',
    loading: 'Please try again later',
    pleaseRelogin: 'Idle for too long, please re-login',
    BuildFailed: 'Build failed',
    NoData: 'no data',
    Alert: 'Alert',
    Success: 'Success',
    Success1: ' success',
    Fail: 'Fail',
    Fail1: ' fail',
    SureTo: 'Confirm to ',
    SuccessfullyModified: 'Successfully modified',
    FailToEdit: 'Fail to edit',
    ThisAgent: ' this agent?',
    TheAdditonOf: ' the additon of the shop?',
    TheAdditonOf1: "Confirm to approve the merchant's info change?",
    TheAdditonOf3: "Confirm to reject the merchant's info change?",

    TheAdditonOf4: "Confirm to approve the additon of the merchant?",
    TheAdditonOf5: "Confirm to reject the additon of the merchant?",

    TheAdditonOf6: "Confirm to approve the shop's info change?",
    TheAdditonOf7: "Confirm to reject the shop's info change?",
    TheAdditonOf8: "Confirm to approve the additon of the shop?",
    TheAdditonOf9: "Confirm to reject the addition of the shop?",

    TheAdditonOf2: ' the additon of the agent?',
    TheShopInfoChange: " the shop's info change?",
    TheMerchantInfoChange: " the merchant's info change?",
    TheAgentInfoChange: " the agent's info change?",
    Approved: 'Approved',
    Rejected: 'Rejected',
    OperationSuccess: 'Operation Successful',
    OperationFail: 'Operation Failure',
    CreateOK: 'Submit OK',
    CreateFailed: 'Submit failed',
    ChangeOK: 'Change OK',
    ChangeFailed: 'Change failed',

    PleaseEnterName: 'Please enter name',
    PleaseEnterBDStaffNumber: 'Please enter BD staff number',
    PleaseEnterIDNumber: 'Please enter ID number',
    PleaseEnterPhoneNumber: 'Please enter phone number',
    PleaseEnterEmail: 'Please enter email',
    BDStaffNumberIsValid: 'BD staff number is valid',
    BDStaffNumberExistsPleaseReEnter: 'BD staff number exists, please re-enter',
    BDRecordCreated: 'BD record created',
    BDCreateFailed: 'BD create failed',
    LengthIsMax25Characters: 'Length is max. 25 characters',
    LengthIsMax10Characters: 'Length is max. 10 characters',
    LengthIsMax20Characters: 'Length is max. 20 characters',
    LengthIsMax11Characters: 'Length is max. 11 characters',
    LengthIsMax50Characters: 'Length is max. 50 characters',

    SureToChangeInfoOfTheMerchant: 'Confirm to make the changes?',
    SureToAddThisMerchant: 'Confirm to add this merchant?',
    SureToEnableThisMerchant: 'Confirm to enable this merchant?',
    SureToSuspendThisMerchant: 'Confirm to disable this merchant?',
    PhoneNumberAlreadyExists: 'Phone number already exists',
    PhoneNumberAlreadyExists1: 'Phone number already exists',
    OfficePhoneNumberAlreadyExists: 'Office phone number already exists',
    TheMerchantIsDisabled: 'The merchant is disabled',
    TheMerchantIsEnabled: 'The merchant is enabled',

    SureToChangeInfoOfTheShop: 'Confirm to make the changes?',
    SureToSuspendThisShop: 'Confirm to disable this shop?',
    SureToEnableThisShop: 'Confirm to enable this shop?',
    SureToApproveTheShopInfoChange: "Confirm to approve the shop's info change?",
    SureToRejectTheShopInfoChange: "Confirm to reject the shop's info change?",
    SureToApproveTheAdditonOfTheShop: 'Confirm to approve the additon of the shop?',
    SureToRejectTheAdditionOfTheShop: 'Confirm to reject the addition of the shop?',
    SureToAddThisShop: 'Confirm to add this shop?',

    SureToEnableThisAgent: 'Confirm to enable this agent?',
    SureToSuspendThisAgent: 'Confirm to disable this agent?',
    SureToChangeInfoOfTheSalesman: 'Confirm to make the changes?',
    SureToAddThisAgent: 'Confirm to add this agent?',
    SureToChangeInfoOfTheAgent: 'Confirm to make the changes?',
    ApproveChangeOfInformation: "Confirm to approve the agent's info change?",
    ApproveRegistration: 'Confirm to approve the additon of the agent?',
    SureToRejectThisAgentInfoChange: 'Confirm to reject this agent info change?',
    SureToRejectTheAdditionOfThisAgent: 'Confirm to reject the addition of this agent?',
    SubmittedApprovalPending: 'Submitted,approval pending',
    TheAgentIsDisabled: 'The agent is disabled',
    TheAgentIsEnabled: 'The agent is enabled',

    SureToAddThisOrganization: 'Confirm to add this organization?',
    SureToChangeInfoOfTheOrganization: 'Confirm to make the changes?',
    ThisOrganization: 'this organization?',

    MerchantNameAlreadyExists: 'Merchant name already exists',
    AgentNameAlreadyExists: 'Agent name already exists',
    SubaccountAlreadyExists: 'Sub-account already exist',

    accountAlreadyExists: 'RMB wallet sub-account no. already exist',
    HKaccountAlreadyExists: 'HKD wallet sub-account no. already exist'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PhoneNumberAlreadyExists', 'Phone number already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ShopNameAlreadyExists', 'Shop name already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CompanyNameAlreadyExists', 'Company name already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'InstitutionNameAlreadyExists', 'Institution name already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', 'Email already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ContactPersonsEmailAlreadyExists', "Contact person's email already exists"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', 'Email already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailFormatIncorrect', 'Email format incorrect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseEnter', 'Please enter '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInput', 'Please input '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseAddMerchantOrShopPhoto', 'Please add merchant or shop photo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'addImage', 'Upload Image'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToLaunchThisAdvertisement', 'Confirm to launch this advertisement ?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAdvertisementLink', 'URL of advertisement image'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'paymentPage', 'Payment Page'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'aPPHomePage', 'APP Home Page'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToDisableThisMcompany', 'Confirm to disable this company?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToEnableThisMcompany', 'Confirm to enable this company?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToMakeTheChanges', 'Confirm to make the changes?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'TheCompanyIsDisabled', 'The company is disabled'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'TheCompanyIsEnabled', 'The company is enabled'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToAddThisCompany', 'Confirm to add this company?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveChangeOfInformationC', "Confirm to approve the company's info change?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveRegistrationC', 'Confirm to approve the additon of the company?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectThisCompanyInfoChange', 'Confirm to reject this company info change?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectTheAdditionOfThisCompany', 'Confirm to reject the additon of the company?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToWithdraw', 'Confirm to withdraw HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'doubt', '?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'withdrawAmountShouldBeNoLessThan', 'Withdraw amount should be no less than HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAccountNo', 'Please input merchant no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate', 'Please input fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseSelectServiceChargeBearer', 'Please select fee bearer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRateHK', 'Please input WeChat Pay HK fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate2', 'Please input Alipay HK fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate3', 'Please input Alipay fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayAccountAlreadyExists', 'Alipay Sub-account already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayHKAccountAlreadyExists', 'Alipay HK Sub-account already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmthewithdrawalrequestof', 'Confirm the withdrawal request of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'hasbeenpaid', ' has been paid?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PaymentConfirmation', 'Payment Confirmation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CancelConfirmation', 'Cancel Confirmation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmtogiveuptheexport', 'Confirm to give up the export?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayDirectHasAlreadyExist', 'Alipay(Direct Merchant) merchant no. has already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'WeChatPayHKNoHasAlreadyExist', 'WeChat Pay merchant no. already exists'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'feeRateFormatIncorrect', ' fee rate format incorrect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmRefund', 'Confirm refund'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseInputMerchantName', 'Please input merchant name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseSelectPassingRules', 'Please select passing rules'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'notice', 'Notice:Refund on the day of Unionpay order is only supported by full refund'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate4', 'Please input Alipay(Online) fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SubAccountNo5', 'Alipay(Online) merchant no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputRejectReasons', 'Please input reject reasons'), _hint),
  login: {
    User: 'User',
    pwd: 'Password',
    Login: 'Login',
    PasswordShouldBeAtLeast6Characters: 'Password should be at least 6 characters'
  },
  index: {
    UniversalPocketPaymentManagement: 'Universal Pocket Payment Management',
    Welcome: 'Welcome,',
    Number: 'No.',
    Operation: 'Operation',
    UnipockPaymentSystemAdministration: 'Unipock Payment System Administration',
    Location: 'Location',
    Entrance: 'Entrance',
    Logout: 'Log out',
    MiPay: 'MiPay Payment System Administration',
    MerchantOrders: 'Merchant Orders.xls',
    amendmentApprovalPending: 'Amendment approval pending',
    newShopApprovalPending: 'New shop approval pending',
    Salesman: 'Salesman',
    Device: "Device",
    searchResults: 'Search Results',
    approval: 'Approval',
    personnel: 'Personnel',
    fund: 'Fund',
    name: "Name",
    name1: "Name",
    status: 'Account Status',
    MerchantInfoExcel: 'Merchant Info'
  },

  trade: {
    jumped: 'Time Period',
    stock: 'Orders',
    WeChatPay: 'WeChatPay',
    MerchantRef: 'Merchant Ref.',
    MerchantRef1: 'Merchant Orders',
    TransactionNo: 'Transaction Number',
    MerchantRefNo: 'Merchant Ref. No.',
    Agent: 'Agent',
    Time: 'Time',
    PaymentTime: 'Payment Time',
    originated: 'Amount ',
    AmountCNY: 'Amount(CNY)',
    TransactionType: 'Type',
    Payment: 'Payment',
    Refund: 'Refund',
    PaymentMethod: 'Method',
    Device: 'Device',
    DeviceID: 'Device ID',
    Staff: 'Staff',
    OrderNumber: 'Order Number',
    Box: 'Scanner',
    AppPay: 'App payment',
    MiniProgram: 'Mini Program Payment',
    SubordinateMerchant: 'API Payment',
    OriginalTransactionNumber: 'Original Trans. No.',
    MerchantTransactionNumber: 'Merchant Trans. No.',
    LANDIA8: 'LANDI A8',

    agentOrMerchantName: 'Agent/Merchant Name',
    agentOrMerchantID: 'Agent/Merchant ID',

    merchantNumber: 'Merchant ID',
    fee: 'Fee',
    receivableAmount: 'Receivable',
    totalAmount: 'Total Amount',
    totalFee: 'Total Fee',
    totalorder: 'Total Orders',
    totalsuccess: 'Total Success Orders',
    volume: 'Total',
    tabulation: 'Merchant List Added',
    utilization: 'Success Rate',
    blanking: 'Maximum time between successful transactions',
    between: 'Minimum time between successful transactions',
    business: 'Add Statistical Merchant',
    Remarks: 'Remark',
    rejectReasons: 'Reject reasons:',
    transaction: 'Transaction',
    frozenAmount: 'Frozen Amount',

    TransactionNumber: 'Transaction Number',
    Refundable: 'Refundable',
    RefundAmount: 'Refund Amount',
    Amount: 'Amount',
    PleaseEnterRefundAmount: 'Please enter refund amount',
    ExceededMaximum50Refunds: 'Exceeded maximum 50 refunds',
    InsufficientBalanceForThisRefund: 'Insufficient balance for this refund',
    CannotRefundUnfinishedTransaction: 'Cannot refund unfinished transaction',
    ExceededRefundablePeriodOf365Days: 'Exceeded refundable period of 365 days',
    ExceededRefundablePeriodOf540Days: 'Exceeded refundable period of 540 days',
    ExceededRefundablePeriodOf24Hours: 'This WeChat Pay order exceeded refundable period of 24 hours',
    onlyOfflineBankCardRefundIsSupported: 'Only offline bank card refund is supported',
    Maximum: 'Maximum',
    Minimum: 'Minimum',
    export: 'Export',

    Unionpay: 'UnionPay',
    H5Payment: 'H5 Payment',
    HideTestMer: 'Hide testing merchant',

    failureReason: 'Failure reason',
    userRemarks: 'User remark',
    merchantRemark: 'Merchant remark',

    transactionDetails: 'Transaction Details',
    Details: 'Details',
    merInfo: 'Merchant information',
    orderInfo: 'Order information',
    deviceInfo: 'Device information',
    remarksInfo: 'Remarks',
    CustomColumns: 'Custom columns',
    Pay: 'Payment',
    SerialNumber: 'Serial Number',
    WalletType: 'Wallet Type',

    Administration: 'Customs',
    RecordName: 'Record name',
    CustomsDeclarationTime: 'Customs Declaration Time',
    CustomsDeclarationNo: 'Customs Declaration No',
    CustomsDeclarationStatus: 'Customs Declaration Status',
    customsList: 'Customs Declaration List',
    CustomsFailureReason: 'Customs Declaration Failure Reason'
  },

  mer: (_mer = {
    Registration: 'Registration',
    Amendment: 'Amendment',
    PendingMerchantApproval: 'Pending Merchant Approval',
    MerchantAddress: 'Merchant Address',
    AccountBalance: 'Account Balance ',
    AvailableBalance: 'Available Balance ',
    OutstandingAmount: 'Outstanding Amount ',
    ApprovalItem: 'Approval Item',
    mchtApproval: 'Mcht Approval',

    Client: "Client",

    CompanyInfo: 'Company Info',
    Merchant: 'Merchant',
    Merchant1: 'Merchant name',
    BusinessAddress: 'Business address',
    MailAddress: 'Mail address',
    BRNo: 'BR no.',
    Capital: 'Capital ',
    YearsOfBusiness: 'Years of business',
    IncorporationCountry: 'Incorporation region',
    EmployeeNo: 'No. of employee',
    MerchantType: 'Merchant type',
    MerchantCategory: 'Merchant category',
    OnlineMerchants: 'Online merchant',
    UnderLineMerchant: 'Offline merchant',
    OwnershipType: 'Ownership type',
    LimitedCompany: 'Limited Company',
    Partnership: 'Partnership',
    SoleProprietor: 'Sole Proprietor',
    Contractperson: 'Contact person',
    Contractperson1: 'Contract',
    Email: 'Email',
    Position: 'Position',
    Position1: 'Title',
    OfficePhone: 'Office phone',
    Mobile: 'Mobile',
    Fax: 'Fax',
    Director: 'Director',
    DirectorHKID: 'Director HKID',
    DirectorPassport: 'Director passport',
    overdue: 'registration certificate date',

    Nationality: 'Nationality',

    ContactInfo: 'Contact Info',
    URL: 'URL',
    TargetLaunchDate: 'Target launch date',
    TechnicalContact: 'Technical contact'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Email', 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PhoneNo', 'Phone no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OperationContact', 'Operation contact'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FinanceContact', 'Finance contact'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessInfo', 'Business Info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessNature', 'Business nature'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ProductsServices', 'Products/services'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TargetCustomers', 'Target customers'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'provider', 'Payment provide used'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Turnover', 'Turnover for the past two years'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'LastYearSalesVol', 'Last year sales vol. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'YearBeforeSales', 'Year before sales '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OnlineBusiness', 'Online Business'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DeliveryProvider', 'Delivery provider'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CustomerHotline', 'Customer hotline'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReturnRefundPolicy', 'Return & refund policy'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FulfuillmentTime', 'Fulfillment cycle time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReceiptProvided', 'Receipt provided'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ForecastMonthlySales', 'Forecast monthly sales'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After3Months', ' after 3 months'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After6Months', ' after 6 months'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After1Year', ' after 1 year'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NoOfTransactions', 'No. of transactions'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SalesVolume', 'Sales volume '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AvgTransactionAmount', 'Avg transaction amount '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MinTransactionAmount', 'Min transaction amount '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MaxTransactionAmount', 'Max transaction amount '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SettlementInfo', 'Settlement Info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountName', 'Account name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountNo', 'Account no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankName', 'Bank name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode', 'Bank code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode1', 'Bank code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BranchCode', 'Branch code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Address', 'Address'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SWIFT', 'SWIFT'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate', 'Fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate1', 'WeChat Pay fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate2', 'WeChat Pay MO fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRateHK', 'WeChat Pay HK fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer', 'WeChat Pay fee bearer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer1', 'Service charge bearer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Customer', 'Customer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Consumer', 'Consumer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Attachments', 'Attachments'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BR', 'BR'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CertOfIncoporation', 'Cert. of incoporation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectorHKID1', 'Director HKID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankStatement', 'Bank statement'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Photos', 'Merchant or shop photos'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Logo', 'Logo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopInfo', 'Shop Info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopModiify', 'Info Modification'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShortName', 'Short name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopPhotos', 'Shop photos'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NewShop', 'New Shop'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PendingShopApproval', 'Pending Shop Approval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Sector', 'Sector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'company', 'Company'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'companyID', 'Company ID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'firm', 'Company'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'WhiteLable', 'White lable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DescriptionOfGoods', "Description of goods"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'WhiteLable', 'White lable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DescriptionOfGoods', "Description of goods"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNo', 'UnionPay merchant no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpayFeeRate', 'UnionPay fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TerminalNo', 'Terminal no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsername', 'AugsPay username'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NotifyKey', 'Notify key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'APIKey', 'API key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SignKey', 'Sign key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayFeeRate', 'AugsPay fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayFeeRate', 'Please input UnionPay fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputTerminalNo', 'Please input terminal no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputNotifyKey', 'Please input notify key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAPIKey', 'Please input API key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputSignKey', 'Please input sign key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayKey', 'Please input UnionPay key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAugsPayFeeRate', 'Please input AugsPay fee rate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNoAlreadyExists', 'UnionPay merchant no. already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsernameAlreadyExists', 'AugsPay username already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MopPayUsernameAlreadyExists', 'MopPay username already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayMerchantNo', 'Alipay(Direct Merchant) merchant no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayFeeRate', 'Alipay(Direct Merchant) fee rate (%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayDirect', 'Alipay(Direct Merchant)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOffline', 'Alipay direct connection(Offline)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOnline', 'Alipay direct connection(Online)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'key', 'Key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merchantNo', 'Merchant no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPay', 'AugsPay'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'userName', 'User Name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOnline', 'Alipay(Online)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOffline', 'Alipay(Offline)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ConfirmToReset', 'Confirm to reset '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'sPassword', ' ’s password?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'resetPassword', 'Reset Password'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'abbreviation', 'Abbreviation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merDescription', 'Merchant description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooShort', 'Merchant description too short'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooLong', 'Merchant description too long'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'delete', 'Confirm to delete the Merchant?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'channelRegistration', 'Channel Registration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'deviceNumber', 'Device Number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'shopNumber', 'Shop Number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'mcInformationForm', 'Merchant Information Form'), _mer),

  agent: {
    certificate: "registration certificate number",
    agent: 'Agent',
    DirectMerchants: 'Direct Merchants',
    BDStaff: 'BD Staff',
    SubordinateAgents: "Subordinate Agents",
    agentApproval: 'Agent Approval',
    agentApproval1: 'Pending Agent Approval',

    BasicInfo: 'Basic Info',
    CompanyInfo: "Company Info",
    Name: 'Name',
    Type: 'Type',
    Address: "Address",
    MailAddr: 'Mail addr.',
    Contact: 'Contact',
    PhoneNo: 'Phone no.',
    MobileNo: 'Mobile no.',
    UpperLevelAgent: 'Upper Level Agent',
    UpperLevelID: 'Upper agent ID',

    SettlementInfo: 'Settlement Info',
    Method: 'Method',
    Bank: 'Bank',

    CommissionInfo: 'Commission Info',
    Scanner: 'Scanner',
    SubscriptionFee: 'Subscription fee',
    OfflineBase: 'Offline base (%)',
    OfflineComm: 'Offline comm. (%)',
    OnlineBase: 'Online base (%)',
    OnlineComm: 'Online comm. (%)',
    EndDate: 'End date',
    BDStaffNo: 'Staff no.',
    commissionRatio: 'Commission (%)',
    hintInfo: "The base rate is the portion of commission that we will not share wilh the agent, the rest we share the percentage as defined in the comm. field. So for example, if a merchant is paying 1.5% comm, his agent may have a base rate of 1% and comm rate of 50%, then (1.5% - 1%) is the comm we share with the agent and the agent will get 50% of that, i.e. (1.5% - 1%) * 50% = 0.25% of the merchant's receiving amount.",

    POS: 'POS purchase ',
    POSmargin: 'POS margin ',
    POSrentalMonth: 'POS rental/month ',
    ScannerPurchase: 'Scanner purchase ',
    ScannerMargin: 'Scanner margin ',
    ScannerRentalMonth: 'Scanner rental/month ',
    AlipayCross: 'Alipay(Cross-border wallet)',
    AlipayHK: 'Alipay(HK wallet)',

    WithdrawalRatio: 'Minimum non-withdrawable ratio'
  },

  salesman: {
    Salesman: 'BD',
    Name: 'Name',
    ID: 'ID',
    ID1: 'ID no.',
    OK: 'OK',
    Status: 'Status',
    NewBDStaff: 'New Entry',
    ModifyTheSalesmanInformation: 'Edit Entry',
    theSalesman: ' the BD?',
    delete: 'Confirm to delete the BD?'
  },

  mec: (_mec = {
    Name1: 'Name',
    Status: 'Status',
    Contact: 'Contact',
    Phone: "Phone",
    Detail: 'Detail',

    OrganizationInfo: 'Organization info',
    RegisterAddress: 'Register address',
    businessLicenseNo: "business license no.",
    validityTime: 'validity time',
    LegalPerson: 'Legal person',
    certificateType: 'Certificate type',
    certificateNo: 'Certificate no.',
    PhoneNo: 'Phone no.',
    PhoneNo1: 'Phone',
    CreationTime: 'Establishment Time',
    CreationTime1: 'Establishment Time'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Contact', 'Contact'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Name', 'Name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhoneNo', 'Phone no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Email', 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementInfo', 'Settlement Info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementBank', 'Settlement bank'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'City', 'City'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountType', 'Account type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountName', 'Account name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountNo', 'Account no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhotoInfo', 'Photo info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDFrontPicture', 'Legal person ID front picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDReversePicture', 'Legal person ID reverse picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardFrontPicture', 'Legal person bankcard front picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardReversePicture', 'Legal person bankcard reverse picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'BusinessLicense', 'Business license'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'TaxRegistrationCertificate', 'Tax registration certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'OrganizationCodeCertificate', 'Organization code certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyFrontPicture', 'Company front picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyLogo', 'Company Logo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'other', 'Others'), _mec),

  AuMer: {
    CompanyInfomation: 'Company Infomation',
    RegistrationName: 'Registration name',
    AustraliaBusinessNumber: 'Australia business number.',
    BusinessInfomation: 'Business infomation',
    Website: 'Website',
    ContactNumber: 'Contact number',
    CompanyDescripption: 'Company descripption',
    Address: 'Address',
    City: 'City',
    Postcode: 'Postcode',
    State: 'State',
    ContactInfomation: 'Contact Infomation',
    FullNmae: 'Full name',
    JobTitle: 'Job title',
    TelephoneNo: 'Telephone No.',
    EmailAddress: 'Email address',
    BillingInfomation: 'Billing Infomation',
    BankName: 'Bank name',
    CompanyAccountNmae: 'Company account name',
    BSB: 'BSB',
    AccountNumber: 'Account number',
    Rate: 'Rate',
    SettlementPeriod: 'Period',
    OtherInformation: 'Other Information'
  },

  inputBox: (_inputBox = {
    merchantName: 'Merchant name',
    exchangeRate: 'Exchange rate',
    deviceNum: 'Device no.',
    bindingsStartDate: 'Binding Date',
    endDateOfBinding: '',
    query: 'query',
    add: 'Add',
    empty: 'Emptied',
    serialNumber: 'Number',
    merchantNumber: 'Merchant no.',
    shopNumber: 'Shop no.',
    shopName: 'Shop',
    deviceState: 'Status',
    weChatSonMerchant: 'Sub-account no.',
    storageTime: 'Stock-in',
    bindingTime: 'Bind',
    modificationTime: 'Config',
    operation: 'Operation',
    modify: 'Modify',
    cancel: 'Cancel',
    ok: 'OK',
    deviceAdd: 'New',
    deviceModify: 'Device modify',
    newDeviceNumber: 'New device number',
    pleaseEnterTheNewDeviceNumber: 'Please enter a new device number',
    pleaseEnterTheStoreNumber: 'Please enter the store number',
    pleaseEnterTheDeviceNumber: 'Please enter the device number',

    pleaseEnterTheWalletType: 'Please select the wallet type',
    pleaseEnterTheChannel: 'Please select the channel',
    success: 'Success',
    fail: 'Failure',
    modifySuccess: 'Successfully modified',
    addSuccess: 'Added successfully',
    addFail: 'Add failed',
    queryErr: 'The query is not entered correctly or the query result does not exist',

    QRcode: 'QR Code',
    fixedCodeID: 'fixed code ID',
    codeNo: 'Code no.',
    generationDate: 'Generated',
    bindingDate: 'Binding date',
    currentState: 'Current State',
    paymentChannel: 'Payment Channel',
    channelNumber: 'Channel number',
    companyNumber: 'Company cumber',
    channelState: 'Channel state',
    costRate: 'Cost rate (%)',
    typeOfTransaction: 'Type of transaction',
    settlementType: 'Settlement type',
    fixedFee: 'Fixed fee',
    priorityLevel: 'Priority level',
    dateOfEntry: 'Date of entry',
    remarks: 'Remark',
    remarks1: 'Remark Details',
    channelRegistrationDate: 'Channel registration date',
    autograph: 'Autograph',
    adapterOrder: 'Adapter Order Single URL',
    paymentAdapter: 'Adapter payment URL',
    adapterCallback: 'Adapter callback URL',

    startDate: 'From',
    endDate: 'To',
    unbound: 'Not bound',
    bindings: 'Bound',
    disable: 'Disabled',
    enable: 'Enabled',
    minimumExchangeRate: 'Minimum exchange rate',
    maximumExchangeRate: 'The maximum exchange rate',
    receivablesArea: 'Institute',
    Australia: 'MiPay',
    HongKong: 'Unipay',
    pleaseEnterTheMerchantName: 'Please enter the business name',
    chooseBranch: 'Choose a branch',
    bindingNumber: 'Quantity',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: 'Assign solid code',
    toTheMerchant: 'Merchant use',
    toTheAgent: 'To the agent'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheMerchantName', 'Please enter the business name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingAndBindingSolidCode', 'Generate and bind the fixed code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheAgentNumber', 'Agent no.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingFixedCode', 'Generate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceID', 'Device ID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceType', 'Device Type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scanner', 'Scanner'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceStatus', 'Device Status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'enabled', 'Enabled'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'disabled', 'Disabled'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'merchant', 'Merchant'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'shop', 'Shop'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deploymentDate', 'Deployment Date'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'search', 'Search'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'clear', 'Clear'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'status', 'Status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'change', 'Change'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'cancelBinding', 'Cancel Binding '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisable', 'Confirm to disable QR Code of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnable', 'Confirm to enable QR Code of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToUnbind', 'Confirm to unbind scanner of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisableS', 'Confirm to disable scanner of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnableS', 'Confirm to enable scanner of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'QRCodeOf', '?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scannerOf', '?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseChooseMerchant', 'Please choose merchant'), _inputBox),

  device: {
    newDevice: 'New Device',
    merchant: 'Merchant',
    shop: 'Shop',
    type: 'Type',
    scanner: 'Scanner',
    QRCode: 'QR Code',
    deviceID: 'Device ID',
    OK: 'OK',
    cancel: 'Cancel',
    deviceNAE: 'Device number already exists'
  },

  newcash: (_newcash = {
    requestDate: 'Request Date',
    merchantName: 'Merchant Name',
    agentName: 'Agent Name',
    bankName: 'Bank',
    bankAccount: 'Bank Account',
    accountName: 'Account Name',
    withdrawAmount: 'Withdraw Amount',
    Arrived: "Received Amount",
    withdrawAmount2: 'Withdraw amount',
    withdrawType: 'Withdraw Type',
    withdrawFee: 'Withdraw Fee',
    remitAmount: 'Remit Amount',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    rejected1: 'Rejected',
    paid: 'Paid',
    operation: 'Operation',
    approve: 'Approve',
    reject: 'Reject'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paid', 'Paid'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToApprove', 'Confirm to approve withdraw request from '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToRefuse', 'Confirm to refuse withdraw request from '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawRequestFrom', '?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'merchantName', 'Merchant Name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawStatus', 'Withdraw Status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'approvalTime', 'Approval Time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paymentTime', 'Remit Time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal', "Withdrawal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal1', "Finance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'WithdrawalRecord', 'Withdrawal Record'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'pendingWithdrawalApproval', 'Pending Withdrawal Approval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantName', 'Agent/Merchant Name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantID', 'Agent/Merchant ID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawErrorTitle', 'Warning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawError', 'The following merchants failed to withdraw, Please try again:'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'none', 'none'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawalConfirmation', 'Withdrawal Confirmation'), _newcash),

  cloudAccount: {
    switchInstitution: 'Switch institution',
    pleaseSelectInstitution: 'Please select institution'
  },

  fund: {
    withdrawAmount: 'Withdraw Account & Amount',
    enterAmount: 'Enter Amount',
    withdraw: 'Withdraw',
    cheque: 'Cheque',
    bankTransfer: 'Bank transfer',
    transferTip: 'CCB/BOC FOC,$50 for other interbank transfer',
    withdrawMethod: 'Withdraw Method',
    warning: 'Warning',
    warningTitle: 'Service time (on working day basis):',
    warningText: 'Request before 9:00am will have cheque issued or bank transfer setup the same day, otherwise the next day.',
    withdrawLimit: 'Withdraw amount should be no less than ',
    confirmWithdraw: 'Confirm to withdraw ',
    confirmWithdrawSuffix: ' ?',
    success: 'Withdrawal success',
    failed: 'Withdrawal failed',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    paid: 'Paid',

    WithdrawalAmount: 'Withdrawable amount',
    warningContent: 'please contact the staff if you have any questions.',
    Withdrawable: "(1) HKD 5 per remittance (the remittance amount is less than HKD 500,000),",
    WithdrawableT: "(2) HKD 10 per remittance (remittance amount over HKD 500,000).",

    see: 'see',
    rechargeRecord: 'Reserve recharge record',
    refundRecord: 'Petty cash refund record',
    imprestAudit: 'Reserve fund recharge audit',
    please: 'please',
    confirmRecharge: 'Confirm to recharge',
    reserveMoney: 'Reserve balance',
    recharge: 'Recharge',
    rechargeTime: 'Recharge time',
    refundTime: 'Refund time',
    rechargeRecords: 'Recharge Records',
    refundRecords: 'Refund Records',
    rechargeAmount: 'Recharge amount',
    refundAmount: 'Refund amount',
    rechargeNotes: 'Recharge  notes',
    rechargeVoucher: 'Recharge voucher',
    fillRemarks: 'Fill in the remarks',
    rechargeRechargeInfo: 'Recharge information of reserve fund',
    reserveWarningTitle: 'The balance of the reserve fund is only used for refund of the merchant, and can not be withdrawn after recharging. If you need to withdraw cash, please contact the staff;',
    reserveWarningText: 'If you need to recharge the reserve fund, please pay in advance and keep the payment voucher;',
    reserveWarningContent: 'The amount of recharge should be consistent with the amount in the voucher. After submitting the recharge, the staff will review the voucher information, and only after passing the review can the balance of the reserve fund be used for refund.'
  },

  profit: {
    profit: 'Profit',
    countDate: 'Period',
    date: 'Period',
    acquirerFee: 'Acquirer Fee',
    channel: 'Channel',
    channelFee: 'Channel Fee',
    agentComm: 'Agent Comm.',
    BDComm: 'BD Comm.',
    settlement: 'Settlement',
    acquirerFeeTotal: 'Acquirer Fee Total',
    agentCommTotal: 'Agent Comm. Total',
    BDCommTotal: 'BD Comm. Total',
    wx: 'WeChat',
    payment: 'Payment Settlement',
    settlementDateRefund: 'Refund Settlement'
  },

  firm: {
    companyName: 'Company Name',
    companyID: 'Company ID',
    agent: 'Agent',
    companyStatus: 'Company Status',
    establishmentDate: 'Establishment Date',

    name: 'Name',
    ID: 'ID',
    status: 'Status',
    merchantQty: 'Merchant Qty',
    registrationDate: 'Registration Date',
    companyApproval: 'Pending Company Approval'
  },

  cash: {
    userNumber: 'Merchant no.',
    auditStatus: 'Approval Status',
    unaudited: '未审核',
    reviewAndPassThrough: 'Approve',
    reviewAndDismissal: '审核驳回',
    alreadyMadeMoney1: 'Payment',
    presentType: 'Withdrawal type',
    check: 'Cheque',
    onlineBanking: 'Bank transfer',
    applicationStartDate: 'Application Date',
    applicationEndDate: '',

    RegistrationName: 'Registration name',
    applicationTime: 'Request date',
    amountOfCash: 'Withdrawal Amount',
    cankCardNumber: 'Bank Account',
    cardholder: 'Acount name',
    BankName: 'Bank name',
    auditTime: 'Approval',
    remittanceDate: 'Remittance',
    notes: 'Remark',
    examine: 'Approval',
    adopt: 'Approve',
    reject: 'Reject',
    playMoney: 'Payment',
    auditHasPassed: 'Approved',
    theAuditHasBeenRejected: 'Rejected',
    errOperation: 'Fund already remitted',
    alreadyPassed: 'Already passed',
    notRepeatOperation: 'Not repeat operation',
    audit: 'Approval pending',
    notMakeMoney: 'Not make money',
    alreadyMadeMoney: 'Already made money',
    query: 'query',
    empty: 'empty'
  },

  shop: {
    Phone: "Phone",
    Phone1: "Phone*",
    Email: 'Email',
    Email1: 'Email*',
    shopApproval: 'Shop Approval',
    shopName: 'Shop Name'
  },

  modifyPwd: {
    PasswordChange: 'Change Password',
    OriginalPassword: 'Original password',
    NewPassword: 'New password',
    Confirm: 'Confirm',
    OK: 'OK',
    Cancel: 'Cancel',
    PasswordIncorrect: 'Password Incorrect',
    NewPasswordLessThan6Digits: 'New password less than 6 digits',
    TheTwoPasswordsDoNotMatch: 'The two passwords do not match',
    TheNewPasswordIsTheSameAsTheOldOne: 'The new password is the same as the old one',
    PleaseInputMoreThan6DigitsPassword: '(At least 6 characters)',
    PleaseBeTheSameAsOriginalPassword: '(Re-enter new password)',
    PleaseInputOriginalPassword: 'Please input original password',
    PleaseInputPasswordAgain: 'Please input password again',
    PleaseInputPassword: 'Please input password',

    formatError: 'The picture format is incorrect'
  },
  other: {
    PhoneNumberAlreadyExist: 'Phone number already exist',
    InformationChange: 'Information Change',
    ConfirmToMakeTheChanges: 'Confirm to make the changes?',
    ConfirmToRegisterTheShop: 'Confirm to register the shop?',
    ConfirmToDeleteTheShop: 'Confirm to delete the shop?',
    MerchantLogo: 'Merchant logo',
    MerchantInfo: 'Merchant registration form',
    PasswordShouldBeAtLeast6Characters: 'Password should be at least 6 characters',
    EmailAlreadyExists: 'Email already exists',
    EstablishmentFrom: 'Establishment Date',
    EstablishmentFrom1: 'Establishment Date',
    EstablishmentFrom2: 'Establishment Date',
    EstablishmentFrom3: 'Establishment Date',
    EstablishmentTo: ''
  },
  modifyShop: {
    ShopDetail: 'Shop detail',
    New: 'New',
    Back: 'Back',
    Rejected: 'Rejected',
    ApprovalPending: 'Approval pending',
    AmendmentApprovalPending: 'Amendment approval pending',
    UploadPhoto: 'Upload',

    ShopNumber: 'Shop no.',
    Edit: 'Edit',
    Suspended: 'Disabled',
    ClickToAddPhotos: 'Click to add photos',
    ShopName: 'Shop Name',
    OK: 'OK',
    OK1: 'OK',
    delete: 'Delete the shop'
  },
  ad: {
    typeOne: 'Type One',
    typeTwo: 'Type Two',
    typeThree: 'Type Three',
    advertisingPosition: 'Advertisement position',
    resolution: 'Size',
    link: 'Link',
    adMgmt: 'Advertisement',
    adSetup: 'Edit',

    NewAdvertisement: 'New Advertisement',
    BusinessNature: 'Industry',
    ConfirmtodeletetheAdvertisement: 'Confirm to delete the Advertisement?',
    ConfirmtomodifytheAdvertisement: 'Confirm to make the changes?',
    Replacethepicture: 'Replace the picture',
    Uploadpicture: 'Upload picture',
    AdvertisementName: 'Name',
    Link: 'Link',
    PleaseAddAdvertisementPicture: 'Please add advertisement picture',

    adData: 'Ad Data',
    Display: 'Display',
    Click: 'Click',
    ClickRate: 'ClickRate'
  },

  settlement: {
    Date: 'Period',
    Merchant: 'Merchant',
    MerchantID: 'Merchant ID',
    SettlementPeriod: 'Settlement Period',
    TransactionAmount: 'Transaction Amount',
    Fee: 'Fee',
    SettlementAmount: 'Settlement Amount',
    Settlement: 'Settlement',

    refundRemarks: 'Refund remarks'
  },

  opinion: {
    Date: 'Period',
    SuggestionList: 'Customer Feedback',
    SuggestionList1: 'Feedbacks',
    SuggestionList2: 'Feedback',
    Time: 'Time',
    Shop: 'Shop',
    Account: 'Account',
    AcountName: 'Acount Name',
    Role: 'Role',
    Subject: 'Subject',
    Content: 'Content',
    Suggestion: 'Suggestion'
  },

  notify: (_notify = {
    title: 'Subject',
    content: '',
    content1: 'Content',
    NotificationHistory: 'Notification Record',
    Recipients: 'Recipients',
    Details: 'Details',
    EditNotification: 'Edit Notification',
    SelectRecipients: 'Select recipients',
    SendTo: 'Send to:',
    Send: 'Send',
    All: 'All',
    Agent: 'Agent',
    Company: 'Company',
    Merchant: 'Merchant',
    Finance: 'Finance',
    BD: 'BD',
    AllAgent: 'All agents',
    AllCompany: 'All companys',
    AllMerchant: 'All merchants',
    AllMerchantAdministrator: 'All merchant aministrator',
    AllShop: 'All shops',
    AllStaff: 'All staff',
    AllFinance: 'All finance',
    AllBD: 'All BD',
    Administrator: 'Administrator',
    MerchantsOf: 'All merchants',
    ConfirmToSend: 'Confirm to send?',
    Notification: 'Notification',
    AlreadyExists: ' already exists',
    PleaseSelectRecipients: 'Please select recipients',
    Notifications: 'Notifications',
    NotificationList: 'Notification List',
    NofiticationDetails: 'Nofitication Details',
    contentExceeding: 'Content exceeding 2000 characters, please reduce the content',
    Only10Images: 'Only 10 images can be uploaded per notification',
    pleaceSelectOrEnputMerchantName: 'Input merchant name',
    addPicture: 'Add Picture'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Merchant', 'Merchant'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Agent', 'Agent'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Company', 'Company'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Shop', 'Shop'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationApproved', ' Registration Approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationRejected', ' Registration Rejected'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationApproved', ' Information Modification Approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationRejected', ' Information Modification Rejected'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationApproved', 'Withdrawal Application Approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationRejected', 'Withdrawal Application Rejected'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'the', 'The'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenApproved', ' registration you submitted has been approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenRejectedRejectReason', ' registration you submitted has been rejected. Reject reason：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenApproved', ' information modification you submitted has been approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenRejectedRejectReason', ' information modification you submitted has been rejected. Reject reason：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'theWithdrawalApplicationOf', 'The withdrawal application of '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'on', ' on '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenApproved', ' you submitted has been approved.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenRejectedRejectReason', ' you submitted has been rejected. Reject reason：'), _notify),

  risk: {
    report: 'Transaction Report',
    automated: 'Report List',
    should: 'Report Date',
    Type: 'Type',
    Edit: 'Edit',
    Remove: 'Remove',
    NewWhiteList: 'New White list',
    Configuration: 'Configuration',
    PassingRules: 'Passing rules',
    DayAmountLimit: 'Day amount limit',
    HourAmountLimit: 'Hour amount limit',
    PerTransactionLimit: 'Per transaction limit',
    MinuteVolumeLimit: 'Minute volume limit',
    ConfirmWhiteRemoving: 'Confirm removing ',
    FromWhiteList: ' from White list?',
    Abnormalty: 'Abnormalty',
    BlackListed: 'Black listed',
    OrderNumber: 'Order Number',
    ConfirmGreyRemoving: 'Confirm removing ',
    fromGreyList: ' from Grey list?',
    ConfirmMoving: 'Confirm removing ',
    toBlackList: ' to Black list?',
    GreyListed: 'Grey listed',
    ConfirmBlackRemoving: 'Confirm removing ',
    fromBlackList: ' from Black list?',
    toGreylist: ' to Grey list',
    ConfirmChanging: 'Confirm changing ',
    ConfirmChangingRiskControlfactors: "Confirm changing this industry's risk control factors?",
    RiskControl: 'Risk Control',
    whiteListEdit: 'White List Edit',
    whiteList: 'White List',
    greyList: 'Grey List',
    blackList: 'Black List',
    items: 'items',

    riskMerchant: 'Merchant Risk Control',
    riskTime: 'Risk Control Time',
    singleDayLimit: 'Single Day Limit',
    TradingLimit: 'Transaction frequency limit',
    addRiskMerchant: 'Add Risk Control Merchant',
    removeRiskMerchant: 'Remove Risk Control Merchant',
    modifyRiskMerchant: 'Modify Risk Control Information',
    isDeleteRiskMerchant: 'Are you sure to remove the merchant from the risk control list？',
    adder: 'Adder',
    verifyIsEmpty: 'Merchant name / No. cannot be blank',
    minLimitRules: 'Please enter at least one limit rule',
    VerifyDcMcName: 'The merchant already exists, please select again',

    singleLimit: 'Single Limit',
    pen: 'Orders'
  },

  History: {
    Applicant: 'Applicant',
    ApplicantAccount: 'Applicant Account',
    ApprovalHistory: 'Approval History',
    Approver: 'Approver',
    ApproverAccount: 'Approver Account',
    Agent: 'Agent ',
    Company: 'Company ',
    Merchant: 'Merchant ',
    shop: 'Shop ',
    refusalReasons: 'Reject Reasons'
  },

  count: {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    hour: 'Hour',
    pleaceSelectTime: 'pleace Select Time',
    endTimeError: 'End time error',
    pleaseSearchLessThan24Months: 'Please search less than 24 months',
    pleaseSearchLessThan16Weeks: 'Please search less than 16 weeks',
    pleaseSearchSessThan62Days: 'Please search less than 62 days',
    pleaseSearchSessThan48Hours: 'Please search less than 48 hours',
    todayReceiptAmount: 'Today amount',
    todayUnionPayAmount: 'Today Unionpay payment total',
    todayWeChatAmount: 'Today WeChat payment total',
    todayHongKongAmount: 'Today WeChat HK total',
    todayWalletAmount: 'Today cross-border WeChat total',
    todayAlipayAmount: 'Today Alipay payment total',
    todayTransactionVolume: 'Today transaction volume',
    transactionAmount: 'Transaction amount',
    transactionVolume: 'Transaction volume',
    newMerchant: 'New merchant',
    date: 'Period',
    amount: 'Amount',
    top10Merchant: 'Top 10 Merchant',
    Month: 'Month',
    sinceEstablishment: 'Since establishment',
    dataSheet: 'Data sheet',
    ranking: 'Ranking',
    failureRate: 'Failure rate'
  },

  user: {
    title: 'User Info',
    tips: '(Click to edit username and avatar)',
    placeholder: 'Please enter',
    qualified1: 'Please enter user name',
    qualified2: 'Please enter the user name correctly',
    qualified3: 'Username must not contain Chinese or English special characters',
    OK: 'OK',
    Cancel: 'Cancel'
  },
  enLocale: __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default.a });

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "19nU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_admin_menu_index__ = __webpack_require__("Vq+d");




function hasPermission(menus, route) {
  if (route.authority) {
    if (menus[route.authority] !== undefined) {
      return menus[route.authority];
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function filterAsyncRouter(asyncRouterMap, menus, menuDatas) {
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (hasPermission(menus, route)) {
      if (localStorage.getItem('locale') == 'zh_cn') {
        route.name = menuDatas[route.authority].title;
      } else if (localStorage.getItem('locale') == 'zh_tw') {
        route.name = menuDatas[route.authority].attr7;
      } else {
        route.name = menuDatas[route.authority].attr8;
      }
      route.icon = menuDatas[route.authority].icon;

      if (localStorage.getItem('userType') == '2' && localStorage.getItem('grade') !== '1') {
        if (['分润', '分潤', 'Profit', '资金管理', "資金管理", 'Fund'].includes(route.name)) {
          route = {};
          return;
        }
      }

      if (localStorage.getItem('companyId') == '2') {
        if (['待审核兑现', '待審批兌現', 'Withdrawal', '公司', "Company", '公司审核', '公司審批', '兑现', '兌現', 'Withdrawal', '分润', '分潤', 'Profit'].includes(route.name)) {
          route = {};
          return;
        }
      }

      if (localStorage.getItem('companyId') == '3') {
        if (['财务', '財務', 'Finance', '风险控制', '風險控制', 'Risk Control'].includes(route.name)) {
          route = {};
          return;
        }

        if (localStorage.getItem('userType') == '5') {
          if (['意见管理', '意見管理', 'Feedback', '通知管理', "通告管理", 'Notification', '代理商审核', '代理商審核', 'Agent_Audit', '兑现审核', '兌現審批', 'Withdrawal_Approval'].includes(route.name)) {
            route = {};
            return;
          }
        }
      }

      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, menus, menuDatas);
      }
      return true;
    }
    return false;
  });

  return accessedRouters;
}

var permission = {
  state: {
    routers: __WEBPACK_IMPORTED_MODULE_1_src_router__["b" /* constantRouterMap */],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = __WEBPACK_IMPORTED_MODULE_1_src_router__["b" /* constantRouterMap */].concat(routers).filter(function (element) {
        return element.authority;
      });
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, menus) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_admin_menu_index__["a" /* fetchAll */])().then(function (data) {
          var menuDatas = {};

          for (var i = 0; i < data.length; i++) {
            menuDatas[data[i].code] = data[i];
          }
          var accessedRouters = filterAsyncRouter(__WEBPACK_IMPORTED_MODULE_1_src_router__["c" /* asyncRouterMap */], menus, menuDatas);

          accessedRouters = accessedRouters.filter(function (element) {
            return element.authority;
          });

          commit('SET_ROUTERS', accessedRouters);
          resolve();
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ "1BzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__("6o49");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SidebarItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default.a },
    data: function data() {
        return {
            collapse: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["permission_routers", "sidebar"]), {
        isCollapse: function isCollapse() {
            return !this.sidebar.opened;
        }
    }),
    created: function created() {},
    mounted: function mounted() {},

    methods: {}
});

/***/ }),

/***/ "1hxP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAAP1BMVEUAAAAAtogAt4cAtooAv48AtogAtYcAtYoAtokAtYkAt4cAtokAtYkAtokAtokAtYgAtYgAtogAtokAtokAtokG8+4zAAAAFHRSTlMAwEA/EPBgMKCAIODPcFDQsJCvj/LDcjsAAAT+SURBVHja7d1bktsgEAXQBgMCvSzbvf+15lEz5XgqtpAuoEbF+ctPUh3ggiVA1DRN0zRNRubiQlBKWf72+w+P4C491cJcglf8wXgP4svp3WPkKIOfOhLq8iwitpjZkDSzt7zH3UmqRXvL+91nEsFMA4Ps4/jB33tOQmk6klaczOgokugy/hiiShFfRmQpUsfGT6rsNGmC5Vy8oWL0wBnZicownjNTRaaV2XJ++RvFPLgIlXmkdCMXYmfKyFku50HZrHWrSrqXGbmw4Wt2rHV4PFmdoQ7LR3CUmOMNBA95x4fxJ6mD2Z+kDmZ/kjqY/UnqSFSJZgGmaueP5POJGVgE29W2vnrH9oTwLMZo6g6sJNHVsSiTrIHuJ30beJe9A/7O6dkOeKI0GjkD5Ps/9cp73GiH3nJ6Cuy2mrZTnEEAVwyDoa1mziHs+AewzmUs53Cnp4n30EKmdI3+G6OQqfArQYHocseP9L8UOuNac/hIfw5XKLoCxRs4I4dOur2URW9HT4G38zIahNn2YHT1MhrkNbrMjujyMhrktzs49ZrDIytRdAVwDhETXdbI+X2LRZeT8+AEi64RW/YKiq7u+OyNiy48gUf+REx0rQ73ntcIia614T5xQRaIrkVOz/rZQRbexMjpWVh0OTk96w+/+0nacvzy5EXYu6iw9AlHkhBdOt/CF4+uG/KsbsffIyK6lJjwRaNL1hABoktjewPsbdKpmV3RFeidEBPfhjJz+EyyxL+gwOGRMyBj3VEBCzragV9mSZkrNto75CEfbnt0TcC8PlMRGoqtgE2n5aNLIWnhqQwPFKI4hnKXIgZeJ+bHCOBTITI2/W3Ri1oyAvS5C+m5OlruBt9tQitEmFaINK0QaVoh0kz0P4arc/K11nkKEXJ4ZwNz8l+ISsoDOjLOIm/fQtKjTgUO2ymgEB4NFeGAx/E6ci9MEQZ40tgD64L0LPBqgP8Q8moBejWggFOaqc3I+xGfcm9k/iOp1887UUREVz9Cz9O7XS+UzaJSG9EDlpZjBQEHSLskm4Pc4Ud6Lb0XgL0wxS3YLmx8G1+RM8gW2AtTWk8feGAvTGHD+pqzjujy2Jrz1XxgdM3r20CqiC6bdo//YI76ze/pMwMc5ICjC+9ZwIzgj7nVZkh/VGw65PFxiDq8V0F09bQqQDuQPRex0LqemcVH1xy5wUh6dA1EkU0iPLpc9PUCsqPLbthQKDq6woYbHyRHlzUb9nhKjq6Q9xIOlT668F3tHbPc6HLZL6pxRQ45XQtcHaRLHATUtMkEn/saOIuFNrqip6Uc52BNmRsBVe4JfqLNAu/h8w53hZ5GieeA4Mv0cryDUkUzAu9YeOeyM/BNjJSJhS+ZBu9H/gBPLCE36u3VneRW1s8DRNJdFmvBfo6bi68vA0TKTaDwj5B986IA/y5Ha46u7zqqvzneEZ2iEkd0ikoc0SkqcUSnqMRRUl1kCsvMq+Pnkzd1CP96YOS6BBc4Jezqkgo+hfj2YXWtQ95qysjcOEYNn9t8272q6VbfjOLsrv9P3eoa5VNzVDSlbB0d4j48vf/z0wK/g2qDoR3EfX/aR/Uq8aUAZaDMNKTrVD0dyl2TDPHJ0OE6bxnjNQnhFmAWl9AYT8Yt+6roSZ5526fPrHei2uJFP9+uUS3hncSm+KFzQb0tZ1A3J2ZsRzFaTyF49WUJIWhdQTM0TdM0TdM0P/0CsjvJwoJB6OoAAAAASUVORK5CYII="

/***/ }),

/***/ "2gkk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sticky',
  props: {
    stickyTop: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 1
    },
    className: {
      type: String
    }
  },
  data: function data() {
    return {
      active: false,
      position: '',
      currentTop: '',
      width: undefined,
      height: undefined,
      child: null,
      stickyHeight: 0

    };
  },

  methods: {
    sticky: function sticky() {
      if (this.active) {
        return;
      }
      this.position = 'fixed';
      this.active = true;
      this.width = this.width + 'px';
    },
    reset: function reset() {
      if (!this.active) {
        return;
      }
      this.position = '';
      this.width = 'auto';
      this.active = false;
    },
    handleScroll: function handleScroll() {
      this.width = this.$el.getBoundingClientRect().width;
      var offsetTop = this.$el.getBoundingClientRect().top;
      if (offsetTop <= this.stickyTop) {
        this.sticky();
        return;
      }
      this.reset();
    }
  },
  mounted: function mounted() {
    this.height = this.$el.getBoundingClientRect().height;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "3zpo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        this.getBreadcrumb();
    },
    data: function data() {
        return {
            levelList: null
        };
    },
    mounted: function mounted() {},

    methods: {
        getBreadcrumb: function getBreadcrumb() {
            var matched = this.$route.matched.filter(function (item) {
                return item.name;
            });
            var first = matched[0];

            this.levelList = matched;
        },
        toLayout: function toLayout() {
            this.$router.push({ path: "/" });
        }
    },
    watch: {
        $route: function $route() {
            this.getBreadcrumb();
        }
    }
});

/***/ }),

/***/ "45On":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.screenfull[data-v-7bd3b246] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  vertical-align: -0.15em;\n}\r\n", ""]);

// exports


/***/ }),

/***/ "4SVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__waves_css__ = __webpack_require__("lbbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__waves_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__waves_css__);



var vueWaves = {};
vueWaves.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.directive('waves', {
    bind: function bind(el, binding) {
      el.addEventListener('click', function (e) {
        var customOpts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, binding.value);
        var opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          ele: el,
          type: 'hit',
          color: 'rgba(0, 0, 0, 0.15)' }, customOpts),
            target = opts.ele;
        if (target) {
          target.style.position = 'relative';
          target.style.overflow = 'hidden';
          var rect = target.getBoundingClientRect();
          var ripple = target.querySelector('.waves-ripple');
          if (!ripple) {
            ripple = document.createElement('span');
            ripple.className = 'waves-ripple';
            ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px';
            target.appendChild(ripple);
          } else {
            ripple.className = 'waves-ripple';
          }
          switch (opts.type) {
            case 'center':
              ripple.style.top = rect.height / 2 - ripple.offsetHeight / 2 + 'px';
              ripple.style.left = rect.width / 2 - ripple.offsetWidth / 2 + 'px';
              break;
            default:
              ripple.style.top = e.pageY - rect.top - ripple.offsetHeight / 2 - document.body.scrollTop + 'px';
              ripple.style.left = e.pageX - rect.left - ripple.offsetWidth / 2 - document.body.scrollLeft + 'px';
          }
          ripple.style.backgroundColor = opts.color;
          ripple.className = 'waves-ripple z-active';
          return false;
        }
      }, false);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (vueWaves);

/***/ }),

/***/ "5/oe":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "wscn-icon hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "t": "1492500959545",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1691",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('path', {
    attrs: {
      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
      "p-id": "1692"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
      "p-id": "1693"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
      "p-id": "1694"
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c926d418", module.exports)
  }
}

/***/ }),

/***/ "5ipy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.navbar[data-v-3ecfcee3] {\n  height: 78px;\n  background-color: #f6f6f6;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n  border-bottom: 0;\n  min-width: 1000px;\n}\n.navbar .navbar-right[data-v-3ecfcee3] {\n    height: 78px;\n    float: right;\n    margin-right: 37px;\n    overflow: hidden;\n    cursor: pointer;\n}\n.navbar .navbar-right .login-img-box[data-v-3ecfcee3] {\n      float: left;\n}\n.navbar .navbar-right .login-img[data-v-3ecfcee3] {\n      width: 60px;\n      height: 60px;\n      border-radius: 50%;\n      display: block;\n      margin: 9px 0;\n      float: left;\n}\n.navbar .navbar-right .login-name[data-v-3ecfcee3] {\n      display: block;\n      float: left;\n      font-size: 18px;\n      padding: 28px 10px 28px 18px;\n      position: relative;\n      color: #333;\n      max-width: 150px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      outline: none;\n}\n.navbar .navbar-right .login-name[data-v-3ecfcee3]:after {\n        content: \" \";\n        width: 4px;\n        height: 4px;\n        border-color: #333 transparent;\n        border-width: 0 0 9px 9px;\n        border-style: solid;\n        position: absolute;\n        right: 0px;\n        bottom: 17px;\n}\n.navbar .navbar-right .line-class[data-v-3ecfcee3] {\n      width: 1px;\n      height: 46px;\n      background-color: #999;\n      float: left;\n      margin: 16px 15px 16px 10px;\n}\n.navbar .navbar-right .lang-box[data-v-3ecfcee3] {\n      overflow: hidden;\n      float: left;\n      padding: 23px 0;\n}\n.navbar .navbar-right .lang-box .lang-ul[data-v-3ecfcee3] {\n        list-style-type: none;\n        overflow: hidden;\n        padding: 0;\n}\n.navbar .navbar-right .lang-box .lang-ul .lang-item[data-v-3ecfcee3] {\n          float: left;\n          width: 32px;\n          height: 32px;\n          line-height: 32px;\n          text-align: center;\n          font-size: 18px;\n          color: #888;\n}\n.navbar .navbar-right .lang-box .lang-ul .lang-item + .lang-item[data-v-3ecfcee3] {\n          margin-left: 6px;\n}\n.navbar .navbar-right .lang-box .lang-ul .active[data-v-3ecfcee3] {\n          background: #5272e9;\n          color: #fff;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel[data-v-3ecfcee3] {\n  margin: 0;\n}\n.isShowUser .el-dialog__footer .dialog-footer .footer-cancel[data-v-3ecfcee3] {\n  margin: 0;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel[data-v-3ecfcee3]:hover {\n  background-color: #fff !important;\n}\n.isShowUser .el-dialog__footer .dialog-footer .footer-cancel[data-v-3ecfcee3]:hover {\n  background-color: #fff !important;\n}\n.controls[data-v-3ecfcee3] {\n  text-align: left;\n  position: relative;\n}\n.controls input[type=\"text\"][data-v-3ecfcee3],\n.controls input[type=\"email\"][data-v-3ecfcee3],\n.controls input[type=\"tel\"][data-v-3ecfcee3],\n.controls textarea[data-v-3ecfcee3],\n.controls button[data-v-3ecfcee3],\n.controls select[data-v-3ecfcee3] {\n  padding: 12px;\n  font-size: 14px;\n  border: 1px solid #c6c6c6;\n  width: 100%;\n  margin-bottom: 18px;\n  color: #888;\n  font-family: \"Lato\", \"sans-serif\";\n  font-size: 16px;\n  font-weight: 300;\n  background-color: #fff;\n  border-radius: 2px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.controls input[type=\"text\"][data-v-3ecfcee3]:focus,\n.controls input[type=\"text\"][data-v-3ecfcee3]:hover,\n.controls input[type=\"email\"][data-v-3ecfcee3]:focus,\n.controls input[type=\"email\"][data-v-3ecfcee3]:hover,\n.controls input[type=\"tel\"][data-v-3ecfcee3]:focus,\n.controls input[type=\"tel\"][data-v-3ecfcee3]:hover,\n.controls textarea[data-v-3ecfcee3]:focus,\n.controls textarea[data-v-3ecfcee3]:hover,\n.controls button[data-v-3ecfcee3]:focus,\n.controls button[data-v-3ecfcee3]:hover,\n.controls select[data-v-3ecfcee3]:focus,\n.controls select[data-v-3ecfcee3]:hover {\n  outline: none;\n  border-color: #9fb1c1;\n}\n.controls input[type=\"text\"]:focus + label[data-v-3ecfcee3],\n.controls input[type=\"text\"]:hover + label[data-v-3ecfcee3],\n.controls input[type=\"email\"]:focus + label[data-v-3ecfcee3],\n.controls input[type=\"email\"]:hover + label[data-v-3ecfcee3],\n.controls input[type=\"tel\"]:focus + label[data-v-3ecfcee3],\n.controls input[type=\"tel\"]:hover + label[data-v-3ecfcee3],\n.controls textarea:focus + label[data-v-3ecfcee3],\n.controls textarea:hover + label[data-v-3ecfcee3],\n.controls button:focus + label[data-v-3ecfcee3],\n.controls button:hover + label[data-v-3ecfcee3],\n.controls select:focus + label[data-v-3ecfcee3],\n.controls select:hover + label[data-v-3ecfcee3] {\n  color: #077abc;\n  cursor: text;\n}\n.controls label[data-v-3ecfcee3] {\n  position: absolute;\n  top: -6px;\n  left: 0;\n  color: #666666;\n  font-size: 18px;\n  display: inline-block;\n  z-index: 99;\n  font-weight: bold;\n  background-color: rgba(255, 255, 255, 0);\n  pointer-events: none;\n  -webkit-transition: color 0.3s, top 0.3s, background-color 0.8s;\n  transition: color 0.3s, top 0.3s, background-color 0.8s;\n}\n.controls label.active[data-v-3ecfcee3] {\n  top: -25px;\n  color: #333333;\n  background-color: white;\n  font-size: 14px;\n}\n.hintInfo[data-v-3ecfcee3] {\n  font-size: 12px;\n  font-weight: normal;\n  color: #999999;\n}\n.controls span.hidden[data-v-3ecfcee3] {\n  display: none;\n}\n@media only screen and (max-width: 1200px) {\n.navbar .logo[data-v-3ecfcee3] {\n    width: 50%;\n}\n}\n.redSpot[data-v-3ecfcee3] {\n  position: relative;\n}\n.redSpot i[data-v-3ecfcee3] {\n    position: absolute;\n    width: 7px;\n    height: 7px;\n    background-color: red;\n    top: 8px;\n    left: 12px;\n    border-radius: 50%;\n}\n#avatarUpload[data-v-3ecfcee3] {\n  float: left;\n}\n.isShowUser[data-v-3ecfcee3] {\n  width: 100%;\n}\n.isShowUser #avatarUpload1[data-v-3ecfcee3] {\n    width: 100%;\n    height: 120px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.isShowUser #avatarUpload1 .el-upload[data-v-3ecfcee3] {\n      width: 120px;\n      height: 120px;\n}\n.isShowUser #avatarUpload1 .el-upload .login-img[data-v-3ecfcee3] {\n        width: 120px;\n        height: 120px;\n        border-radius: 50%;\n        display: block;\n}\n.isShowUser .user_input[data-v-3ecfcee3] {\n    width: 100%;\n    margin: 10px auto;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.isShowUser .user_input .el-input[data-v-3ecfcee3] {\n      width: 60%;\n      font-size: 16px;\n}\n.isShowUser .user_input .user_text[data-v-3ecfcee3] {\n      font-size: 24px;\n      font-weight: bold;\n      text-align: center;\n}\n.isShowUser .tip[data-v-3ecfcee3] {\n    display: inline-block;\n    width: 100%;\n    height: 10%;\n    text-align: center;\n    color: #d7d7d7;\n}\n.isShowUser .psw_box[data-v-3ecfcee3] {\n    width: 100%;\n    height: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 15px 0;\n    text-align: center;\n}\n.isShowUser .psw_box[data-v-3ecfcee3]:hover {\n      cursor: pointer;\n}\n.isShowUser .psw_box .psw-change[data-v-3ecfcee3] {\n      display: inline-block;\n      height: 20px;\n      line-height: 20px;\n      font-size: 18px;\n      text-align: center;\n      text-decoration: underline;\n      color: #5272e9;\n}\n.isShowUser .el-dialog__footer[data-v-3ecfcee3] {\n    height: 0 !important;\n    background: #fff;\n}\n.isShowUser .el-dialog__footer .dialog-footer[data-v-3ecfcee3] {\n      background: #fff;\n}\n.isShowUser .el-dialog__footer .dialog-footer .footer-ok[data-v-3ecfcee3] {\n        margin-top: -100px;\n        margin-bottom: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "6HNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    }
  }
});

/***/ }),

/***/ "6o49":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("sG7e")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aacO"),
  /* template */
  __webpack_require__("fUFR"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2320244c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\SidebarItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarItem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2320244c", Component.options)
  } else {
    hotAPI.reload("data-v-2320244c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "7Iw2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.hamburger[data-v-c926d418] {\r\n\tdisplay: inline-block;\r\n\tcursor: pointer;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\t-webkit-transform: rotate(0deg);\r\n\t        transform: rotate(0deg);\r\n\t-webkit-transition: .38s;\r\n\ttransition: .38s;\r\n\t-webkit-transform-origin: 50% 50%;\r\n\t        transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-c926d418] {\r\n\t-webkit-transform: rotate(90deg);\r\n\t        transform: rotate(90deg);\n}\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "7aEP":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eca5e0e0", module.exports)
  }
}

/***/ }),

/***/ "88h1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iMd8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("07c2ae48", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a0c7aa2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a0c7aa2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9V4I":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "navbar-right"
  }, [_c('div', {
    attrs: {
      "id": "avatarUpload"
    }
  }, [_c('img', {
    staticClass: "login-img",
    attrs: {
      "src": _vm.loginImg
    }
  })]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "login-img-box",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link login-name",
    attrs: {
      "title": _vm.userName
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.phone === '13501189583' || _vm.phone === '15018955912' || _vm.phone === 'Mok' || _vm.phone === '65263913' ? false : true) ? _c('el-dropdown-item', {
    attrs: {
      "command": "message"
    }
  }, [(_vm.unreadMsg) ? _c('div', {
    staticClass: "redSpot"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tongzhi"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('notify.Notifications')))])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "user"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-yonghu1"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('user.title')))])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tuichu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.Logout')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line-class"
  }), _vm._v(" "), _c('div', {
    staticClass: "lang-box"
  }, [_c('ul', {
    staticClass: "lang-ul"
  }, [_c('li', {
    class: ['lang-item', {
      'active': _vm.isEn
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('en')
      }
    }
  }, [_vm._v("En")]), _vm._v(" "), _c('li', {
    class: ['lang-item', {
      'active': _vm.isZh_tw
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('zh_tw')
      }
    }
  }, [_vm._v("繁")]), _vm._v(" "), _c('li', {
    class: ['lang-item', {
      'active': _vm.isZh_cn
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('zh_cn')
      }
    }
  }, [_vm._v("简")])])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "isShowUser notify-dialog",
    attrs: {
      "title": _vm.$t('user.title'),
      "width": "360px",
      "lock-scroll": false,
      "close-on-click-modal": false,
      "center": "",
      "show-close": false,
      "visible": _vm.dialogUserVisible,
      "custom-class": "custom-dialogUser",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogUserVisible = $event
      }
    }
  }, [_c('el-upload', {
    attrs: {
      "id": "avatarUpload1",
      "action": "/api/share/picture/upload",
      "on-success": _vm.uploadSuccess,
      "before-upload": _vm.beforeImgUpload,
      "show-file-list": false,
      "name": "upfile",
      "list-type": "picture",
      "headers": _vm.headers
    }
  }, [_c('img', {
    staticClass: "login-img",
    attrs: {
      "src": _vm.loginImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_input"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputVisible),
      expression: "isInputVisible"
    }],
    staticClass: "user_text",
    attrs: {
      "title": _vm.userName
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isInputVisible),
      expression: "!isInputVisible"
    }],
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": _vm.$t('user.placeholder'),
      "autoComplete": "off",
      "id": "userName"
    },
    on: {
      "clear": _vm.clearInput,
      "input": function($event) {
        _vm.setlenght(_vm.userName, 12)
      },
      "blur": _vm.removeStyle
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.removeStyle($event)
      }
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tip",
    attrs: {
      "title": _vm.$t('user.tips')
    }
  }, [_vm._v(_vm._s(_vm.$t('user.tips')))]), _vm._v(" "), _c('div', {
    staticClass: "psw_box"
  }, [_c('span', {
    staticClass: "psw-change",
    on: {
      "click": _vm.showPsw
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PasswordChange')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer-ok",
    on: {
      "click": function($event) {
        _vm.submitUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user.OK')))]), _vm._v(" "), _c('el-button', {
    staticClass: "footer-cancel footer-cancen-btn",
    on: {
      "click": function($event) {
        _vm.closeUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user.Cancel')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "modifyPwd",
    attrs: {
      "title": _vm.$t('modifyPwd.PasswordChange'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogFormVisible,
      "custom-class": "custom-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "pwdForm",
    attrs: {
      "model": _vm.pwdForm,
      "rules": _vm.modifyPwdRule,
      "inline": true,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "id": "oldPwdItem",
      "prop": "oldPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "oldPwdInput",
      "id": "oldPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.OriginalPassword')))]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "oldPwdInput",
      "maxlength": 50,
      "name": "Input1",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('oldPwd')
      },
      "blur": function($event) {
        _vm.delActive('oldPwd')
      }
    },
    model: {
      value: (_vm.pwdForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "oldPwd", $$v)
      },
      expression: "pwdForm.oldPwd"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "newPwdItem",
      "prop": "newPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "newPwdInput",
      "id": "newPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.NewPassword')) + "\n                        "), _c('span', {
    staticClass: "hintInfo",
    attrs: {
      "id": "newPwdSpan"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PleaseInputMoreThan6DigitsPassword')))])]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "newPwdInput",
      "maxlength": 50,
      "name": "Input2",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('newPwd', 'newPwdSpan')
      },
      "blur": function($event) {
        _vm.delActive('newPwd', 'newPwdSpan')
      }
    },
    model: {
      value: (_vm.pwdForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newPwd", $$v)
      },
      expression: "pwdForm.newPwd"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "confirmPwdItem",
      "prop": "confirmPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "confirmPwdInput",
      "id": "confirmPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.Confirm')) + "\n                        "), _c('span', {
    staticClass: "hintInfo",
    attrs: {
      "id": "comfirmPwdSpan"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PleaseBeTheSameAsOriginalPassword')))])]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "confirmPwdInput",
      "maxlength": 50,
      "name": "Input3",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('confirmPwd', 'comfirmPwdSpan')
      },
      "blur": function($event) {
        _vm.delActive('confirmPwd', 'comfirmPwdSpan')
      }
    },
    model: {
      value: (_vm.pwdForm.confirmPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "confirmPwd", $$v)
      },
      expression: "pwdForm.confirmPwd"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer-ok",
    on: {
      "click": function($event) {
        _vm.submitForm('pwdForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.OK')))]), _vm._v(" "), _c('el-button', {
    staticClass: "footer-cancel footer-cancen-btn",
    on: {
      "click": function($event) {
        _vm.closeModifyPwd('pwdForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.Cancel')))])], 1)], 1), _vm._v(" "), (_vm.phone === '13501189583' || _vm.phone === '15018955912' || _vm.phone === 'Mok' || _vm.phone === '65263913' ? false : true) ? _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.notifyLoading),
      expression: "notifyLoading"
    }],
    staticClass: "notify-dialog",
    attrs: {
      "title": _vm.$t('notify.NotificationList'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": true,
      "visible": _vm.dialogMessage,
      "custom-class": "message-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMessage = $event
      }
    }
  }, [_c('ul', {
    staticClass: "notify-ul"
  }, _vm._l((_vm.notifyData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "notify-item",
      on: {
        "click": function($event) {
          _vm.showMsgDetail(item, index)
        }
      }
    }, [_c('div', [(item.readState == 0) ? _c('i') : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nofity-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "nofity-time"
    }, [_vm._v(_vm._s(_vm._f("parseTime")(item.addedDate, '{y}-{m}-{d}')))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "18px"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })), _vm._v(" "), _c('el-dialog', {
    staticClass: "notify-dialog notify-detail-dialog",
    attrs: {
      "title": _vm.$t('notify.NofiticationDetails'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogMsgDetail,
      "custom-class": "message-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMsgDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "notify-detail"
  }, [_c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.msgDetailData.title) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("parseTime")(_vm.msgDetailData.addedDate, '{y}-{m}-{d}')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "concentBox",
    domProps: {
      "innerHTML": _vm._s(_vm.nitifyContent)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer_ok",
    on: {
      "click": _vm.closeMsg
    }
  }, [_vm._v(_vm._s(_vm.$t('button.OK')))])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ecfcee3", module.exports)
  }
}

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "AUGu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TuQf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("73263227", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fd14bea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fd14bea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AkUR":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pkH5")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aret"),
  /* template */
  __webpack_require__("OBRG"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fce90fd",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\Layout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Layout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fce90fd", Component.options)
  } else {
    hotAPI.reload("data-v-5fce90fd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "AqkB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("koFB");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("213b0912", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73d89c54\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73d89c54\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DOpt":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("1BzD"),
  /* template */
  __webpack_require__("wCnr"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c422f19", Component.options)
  } else {
    hotAPI.reload("data-v-0c422f19", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "DxN1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7Iw2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("29ac30c0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c926d418\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c926d418\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Gay3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Hana":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Levelbar__ = __webpack_require__("N2mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabsView__ = __webpack_require__("jSdT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TabsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Hamburger__ = __webpack_require__("dahE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Hamburger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Hamburger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Screenfull__ = __webpack_require__("k0sJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Screenfull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ErrLog__ = __webpack_require__("QCgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ErrLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_ErrLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_errLog__ = __webpack_require__("t1CJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_api_merchant_index__ = __webpack_require__("U/Dg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_api_notify_index__ = __webpack_require__("Hedc");


















/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Levelbar: __WEBPACK_IMPORTED_MODULE_6__Levelbar___default.a, TabsView: __WEBPACK_IMPORTED_MODULE_7__TabsView___default.a, Hamburger: __WEBPACK_IMPORTED_MODULE_8_components_Hamburger___default.a, ErrorLog: __WEBPACK_IMPORTED_MODULE_10_components_ErrLog___default.a, Screenfull: __WEBPACK_IMPORTED_MODULE_9_components_Screenfull___default.a },
    data: function data() {
        var _this = this;

        var checkOldPwd = function checkOldPwd(rule, value, callback) {
            if (!value) {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputOriginalPassword")));
            } else if (value === "") {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputOriginalPassword")));
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_api_login__["a" /* checkPwd */])(_this.phone, value).then(function (res) {
                    if (res.code === 0) {
                        callback();
                    } else {
                        return callback(new Error(_this.$t("modifyPwd.PasswordIncorrect")));
                    }
                });
            }
        };
        var checkNewPwd = function checkNewPwd(rule, value, callback) {
            if (!value) {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputPassword")));
            } else if (value === "") {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputPassword")));
            } else if (value === _this.pwdForm.oldPwd) {
                return callback(new Error(_this.$t("modifyPwd.TheNewPasswordIsTheSameAsTheOldOne")));
            } else if (value.length < 6) {
                return callback(new Error(_this.$t("modifyPwd.NewPasswordLessThan6Digits")));
            } else {
                callback();
            }
        };
        var checkConfirmPwd = function checkConfirmPwd(rule, value, callback) {
            if (!value) {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputPasswordAgain")));
            }
            if (value === "") {
                return callback(new Error(_this.$t("modifyPwd.PleaseInputPasswordAgain")));
            } else if (value !== _this.pwdForm.newPwd) {
                return callback(new Error(_this.$t("modifyPwd.TheTwoPasswordsDoNotMatch")));
            } else {
                callback();
            }
        };
        return {
            headers: { "access-token": sessionStorage.getItem("access-token") },
            isZh_cn: localStorage.getItem("locale") === "zh_cn" ? true : false,
            isZh_tw: localStorage.getItem("locale") === "zh_tw" ? true : false,
            isEn: localStorage.getItem("locale") === "en" ? true : false,
            log: __WEBPACK_IMPORTED_MODULE_11_store_errLog__["a" /* default */].state.errLog,
            userName: localStorage.getItem("userName"),
            phone: localStorage.getItem("phone"),
            loginImg: localStorage.getItem("userLoginImg") ? localStorage.getItem("userLoginImg") : "http://unipock.img-cn-shenzhen.aliyuncs.com/201805/20180524110600636.png",
            pwdForm: {
                oldPwd: undefined,
                newPwd: undefined,
                confirmPwd: undefined
            },
            dialogFormVisible: false,
            dialogUserVisible: false,
            isInputVisible: true,
            modifyPwdRule: {
                oldPwd: [{ validator: checkOldPwd, trigger: "blur" }],
                newPwd: [{ validator: checkNewPwd, trigger: "blur" }],
                confirmPwd: [{ validator: checkConfirmPwd, trigger: "blur" }]
            },
            dialogMessage: false,
            notifyData: [],
            dialogMsgDetail: false,
            msgDetailData: {},
            notifyLoading: true,
            unreadMsg: false,
            nitifyContent: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["sidebar", "name", "avatar"])),
    mounted: function mounted() {
        $(".navbar-right").removeAttr("tabIndex");
        this.getNotifyList();
    },

    methods: {
        uploadSuccess: function uploadSuccess(res) {
            var _this2 = this;

            console.log(res, 'res-uploadSuccess');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_api_login__["b" /* modifyAvatar */])({
                userid: localStorage.getItem('access-userId'),
                url: res.value
            }).then(function (response) {
                if (response.code == 0) {
                    _this2.$notify({
                        title: _this2.$t("hint.Alert"),
                        message: _this2.$t("hint.ChangeOK"),
                        type: "success",
                        duration: 3000
                    });
                    _this2.loginImg = res.value;
                } else {
                    _this2.$notify({
                        title: _this2.$t("hint.Alert"),
                        message: _this2.$t("hint.ChangeFailed"),
                        type: "error",
                        duration: 3000
                    });
                }
            });
        },
        beforeImgUpload: function beforeImgUpload(file) {
            var isGIF = file.type === 'image/gif';
            var isLt5M = file.size / 1024 / 1024 < 5;
            if (isGIF) {
                this.$message(this.$t('modifyPwd.formatError'));
                return false;
            }
            if (!isLt5M) {
                this.$message(this.$t("hint.ThePictureSizeMustNotExceed5M"));
                return false;
            }
            return isLt5M;
        },
        setlenght: function setlenght(str, lenght) {
            var a = 0,
                b = void 0,
                content = void 0,
                newStr = '';
            content = str;
            for (var i = 0; i < content.length; i++) {
                if (content[i].charCodeAt() > 0 && content[i].charCodeAt() < 255) {
                    a += 1;
                } else {
                    a += 2;
                }
                if (a <= lenght) {
                    console.log(length, 'jinru');
                    newStr += content[i].charAt();
                }
            }
            b = a > length;
            if (b) {
                this.userName = newStr;
            }
        },
        removeStyle: function removeStyle() {
            console.log('改變時間事件');
            if (this.userName === "" || !this.userName) {
                this.$message({
                    showClose: true,
                    message: this.$t("user.qualified1"),
                    type: 'warning'
                });
                this.userName = "";
                this.isInputVisible = false;
            } else if (!this.userName.match("^[a-zA-Z0-9_\u4E00-\u9FA5]+$")) {
                this.$message({
                    showClose: true,
                    message: this.$t("user.qualified3"),
                    type: 'warning'
                });
                this.userName = "";
                this.isInputVisible = false;
            } else {
                this.isInputVisible = true;
            }
        },
        clearInput: function clearInput() {
            this.userName = "";
            this.isInputVisible = false;
        },
        showInput: function showInput() {
            console.log('點擊事件');
            this.isInputVisible = false;
        },
        showPsw: function showPsw() {
            this.dialogFormVisible = true;
            this.dialogUserVisible = false;
            if (this.userName === "") {
                this.userName = localStorage.getItem("userName");
            }
        },
        closeMsg: function closeMsg() {
            this.dialogMsgDetail = false;
            this.msgDetailData = {};
            for (var i = 0; i < this.notifyData.length; i++) {
                if (this.notifyData[i].readState == 0) {
                    this.unreadMsg = true;
                    break;
                } else {
                    this.unreadMsg = false;
                }
            }
        },
        showMsgDetail: function showMsgDetail(item, index) {
            this.msgDetailData = item;
            if (item.msgType == 1 || item.msgType == 2) this.nitifyContent = this.msgDetailData.body;else this.nitifyContent = this.msgDetailData.body.slice(this.msgDetailData.body.indexOf('</h2>') + 5);
            this.dialogMsgDetail = true;
            if (item.readState == 0) {
                this.updateMsgState(item, index);
            }
        },
        addActive: function addActive(id, spanId) {
            $("#" + id).next().children().removeAttr("readonly");

            $("#" + id).addClass("active");
            if (spanId === null) {
                return false;
            } else {
                $("#" + spanId).addClass("hidden");
            }
        },
        delActive: function delActive(id, spanId) {
            if (this.pwdForm[id] === "" || this.pwdForm[id] === null || this.pwdForm[id] === undefined) {
                $("#" + id).removeClass("active");
            } else {
                return false;
            }
            if (spanId === null) {
                return false;
            } else {
                $("#" + spanId).removeClass("hidden");
            }
        },
        closeUser: function closeUser() {
            this.dialogUserVisible = false;
            this.isInputVisible = true;
            this.userName = localStorage.getItem("userName");
        },
        closeModifyPwd: function closeModifyPwd(formRule) {
            this.dialogFormVisible = false;
            this.dialogUserVisible = true;
            this.isInputVisible = true;
            this.$refs[formRule].resetFields();
            this.pwdForm.oldPwd = undefined;
            this.pwdForm.newPwd = undefined;
            this.pwdForm.confirmPwd = undefined;
            $("#oldPwd").removeClass("active");
            $("#newPwd").removeClass("active");
            $("#confirmPwd").removeClass("active");
            $("#newPwdSpan").removeClass("hidden");
            $("#comfirmPwdSpan").removeClass("hidden");
        },
        toggleSideBar: function toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        changeLocale: function changeLocale(value) {
            var _this3 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_api_merchant_index__["a" /* queryIndustry */])(localStorage.getItem("locale") === "en" ? "1" : "0").then(function (res) {
                if (res.code == 0) {
                    localStorage.setItem("locale", value);
                    _this3.$i18n.locale = value;
                    localStorage.setItem("queryIndustryObj", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(res.value));
                    location.reload();
                }
            });
        },
        showLocale: function showLocale() {
            $(".localeUl").toggleClass("toggle");
            $(".toggleImgBox").toggleClass("toggleImgBox1");
            $(".toggleLi").toggleClass("toggleLi1");
        },
        logout: function logout() {
            sessionStorage.removeItem("access-token");
            sessionStorage.removeItem("hideTestData");
            localStorage.clear();
            location.reload();
        },
        submitForm: function submitForm(form) {
            var _this4 = this;

            this.$refs[form].validate(function (valid) {
                if (valid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_api_login__["c" /* modifyPwd */])({
                        phone: _this4.phone,
                        password: _this4.pwdForm.oldPwd,
                        newPassword: _this4.pwdForm.newPwd
                    }).then(function (res) {
                        if (res.code === 0) {
                            _this4.closeModifyPwd("pwdForm");
                            _this4.$notify({
                                title: _this4.$t("hint.Alert"),
                                message: _this4.$t("hint.OperationSuccess"),
                                type: "success",
                                duration: 2000
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        submitUser: function submitUser() {
            var _this5 = this;

            if (this.userName === "" || !this.userName) {
                this.$message({
                    showClose: true,
                    message: this.$t("user.qualified2"),
                    type: 'warning'
                });
                return false;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_api_login__["d" /* modifyUser */])({
                id: localStorage.getItem("access-userId"),
                userName: this.userName
            }).then(function (res) {
                console.log('res-submitUser: ', res);
                if (res.code === 0) {
                    localStorage.setItem("userName", _this5.userName);
                    _this5.closeUser();
                    _this5.$notify({
                        title: _this5.$t("hint.Alert"),
                        message: _this5.$t("hint.OperationSuccess"),
                        type: "success",
                        duration: 2000
                    });
                }
            });
        },
        handleCommand: function handleCommand(command) {
            if (command == "user") {
                this.dialogUserVisible = true;
            } else if (command == "logout") {
                this.logout();
            } else {
                this.dialogMessage = true;
            }
        },
        getNotifyList: function getNotifyList() {
            var _this6 = this;

            var _that = this;
            var obj = {};
            obj.companyId = localStorage.getItem("companyId");
            obj.userId = localStorage.getItem("access-userId");

            var msg = {};
            var currency = void 0;
            if (obj.companyId == "1") currency = "HK$ ";
            if (obj.companyId == "2") currency = "A$ ";
            if (obj.companyId == "3") currency = "MOP$ ";
            var actions = function actions() {
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([[/^00[0-4]+/, function () {
                    if (key.substr(2, 1) == 0) {
                        return msg = {
                            title: _this6.$t('notify.Merchant') + _this6.$t('notify.registrationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Merchant') + _this6.$t('notify.registrationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 1) {
                        return msg = {
                            title: _this6.$t('notify.Shop') + _this6.$t('notify.registrationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Shop') + _this6.$t('notify.registrationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 2) {
                        return msg = {
                            title: _this6.$t('notify.Agent') + _this6.$t('notify.registrationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Agent') + _this6.$t('notify.registrationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 3) {
                        return msg = {
                            title: _this6.$t('notify.Company') + _this6.$t('notify.registrationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Company') + _this6.$t('notify.registrationYouSubmittedHasBeenApproved')
                        };
                    }
                }], [/^01[0-4]+/, function () {
                    if (key.substr(2, 1) == 0) {
                        return msg = {
                            title: _this6.$t('notify.Merchant') + _this6.$t('notify.registrationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Merchant') + _this6.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 1) {
                        return msg = {
                            title: _this6.$t('notify.Shop') + _this6.$t('notify.registrationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Shop') + _this6.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 2) {
                        return msg = {
                            title: _this6.$t('notify.Agent') + _this6.$t('notify.registrationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Agent') + _this6.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 3) {
                        return msg = {
                            title: _this6.$t('notify.Company') + _this6.$t('notify.registrationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Company') + _this6.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                }], [/^10[0-4]+/, function () {
                    if (key.substr(2, 1) == 0) {
                        return msg = {
                            title: _this6.$t('notify.Merchant') + _this6.$t('notify.informationModificationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Merchant') + _this6.$t('notify.informationModificationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 1) {
                        return msg = {
                            title: _this6.$t('notify.Shop') + _this6.$t('notify.informationModificationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Shop') + _this6.$t('notify.informationModificationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 2) {
                        return msg = {
                            title: _this6.$t('notify.Agent') + _this6.$t('notify.informationModificationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Agent') + _this6.$t('notify.informationModificationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 3) {
                        return msg = {
                            title: _this6.$t('notify.Company') + _this6.$t('notify.informationModificationApproved'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Company') + _this6.$t('notify.informationModificationYouSubmittedHasBeenApproved')
                        };
                    }
                    if (key.substr(2, 1) == 4) {
                        if (localStorage.getItem('locale') == 'en') {
                            return msg = {
                                title: _this6.$t('notify.withdrawalApplicationApproved'),
                                body: _this6.$t('notify.theWithdrawalApplicationOf') + currency + money + _this6.$t('notify.on') + time + _this6.$t('notify.youSubmittedHasBeenApproved')
                            };
                        }
                        if (localStorage.getItem('locale') != 'en') {
                            return msg = {
                                title: _this6.$t('notify.withdrawalApplicationApproved'),
                                body: _this6.$t('notify.theWithdrawalApplicationOf') + time + _this6.$t('notify.on') + currency + money + _this6.$t('notify.youSubmittedHasBeenApproved')
                            };
                        }
                    }
                }], [/^11[0-4]+/, function () {
                    if (key.substr(2, 1) == 0) {
                        return msg = {
                            title: _this6.$t('notify.Merchant') + _this6.$t('notify.informationModificationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Merchant') + _this6.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 1) {
                        return msg = {
                            title: _this6.$t('notify.Shop') + _this6.$t('notify.informationModificationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Shop') + _this6.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 2) {
                        return msg = {
                            title: _this6.$t('notify.Agent') + _this6.$t('notify.informationModificationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Agent') + _this6.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 3) {
                        return msg = {
                            title: _this6.$t('notify.Company') + _this6.$t('notify.informationModificationRejected'),
                            body: _this6.$t('notify.the') + "“" + name + "”" + _this6.$t('notify.Company') + _this6.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons
                        };
                    }
                    if (key.substr(2, 1) == 4) {
                        if (localStorage.getItem('locale') == 'en') {
                            return msg = {
                                title: _this6.$t('notify.withdrawalApplicationRejected'),
                                body: _this6.$t('notify.theWithdrawalApplicationOf') + currency + money + _this6.$t('notify.on') + time + _this6.$t('notify.youSubmittedHasBeenRejectedRejectReason') + rejectReasons
                            };
                        }
                        if (localStorage.getItem('locale') != 'en') {
                            return msg = {
                                title: _this6.$t('notify.withdrawalApplicationRejected'),
                                body: _this6.$t('notify.theWithdrawalApplicationOf') + time + _this6.$t('notify.on') + currency + money + _this6.$t('notify.youSubmittedHasBeenRejectedRejectReason') + rejectReasons
                            };
                        }
                    }
                }]]);
            };
            var info = void 0,
                name = void 0,
                rejectReasons = void 0;
            var key = void 0;
            var action = void 0;
            var time = void 0,
                money = void 0;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_api_notify_index__["a" /* findMessageListByUserId */])(obj).then(function (res) {
                if (res.code == 0) {
                    _this6.notifyData = res.value.rows;

                    for (var i = 0; i < _that.notifyData.length; i++) {
                        if (_that.notifyData[i].msgType != 0) {
                            info = JSON.parse(_that.notifyData[i].title);
                            rejectReasons = _that.notifyData[i].content;
                            if (_that.notifyData[i].msgType == 1) {
                                name = _that.notifyData[i].body;
                                key = info.remarks + info.status + info.type;
                            } else if (_that.notifyData[i].msgType == 2) {
                                time = JSON.parse(_that.notifyData[i].body).time;
                                money = _that.fmoney(JSON.parse(_that.notifyData[i].body).money);
                                key = '1' + info.status + info.type;
                            }

                            action = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(actions())).filter(function (_ref) {
                                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                                    item = _ref2[0],
                                    value = _ref2[1];

                                return item.test(key);
                            });
                            action.forEach(function (_ref3) {
                                var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                                    item = _ref4[0],
                                    value = _ref4[1];

                                return value.call(_this6);
                            });
                            _that.notifyData[i].title = msg.title;
                            _that.notifyData[i].body = msg.body;
                            _that.notifyData[i].content = msg.body;
                        }
                    }
                    for (var _i = 0; _i < _that.notifyData.length; _i++) {
                        if (_that.notifyData[_i].readState == 0) {
                            _that.unreadMsg = true;
                            break;
                        }
                    }
                }
            });
        },
        updateMsgState: function updateMsgState(item, index) {
            var _this7 = this;

            var obj = {
                id: item.id,
                readState: 1
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_api_notify_index__["b" /* updateMessage */])(obj).then(function (res) {
                if (res.code == 0) {
                    _this7.notifyData[index].readState = 1;
                }
            });
        },
        fmoney: function fmoney(s) {
            if (s === "" || s === undefined) return s = "0.00";
            s = s / 100;
            var n = 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s.split(".")[0].split("").reverse(),
                r = s.split(".")[1];
            var t = "";
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            t = t.split("").reverse().join("") + "." + r;
            if (t.includes("-")) {
                var _n = t.indexOf("-") + 1;
                if (t[_n] == ",") {
                    t = "-" + t.substring(_n + 1);
                }
            }
            return t;
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ "Hedc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = findMessageList;
/* harmony export (immutable) */ __webpack_exports__["a"] = findMessageListByUserId;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = sendMeassge;
/* harmony export (immutable) */ __webpack_exports__["g"] = findCashier;
/* harmony export (immutable) */ __webpack_exports__["e"] = findFinancial;
/* harmony export (immutable) */ __webpack_exports__["d"] = findFirm;
/* harmony export (immutable) */ __webpack_exports__["f"] = findBD;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_fetch__ = __webpack_require__("Vo7i");


function findMessageList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/message/findMessageList',
    method: 'post',
    data: data
  });
}

function findMessageListByUserId(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/message/findMessageListByUserId',
    method: 'post',
    data: data
  });
}

function updateMessage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/message/updateMessageReceiverById',
    method: 'post',
    data: data
  });
}

function sendMeassge(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/message/sendMeassge',
    method: 'post',
    data: data
  });
}

function findCashier(shopId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/findCashierByShopId/' + shopId,
    method: 'get'
  });
}

function findFinancial(companyId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/findFinancialByCompanyId/' + companyId,
    method: 'get'
  });
}

function findFirm(companyId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/findFirmBycompanyId/' + companyId,
    method: 'get'
  });
}

function findBD(companyId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/findSalesmanBycompanyId/' + companyId,
    method: 'get'
  });
}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permission__ = __webpack_require__("19nU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_4__modules_permission__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KqwA":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    staticStyle: {
      "min-height": "100%"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50d0e037", module.exports)
  }
}

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("kLoR")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xJD8"),
  /* template */
  __webpack_require__("7aEP"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eca5e0e0", Component.options)
  } else {
    hotAPI.reload("data-v-eca5e0e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = loginByEmail;
/* unused harmony export logout */
/* harmony export (immutable) */ __webpack_exports__["h"] = getInfo;
/* harmony export (immutable) */ __webpack_exports__["g"] = getUserType;
/* harmony export (immutable) */ __webpack_exports__["c"] = modifyPwd;
/* harmony export (immutable) */ __webpack_exports__["d"] = modifyUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkPwd;
/* harmony export (immutable) */ __webpack_exports__["e"] = resetPwd;
/* harmony export (immutable) */ __webpack_exports__["b"] = modifyAvatar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_fetch__ = __webpack_require__("Vo7i");


function loginByEmail(phone, password) {
  var data = {
    phone: phone,
    password: password
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/auth/token',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/jwt/invalid',
    method: 'post'
  });
}

function getInfo(token) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/auth/user',
    method: 'get',
    data: token
  });
}

function getUserType(userId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/group/getUserIdSelectRoleType/' + userId,
    method: 'get'
  });
}

function modifyPwd(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/changePassword',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function modifyUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/updateAccountSelective',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkPwd(phone, password) {
  var data = {
    phone: phone,
    password: password
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/auth/checkPassword',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function resetPwd(userId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/auth/user/resetPassword/' + userId,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function modifyAvatar(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/auth/userExtend/alterImg',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

/***/ }),

/***/ "N2mp":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("88h1")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("3zpo"),
  /* template */
  __webpack_require__("lKZY"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a0c7aa2",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\Levelbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Levelbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a0c7aa2", Component.options)
  } else {
    hotAPI.reload("data-v-4a0c7aa2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_iconfont_iconfont__ = __webpack_require__("f8sx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_iconfont_iconfont___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_iconfont_iconfont__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Sticky__ = __webpack_require__("vHhr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_Sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Icon_svg__ = __webpack_require__("xNsp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_Icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directive_waves__ = __webpack_require__("4SVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_store_errLog__ = __webpack_require__("t1CJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_lang_en_js__ = __webpack_require__("/uab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_lang_zh_cn_js__ = __webpack_require__("QFvO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_lang_zh_tw_js__ = __webpack_require__("UsXh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__("gwsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_locale_lang_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_ifvisible_js__ = __webpack_require__("n47Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_ifvisible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_ifvisible_js__);




































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_13_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('Sticky', __WEBPACK_IMPORTED_MODULE_15_components_Sticky___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('icon-svg', __WEBPACK_IMPORTED_MODULE_16_components_Icon_svg___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_i18n__["a" /* default */]);

var messages = {
  en: __WEBPACK_IMPORTED_MODULE_21__common_lang_en_js__["a" /* default */],
  zh_cn: __WEBPACK_IMPORTED_MODULE_22__common_lang_zh_cn_js__["a" /* default */],
  zh_tw: __WEBPACK_IMPORTED_MODULE_23__common_lang_zh_tw_js__["a" /* default */]
};


if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'en');
}

var i18n = new __WEBPACK_IMPORTED_MODULE_20_vue_i18n__["a" /* default */]({
  locale: localStorage.getItem('locale'),
  messages: messages });

var locale = void 0;
if (localStorage.getItem('locale') === 'en') {
  locale = __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en___default.a;
} else if (localStorage.getItem('locale') === 'zh_cn') {
  locale = __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_zh_CN___default.a;
} else if (localStorage.getItem('locale') === 'zh_tw') {
  locale = __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_locale_lang_zh_TW___default.a;
}

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, {
  locale: locale
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({ i18n: i18n }).$mount('#app');

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__directive_waves__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_12__filters__[key]);
});

var whiteList = ['/login', '/authredirect'];
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  $('html').css({
    'background-color': '#fff'
  });
  $(".sidebar-container .el-menu--inline .el-menu-item").removeClass('is-active');
  __WEBPACK_IMPORTED_MODULE_8_nprogress___default.a.start();
  if (sessionStorage.getItem("access-token")) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.menus === undefined) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('GetInfo').then(function (info) {
          var menus = {};

          for (var i = 0; i < info.value.menus.length; i++) {
            menus[info.value.menus[i].code] = true;
          }
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('GenerateRoutes', menus).then(function () {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.addRouters);
            next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to));
          });
        }).catch(function (error) {
          console.log(error);
          sessionStorage.removeItem('access-token');
          next({
            path: '/login'
          });
          __WEBPACK_IMPORTED_MODULE_8_nprogress___default.a.done();
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      __WEBPACK_IMPORTED_MODULE_8_nprogress___default.a.done();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_8_nprogress___default.a.done();
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

if (true) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.errorHandler = function (err, vm) {
    console.log(err, window.location.href);
    __WEBPACK_IMPORTED_MODULE_18_store_errLog__["a" /* default */].pushLog({
      err: err,
      url: window.location.href,
      vm: vm
    });
  };
}
var timeId = void 0;
__WEBPACK_IMPORTED_MODULE_27_ifvisible_js___default.a.setIdleDuration(10);
__WEBPACK_IMPORTED_MODULE_27_ifvisible_js___default.a.on("idle", function () {
  clearTimeout(timeId);

  timeId = setTimeout(function () {
    var timeMsg = void 0;
    if (localStorage.getItem('locale') === 'zh_cn') {
      timeMsg = '闲置时间过长，请重新登录';
    } else if (localStorage.getItem('locale') === 'zh_tw') {
      timeMsg = '閒置時間過長，請重新登入';
    } else {
      timeMsg = 'Idle for too long, please re-login';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: timeMsg, duration: 3 * 1000 });

    setTimeout(function () {
      sessionStorage.removeItem('access-token');
      localStorage.clear();
      location.reload();
    }, 4000);

    clearTimeout(timeId);
  }, 1800000);
});
__WEBPACK_IMPORTED_MODULE_27_ifvisible_js___default.a.on("blur", function () {
  clearTimeout(timeId);

  timeId = setTimeout(function () {
    var timeMsg = void 0;
    if (localStorage.getItem('locale') === 'zh_cn') {
      timeMsg = '闲置时间过长，请重新登录';
    } else if (localStorage.getItem('locale') === 'zh_tw') {
      timeMsg = '閒置時間過長，請重新登入';
    } else {
      timeMsg = 'Idle for too long, please re-login';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: timeMsg, duration: 3 * 1000 });

    setTimeout(function () {
      sessionStorage.removeItem('access-token');
      localStorage.clear();
      location.reload();
    }, 4000);

    clearTimeout(timeId);
  }, 1800000);
});
__WEBPACK_IMPORTED_MODULE_27_ifvisible_js___default.a.on("wakeup", function () {
  clearTimeout(timeId);
});

var vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_7__App___default.a
  }
});

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S": this.getMilliseconds() };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }return fmt;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ "OBRG":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('el-tooltip', {
    class: [{
      'width100': _vm.isShrinkage
    }],
    attrs: {
      "effect": "light",
      "disabled": _vm.toggleMer,
      "visible-arrow": false,
      "placement": "right",
      "popper-class": "tooltip_toggle"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    on: {
      "click": _vm.switchSystem
    },
    slot: "content"
  }, [_c('img', {
    staticClass: "switch-img",
    attrs: {
      "src": __webpack_require__("1hxP"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-logo",
    attrs: {
      "index": "top"
    }
  }, [_c('div', {
    staticClass: "menu-logo-wrapper unipay-div",
    style: (_vm.companyId != 2 ? 'top:0;z-index:2000' : 'top:-78px;z-index:1')
  }, [_c('img', {
    class: ['logo-img', {
      'logo-shrink-img': _vm.isShrinkage
    }],
    attrs: {
      "src": __webpack_require__("Z39e")
    }
  }), _vm._v(" "), _c('div', {
    class: ['divide-line', {
      'hide-el': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    class: ['logo-system', {
      'hide-el': _vm.isShrinkage
    }]
  }, [_vm._v("Unipay")])]), _vm._v(" "), (_vm.whiteLabel == 'N' || _vm.whiteLabel == 'undefined') ? _c('div', {
    staticClass: "menu-logo-wrapper mipay-div",
    style: (_vm.companyId == 2 ? 'top:0;z-index:2000' : 'top:-78px;z-index:1')
  }, [_c('img', {
    class: ['logo-img', {
      'logo-shrink-img': _vm.isShrinkage
    }],
    attrs: {
      "src": __webpack_require__("Gay3")
    }
  }), _vm._v(" "), _c('div', {
    class: ['divide-line', {
      'hide-el': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    class: ['logo-system', {
      'hide-el': _vm.isShrinkage
    }]
  }, [_vm._v("MiPay")])]) : _vm._e()])]), _vm._v(" "), _c('sidebar', {
    class: ['sidebar-container', {
      'sidebar-container-shrinkage': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle",
    class: [{
      'width100': _vm.isShrinkage
    }],
    attrs: {
      "index": "bottom"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-slide-icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggleSildeBar
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-hamburger"
    }
  })])]), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('div', {
    class: ['main-container', {
      'main-container-shrinkage': _vm.isShrinkage
    }]
  }, [(_vm.isRouterAlive) ? _c('app-main') : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fce90fd", module.exports)
  }
}

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/gateLog/index.vue": [
		"S1Sh",
		87
	],
	"./admin/group/components/groupAuthority.vue": [
		"firN",
		77
	],
	"./admin/group/components/groupDetail.vue": [
		"Ffe0",
		85
	],
	"./admin/group/components/groupUser.vue": [
		"jmoS",
		76
	],
	"./admin/group/index.vue": [
		"r7bU",
		34
	],
	"./admin/groupType/index.vue": [
		"swy7",
		86
	],
	"./admin/index.vue": [
		"x0vE",
		98
	],
	"./admin/menu/components/element.vue": [
		"O03E",
		0
	],
	"./admin/menu/index.vue": [
		"6Vqe",
		93
	],
	"./admin/user/index.vue": [
		"cgTB",
		84
	],
	"./charts/index.vue": [
		"GX1H",
		97
	],
	"./charts/keyboard.vue": [
		"vGRE",
		42,
		102
	],
	"./charts/keyboard2.vue": [
		"V4P/",
		41,
		102
	],
	"./charts/line.vue": [
		"q/Nx",
		40,
		102
	],
	"./charts/mixChart.vue": [
		"P2bu",
		102,
		39
	],
	"./components/avatarUpload.vue": [
		"czzu",
		17
	],
	"./components/backToTop.vue": [
		"OxUa",
		43
	],
	"./components/countTo.vue": [
		"yO85",
		72
	],
	"./components/dndlist.vue": [
		"uxvo",
		26
	],
	"./components/dropzone.vue": [
		"eBLZ",
		24
	],
	"./components/index.vue": [
		"DT/a",
		96
	],
	"./components/jsoneditor.vue": [
		"0AHb",
		8
	],
	"./components/markdown.vue": [
		"NlNW",
		4
	],
	"./components/mixin.vue": [
		"YVvD",
		21
	],
	"./components/splitpane.vue": [
		"oD1W",
		10
	],
	"./components/sticky.vue": [
		"PBxb",
		75
	],
	"./components/tinymce.vue": [
		"LkOT",
		20
	],
	"./dashboard/editor/barChart.vue": [
		"G/pg",
		102,
		92
	],
	"./dashboard/editor/index.vue": [
		"DY7s",
		102,
		2
	],
	"./dashboard/editor/lineChart.vue": [
		"px2r",
		83,
		102
	],
	"./dashboard/editor/pieChart.vue": [
		"oluO",
		91,
		102
	],
	"./dashboard/index.vue": [
		"ARoL",
		102,
		1
	],
	"./errlog/errcode.vue": [
		"PT2v",
		95
	],
	"./errlog/index.vue": [
		"F+z8",
		50
	],
	"./error/401.vue": [
		"3RDD",
		71
	],
	"./error/404.vue": [
		"34W9",
		49
	],
	"./example/form.vue": [
		"Lby4",
		3
	],
	"./example/tab/components/tabPane.vue": [
		"+NrA",
		82
	],
	"./example/tab/index.vue": [
		"dIv6",
		33
	],
	"./example/table/dragTable.vue": [
		"FQgX",
		48
	],
	"./example/table/dynamictable.vue": [
		"mWT0",
		32
	],
	"./example/table/dynamictable/fixedThead.vue": [
		"zKV+",
		90
	],
	"./example/table/dynamictable/unfixedThead.vue": [
		"E0HR",
		89
	],
	"./example/table/index.vue": [
		"plNp",
		94
	],
	"./example/table/inlineEditTable.vue": [
		"Cnbe",
		81
	],
	"./example/table/table.vue": [
		"UVw1",
		74
	],
	"./excel/index.vue": [
		"OqES",
		80
	],
	"./excel/selectExcel.vue": [
		"zNV3",
		79
	],
	"./layout/AppMain.vue": [
		"TAmc"
	],
	"./layout/Layout.vue": [
		"AkUR"
	],
	"./layout/Levelbar.vue": [
		"N2mp"
	],
	"./layout/Navbar.vue": [
		"kzJD"
	],
	"./layout/Sidebar.vue": [
		"DOpt"
	],
	"./layout/SidebarItem.vue": [
		"6o49"
	],
	"./layout/TabsView.vue": [
		"jSdT"
	],
	"./login/authredirect.vue": [
		"+abo",
		99
	],
	"./login/index.vue": [
		"T+/8",
		25
	],
	"./login/socialsignin.vue": [
		"dZXH",
		70
	],
	"./permission/index.vue": [
		"V9V6",
		88
	],
	"./qiniu/upload.vue": [
		"nOMn",
		78
	],
	"./theme/index.vue": [
		"7bVT",
		69
	],
	"./welcome/index.vue": [
		"ZO6g",
		102,
		5
	],
	"./z_SalesmanManage/index.vue": [
		"oZId",
		38
	],
	"./z_advert/index.vue": [
		"R0DW",
		68
	],
	"./z_advert/sonViews/adData.vue": [
		"eySR",
		102,
		16
	],
	"./z_auditManage/agentAudit/index.vue": [
		"JhFt",
		67
	],
	"./z_auditManage/firmAudit/index.vue": [
		"DQbO",
		66
	],
	"./z_auditManage/imprestAudit/index.vue": [
		"OdM8",
		65
	],
	"./z_auditManage/merAudit/index.vue": [
		"tsZc",
		64
	],
	"./z_auditManage/refundAudit/index.vue": [
		"RlQY",
		73
	],
	"./z_auditManage/shopAudit/index.vue": [
		"PGSZ",
		63
	],
	"./z_auditManage/sonViews/agentAuditDetails.vue": [
		"sQub",
		29
	],
	"./z_auditManage/sonViews/agentAuditRecord.vue": [
		"FwMs",
		62
	],
	"./z_auditManage/sonViews/firmAuditDetails.vue": [
		"4lkN",
		28
	],
	"./z_auditManage/sonViews/firmAuditRecord.vue": [
		"DMAk",
		61
	],
	"./z_auditManage/sonViews/merAuditDetails.vue": [
		"jSNx",
		23
	],
	"./z_auditManage/sonViews/merAuditRecord.vue": [
		"V+pw",
		60
	],
	"./z_auditManage/sonViews/shopAuditDetails.vue": [
		"3UPt",
		27
	],
	"./z_auditManage/sonViews/shopAuditRecord.vue": [
		"wf03",
		59
	],
	"./z_businessManagement/agent/index.vue": [
		"/P6u",
		58
	],
	"./z_businessManagement/firm/index.vue": [
		"3Jqc",
		57
	],
	"./z_businessManagement/merchant/index.vue": [
		"DWE3",
		47
	],
	"./z_businessManagement/notify/index.vue": [
		"1Myc",
		37
	],
	"./z_businessManagement/opinion/index.vue": [
		"a0DH",
		15
	],
	"./z_businessManagement/sonViews/agentManage.vue": [
		"BV47",
		56
	],
	"./z_businessManagement/sonViews/editNotify.vue": [
		"1JEZ",
		19
	],
	"./z_businessManagement/sonViews/firmDetails.vue": [
		"hpYK",
		46
	],
	"./z_businessManagement/sonViews/merDetails.vue": [
		"h6qX",
		45
	],
	"./z_businessManagement/sonViews/shop.vue": [
		"xNgB",
		18
	],
	"./z_deviceManagement/index.vue": [
		"1Tyn",
		6
	],
	"./z_mechanism/components/mecAdd.vue": [
		"ktO0",
		55
	],
	"./z_mechanism/mechanism/index.vue": [
		"jwKW",
		22
	],
	"./z_merchantWithdrawCash/fund/index.vue": [
		"35ai",
		14
	],
	"./z_merchantWithdrawCash/profit/index.vue": [
		"Iu7q",
		13
	],
	"./z_merchantWithdrawCash/settlement/index.vue": [
		"JtxN",
		12
	],
	"./z_merchantWithdrawCash/sonViews/fundRechargeRecord.vue": [
		"p1eI",
		54
	],
	"./z_merchantWithdrawCash/sonViews/fundRefundRecord.vue": [
		"qoHy",
		53
	],
	"./z_merchantWithdrawCash/withdrawAudit/index.vue": [
		"XsZ8",
		52
	],
	"./z_merchantWithdrawCash/withdrawal/index.vue": [
		"9Ywq",
		11
	],
	"./z_riskControl/index.vue": [
		"MeMo",
		31
	],
	"./z_riskControl/merchantControl/index.vue": [
		"aIHe",
		30
	],
	"./z_riskControl/report/index.vue": [
		"L+x4",
		7
	],
	"./z_riskControl/riskMonitor/index.vue": [
		"CSEp",
		36
	],
	"./z_riskControl/riskReport/index.vue": [
		"46tJ",
		35
	],
	"./z_riskControl/ruleSettings/index.vue": [
		"/6O1",
		51
	],
	"./z_tradeManagement/customs/index.vue": [
		"laWY",
		44
	],
	"./z_tradeManagement/tradingFlow/index.vue": [
		"U60u",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "Opzk";

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["timeAgo"] = timeAgo;
/* harmony export (immutable) */ __webpack_exports__["parseTime"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["formatTime"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["nFormatter"] = nFormatter;
/* harmony export (immutable) */ __webpack_exports__["html2Text"] = html2Text;
/* harmony export (immutable) */ __webpack_exports__["toThousandslsFilter"] = toThousandslsFilter;
/* harmony export (immutable) */ __webpack_exports__["personalFormat"] = personalFormat;
/* harmony export (immutable) */ __webpack_exports__["camtData"] = camtData;
/* harmony export (immutable) */ __webpack_exports__["fMoney"] = fMoney;
/* harmony export (immutable) */ __webpack_exports__["fMoneyFilter"] = fMoneyFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}
function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if ((time + '').length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) == 'object') {
    date = time;
  } else if (typeof time == 'string') {
    date = new Date(time);
  } else {
    date = new Date(parseInt(time));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

function nFormatter(num, digits) {
  var si = [{ value: 1E18, symbol: 'E' }, { value: 1E15, symbol: 'P' }, { value: 1E12, symbol: 'T' }, { value: 1E9, symbol: 'G' }, { value: 1E6, symbol: 'M' }, { value: 1E3, symbol: 'k' }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

function personalFormat(val) {
  console.log('转换personal');
  return val === 'Y' ? '线下' : '线上';
}

function camtData(formaString) {
  var lastFormaString = formaString / 100;
  return lastFormaString;
}

function fMoney(s) {
  if ((typeof s === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(s)) == undefined) return;
  var flag = false;
  s = s + '';
  if (s.indexOf('-') != -1) {
    flag = true;
    s = s.substring(s.indexOf('-') + 1);
  }
  s = s / 100;
  var n = 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
  var t = "";
  for (var i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
  }
  var result = t.split("").reverse().join("") + "." + r;
  if (flag == true) return result = '-' + result;
  return result;
}

function fMoneyFilter(s) {
  s = Math.abs(s);
  return s;
}

/***/ }),

/***/ "QCgX":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("AUGu")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("pJuz"),
  /* template */
  __webpack_require__("srSI"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fd14bea",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\components\\ErrLog\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3fd14bea", Component.options)
  } else {
    hotAPI.reload("data-v-3fd14bea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "QFvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__);


var _hint, _mer, _mec, _inputBox, _newcash, _cash, _notify;


/* harmony default export */ __webpack_exports__["a"] = ({
  message: '系统登录',
  welecome: '欢迎',
  layer: {
    toggle: '您确定要切换语言版本吗?',
    tips: '语言切换',
    welcome: '欢迎使用！'
  },
  button: {
    humilis: '保存成功',
    search: '搜索',
    Reset: '清空',
    New: '新增',
    New1: '新增',
    NewMer: '新增商户',
    NewDevice: '新增设备',
    NewAgent: '新增代理商',
    NewSalesman: '新增业务员',
    Modify: '修改',
    OK: '确定',
    Cancel: '取消',
    Shops: '店铺',
    Shops1: '店铺',
    Shops2: '店铺列表',
    Merchant: '商户',
    Enabled: '启用',
    Enabled1: '启用',
    Enabled2: '启用',
    Suspended: '停用',
    Suspended1: '停用',
    Suspended2: '停用',
    Suspended3: '停用',
    Approval: '审核',
    Approve: '审核通过',
    Approve1: '审核不通过',
    Reject: '拒绝',
    Reject1: '拒绝',
    EnterDetail: '进入详情',
    Return: '返回',
    RefreshStatus: '刷新交易状态',
    SaveResult: '导出搜索结果',
    delete: '删除',
    Resubmit: '重新提交',
    Manage: '管理',
    Refresh: '刷新',
    Close: '关闭',

    view: '查看大图',

    loading: '加载中',
    sending: '发送中',
    colon: '：',
    save: '保存',
    saveTime: '保存时间',
    saveMer: '已保存商户',
    cancelMer: '未保存商户',
    edit: '编辑'
  },
  search: {
    RefNo: '系统流水号',
    RefNo1: '系统流水号',
    SubAccountNo: '子商户号',

    WechatRMBWallet: '微信支付',
    WechatMOPWallet: '微信支付 MO',
    WechatHKDWallet: '微信支付 HK',
    WeChatPayCatering: ' 微信支付（餐饮）',
    AlipayHK: '支付宝 HK',
    Alipay: '支付宝',
    Conditions: '暂无结果，请重置条件查找',
    SubAccountNo3: '支付宝HK商户号',
    SubAccountNo4: '支付宝商户号',
    ServiceChargeRate2: '支付宝HK手续费率（%）',
    ServiceChargeRate3: '支付宝手续费率（%）',
    channelInfo: '通道资料',
    channelInfo1: '通道资料',
    SubAccountNo2: '微信支付商户号',
    HKSubAccountNo: '微信支付 HK 商户号',
    WalletType: '钱包类别',
    RMBWallet: '人民币钱包',
    HKDWallet: '港币钱包',
    RMBOrHKD: '人民币钱包商户号或港币钱包商户号',
    Channel: '通道',
    PursePain: '前宝通机构',
    wherewithal: 'Allinpay 机构',

    CrossBorderWallet: '跨境钱包',
    HongKongWallet: '香港钱包',
    SweepPay: '刷卡支付',
    ScanPay: '扫码支付',
    Review: "微信审核状态",
    wereNot: "未审核",
    associates: "审核通过",
    Audit: "审核中",
    partnership: "审核驳回",

    SweepPay1: '付款码支付',

    SubAccountNo1: '子商户号',
    AgentName: '所属代理商',
    AgentName2: '所属代理商',
    MerchantName: '商户名称',
    MerchantName1: '商户名称',
    MerchantName2: '商户名称',
    TransactionCompleted: '交易结果',
    TransactionCompleted1: '交易结果',
    TransactionCompleted2: '交易结果',
    Select: '选择通道',
    YES: '是',
    NO: '否',
    Yes: '成功',
    No: '失败',
    refunding: '处理中',
    remarks: '用户备注',
    Institutional: '机构模式',
    TransactionType: '交易类型',
    TransactionType1: '交易类型',
    WeChatPaySweep: '微信刷卡支付',
    WeChatPayScan: '扫码支付',
    OAPayment: '公众号支付',
    SelectBeginTime: '交易时间',
    SelectBeginTime1: '订单时间',
    SelectEndTime: '',
    TransactionStatus: '结算状态',
    TransactionStatus1: '结算状态',
    SettledDone: '已结算',
    NotSettled: '未结算',

    AgentName1: '代理商名称',
    AccountStatus: '商户状态',
    Pending: '未审核',
    Rejected: '审核未通过',
    EstablishmentDate: '入网时间',

    levelID: '代理商编号',
    levelID1: '代理商编号',
    UpperLevel: '上级代理名称',
    UpperLevel1: '上级代理名称',
    UpperLevel2: '上级代理名称',
    Status: '代理商状态',
    Status1: '代理商状态',
    Status2: '代理商状态',

    websitePayment: '网页支付',
    PC2Mobile: '网页支付',
    WAPPayment: 'WAP 支付',
    APPPayment: 'APP 支付',
    bankCardPayment: '银行卡支付',

    Undeclared: '未申报',
    DeclarationSubmit: '申报已提交',
    Reporting: '申报中',
    DeclarationSuccess: '申报成功',
    DeclarationFail: '申报失败',
    ApiError: '海关接口异常'
  },
  placeH: {
    All: '所有',
    Please: '请选择',
    Required: '(必填)'
  },
  hint: (_hint = {
    supplement: '请补充通道商户号',
    ThePictureSizeMustNotExceed5M: '上传图片大小不能超过 5MB',
    MandatoryFieldsAreNotFilledIn: '必填项未填写',
    usernameDoesNotExist: '用户不存在',
    pwdErr: '密码错误，请重新登录',
    loading: '请稍候再试',
    pleaseRelogin: '闲置时间过长，请重新登录',
    BuildFailed: '生成失败',
    NoData: '无数据',
    Alert: '提示',
    Success: '成功',
    Success1: '成功',
    Fail: '失败',
    Fail1: '失败',
    SureTo: '确定',
    SuccessfullyModified: '修改成功',
    FailToEdit: '修改失败',
    ThisAgent: '该代理商吗?',
    TheAdditonOf: '该店铺的进件申请吗?',

    TheAdditonOf1: '确定批准该商户的信息修改吗?',
    TheAdditonOf3: '确定拒绝该商户的信息修改吗?',

    TheAdditonOf4: '确定批准该商户的进件申请吗?',
    TheAdditonOf5: '确定拒绝该商户的进件申请吗?',

    TheAdditonOf6: "确定批准该店铺的信息修改吗?",
    TheAdditonOf7: "确定拒绝该店铺的信息修改吗?",
    TheAdditonOf8: "确定批准该店铺的进件申请吗?",
    TheAdditonOf9: "确定拒绝该店铺的进件申请吗?",

    TheAdditonOf2: '该代理商的进件申请吗?',
    TheShopInfoChange: '该店铺的信息修改吗?',
    TheMerchantInfoChange: '该商户的信息修改吗?',
    TheAgentInfoChange: '该代理商的信息修改吗?',
    Approved: '审核成功',
    Rejected: '审核失败',
    OperationSuccess: '操作成功',
    OperationFail: '操作失败',
    CreateOK: '提交成功',
    CreateFailed: '提交失败',
    ChangeOK: '修改成功',
    ChangeFailed: '修改失败',

    PleaseEnterName: '请输入姓名',
    PleaseEnterBDStaffNumber: '请输入业务员编号',
    PleaseEnterIDNumber: '请输入身份证号码',
    PleaseEnterPhoneNumber: '请输入联系电话',
    PleaseEnterEmail: '请输入电邮',
    BDStaffNumberIsValid: '业务员编号验证通过',
    BDStaffNumberExistsPleaseReEnter: '业务员编号已存在，请重新输入',
    BDRecordCreated: '新增业务员成功',
    BDCreateFailed: '新增业务员失败',
    LengthIsMax25Characters: '长度在 0 到 25 个字符',
    LengthIsMax10Characters: '长度在 0 到 10 个字符',
    LengthIsMax20Characters: '长度在 0 到 20 个字符',
    LengthIsMax11Characters: '长度在 0 到 11 个字符',
    LengthIsMax50Characters: '长度在 0 到 50 个字符',

    SureToChangeInfoOfTheMerchant: '确定修改商户信息吗?',
    SureToAddThisMerchant: '确定增加该商户吗?',
    SureToEnableThisMerchant: '确定启用该商户吗?',
    SureToSuspendThisMerchant: '确定停用该商户吗?',
    PhoneNumberAlreadyExists: '手机号码已存在',
    PhoneNumberAlreadyExists1: '座机已存在',
    OfficePhoneNumberAlreadyExists: '公司号码已存在',
    TheMerchantIsDisabled: '商户已停用',
    TheMerchantIsEnabled: '商户已启用',

    SureToChangeInfoOfTheShop: '确定修改店铺信息吗?',
    SureToSuspendThisShop: '确定停用该店铺吗?',
    SureToEnableThisShop: '确定启用该店铺吗?',
    SureToApproveTheShopInfoChange: '确定批准该店铺的信息修改吗?',
    SureToRejectTheShopInfoChange: '确定拒绝该店铺的信息修改吗?',
    SureToApproveTheAdditonOfTheShop: '确定批准该店铺的进件申请吗?',
    SureToRejectTheAdditionOfTheShop: '确定拒绝该店铺的进件申请吗?',
    SureToAddThisShop: '确定新增该店铺吗?',

    SureToEnableThisAgent: '确定启用该代理商吗?',
    SureToSuspendThisAgent: '确定停用该代理商吗?',
    SureToChangeInfoOfTheSalesman: '确定修改该业务员信息吗?',
    SureToChangeInfoOfTheAgent: '确定修改该代理商信息吗?',
    SureToAddThisAgent: '确定新增该代理商吗?',
    ApproveChangeOfInformation: '确定通过该代理商信息修改吗？',
    ApproveRegistration: '确定通过该代理商进件申请吗？',
    SureToRejectThisAgentInfoChange: '确定拒绝该代理商的信息修改吗?',
    SureToRejectTheAdditionOfThisAgent: '确定拒绝该代理商的进件申请吗?',
    SubmittedApprovalPending: '已提交，审核中',
    TheAgentIsDisabled: '代理已停用',
    TheAgentIsEnabled: '代理已启用',

    SureToAddThisOrganization: '确定新增该机构吗?',
    SureToChangeInfoOfTheOrganization: '确定修改该机构吗?',
    ThisOrganization: '该机构吗?',

    MerchantNameAlreadyExists: '商户名称已存在',
    AgentNameAlreadyExists: '代理商名称已存在',
    SubaccountAlreadyExists: '子商户号已存在',

    accountAlreadyExists: '人民币钱包商户号已存在',
    HKaccountAlreadyExists: '港币钱包商户号已存在'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PhoneNumberAlreadyExists', '手机号码已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ShopNameAlreadyExists', '店铺名称已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CompanyNameAlreadyExists', '公司名称已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'InstitutionNameAlreadyExists', '机构名称已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', '业务员电邮已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ContactPersonsEmailAlreadyExists', '联系人邮箱地址已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', '邮箱地址已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailFormatIncorrect', '邮箱格式不正确,请重新输入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseEnter', '请输入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInput', '请填写'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseAddMerchantOrShopPhoto', "请添加公司或店铺照片"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'addImage', '添加图片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToLaunchThisAdvertisement', '确定发布该广告吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAdvertisementLink', '请输入链接'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'paymentPage', '付款成功页'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'aPPHomePage', 'APP首页'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToDisableThisMcompany', '确定停用该公司吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToEnableThisMcompany', '确定启用该公司吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToMakeTheChanges', '确定修改公司信息吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'TheCompanyIsDisabled', '公司已停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'TheCompanyIsEnabled', '公司已启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToAddThisCompany', '确定新增该公司吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveChangeOfInformationC', '确定通过该公司信息修改吗？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveRegistrationC', '确定通过该公司进件申请吗？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectThisCompanyInfoChange', '确定拒绝该公司的信息修改吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectTheAdditionOfThisCompany', '确定拒绝该公司的进件申请吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToWithdraw', '确定提现HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'doubt', '吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'withdrawAmountShouldBeNoLessThan', '兑现金额不能小于HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAccountNo', '请填写商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate', '请填写微信支付手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseSelectServiceChargeBearer', '请选择手续费承担方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRateHK', '请填写微信支付HK手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate2', '请填写支付宝HK手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate3', '请填写支付宝手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayAccountAlreadyExists', '支付宝商户号已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayHKAccountAlreadyExists', '支付宝HK商户号已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmthewithdrawalrequestof', '确认'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'hasbeenpaid', '的提现申请已打款?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PaymentConfirmation', '确认打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CancelConfirmation', '取消确认'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmtogiveuptheexport', '确认放弃导出吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayDirectHasAlreadyExist', '支付宝(直连)商户号已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'WeChatPayHKNoHasAlreadyExist', '微信支付 HK商户号已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'feeRateFormatIncorrect', '手续费率格式错误'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmRefund', '确认退款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseInputMerchantName', '请填写商户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseSelectPassingRules', '请选择放行规则'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'notice', '提示：银联订单当天退款只支持全额退款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate4', '请填写支付宝(线上)手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SubAccountNo5', '支付宝(线上)商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputRejectReasons', '请填写驳回原因'), _hint),
  login: {
    User: '用户',
    pwd: '密码',
    Login: '登录',
    PasswordShouldBeAtLeast6Characters: '密码不能少于6位'
  },
  index: {
    UniversalPocketPaymentManagement: '前宝通支付管理',
    Welcome: '欢迎您,',
    Number: '序号',
    Operation: '操作',
    UnipockPaymentSystemAdministration: '前宝通支付管理系统',
    Location: '当前位置',
    Entrance: '欢迎页',
    Logout: '退出登录',
    MiPay: 'MiPay支付系统管理',
    MerchantOrders: '企业商户交易报表.xls',
    amendmentApprovalPending: '修改信息审核中',
    newShopApprovalPending: '新增店铺审核中',
    Salesman: '业务员管理',
    Device: "设备管理",
    searchResults: '搜索结果',
    approval: '审核管理',
    personnel: '人员管理',
    fund: '资金管理',
    name: "名称",
    name1: "商户名称",
    status: '商户状态',
    MerchantInfoExcel: '商户资料'
  },

  trade: {
    jumped: '交易时段',
    stock: '交易笔数',
    WeChatPay: '微信支付',
    MerchantRef: '交易流水',
    MerchantRef1: '交易流水',
    TransactionNo: '交易流水号',
    MerchantRefNo: '商户流水号',
    Agent: '所属代理商',
    Time: '交易时间',
    PaymentTime: '支付时间',
    originated: '交易金额',
    AmountCNY: '金额(CNY)',
    TransactionType: '交易类型',
    Payment: '收款',
    Refund: '退款',
    PaymentMethod: '支付方式',
    Device: '设备',
    DeviceID: '设备编号',
    Staff: '操作员',
    OrderNumber: '订单号',
    whetherToPay: '是否付款',
    Box: '派派小盒',
    AppPay: 'APP支付',
    MiniProgram: '小程序支付',
    SubordinateMerchant: 'API支付',
    OriginalTransactionNumber: '原系统流水号',
    MerchantTransactionNumber: '商户流水号',
    LANDIA8: '联迪A8',

    merchantNumber: '商户编号',
    fee: '手续费',
    receivableAmount: '实收金额',
    totalAmount: '总交易金额',
    totalorder: '总交易笔数',
    totalsuccess: '交易成功笔数',
    volume: '总数',
    tabulation: '已添加商户列表',
    utilization: '交易成功率',
    blanking: '成功交易最大间隔',
    between: '成功交易最小间隔',
    business: '添加统计商户',
    totalFee: '总手续费',
    Remarks: '备注',
    rejectReasons: '驳回原因:',
    transaction: '交易管理',
    frozenAmount: '冻结金额',

    TransactionNumber: '订单编号',
    Refundable: '可退金额',
    RefundAmount: '退款金额',
    Amount: '金额',
    PleaseEnterRefundAmount: '请输入退款金额',
    ExceededMaximum50Refunds: '该笔订单退款已达到 50 次',
    InsufficientBalanceForThisRefund: '账户余额不足以支持退款',
    CannotRefundUnfinishedTransaction: '失败订单无法进行退款',
    ExceededRefundablePeriodOf365Days: '该笔订单已超过 365 天',
    ExceededRefundablePeriodOf540Days: '该笔订单已超过 540 天',
    ExceededRefundablePeriodOf24Hours: '该笔订单已超过 24 小时',
    onlyOfflineBankCardRefundIsSupported: '仅支持线下银行卡退款',
    Maximum: '最大值',
    Minimum: '最小值',
    export: '导出',

    Unionpay: '银联',
    H5Payment: 'H5 支付',
    HideTestMer: '隐藏测试商户',

    failureReason: '失败原因',
    userRemarks: '用户备注',
    merchantRemark: '商户备注',

    transactionDetails: '交易详情',
    Details: '详情',
    merInfo: '商户信息',
    orderInfo: '订单信息',
    deviceInfo: '设备信息',
    remarksInfo: '备注信息',
    CustomColumns: '自定义列',
    Pay: '支付',
    SerialNumber: '流水号',
    WalletType: '钱包类型',

    Administration: '报关管理',
    RecordName: '备案名称',
    CustomsDeclarationTime: '报关时间',
    CustomsDeclarationNo: '报关编号',
    CustomsDeclarationStatus: '报关状态',
    customsList: '报关列表',
    CustomsFailureReason: '报关失败原因'

  },

  mer: (_mer = {
    Registration: '进件',
    Amendment: '修改信息',
    PendingMerchantApproval: '待审核商户',
    MerchantAddress: '商户地址',
    AccountBalance: '账户结余',
    AvailableBalance: '可用结余',
    OutstandingAmount: '未结算金额',
    ApprovalItem: '审核事项',
    mchtApproval: '商户审核',

    Client: "商户管理",

    CompanyInfo: '公司资料',
    Merchant: '商户名称',
    Merchant1: '商户名称',
    BusinessAddress: '业务地址',
    MailAddress: '邮寄地址',
    BRNo: '商业登记号码',
    Capital: '资本',
    YearsOfBusiness: '成立年数',
    IncorporationCountry: '成立地点',
    EmployeeNo: '雇员人数',
    MerchantType: '商户类型',
    MerchantCategory: '商户类目',
    OnlineMerchants: '线上商户',
    UnderLineMerchant: '线下商户',
    OwnershipType: '公司类别',
    LimitedCompany: '有限公司',
    Partnership: '合伙',
    SoleProprietor: '独资',
    Contractperson: '联系人 ',
    Contractperson1: '联系人 ',
    Email: '电邮地址',
    Position: '职位',
    Position1: '职位',
    OfficePhone: '公司电话',
    Mobile: '手机号码',
    Fax: '传真号码',
    Director: '董事',
    DirectorHKID: '董事身份证号码',
    DirectorPassport: '董事护照号码',
    Nationality: '国籍',
    overdue: '公司注册过期时间',

    ContactInfo: '联系资料',
    URL: '网址',
    TargetLaunchDate: '预定服务推出日期',
    TechnicalContact: '技术联系人'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Email', '电邮'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PhoneNo', '联系电话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OperationContact', '营运联系人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FinanceContact', '财务联系人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessInfo', '业务资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessNature', '业务性质'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ProductsServices', '产品 / 服务类别'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TargetCustomers', '目标顾客'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'provider', '现在/曾经使用的支付服务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Turnover', '过去两年营业额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'LastYearSalesVol', '去年度营业额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'YearBeforeSales', '前年度营业额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OnlineBusiness', '网上业务资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DeliveryProvider', '送货供应商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CustomerHotline', '客户服务热线'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReturnRefundPolicy', '退换货政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FulfuillmentTime', '收单至送货需时'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReceiptProvided', '有否签收'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ForecastMonthlySales', '预算每月营业额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After3Months', '三个月后'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After6Months', '六个月后'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After1Year', '一年后'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NoOfTransactions', '每月交易宗数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SalesVolume', '每月营业总额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AvgTransactionAmount', '每宗交易平均金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MinTransactionAmount', '每宗交易最低金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MaxTransactionAmount', '每宗交易最高金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SettlementInfo', '清/结算资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountName', '账户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountNo', '账户号码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankName', '银行名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode', '银行编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode1', '银行编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BranchCode', '分行编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Address', '银行地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SWIFT', '银行国际代码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate', '手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate1', '微信支付手续费率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate2', '微信支付MO手续费率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRateHK', '微信支付HK手续费率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer', '微信支付手续费承担方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer1', '手续费承担方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Customer', '顾客'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Consumer', '消费者'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Attachments', '附件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BR', '商业登记证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CertOfIncoporation', '公司注册证明'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectorHKID1', '董事身份证或护照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankStatement', '公司银行月结单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Photos', '公司或店铺照片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Logo', '商户图标'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopInfo', '店铺资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopModiify', '店铺修改'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShortName', '简称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopPhotos', '店铺照片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NewShop', '新增店铺'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PendingShopApproval', '待审批店鋪'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Sector', '行业'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'company', '上级公司名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'companyID', '上级公司编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'firm', '公司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'WhiteLable', '白标'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DescriptionOfGoods', "商品名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNo', '银联商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpayFeeRate', '银联手续费率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TerminalNo', '终端号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsername', 'AugsPay用户名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NotifyKey', '回调密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'APIKey', '接口密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SignKey', '签名密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayFeeRate', 'AugsPay手续费率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayFeeRate', '请填写银联手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputTerminalNo', '请填写终端号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputNotifyKey', '请填写回调密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAPIKey', '请填写接口密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputSignKey', '请填写签名密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayKey', '请填写银联密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAugsPayFeeRate', '请填写AugsPay手续费率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNoAlreadyExists', '银联商户号已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsernameAlreadyExists', 'AugsPay用户名已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MopPayUsernameAlreadyExists', 'MopPay用户名已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayMerchantNo', '支付宝(直连)商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayFeeRate', '支付宝(直连)手续费率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayDirect', '支付宝(直连)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOnline', '支付宝直连(线上)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOffline', '支付宝直连(线下)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'key', '密钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merchantNo', '商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPay', 'AugsPay'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'userName', '用户名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOnline', '支付宝(线上)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOffline', '支付宝(线下)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ConfirmToReset', '确定重置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'sPassword', '的密码吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'resetPassword', '重置密码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'abbreviation', '简称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merDescription', '商户简介'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooShort', '商户简介过短'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooLong', '商户简介过长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'delete', '确定删除该商户吗'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'channelRegistration', '自动进件中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'deviceNumber', '设备号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'shopNumber', '店铺门牌号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'mcInformationForm', '商户信息表'), _mer),

  agent: {
    certificate: "公司注册文件编号",
    agent: '代理商',
    DirectMerchants: '直营商户数',
    BDStaff: '业务员数',
    SubordinateAgents: "下级代理商数",
    agentApproval: '代理商审核',
    agentApproval1: '代理商审核',

    BasicInfo: '基本资料',
    CompanyInfo: "公司资料",
    Name: '名称',
    Type: '类型',
    Address: "地址",
    MailAddr: '邮寄地址',
    Contact: '联系人',
    PhoneNo: '座机',
    MobileNo: '手机',
    UpperLevelAgent: '上级代理商名称',
    UpperLevelID: '上级代理编号',

    SettlementInfo: '结算资料',
    Method: '结算方式',
    Bank: '银行',

    CommissionInfo: '佣金资料',
    Scanner: '扫码器',
    SubscriptionFee: '加盟费',
    OfflineBase: '线下基率(%)',
    OfflineComm: '线下佣金(%)',
    OnlineBase: '线上基率(%)',
    OnlineComm: '线上佣金(%)',
    EndDate: '结束日期',
    BDStaffNo: '业务员编号',
    commissionRatio: '业务员佣金 (%)',
    hintInfo: "基率为手续费不参与分佣计算的部分，其余手续费将按所填写的佣金比例与代理商进行分佣。例如，某个商户的手续费率为 1.5%，其代理商的基率为 1%，佣金比例为 50%，那么（1.5% - 1%）即为参与分佣的手续费率，代理商获得其中佣金的 50%，即（1.5% - 1%）* 50% = 0.25%，则该代理商可获得的佣金为其发展的商户的交易额的 0.25%",

    POS: 'POS 采购',
    POSmargin: 'POS 按金',
    POSrentalMonth: 'POS 租金/月',
    ScannerPurchase: '扫码器采购',
    ScannerMargin: '扫码器按金',
    ScannerRentalMonth: '扫码器租金/月',
    AlipayCross: '支付宝(跨境钱包)',
    AlipayHK: '支付宝(本地钱包)',

    WithdrawalRatio: '最低不可提现比例 '
  },

  salesman: {
    Salesman: '业务员',
    Name: '姓名',
    ID: '身份证号码',
    ID1: '身份证号码',
    OK: '新增',
    Status: '当前状态',
    NewBDStaff: '新增业务员',
    ModifyTheSalesmanInformation: '修改业务员信息',
    theSalesman: '该业务员吗?',
    delete: '确定删除该业务员吗'
  },

  mec: (_mec = {
    Name1: '机构名称',
    Status: '机构状态',
    Contact: '联系人名称',
    Phone: "联系人电话",
    Detail: '机构详情',

    OrganizationInfo: '机构信息',
    RegisterAddress: '机构注册地址',
    businessLicenseNo: "营业执照号",
    validityTime: '营业执照有效期',
    LegalPerson: '法人姓名',
    certificateType: '法人证件类型',
    certificateNo: '法人证件号码',
    PhoneNo: '法人联系电话',
    CreationTime: '入网时间',
    CreationTime1: '入网时间'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Contact', '联系人信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Name', '姓名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhoneNo', '电话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhoneNo1', '电话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Email', '电邮'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementInfo', '结算信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementBank', '清算银行名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'City', '银行所在城市'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountType', '账户类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountName', '开户人名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountNo', '结算账户号码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhotoInfo', '照片资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDFrontPicture', '法人身份证正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDReversePicture', '法人身份证反面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardFrontPicture', '法人银行卡正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardReversePicture', '法人银行卡反面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'BusinessLicense', '营业执照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'TaxRegistrationCertificate', '税务登记证照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'OrganizationCodeCertificate', '机构代码证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyFrontPicture', '公司正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyLogo', '公司Logo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'other', '其他'), _mec),

  AuMer: {
    CompanyInfomation: '公司信息',
    RegistrationName: '公司名称',
    AustraliaBusinessNumber: '澳洲商业注册号',
    BusinessInfomation: '业务范围',
    Website: '公司网站',
    ContactNumber: '公司电话',
    CompanyDescripption: '公司简介',
    Address: '公司地址',
    City: '城市',
    Postcode: '邮编',
    State: '州',
    ContactInfomation: '联系方式',
    FullNmae: '全名',
    JobTitle: '职称',
    TelephoneNo: '电话号码',
    EmailAddress: '邮箱地址',
    BillingInfomation: '公司银行账户信息',
    BankName: '银行名称',
    CompanyAccountNmae: '账户名',
    BSB: '分行代码',
    AccountNumber: '账户',
    Rate: '费率',
    SettlementPeriod: '结算周期',
    OtherInformation: '其他资料'
  },

  inputBox: (_inputBox = {
    merchantName: '商户名称',
    exchangeRate: '汇率',
    deviceNum: '设备编号',
    bindingsStartDate: '绑定时间',
    endDateOfBinding: '',
    query: '查询',
    add: '添加',
    empty: '清空',
    serialNumber: '序号',
    merchantNumber: '商户编号',
    shopNumber: '店铺编号',
    shopName: '店铺名称',
    deviceState: '设备状态',
    weChatSonMerchant: '微信子商户号',
    storageTime: '入库时间',
    bindingTime: '绑定时间',
    modificationTime: '修改时间',
    operation: '操作',
    modify: '修改',
    cancel: '取消',
    ok: '确定',
    deviceAdd: '设备添加',
    deviceModify: '设备修改',
    newDeviceNumber: '新设备号',
    pleaseEnterTheNewDeviceNumber: '请输入新设备号',
    pleaseEnterTheStoreNumber: '请输入店铺编号',
    pleaseEnterTheDeviceNumber: '请输入设备编号',

    pleaseEnterTheWalletType: '请选择钱包类别',
    pleaseEnterTheChannel: '请选择通道',
    success: '成功',
    fail: '失败',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    addFail: '添加失败',
    queryErr: '查询条件输入错误或查询结果不存在',

    QRcode: '固码',
    fixedCodeID: '固码ID',
    codeNo: '码号',
    generationDate: '生成日期',
    bindingDate: '绑定日期',
    currentState: '当前状态',
    paymentChannel: '支付通道',
    channelNumber: '通道编号',
    companyNumber: '公司编号',
    channelState: '通道状态',
    costRate: '成本费率(%)',
    typeOfTransaction: '交易类型',
    settlementType: '结算类型',
    fixedFee: '固定手续费',
    priorityLevel: '优先级别',
    dateOfEntry: '录入日期',
    remarks: '备注',
    remarks1: '备注',
    channelRegistrationDate: '通道注册日期',
    autograph: '签名',
    adapterOrder: '适配器下单URL',
    paymentAdapter: '适配器代付URL',
    adapterCallback: '适配器回调URL',

    startDate: '开始日期',
    endDate: '结束日期',
    unbound: '未绑定',
    bindings: '已绑定',
    disable: '停用',
    enable: '启用',
    minimumExchangeRate: '最小汇率',
    maximumExchangeRate: '最大汇率',
    receivablesArea: '收款区域',
    Australia: '澳大利亚',
    HongKong: '香港',
    pleaseEnterTheMerchantName: '请输入商户名称',
    chooseBranch: '选择分店',
    bindingNumber: '绑定数量',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: '分配固码',
    toTheMerchant: '给商户',
    toTheAgent: '给代理'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheMerchantName', '请输入商户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingAndBindingSolidCode', '生成并绑定固码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheAgentNumber', '请输入代理商编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingFixedCode', '生成固码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceID', '设备编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceType', '设备类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scanner', '派派小盒'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceStatus', '设备状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'enabled', '已启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'disabled', '已停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'merchant', '所属商户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'shop', '所属店铺'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deploymentDate', '投用日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'search', '搜索'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'clear', '清空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'status', '状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'change', '修改'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'cancelBinding', '取消绑定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisable', '确定停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnable', '确定启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToUnbind', '确定取消绑定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnableS', '确定启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisableS', '确定停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'QRCodeOf', '的固码吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scannerOf', '的派派小盒吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseChooseMerchant', '请先选择所属商户'), _inputBox),

  device: {
    newDevice: '新增设备',
    merchant: '所属商户',
    shop: '所属店铺',
    type: '设备类型',
    scanner: '派派小盒',
    QRCode: '固码',
    deviceID: '设备编号',
    OK: '确定',
    cancel: '取消',
    deviceNAE: '设备编号已存在'
  },

  newcash: (_newcash = {
    requestDate: '申请时间',
    merchantName: '商户名称',
    bankName: '银行名称',
    agentName: '代理商名称',
    bankAccount: '银行账户',
    accountName: '账户名称',
    withdrawAmount: '提现金额',
    Arrived: "到账金额",

    withdrawAmount2: '提现金额',
    withdrawType: '提现类型',
    withdrawFee: '提现手续费',
    remitAmount: '打款金额',
    status: '状态',
    pending: '未审核',
    approved: '审核通过',
    rejected: '驳回',
    rejected1: '审核驳回',
    paid: '已打款',
    operation: '操作',
    approve: '通过',
    reject: '驳回'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paid', '已打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToApprove', '确定通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToRefuse', '确定驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawRequestFrom', '的提现申请吗?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'merchantName', '商户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawStatus', '提现状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'approvalTime', '审核时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paymentTime', '打款时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal', "提现"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal1', "财务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'WithdrawalRecord', "提现记录"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'pendingWithdrawalApproval', '兑现审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantName', '代理商/商户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantID', '代理商/商户编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawErrorTitle', '提示'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawError', '以下商户提现失败，请重试：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'none', '无'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawalConfirmation', '提现确认'), _newcash),

  cloudAccount: {
    switchInstitution: '切换机构',
    pleaseSelectInstitution: '请选择机构'
  },

  fund: {
    withdrawAmount: '提现账户及金额',
    enterAmount: '输入金额',
    withdraw: '提现',
    cheque: '支票付款',
    bankTransfer: '银行转账',
    transferTip: '建设/中银转账免手续费，跨行转账每笔HK$ 50',
    withdrawMethod: '提现方式',
    warning: '温馨提示',
    warningTitle: '提现时间（按工作日计算）：',
    warningText: '上午9:00前的申请当天出票或转账；其后的第二天处理',
    withdrawLimit: '提现金额不能小于',
    confirmWithdraw: '确定提现 ',
    confirmWithdrawSuffix: '吗?',
    success: '提现成功',
    failed: '提现失败',
    pending: '未审核',
    approved: '审核通过',
    rejected: '审核驳回',
    paid: '已打款',

    WithdrawalAmount: '可提现金额',
    warningContent: '如有疑问请联系工作人员',
    Withdrawable: "(1)港币5元每笔汇款 (汇款金额少于或等于港币500,000元),",
    WithdrawableT: "(2)港币10元每笔汇款(汇款金额大于港币500,000元）",

    see: '查看',
    rechargeRecord: '备用金充值记录',
    refundRecord: '备用金退款记录',
    imprestAudit: '备用金充值审核',
    please: '请',
    confirmRecharge: '确定充值',
    reserveMoney: '备用金余额',
    recharge: '充值',
    rechargeTime: '充值时间',
    refundTime: '退款时间',
    rechargeRecords: '充值记录',
    refundRecords: '退款记录',
    rechargeAmount: '充值金额',
    refundAmount: '退款金额',
    rechargeNotes: '充值备注',
    rechargeVoucher: '充值凭证',
    fillRemarks: '填写备注',
    rechargeRechargeInfo: '备用金充值信息',
    reserveWarningTitle: '备用金余额仅用作商户退款使用,充值后不可提现,如需提现，请联系工作人员;',
    reserveWarningText: '如需充值备用金，请提前打款并保留打款凭证;',
    reserveWarningContent: '充值金额需与凭证中金额相符,提交充值后将有工作人员审核凭证信息,审核通过方可使用备用金余额进行退款。'

  },

  profit: {
    profit: '分润',
    countDate: '结算日期',
    date: '日期',
    acquirerFee: '机构分润',
    channel: '渠道',
    channelFee: '渠道分润',
    agentComm: '代理商分润',
    BDComm: '业务员分润',
    settlement: '结算金额',
    acquirerFeeTotal: '机构分润总额',
    agentCommTotal: '代理商分润总额',
    BDCommTotal: '业务员佣金总额',
    wx: '微信',
    payment: '结算收款',
    settlementDateRefund: '结算退款'
  },

  firm: {
    companyName: '公司名称',
    companyID: '公司编号',
    agent: '上级代理商名称',
    companyStatus: '公司状态',
    establishmentDate: '入网时间',

    name: '公司名称',
    ID: '公司编号',
    status: '状态',
    merchantQty: '直属商户数',
    registrationDate: '入网时间',
    companyApproval: '公司审核'
  },

  cash: (_cash = {
    userNumber: '用户编号',
    auditStatus: '审核状态',
    unaudited: '未审核',
    reviewAndPassThrough: '审核通过',
    reviewAndDismissal: '审核驳回',
    alreadyMadeMoney1: '已打款',
    presentType: '提现类型',
    check: '电子支票',
    onlineBanking: '银行转账',
    applicationStartDate: '申请时间',
    applicationEndDate: ''
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'userNumber', '用户编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'companyName', '公司名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'applicationTime', '申请时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditStatus', '审核状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'presentType', '提现类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'amountOfCash', '提现金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'cankCardNumber', '银行卡号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'cardholder', '持卡人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'bankName', '银行名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditTime', '审核时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'remittanceDate', '汇款时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notes', '注释'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'examine', '审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'adopt', '通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'reject', '驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'playMoney', '打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditHasPassed', '审核已通过,可打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'theAuditHasBeenRejected', '审核已驳回,无法进行操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'errOperation', '错误操作!已打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'alreadyPassed', '审核已通过,不能驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notRepeatOperation', '审核已驳回,请勿重复操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'audit', '审核中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notMakeMoney', '审核已驳回,无法打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'alreadyMadeMoney', '已打款,请勿重复操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'query', '查询'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'empty', '清空'), _cash),

  shop: {
    Phone: "联系人电话",
    Phone1: "联系人电话*",
    Email: '电邮',
    Email1: '电邮*',
    shopApproval: '店铺审核',
    shopName: '店铺名称'
  },

  modifyPwd: {
    PasswordChange: '修改密码',
    OriginalPassword: '原密码',
    NewPassword: '新密码',
    Confirm: '确认密码',
    OK: '确定修改',
    Cancel: '取消',
    PasswordIncorrect: '密码输入错误',
    NewPasswordLessThan6Digits: '新密码少于6位字符',
    TheTwoPasswordsDoNotMatch: '两次密码不一致',
    TheNewPasswordIsTheSameAsTheOldOne: '新密码与原密码相同',
    PleaseInputMoreThan6DigitsPassword: '（请输入6位以上密码）',
    PleaseBeTheSameAsOriginalPassword: '（请与新密码一致）',
    PleaseInputOriginalPassword: '请输入原密码',
    PleaseInputPasswordAgain: '请再次输入密码',
    PleaseInputPassword: '请输入密码',

    formatError: '图片格式不正确'
  },
  other: {
    PhoneNumberAlreadyExist: '业务员联系电话已存在',
    InformationChange: '修改资料',
    ConfirmToMakeTheChanges: '确定修改店铺资料吗?',
    ConfirmToRegisterTheShop: '确定新增该店铺吗?',
    ConfirmToDeleteTheShop: '确定删除该店铺吗?',
    MerchantLogo: '商戶Logo',
    MerchantInfo: '商户信息登记表',
    PasswordShouldBeAtLeast6Characters: '密码不能少于6位',
    EmailAlreadyExists: '业务员邮箱已存在',
    EstablishmentFrom: '入网时间',
    EstablishmentFrom1: '入网时间',
    EstablishmentFrom2: '入网时间',
    EstablishmentFrom3: '入网时间',
    EstablishmentTo: ''
  },
  modifyShop: {
    ShopDetail: '进入店铺',
    New: '添加店铺',
    Back: '返回上一层',
    Rejected: '审核未通过!',
    ApprovalPending: '店铺审核中...',
    AmendmentApprovalPending: '修改资料审核中...',
    UploadPhoto: '上传图片',
    ShopNumber: '店铺编号',
    Edit: '修改信息',
    Suspended: '已停用!',
    ClickToAddPhotos: '点击添加图片',
    ShopName: '填写店名',
    OK: '完成',
    OK1: '提交',
    delete: '删除店铺'
  },
  ad: {
    typeOne: '类型一',
    typeTwo: '类型二',
    typeThree: '类型三',
    advertisingPosition: '广告位',
    resolution: '分辨率',
    link: '链接',
    adMgmt: '广告',
    adSetup: '广告',

    NewAdvertisement: '添加广告',
    BusinessNature: '广告行业',
    ConfirmtodeletetheAdvertisement: '确定删除该条广告吗?',
    ConfirmtomodifytheAdvertisement: '确定修改该条广告吗?',
    Replacethepicture: '更换图片',
    Uploadpicture: '上传图片',
    AdvertisementName: '广告名称',
    Link: '跳转链接',
    PleaseAddAdvertisementPicture: '请添加广告图片',

    adData: '广告数据',
    Display: '曝光量',
    Click: '点击量',
    ClickRate: '点击率'
  },

  settlement: {
    Date: '结算日期',
    Merchant: '商户名称',
    MerchantID: '商户编号',
    SettlementPeriod: '结算周期',
    TransactionAmount: '交易总额',
    Fee: '手续费',
    SettlementAmount: '结算总额',
    Settlement: '商户结算',

    refundRemarks: '退款备注'
  },

  opinion: {
    Date: '日期',
    SuggestionList: '意见列表',
    SuggestionList1: '意见列表',
    SuggestionList2: '意见列表',
    Time: '时间',
    Shop: '店铺',
    Account: '账户',
    AcountName: '账户名称',
    Role: '角色',
    Subject: '主题',
    Content: '内容',
    Suggestion: '反馈详情'
  },

  notify: (_notify = {
    title: '通知主题',
    content: '',
    content1: '通知内容',
    NotificationHistory: '通知记录',
    Recipients: '收件人',
    Details: '详情',
    EditNotification: '通知编辑',
    SelectRecipients: '选择收件人',
    SendTo: '发送至:',
    Send: '发送',
    All: '全部',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商户',
    Finance: '财务',
    BD: '业务员',
    AllAgent: '所有代理商',
    AllCompany: '所有公司',
    AllMerchant: '所有商户',
    AllMerchantAdministrator: '所有商户管理员',
    AllShop: '所有店铺',
    AllStaff: '所有员工',
    AllFinance: '所有财务',
    AllBD: '所有业务员',
    Administrator: '管理员',
    MerchantsOf: '直屬商户',
    ConfirmToSend: '确定发送?',
    Notification: '通知',
    AlreadyExists: '已存在',
    PleaseSelectRecipients: '请选择收件人',
    Notifications: '消息通知',
    NotificationList: '消息列表',
    NofiticationDetails: '消息详情',
    contentExceeding: '内容超过2000字符,请删减内容',
    Only10Images: '每篇通知只允许上传 10 张图片',
    pleaceSelectOrEnputMerchantName: '请选择/输入商户名',
    addPicture: '添加图片'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Merchant', '商户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Agent', '代理商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Company', '公司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Shop', '店铺'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationApproved', '进件审核通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationRejected', '进件审核驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationApproved', '修改信息审核通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationRejected', '修改信息审核驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationApproved', '兑现申请审核通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationRejected', '兑现申请审核驳回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'the', '您提交的'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenApproved', '进件申请已通过审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenRejectedRejectReason', '进件申请被驳回，驳回原因：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenApproved', '修改信息申请已通过审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenRejectedRejectReason', '修改信息申请被驳回，驳回原因：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'theWithdrawalApplicationOf', '您于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'on', '提交的'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenApproved', '兑现申请已通过审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenRejectedRejectReason', '兑现申请被驳回，驳回原因：'), _notify),

  risk: {
    report: '交易报告',
    automated: '报告列表',
    should: '报告日期',
    Type: '风控类型',
    Edit: '修改',
    Remove: '移除',
    NewWhiteList: '添加白名单',
    Configuration: '规则设置',
    PassingRules: '放行规则',
    DayAmountLimit: '单日限额',
    HourAmountLimit: '小时限额',
    PerTransactionLimit: '单笔限额',
    MinuteVolumeLimit: '分钟限频',
    ConfirmWhiteRemoving: '确定从白名单中移除',
    FromWhiteList: '吗?',
    Abnormalty: '异常交易',
    BlackListed: '转为黑名单',
    OrderNumber: '订单号',
    ConfirmGreyRemoving: '确定从灰名单中移除',
    fromGreyList: '吗?',
    ConfirmMoving: '确定将',
    toBlackList: '转移到黑名单吗?',
    GreyListed: '转为灰名单',
    ConfirmBlackRemoving: '确定从黑名单中移除',
    fromBlackList: '吗?',
    toGreylist: '转移到灰名单吗',
    ConfirmChanging: '确定修改',
    ConfirmChangingRiskControlfactors: '确定修改该行业的风控参数吗?',
    RiskControl: '风险控制',
    whiteListEdit: '白名单修改',
    whiteList: '白名单',
    greyList: '灰名单',
    blackList: '黑名单',
    items: '笔',

    riskMerchant: '商户风控',
    riskTime: '风控时间',
    singleDayLimit: '单日限额',
    singleLimit: '单笔限额',
    addRiskMerchant: '添加风控商户',
    removeRiskMerchant: '移除风控商户',
    modifyRiskMerchant: '修改风控商户',
    isDeleteRiskMerchant: '是否确认从风控列表中移除该商户？',
    adder: '添加者',
    verifyIsEmpty: '商户名称/编号不得为空',
    minLimitRules: '请至少输入一项限额规则',
    VerifyDcMcName: '该商户已存在，请重新选择',

    TradingLimit: '交易限频',
    pen: '笔'
  },

  History: {
    Applicant: '申请人',
    ApplicantAccount: '申请人账户',
    ApprovalHistory: '审核记录',
    Approver: '审核人',
    ApproverAccount: '审核人账户',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商户',
    shop: '店铺',
    refusalReasons: '驳回原因'
  },

  count: {
    month: '月',
    week: '周',
    day: '日',
    hour: '时',
    pleaceSelectTime: '请选择时间',
    endTimeError: '结束时间错误',
    pleaseSearchLessThan24Months: '搜索时间请勿超过24个月',
    pleaseSearchLessThan16Weeks: '搜索时间请勿超过16周',
    pleaseSearchSessThan62Days: '搜索时间请勿超过62天',
    pleaseSearchSessThan48Hours: '搜索时间请勿超过48小时',
    todayReceiptAmount: '今日收款总额',
    todayUnionPayAmount: '今日银联收款总额',
    todayWeChatAmount: '今日微信收款总额',
    todayHongKongAmount: '今日香港微信总额',
    todayWalletAmount: '今日跨境微信总额',
    todayAlipayAmount: '今日支付宝收款总额',
    todayTransactionVolume: '今日交易量',
    transactionAmount: '交易额',
    transactionVolume: '交易量',
    newMerchant: '新增商户',
    date: '日期',
    amount: '交易额',
    top10Merchant: 'Top10商户',
    Month: '月',
    sinceEstablishment: '开通以来',
    dataSheet: '数据表',
    ranking: '排行',
    failureRate: '失败率'
  },

  user: {
    title: '用户信息',
    tips: '(点击编辑用户名和头像)',
    placeholder: '请输入（回车确认）',
    qualified1: '请输入用户名',
    qualified2: '请正确输入用户名',
    qualified3: '用户名不得含有中英文的特殊字符',
    OK: '确定',
    Cancel: '取消'
  },

  zhCNLocale: __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default.a });

/***/ }),

/***/ "QQIG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@charset \"UTF-8\";\n.grey-btn {\n  background: #B4B8B7;\n  border-color: #B4B8B7;\n  color: #fff;\n}\n.grey-btn:hover {\n    border-color: #B4B8B7;\n    background-color: #B4B8B7;\n    color: #fff;\n}\n.grey-btn:hover:before, .grey-btn:hover:after {\n      background: #B4B8B7;\n}\n.blue-btn {\n  background: #5272e9;\n  border-color: #5272e9;\n  color: #fff;\n}\n.blue-btn:hover {\n    border-color: #5272e9;\n    background-color: #5272e9;\n    color: #fff;\n}\n.blue-btn:hover:before, .blue-btn:hover:after {\n      background: #5272e9;\n}\n.light-blue-btn {\n  background: #0099DF;\n  border-color: #0099DF;\n  color: #fff;\n}\n.light-blue-btn:hover {\n    border-color: #0099DF;\n    background-color: #0099DF;\n    color: #fff;\n}\n.light-blue-btn:hover:before, .light-blue-btn:hover:after {\n      background: #0099DF;\n}\n.green-btn {\n  background: #00B589;\n  border-color: #00B589;\n  color: #fff;\n}\n.green-btn:hover {\n    border-color: #00B589;\n    background-color: #00B589;\n    color: #fff;\n}\n.green-btn:hover:before, .green-btn:hover:after {\n      background: #00B589;\n}\n.yellow-btn {\n  background: #FF9600;\n  border-color: #FF9600;\n  color: #fff;\n}\n.yellow-btn:hover {\n    border-color: #FF9600;\n    background-color: #FF9600;\n    color: #fff;\n}\n.yellow-btn:hover:before, .yellow-btn:hover:after {\n      background: #FF9600;\n}\n.red-btn {\n  background: #C03639;\n  border-color: #C03639;\n  color: #fff;\n}\n.red-btn:hover {\n    border-color: #C03639;\n    background-color: #C03639;\n    color: #fff;\n}\n.red-btn:hover:before, .red-btn:hover:after {\n      background: #C03639;\n}\n.pink-btn {\n  background: #E65D6E;\n  border-color: #E65D6E;\n  color: #fff;\n}\n.pink-btn:hover {\n    border-color: #E65D6E;\n    background-color: #E65D6E;\n    color: #fff;\n}\n.pink-btn:hover:before, .pink-btn:hover:after {\n      background: #E65D6E;\n}\n.tiffany-btn {\n  background: #4AB7BD;\n  border-color: #4AB7BD;\n  color: #fff;\n}\n.tiffany-btn:hover {\n    border-color: #4AB7BD;\n    background-color: #4AB7BD;\n    color: #fff;\n}\n.tiffany-btn:hover:before, .tiffany-btn:hover:after {\n      background: #4AB7BD;\n}\n.white-btn {\n  background: #ffffff;\n  border-color: #ffffff;\n  color: #fff;\n  color: #333;\n}\n.white-btn:hover {\n    border-color: #ffffff;\n    background-color: #ffffff;\n    color: #fff;\n}\n.white-btn:hover:before, .white-btn:hover:after {\n      background: #ffffff;\n}\n.pan-btn {\n  font-size: 14px;\n  color: #fff;\n  padding: 14px 36px;\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  margin-right: 25px;\n  -webkit-transition: 600ms ease all;\n  transition: 600ms ease all;\n  position: relative;\n  display: inline-block;\n}\n.pan-btn:hover {\n    background: #fff;\n}\n.pan-btn:hover:before, .pan-btn:hover:after {\n      width: 100%;\n      -webkit-transition: 600ms ease all;\n      transition: 600ms ease all;\n}\n.pan-btn:before, .pan-btn:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 2px;\n    width: 0;\n    -webkit-transition: 400ms ease all;\n    transition: 400ms ease all;\n}\n.pan-btn::after {\n    right: inherit;\n    top: inherit;\n    left: 0;\n    bottom: 0;\n}\n.custom-button {\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  background: #fff;\n  color: #fff;\n  -webkit-appearance: none;\n  text-align: center;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  padding: 10px 15px;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.mini-btn {\n  padding: 0;\n  border-radius: 4px;\n  font-size: 10px;\n  width: 57px;\n}\n.mini2-btn {\n  height: 40px;\n  line-height: 40px;\n  padding: 0;\n  border-radius: 4px;\n  font-size: 14px;\n  width: 100px;\n}\n.min-btn {\n  padding: 0;\n  border-radius: 4px;\n  font-size: 10px;\n  width: 66px;\n}\n.small-btn {\n  height: 33px;\n  line-height: 33px;\n  padding: 0;\n  border-radius: 5px;\n  width: 115px;\n}\n.secondary-btn {\n  height: 40px;\n  border-radius: 6px;\n  width: 150px;\n}\n.max-btn {\n  height: 39px;\n  border-radius: 6px;\n  width: 160px;\n}\n.el-button--primary {\n  background-color: #5272e9;\n}\n.el-button--primary:hover {\n  background: #31A8FD;\n}\n.sidebar-container > .el-menu {\n  width: 100% !important;\n  min-height: 100%;\n}\n.hideSidebar .el-submenu > .el-submenu__title,\n.hideSidebar .submenu-title-noDropdown {\n  padding-left: 10px !important;\n}\n.hideSidebar .submenu-title-noDropdown span,\n.hideSidebar .el-submenu > .el-submenu__title > span {\n  height: 0;\n  width: 0;\n  overflow: hidden;\n  visibility: hidden;\n  display: inline-block;\n}\n.hideSidebar .nest-menu .el-submenu__title {\n  text-align: initial !important;\n  padding-left: 20px !important;\n}\n.hideSidebar .nest-menu .el-submenu__title span {\n    height: auto;\n    width: auto;\n    visibility: visible;\n    display: inline;\n}\n.hideSidebar .nest-menu .el-submenu__title .el-submenu__icon-arrow {\n    display: block !important;\n}\n.el-submenu__icon-arrow {\n  -webkit-transform: rotateZ(-90deg);\n          transform: rotateZ(-90deg);\n}\n.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {\n  -webkit-transform: rotateZ(0deg);\n          transform: rotateZ(0deg);\n}\n.hideSidebar .menu-wrapper > .el-menu-item,\n.hideSidebar .submenu-title-noDropdown,\n.hideSidebar .menu-wrapper > .el-submenu .el-submenu__title {\n  text-align: center;\n}\n.hideSidebar .el-menu-item .el-submenu__icon-arrow,\n.hideSidebar .el-submenu .el-submenu__title .el-submenu__icon-arrow {\n  display: none;\n}\n.hideSidebar .submenu-title-noDropdown {\n  position: relative;\n}\n.hideSidebar .submenu-title-noDropdown span {\n    -webkit-transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);\n    opacity: 0;\n}\n.hideSidebar .submenu-title-noDropdown:hover span {\n    display: block;\n    border-radius: 3px;\n    z-index: 1002;\n    width: 140px;\n    height: 56px;\n    visibility: visible;\n    position: absolute;\n    right: -145px;\n    text-align: left;\n    text-indent: 20px;\n    top: 0px;\n    background-color: #1f2d3d;\n    opacity: 1;\n}\n.el-menu-item, .el-submenu__title {\n  color: #fff;\n  height: 80px;\n  line-height: 80px;\n}\n.el-submenu .el-menu-item {\n  min-width: 180px !important;\n  background-color: #4964cf;\n  color: #fff;\n  height: 70px;\n  line-height: 70px;\n}\n.el-submenu__title:hover {\n  background: #4964cf;\n  color: #fff;\n}\n.el-menu-item.is-active {\n  position: relative;\n}\n.el-submenu.is-active .el-submenu__title {\n  background: #5272e9;\n  color: #fff;\n}\n.el-submenu__title i {\n  color: #fff;\n}\n.el-menu {\n  background-color: #5272e9;\n}\n.el-menu-item.is-active ::after {\n  content: '';\n  width: 4px;\n  height: 50px;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  background-color: #51d790;\n}\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-family: Helvetica, Arial, \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\";\n}\nhtml {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 100%;\n  background-color: #f6f6f6 !important;\n  min-width: 1000px;\n}\n[v-cloak] {\n  display: none;\n}\n*,\n*:after,\n*:before {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n}\n.no-padding {\n  padding: 0 !important;\n}\n.padding-content {\n  padding: 4px 0;\n}\n.clearFloat {\n  float: none !important;\n}\n.limit {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\na:active,\na:focus {\n  outline: none;\n}\na,\na:focus,\na:hover {\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n}\n.fr {\n  float: right;\n}\n.fl {\n  float: left;\n}\n.pr-5 {\n  padding-right: 5px;\n}\n.pl-5 {\n  padding-left: 5px;\n}\n.block {\n  display: block;\n}\n.pointer {\n  cursor: pointer;\n}\n.inlineBlock {\n  display: block;\n}\nimg[src=\"\"],\nimg:not([src]) {\n  opacity: 0;\n}\ncode {\n  background: #eef1f6;\n  padding: 15px 10px;\n  margin-bottom: 20px;\n  display: block;\n  line-height: 36px;\n}\ncode a {\n    color: #337ab7;\n    cursor: pointer;\n}\ncode a:hover {\n      color: #20a0ff;\n}\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.fade-enter,\n.fade-leave-active {\n  opacity: 0;\n}\n.app-container {\n  padding: 20px;\n}\n.components-container {\n  margin: 30px 50px;\n  position: relative;\n}\n.pagination-container {\n  margin-top: 15px;\n}\n.editor-container .CodeMirror {\n  height: 100% !important;\n}\n.text-center {\n  text-align: center;\n}\n.svg-icon {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  fill: currentColor;\n  overflow: hidden;\n  margin-right: 18px;\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.svg-notify-close {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  fill: currentColor;\n  overflow: hidden;\n  -webkit-transition: all 1s;\n  transition: all 1s;\n  margin: 0;\n}\n.sub-navbar {\n  height: 50px;\n  line-height: 50px;\n  position: relative;\n  width: 100%;\n  text-align: right;\n  padding-right: 20px;\n  -webkit-transition: 600ms ease position;\n  transition: 600ms ease position;\n  background: -webkit-gradient(linear, left top, right top, from(#20b6f9), color-stop(0%, #20b6f9), color-stop(100%, #2178f1), to(#2178f1));\n  background: linear-gradient(90deg, #20b6f9 0%, #20b6f9 0%, #2178f1 100%, #2178f1 100%);\n}\n.sub-navbar .subtitle {\n    font-size: 20px;\n    color: #fff;\n}\n.sub-navbar.draft {\n    background: #d0d0d0;\n}\n.sub-navbar.deleted {\n    background: #d0d0d0;\n}\n.link-type,\n.link-type:focus {\n  color: #337ab7;\n  cursor: pointer;\n}\n.link-type:hover,\n  .link-type:focus:hover {\n    color: #20a0ff;\n}\n.deletedTag,\n.draftTag,\n.publishedTag {\n  color: #fff;\n  background-color: #30B08F;\n  line-height: 1;\n  text-align: center;\n  margin: 0;\n  padding: 8px 12px;\n  font-size: 14px;\n  border-radius: 4px;\n  position: absolute;\n  left: 20px;\n  top: 10px;\n}\n.draftTag {\n  background-color: #FF9600;\n}\n.deletedTag {\n  background-color: #C03639;\n}\n.input-label {\n  font-size: 14px;\n  color: #48576a;\n  line-height: 1;\n  padding: 11px 5px 11px 0;\n}\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.no-marginLeft .el-checkbox {\n  margin: 0 20px 15px 0;\n}\n.no-marginLeft .el-checkbox + .el-checkbox {\n  margin-left: 0;\n}\n.filter-container {\n  padding-bottom: 10px;\n}\n.filter-container .filter-item {\n    display: inline-block;\n    vertical-align: middle;\n    margin-bottom: 10px;\n}\n.shopDelUl .el-select,\n.addShop .el-select {\n  width: auto;\n}\n.multiselect {\n  line-height: 16px;\n}\n.multiselect--active {\n  z-index: 1000 !important;\n}\n.simplemde-container .CodeMirror-fullscreen,\n.simplemde-container .editor-toolbar.fullscreen {\n  z-index: 1003;\n}\n.el-dialog {\n  -webkit-transform: none;\n          transform: none;\n  left: 0;\n  position: relative;\n  margin: 0 auto;\n  width: 450px;\n}\n.el-dialog__footer {\n  background-color: #fff;\n  margin-top: -1px;\n}\n.github-corner:hover .octo-arm {\n  -webkit-animation: octocat-wave 560ms ease-in-out;\n          animation: octocat-wave 560ms ease-in-out;\n}\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\ninput::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n.el-date-editor.el-input,\n.el-input {\n  width: 223px;\n}\n.el-input__inner {\n  border-radius: 4px;\n  height: 40px;\n}\n.el-table th > .cell {\n  word-break: keep-all;\n}\n.filter-container .filter-item {\n  margin-bottom: 2px;\n}\n.selectMer .el-select-dropdown__item {\n  width: 213px;\n}\n.noLabel {\n  margin-top: 25px;\n}\n.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover,\n.el-select-dropdown__item.hover,\n.el-select-dropdown__item:hover {\n  background-color: #f5f7fa;\n}\n.el-table th {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n.el-table__footer-wrapper thead div,\n.el-table__header-wrapper thead div {\n  background-color: #fff;\n  color: #006AB6;\n  font-size: 18px;\n  color: #5272e9;\n  font-weight: bold;\n}\n.el-table__fixed-header-wrapper thead div {\n  background-color: #fff;\n  color: #006AB6;\n  font-size: 18px;\n  color: #5272e9;\n  font-weight: bold;\n}\n.el-table__fixed-right::before,\n.el-table__fixed::before {\n  background-color: #fff;\n  height: 0;\n}\n.table-head {\n  padding-left: 16px;\n  height: 50px;\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 50px;\n  border-top: 1px solid rgba(73, 100, 207, 0.2);\n  position: relative;\n  background-color: #5272e9;\n  color: #fff;\n}\n.table-head::before {\n  content: '';\n  width: 4px;\n  height: 26px;\n  background: #fff;\n  position: absolute;\n  left: 0;\n  top: 12px;\n}\n.search-result-head {\n  padding-left: 16px;\n  height: 40px;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 40px;\n  color: #333;\n  border-top: 1px solid rgba(73, 100, 207, 0.2);\n  position: relative;\n}\n.search-result-head .hideTest-box {\n    float: left;\n    cursor: pointer;\n    margin-right: 18px;\n    margin-top: 5px;\n}\n.search-result-head .hideTest-box span {\n      font-size: 14px;\n      vertical-align: middle;\n}\n.search-result-head .test {\n    background: #5272e9;\n    color: #fff;\n    width: 90px;\n    text-align: center;\n    height: 30px;\n    line-height: 30px;\n    border-radius: 4px;\n}\n.search-result-head::before {\n  content: '';\n  width: 4px;\n  height: 24px;\n  background: #5272e9;\n  position: absolute;\n  left: 0;\n  top: 8px;\n}\n.card {\n  background: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  min-width: 1076px;\n}\n.card-table {\n  -webkit-box-shadow: 0px 0px 34px rgba(109, 140, 255, 0.32);\n          box-shadow: 0px 0px 34px rgba(109, 140, 255, 0.32);\n  background: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  min-width: 1076px;\n}\n.card-table .content, .card-table .content_item {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.card-table-title {\n  height: 45px;\n  background: #5272e9;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  padding-left: 43px;\n  font-size: 24px;\n  color: white;\n  line-height: 45px;\n  font-weight: bold;\n}\n.roster-box {\n  padding: 20px;\n  overflow: hidden;\n}\n.roster-box .rosters {\n    float: left;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    list-style: none;\n}\n.roster-box .rosters .roster-item {\n      float: left;\n      width: 100px;\n      height: 40px;\n      line-height: 38px;\n      background-color: #fff;\n      color: #5272e9;\n      text-align: center;\n      border: 1px solid #5272e9;\n      border-radius: 50px;\n      cursor: pointer;\n      font-size: 14px;\n}\n.roster-box .rosters .roster-item + .roster-item {\n      margin-left: 15px;\n}\n.roster-box .rosters .active {\n      background-color: #5272e9;\n      color: #fff;\n}\n.roster-box a {\n    float: right;\n    border-radius: 50px;\n}\n.el-table .cell {\n  text-align: center;\n  word-break: break-word;\n  white-space: pre !important;\n}\n.Merchant-risk .el-table .cell {\n  white-space: nowrap !important;\n}\n.animate_td .cell {\n  background-color: #5272E9;\n  border-top-left-radius: 17px;\n  border-bottom-left-radius: 17px;\n  position: absolute;\n  top: 6px;\n  right: 0px;\n  width: auto;\n  height: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\n.el-select-custom {\n  width: 223px !important;\n  min-width: 223px !important;\n}\n.el-table__fixed-right {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.el-table__fixed {\n  z-index: 23;\n}\n.el-table tr {\n  background-color: transparent;\n}\n.fixed-column-1 {\n  width: 120px !important;\n  right: 15px !important;\n  background-color: transparent;\n}\n.fixed-column-2 {\n  width: 180px !important;\n  right: 15px !important;\n  background-color: transparent;\n}\n.fixed-column-3 {\n  width: 230px !important;\n  right: 15px !important;\n  background-color: transparent;\n}\n.fixed-column-4 {\n  width: 293px !important;\n  right: 15px !important;\n  background-color: transparent;\n}\n.right-zero {\n  right: 0px !important;\n}\n.el-table__fixed-right-patch {\n  width: 0 !important;\n  height: 0 !important;\n}\n.el-table__fixed-body-wrapper .el-table__body td:nth-last-of-type(2) {\n  border-right: 0;\n}\n.el-table th:nth-last-of-type(1) {\n  border-bottom: 1px solid #ebeef5;\n  left: 0;\n  top: 0;\n}\n.el-table th:nth-last-of-type(2) {\n  border-right: 0;\n}\n.el-table td,\n.el-table th.is-leaf {\n  background: transparent;\n}\n.el-table__fixed-right tr:nth-child(even) {\n  background-color: rgba(238, 237, 255, 0);\n}\n.el-table__body-wrapper tr:nth-child(even) {\n  background-color: #eef7ff;\n}\n.el-table__fixed .el-table__fixed-body-wrapper tr:nth-child(even) {\n  background-color: #eef7ff;\n}\n.el-table__fixed .el-table__fixed-body-wrapper tr:nth-child(odd) {\n  background-color: white;\n}\n.el-table--enable-row-transition .el-table__body td {\n  padding: 6px 0;\n  font-size: 12px;\n  position: relative;\n  z-index: 0;\n}\n.search {\n  overflow: hidden;\n  clear: both;\n}\n.search-input {\n  display: inline-block;\n  padding: 10px 40px;\n}\n.search-input > div {\n  width: 223px;\n  float: left;\n  margin-bottom: 13px;\n  margin-right: 29px;\n}\n.search-input > div label {\n  display: block;\n  line-height: 15px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #0a0a0a;\n  margin-bottom: 10px;\n  height: 15px;\n}\n.search-btn {\n  display: inline-block;\n}\n.date-wrapper {\n  position: relative;\n}\n.date-line {\n  position: absolute;\n  right: -19px;\n  top: 44px;\n  background-color: #000;\n  width: 10px;\n  height: 2px;\n}\n.el-message-box__message p {\n  word-break: break-word;\n}\n@media screen and (min-width: 1919px) {\n.search-input {\n    width: 1593px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n}\n@media screen and (min-width: 1890px) and (max-width: 1918px) {\n.search-input {\n    width: 1564px;\n    padding-right: 11px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n}\n@media screen and (min-width: 1638px) and (max-width: 1889px) {\n.search-input {\n    width: 1311px;\n    padding-right: 11px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n}\n@media screen and (min-width: 1636px) and (max-width: 1637px) {\n.search-input {\n    width: 1311px;\n    padding-right: 11px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n}\n@media screen and (min-width: 1571px) and (max-width: 1635px) {\n.search-input {\n    width: 1242px;\n    padding-right: 11px;\n}\n.search-input > div {\n    margin-right: 15px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n.date-line {\n    right: -11px;\n    width: 8px;\n}\n}\n@media screen and (min-width: 1521px) and (max-width: 1570px) {\n.search-input {\n    width: 1192px;\n    padding-right: 11px;\n    padding-left: 25px;\n}\n.search-input > div {\n    margin-right: 8px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n.date-line {\n    right: -6px;\n    width: 4px;\n}\n}\n@media screen and (min-width: 1442px) and (max-width: 1520px) {\n.search-input {\n    width: 1116px;\n    padding-right: 11px;\n}\n.search-input > div {\n    margin-right: 42px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n    margin-right: 45px !important;\n}\n.date-line {\n    right: -28px;\n    width: 14px;\n}\n}\n@media screen and (min-width: 1368px) and (max-width: 1441px) {\n.search-input {\n    width: 1080px;\n    padding-right: 24px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n    margin-right: 36px !important;\n}\n}\n@media screen and (min-width: 1133px) and (max-width: 1367px) {\n.search-input {\n    padding-right: 24px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: right !important;\n}\n}\n@media screen and (max-width: 1132px) {\n.search-input {\n    width: 100%;\n    padding-right: 24px;\n}\n.search-btn-group {\n    padding-top: 25px;\n    float: float !important;\n}\n}\n.el-input__icon {\n  line-height: 0;\n}\n.rotate:before {\n  -webkit-animation: rotate 0.5s infinite;\n          animation: rotate 0.5s infinite;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.el-loading-spinner .path {\n  stroke: #5272e9;\n}\n.el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-progress-bar__inner {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n  background-color: #5272e9;\n  -webkit-transition: width .6s ease;\n  transition: width .6s ease;\n  -webkit-animation: progress-bar-stripes 0.40s linear infinite;\n          animation: progress-bar-stripes 0.40s linear infinite;\n}\n@-webkit-keyframes progress-bar-stripes {\nfrom {\n    background-position: 40px 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n@keyframes progress-bar-stripes {\nfrom {\n    background-position: 40px 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n.el-button + .el-button {\n  margin-left: 18px;\n}\n.search-btn button:nth-child(2) {\n  margin-left: 18px;\n}\n.btn-clearance {\n  display: block;\n  margin-top: 5px;\n  margin-left: 0;\n}\n.el-input__prefix {\n  color: #000;\n  font-size: 20px;\n}\n.el-message-box {\n  width: 365px;\n  border: 0;\n  border-radius: 9px;\n  padding-bottom: 24px;\n  overflow: inherit;\n}\n.el-message-box__header {\n  height: 50px;\n  padding-top: 0;\n  background-color: #5272E9;\n  text-align: center;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin-bottom: 0;\n}\n.el-message-box__title {\n  height: 100%;\n  color: #fff;\n  line-height: 50px;\n}\n.el-message-box__message {\n  text-align: center;\n  font-size: 16px;\n  padding: 0 20px;\n}\n.el-message-box__message p {\n    word-break: break-word;\n}\n.el-message-box__content {\n  padding: 40px 0;\n}\n.el-message-box__btns {\n  padding: 0 42px;\n}\n.el-message-box__btns > .el-button--default {\n  float: left;\n  width: 115px;\n  height: 33px;\n  background: #fff;\n  border: 1px solid #666;\n  border-radius: 8px;\n  color: #666;\n  padding: 0;\n}\n.el-message-box__btns > .el-button--default:hover {\n  background: #fff;\n  border: 1px solid #5272e9;\n  color: #5272e9;\n}\n.el-message-box__btns > .el-button--default:focus {\n  background: #fff !important;\n  border: 1px solid #5272e9 !important;\n  color: #5272e9 !important;\n}\n.el-message-box__btns > .el-button--primary {\n  float: right;\n  width: 115px;\n  height: 33px;\n  background: #5272e9;\n  color: #fff;\n  border: 1px solid #5272e9;\n  padding: 0;\n}\n.el-button--primary:hover {\n  background: #355be6 !important;\n  border-color: #355be6 !important;\n  color: #fff !important;\n}\n.el-message-box__btns > .el-button--primary:focus {\n  background: #5272e9 !important;\n  border-color: #5272e9 !important;\n  color: #fff !important;\n}\n.el-button:hover,\n.el-message-box__btns > .el-button--default:focus {\n  background: -webkit-linear-gradient(top, #2ACBA4, #149A79 !important);\n  border-color: #2ACBA4;\n  color: #fff;\n}\n.single-msg-box .el-message-box__btns {\n  text-align: center;\n}\n.single-msg-box .el-message-box__btns .el-button--primary {\n  float: none;\n}\n.el-pagination {\n  text-align: center;\n  padding: 0 0 5px 0;\n  position: relative;\n}\n\n/*form表单*/\n.form-table {\n  border-color: #999;\n}\n.form-table tr td {\n  text-align: center;\n  vertical-align: middle;\n  height: 30px;\n  border: 1px solid #999;\n  background-color: #fff;\n}\n.form-table tr td input {\n  border: none;\n  width: 100%;\n  height: 30px;\n  padding-left: 5px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.form-table tr td input:hover {\n  text-overflow: clip;\n}\n.form-table tr td input:focus {\n  text-overflow: clip;\n}\n.form-table tr td input[type=\"file\"] {\n  position: relative;\n  top: 6px;\n}\n.btn-box {\n  padding: 52px 0 78px;\n  text-align: center;\n  border-top: none;\n}\n.btn-box > button + button {\n  margin-left: 90px !important;\n}\n.btn-box > button:nth-child(1) {\n  margin-left: 0;\n}\n.bj-line {\n  height: 22px;\n}\n.btn-box2 {\n  margin-top: 53px;\n  text-align: center;\n}\n.btn-box2 > button {\n  margin-left: 90px;\n}\n.btn-box2 > button:nth-child(1) {\n  margin-left: 0;\n}\n.white-btn:hover {\n  color: #333;\n  border-color: transparent;\n}\n.yellow-btn:hover {\n  background-color: #fdb44c;\n  border-color: #fdb44c;\n}\n.green-btn:hover {\n  border-color: #2dd4ab;\n  background-color: #2dd4ab;\n}\n.grey-btn:hover {\n  border-color: rgba(180, 184, 183, 0.9);\n  background-color: rgba(180, 184, 183, 0.9);\n}\n.blue-btn:hover {\n  border-color: #1e90ff;\n  background-color: #1e90ff;\n}\n.el-tabs__item .is-active {\n  color: #006ab6 !important;\n}\n.el-tabs__active-bar {\n  background-color: transparent;\n}\n.el-tabs__header {\n  border: none;\n}\n.el-tabs__item {\n  margin-right: 100px;\n}\n.el-tabs--border-card > .el-tabs__header .el-tabs__item {\n  color: #75b2de;\n}\n.imgTdUl {\n  text-decoration: none;\n}\n.imgTdUl li {\n  display: inline-block;\n  margin: 5px;\n}\n.imgBox {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  margin: 0 auto;\n}\n.imgNow {\n  height: 100%;\n  width: 100%;\n}\n#addShopImgList {\n  text-decoration: none;\n  display: inline-block;\n}\n#addShopImgList li {\n  margin-left: 18px;\n  margin-bottom: 18px;\n  width: 122px;\n  height: 150px;\n  border-radius: 8px;\n  -webkit-box-shadow: 0px 0px 24px rgba(191, 205, 255, 0.59);\n          box-shadow: 0px 0px 24px rgba(191, 205, 255, 0.59);\n  position: relative;\n}\n#addShopImgList li:hover img {\n  top: 6px;\n  right: 6px;\n  display: inline-block;\n}\n#addShopImgList li img {\n  height: 100%;\n  width: 100%;\n}\n.shopMetails {\n  width: 100px;\n  height: 100px;\n}\n#modifyShopUl {\n  text-decoration: none;\n  display: inline-block;\n}\n#modifyShopUl li {\n  margin: 5px;\n  display: inline-block;\n  position: relative;\n  list-style: none;\n}\n#modifyShopUl li img {\n  height: 80px;\n  width: 80px;\n}\n#shopAuditImgList li {\n  width: 80px;\n  height: 80px;\n  display: inline-block;\n  list-style: none;\n  margin: 5px;\n}\n#shopAuditImgList li img {\n  height: 100%;\n  width: 100%;\n}\n#merAuditImgList {\n  padding: 0;\n}\n#merAuditImgList li {\n  width: 80px;\n  height: 80px;\n  display: inline-block;\n  list-style: none;\n  margin: 5px;\n}\n#merAuditImgList li img {\n  height: 100%;\n  width: 100%;\n}\n.merAuditImg {\n  width: 80px;\n  height: 80px;\n}\n@-webkit-keyframes octocat-wave {\n0%,\n  100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n20%,\n  60% {\n    -webkit-transform: rotate(-25deg);\n            transform: rotate(-25deg);\n}\n40%,\n  80% {\n    -webkit-transform: rotate(10deg);\n            transform: rotate(10deg);\n}\n}\n@keyframes octocat-wave {\n0%,\n  100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n20%,\n  60% {\n    -webkit-transform: rotate(-25deg);\n            transform: rotate(-25deg);\n}\n40%,\n  80% {\n    -webkit-transform: rotate(10deg);\n            transform: rotate(10deg);\n}\n}\n@media (max-width: 500px) {\n.github-corner:hover .octo-arm {\n    -webkit-animation: none;\n            animation: none;\n}\n.github-corner .octo-arm {\n    -webkit-animation: octocat-wave 560ms ease-in-out;\n            animation: octocat-wave 560ms ease-in-out;\n}\n}\n.el-dialog--small {\n  width: 680px;\n}\n.BD-style .el-dialog {\n  border-radius: 20px;\n  width: 689px;\n}\n.BD-style .el-dialog__footer {\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n}\n.BD-style .el-dialog .el-dialog__header {\n  background-color: #5272e9;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  padding: 16px;\n}\n.BD-style .el-dialog .el-dialog__header .el-dialog__title {\n    color: #fff;\n    font-weight: normal;\n}\n.BD-style .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {\n    color: #fff;\n}\n.BD-style .el-dialog .el-dialog__header .el-form-item__label {\n    color: #444;\n}\n.el-dialog__body {\n  padding: 30px 20px;\n}\n.BD-style .el-dialog .el-dialog__body .BD-item {\n  width: 300px;\n}\n.BD-style .el-dialog .el-dialog__body .BD-item .el-input__inner:focus {\n    border-color: #0a0a0a;\n}\n.BD-style .el-dialog .el-dialog__body .BD-item .el-input__inner {\n    border: 1px solid #D7D7D7;\n    border-radius: 5px;\n}\n.BD-style .el-dialog .el-dialog__body .phoneInp {\n  height: 39px;\n  outline: none;\n  border: 1px solid #D7D7D7;\n  border-radius: 5px;\n  padding: 3px 10px;\n}\n.BD-style .el-dialog .el-dialog__body .phoneInp:focus {\n  border-color: #0A0A0A;\n}\n.BD-style .el-dialog .el-dialog__body .el-input-img {\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  right: 10px;\n  top: 5px;\n}\n.BD-style .el-dialog .el-dialog__body .el-input-img img {\n    width: 100%;\n    height: 100%;\n}\n.BD-style .el-form-item.is-required .el-form-item__label:before {\n  content: '';\n}\n.BD-style .el-dialog .dialog-footer .footer-ok {\n  color: #fff;\n  background-color: #5272e9;\n  border: 1px solid #5272e9;\n  width: 128px;\n  font-size: 18px;\n}\n.modifyPwd .el-dialog--small {\n  line-height: 0;\n  border-radius: 8px;\n}\n.modifyPwd .el-dialog--small .el-dialog__header {\n    height: 84px;\n    line-height: 97px;\n    background-color: #006ab6;\n    text-align: center;\n    padding: 0;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n}\n.modifyPwd .el-dialog--small .el-dialog__header .el-dialog__title {\n      color: #FFFFFF;\n      font-weight: normal;\n      font-size: 30px;\n}\n.modifyPwd .el-dialog--small {\n  width: 350px !important;\n}\n.modifyPwd .el-dialog__header {\n  background-color: #5272e9;\n  text-align: center;\n  padding: 18px;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  font-weight: bold;\n}\n.modifyPwd .el-dialog__header .el-dialog__title {\n    color: #fff;\n}\n.modifyPwd .el-form-item {\n  display: block;\n  margin-bottom: 15px;\n  height: 44px;\n}\n.modifyPwd .el-form-item .el-form-item__content .el-input {\n    width: 100%;\n    height: 20px;\n}\n.modifyPwd .el-form-item .el-form-item__content .el-input .el-input__inner {\n      border: none;\n      padding: 0;\n      border-bottom: 1px solid #575757;\n      height: 20px;\n      font-size: 16px;\n      font-weight: bold;\n}\n.modifyPwd .el-form-item .el-form-item__content .el-input .el-input__inner:focus {\n      color: #006ab6;\n      border-color: #006ab6;\n}\n.modifyPwd .el-form-item .el-form-item__content .el-input .el-input__inner::after {\n      content: ' ';\n      width: 100%;\n      height: 1px;\n      background-color: #333;\n}\n.modifyPwd .el-dialog__footer .dialog-footer,\n.isShowUser .el-dialog__footer .dialog-footer,\n.el-dialog-add .el-dialog__footer .dialog-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  display: -webkit-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-ok,\n  .isShowUser .el-dialog__footer .dialog-footer .footer-ok,\n  .el-dialog-add .el-dialog__footer .dialog-footer .footer-ok {\n    background-color: #5272e9;\n    border: 1px solid #5272e9;\n    color: #fff;\n    width: 200px;\n    height: 48px;\n    font-size: 24px;\n    font-weight: normal;\n    margin-top: -32px;\n    margin-bottom: 10px;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-ok:hover,\n    .isShowUser .el-dialog__footer .dialog-footer .footer-ok:hover,\n    .el-dialog-add .el-dialog__footer .dialog-footer .footer-ok:hover {\n      background-color: #1e90ff;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel,\n  .isShowUser .el-dialog__footer .dialog-footer .footer-cancel,\n  .el-dialog-add .el-dialog__footer .dialog-footer .footer-cancel {\n    color: #5272E9;\n    background-color: #fff;\n    border: 0;\n}\n.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel:hover,\n    .isShowUser .el-dialog__footer .dialog-footer .footer-cancel:hover,\n    .el-dialog-add .el-dialog__footer .dialog-footer .footer-cancel:hover {\n      color: #1e90ff;\n}\ninput#userName.el-input__inner {\n  text-align: center !important;\n  width: 100%;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 1px;\n  -webkit-appearance: none;\n  padding: 0;\n}\n.el-form-item__error {\n  text-align: right;\n  right: 0;\n  font-weight: bold;\n}\n.selectShopIndustry {\n  height: 30px;\n  width: 280px;\n}\n.selectShopIndustry .el-input {\n    height: 30px;\n    width: 280px !important;\n}\n.selectShopIndustry .el-input__inner {\n    height: 30px;\n    width: 280px;\n    border: none;\n    border-bottom: 1px solid #333333 !important;\n    padding: 0;\n    color: #666666;\n    font-size: 20px;\n}\n#modifyShopElupload .el-upload {\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n  margin-top: 35px;\n}\n#modifyShopElupload .el-upload .avatar-uploader-icon {\n    width: 60px;\n    height: 60px;\n}\n#addShopElupload .el-upload {\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n  margin-top: 35px;\n}\n#addShopElupload .el-upload .avatar-uploader-icon {\n    width: 60px;\n    height: 60px;\n}\n.delShopImg {\n  display: inline-block;\n  width: 18px;\n  height: 20px;\n  cursor: pointer;\n  position: absolute;\n  top: 6px;\n  right: 6px;\n}\n.delShopImg img {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    display: none;\n    width: 100%;\n    height: 100%;\n}\n.el-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n}\n.el-carousel .el-carousel__container .el-carousel__arrow {\n  font-size: 30px !important;\n  top: 70%;\n}\n#oldPwdItem .el-form-item__label {\n  font-size: 10px;\n}\n.delImg {\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  background-color: #DE3838;\n  color: white;\n  font-weight: 700;\n  border: 1px solid #DE3838;\n  border-radius: 7px;\n  line-height: 14px;\n  padding-left: 1px;\n  cursor: pointer;\n}\n@media only screen and (min-width: 1920px) {\n.el-carousel .el-carousel__container .el-carousel__arrow {\n    font-size: 30px !important;\n    top: 90%;\n}\n}\n.custom-dialog, .custom-dialogUser {\n  margin-top: 0 !important;\n  border-radius: 20px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  background-color: transparent;\n  overflow: hidden;\n}\n.custom-dialog .el-dialog__body, .custom-dialogUser .el-dialog__body {\n    padding: 30px 20px 40px;\n    background-color: #fff;\n}\n.custom-dialogUser .el-dialog__footer {\n  background-color: #fff;\n  border-color: #FFFFFF;\n  height: 0px !important;\n}\n#HKAddDialog .el-form .el-form-item:nth-child(2n) {\n  margin-left: 25px;\n  margin-right: 0;\n}\n.el-button:hover {\n  background-color: #355be6;\n  border: 1px solid #355be6;\n  color: #fff;\n}\n.el-button:focus {\n  background-color: #5272e9;\n  border-color: #5272e9 !important;\n  color: #fff;\n}\n.breadcrumb-father {\n  position: fixed;\n  z-index: 1002;\n  top: 29px;\n}\n.new-breadcrumb {\n  font-size: 14px;\n  color: #4964CF;\n  overflow: hidden;\n}\n.new-breadcrumb .arrow {\n    font-size: 18px;\n    margin: 0 4px;\n    height: 22px;\n    line-height: 22px;\n}\n.new-breadcrumb a {\n    float: left;\n    margin-right: 4px;\n    height: 22px;\n    line-height: 22px;\n}\n.new-breadcrumb span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 223px;\n    white-space: nowrap;\n    float: left;\n    height: 22px;\n    line-height: 22px;\n}\n.el-table__body-wrapper::-webkit-scrollbar {\n  /*滚动条整体样式*/\n  width: 15px;\n  /*高宽分别对应横竖滚动条的尺寸*/\n  height: 15px;\n}\n.el-table__body-wrapper::-webkit-scrollbar-thumb {\n  /*滚动条里面小方块*/\n  border-radius: 5px;\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n  background: rgba(0, 0, 0, 0.2);\n}\n.el-table__body-wrapper::-webkit-scrollbar-track {\n  /*滚动条里面轨道*/\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  background: rgba(0, 0, 0, 0.1);\n}\n.time-input {\n  -webkit-appearance: none;\n  background-color: #fff;\n  background-image: none;\n  border-radius: 4px;\n  border: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #606266;\n  display: inline-block;\n  font-size: 14px;\n  height: 40px;\n  line-height: 40px;\n  outline: 0;\n  padding: 0;\n  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 100%;\n}\n.time-input:hover {\n  border-color: #c0c4cc;\n}\n.time-input:focus {\n  border-color: #409EFF;\n  outline: 0;\n}\n.time-input::-webkit-input-placeholder {\n  color: #c0c4cc;\n}\n.time-input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #c0c4cc;\n}\n.time-input::-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #c0c4cc;\n}\n.time-input::-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #c0c4cc;\n}\n.area-wrapper {\n  position: relative;\n}\n.menu-wrapper .is-active {\n  color: white;\n}\n.handle-area {\n  display: none;\n  position: absolute;\n  right: -3px;\n  top: 0;\n  background-color: #5272e9;\n  color: #fff;\n  padding: 0 20px;\n  border-top-left-radius: 17px;\n  border-bottom-left-radius: 17px;\n}\n.handle-hidden-1 {\n  position: absolute;\n  right: -120px;\n  top: 0;\n}\n.handle-hidden-2 {\n  position: absolute;\n  right: -240px;\n  top: 6px;\n}\n.handle-hidden-3 {\n  position: absolute;\n  right: -360px;\n  top: 6px;\n}\n.handle-hidden-4 {\n  position: absolute;\n  right: -480px;\n  top: 6px;\n}\n.el-table .animate_td {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.el-table .Underline {\n  text-decoration: underline;\n  white-space: normal !important;\n}\n.el-table .see:hover {\n  background: #5272e9;\n}\n.el-table .see {\n  width: 50px;\n  height: 21px;\n  margin-top: 4px;\n  border-radius: 5px;\n  border: none;\n  text-decoration: none;\n  display: inline-block;\n  background: #5272e9;\n  color: #FFF;\n  white-space: normal !important;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n.svg-slide-icon {\n  margin-right: 15px;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  color: #fff;\n}\n.svg-title-icon {\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  margin-top: -6px;\n}\n.svg-head-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  margin-top: 0;\n}\n.svg-action-icon {\n  margin: 0 0 2px 0;\n  cursor: pointer;\n  color: #fff;\n}\n.svg-link-class {\n  margin-left: 40px;\n}\n.svg-link-class:last-child {\n  margin-right: 40px;\n}\n.tooltip_toggle {\n  background-color: transparent !important;\n  border: none !important;\n}\n.el-dialog-add .el-dialog {\n  width: 420px;\n  border-radius: 8px;\n}\n.el-dialog-withdraw .el-dialog {\n  width: 450px;\n}\n.el-dialog-withdraw .el-dialog .disabled-btn {\n    background-color: #999 !important;\n    border: 1px solid #999 !important;\n    cursor: no-drop;\n}\n.el-radio:focus:not(.is-focus):not(:active) .el-radio__inner {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #afabab;\n  color: #fff;\n  background: #fff;\n  display: block;\n}\n.el-radio__inner:hover {\n  border-color: #5272e9;\n}\n.el-radio__inner {\n  width: 20px;\n  height: 20px;\n}\n.el-radio__inner::after {\n  width: 8px;\n  height: 8px;\n  background-color: #5272e9;\n}\n.el-dialog-add .el-form-item.is-error .el-input__inner {\n  border-color: #c0c4cc;\n}\n.el-dialog-add .el-form-item.is-error .el-input__inner:focus {\n  border-color: #409eff;\n}\n.el-dialog-add .el-form-item__label::before {\n  content: '' !important;\n}\n.el-dialog-add .el-dialog__body {\n  padding: 20px 20px 8px 20px;\n}\n.el-dialog-withdraw .el-dialog__body {\n  padding: 20px 20px 10px 20px;\n}\n.el-dialog-withdraw .el-dialog__footer {\n  margin-top: 0;\n}\n.el-dialog-add .el-dialog__header {\n  text-align: center;\n  background-color: #5272e9;\n  height: 55px;\n  line-height: 55px;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  padding: 0;\n}\n.el-dialog-ad .el-dialog__header {\n  text-align: center;\n  background-color: #5272e9;\n  height: 40px;\n  line-height: 40px;\n  padding: 0;\n}\n.el-dialog-ad .el-dialog__headerbtn {\n  position: absolute;\n  top: 3px;\n  right: 20px;\n  padding: 0;\n  background: 0 0;\n  border: none;\n  outline: 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n.el-dialog-ad .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.el-dialog-add .el-dialog__title {\n  color: #fff;\n  font-size: 18px;\n}\n.el-dialog-ad .el-dialog__title {\n  color: #fff;\n  font-size: 18px;\n}\n.el-dialog-add .el-form--inline .el-form-item {\n  width: 100%;\n  overflow: hidden;\n}\n.el-dialog-add .el-form--inline .el-form-item__label {\n  float: left;\n  display: inline-block;\n  width: 86px;\n  font-weight: bold;\n}\n.el-dialog-add .el-select,\n.el-dialog-add .el-select > .el-input,\n.el-dialog-add .el-input {\n  width: 100%;\n}\n.el-select {\n  width: 100%;\n}\n.el-dialog-add .el-form--label-top .el-form-item__label {\n  text-align: right;\n}\n.el-dialog-add .el-form--inline.el-form--label-top .el-form-item__content {\n  float: right;\n  width: 288px;\n}\n.el-dialog-add .el-dialog__footer {\n  padding: 40px 30px 0px;\n}\n.el-dialog-add .el-dialog__footer .dialog-footer .footer-cancel {\n  margin-left: 0;\n}\ninput.invalid::-webkit-input-placeholder {\n  color: red;\n}\n.border_red {\n  border-color: red !important;\n}\n.ad-wrapper-div {\n  overflow: hidden;\n  min-width: 1224px;\n  padding: 0 0 17px 17px;\n}\n.ad-wrapper-div .ad-cards {\n    overflow: hidden;\n    float: left;\n    margin-top: 35px;\n    margin-right: 40px;\n    border-radius: 20px;\n    -webkit-box-shadow: 0px 0px 30px rgba(109, 140, 255, 0.3);\n            box-shadow: 0px 0px 30px rgba(109, 140, 255, 0.3);\n    position: relative;\n}\n.ad-wrapper-div .ad-cards .ad-card-div {\n      width: 360px;\n      height: 360px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img {\n        height: 140px;\n        background-color: #f1f4ff;\n        position: relative;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img img {\n          width: 100%;\n          height: 100%;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .btn-div {\n          position: absolute;\n          right: 9px;\n          top: 10px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .btn-div span {\n            background-color: #333;\n            border-radius: 50%;\n            width: 44px;\n            height: 44px;\n            display: inline-block;\n            opacity: .7;\n            cursor: pointer;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .btn-div span .icon-btn {\n              width: 100%;\n              height: 100%;\n              color: #fff;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .btn-div span + span {\n            margin-left: 10px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div {\n          position: absolute;\n          left: 0;\n          top: 0;\n          width: 100%;\n          height: 140px;\n          background-color: rgba(0, 0, 0, 0.4);\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .content {\n            text-align: center;\n            color: #fff;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .content .svg-pic {\n              position: relative;\n              background-color: #333;\n              border-radius: 50%;\n              opacity: .7;\n              width: 60px;\n              height: 60px;\n              margin: 20px auto;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .content .svg-pic .uploadImg {\n                width: 100%;\n                height: 100%;\n                color: #fff;\n                position: absolute;\n                left: 0;\n                top: 0;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .content .svg-pic input {\n                width: 100%;\n                height: 100%;\n                opacity: 0;\n                cursor: pointer;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .content span {\n              font-size: 14px;\n              display: block;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .shadow-div .el-upload {\n            width: 100%;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div {\n          background-color: transparent;\n          cursor: pointer;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div .pic-svg-class {\n            width: 80px;\n            height: 90px;\n            margin: 5px auto;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div span {\n            color: #5272e9;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div input {\n            width: 100%;\n            height: 100%;\n            opacity: 0;\n            position: absolute;\n            cursor: pointer;\n            left: 0;\n            top: 0;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div #changePic {\n            display: none;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-img .add-div #changePic span {\n              color: #fff;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content {\n        height: 220px;\n        background-color: #fff;\n        overflow: hidden;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .title {\n          height: 82px;\n          padding: 16px 18px;\n          font-size: 18px;\n          font-weight: bold;\n          position: relative;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .title span {\n            overflow: hidden;\n            display: block;\n            height: 48px;\n            word-break: break-word;\n            line-height: 48px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .title::after {\n            content: ' ';\n            width: 336px;\n            height: 1px;\n            background-color: #E6E6E6;\n            position: absolute;\n            bottom: 0;\n            left: 12px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .title .multiple-line {\n            height: auto;\n            word-break: break-all;\n            line-height: normal;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 2;\n            line-height: 24px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont {\n          overflow: hidden;\n          margin-top: 12px;\n          padding-left: 20px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont .left,\n          .ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont .right {\n            float: left;\n            height: 30px;\n            line-height: 30px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont .left {\n            width: 85px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont .right {\n            width: 220px;\n            text-indent: 4px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont .multiple-line {\n            height: auto;\n            line-height: normal;\n            word-break: break-word;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 3;\n            line-height: 24px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content .cont + .cont {\n          margin-top: 10px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont {\n        color: #666;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont input,\n        .ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont select {\n          width: 232px;\n          height: 34px;\n          border: 0;\n          border-bottom: 1px solid #e6e6e6;\n          -webkit-box-sizing: border-box;\n                  box-sizing: border-box;\n          float: left;\n          outline: none;\n          -webkit-transition: all .3s;\n          transition: all .3s;\n          text-indent: 6px;\n          border-radius: 0;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont input:focus,\n          .ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont select:focus {\n            border-color: #5272e9;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont select {\n          float: none;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont .el-input {\n          float: left;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont .left,\n        .ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont .right {\n          height: 35px;\n          line-height: 35px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .cont + .cont {\n        margin-top: 14px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns {\n        margin-top: 22px;\n        text-align: center;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .confirm-btn,\n        .ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .cancel-btn {\n          width: 88px;\n          height: 32px;\n          line-height: 30px;\n          border-radius: 16px;\n          -webkit-transition: all .3s;\n          transition: all .3s;\n          outline: none;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .confirm-btn {\n          background-color: #5272e9;\n          color: #fff;\n          border: 1px solid #5272e9;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .confirm-btn:hover {\n            background-color: #355be6;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .cancel-btn {\n          background-color: #fff;\n          color: #5272e9;\n          border: 1px solid #5272e9;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns .cancel-btn:hover {\n            background-color: #5272e9;\n            color: #fff;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .ad-content-edit .btns button + button {\n          margin-left: 45px;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .fore-div {\n        background-color: #fff;\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .fore-div .circle {\n          width: 120px;\n          height: 120px;\n          border-radius: 50%;\n          background-color: #f1f4ff;\n          position: absolute;\n          left: 50%;\n          top: 47%;\n          -webkit-transform: translate(-50%, -50%);\n                  transform: translate(-50%, -50%);\n          cursor: pointer;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .fore-div .circle::before {\n            content: ' ';\n            position: absolute;\n            left: 36px;\n            top: 58px;\n            width: 48px;\n            height: 4px;\n            background-color: #96acfc;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .fore-div .circle::after {\n            content: ' ';\n            position: absolute;\n            left: 58px;\n            top: 36px;\n            width: 4px;\n            height: 48px;\n            background-color: #96acfc;\n}\n.ad-wrapper-div .ad-cards .ad-card-div .fore-div .circle span {\n            position: absolute;\n            top: 134px;\n            left: 50%;\n            -webkit-transform: translateX(-50%);\n                    transform: translateX(-50%);\n            color: #999;\n            width: 145px;\n            text-align: center;\n}\n.ad-wrapper-div .ad-cards .del {\n      position: absolute;\n      left: 0;\n      top: 0;\n      background-color: #fff;\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      display: none;\n}\n.ad-wrapper-div .ad-cards .del .cont {\n        margin-top: 80px;\n        font-size: 20px;\n        font-weight: bold;\n        padding: 0 6px;\n}\n.ad-wrapper-div .ad-cards .del .confirm-btn,\n      .ad-wrapper-div .ad-cards .del .cancel-btn {\n        width: 200px;\n        height: 32px;\n        line-height: 30px;\n        border-radius: 16px;\n        -webkit-transition: all .3s;\n        transition: all .3s;\n        outline: none;\n}\n.ad-wrapper-div .ad-cards .del .confirm-btn {\n        background-color: #5272e9;\n        color: #fff;\n        border: 1px solid #5272e9;\n        margin-top: 80px;\n}\n.ad-wrapper-div .ad-cards .del .confirm-btn:hover {\n          background-color: #355be6;\n}\n.ad-wrapper-div .ad-cards .del .cancel-btn {\n        background-color: #fff;\n        color: #5272e9;\n        border: 1px solid #5272e9;\n        margin-top: 28px;\n}\n.ad-wrapper-div .ad-cards .del .cancel-btn:hover {\n          background-color: #5272e9;\n          color: #fff;\n}\n.ad-wrapper-div .ad-cards div[id^=\"btn-div-\"] {\n      display: none;\n}\n.ad-wrapper-div .ad-cards div[id^=\"shadow-div-\"] {\n      display: none;\n}\n.ad-wrapper-div .ad-cards div[id^=\"ad-content-view-\"] {\n      display: block;\n}\n.ad-wrapper-div .ad-cards div[id^=\"ad-content-edit-\"] {\n      display: none;\n}\n.footer-btn-div {\n  text-align: center;\n  padding: 40px 0 30px 0;\n}\n.footer-btn-div button {\n    border-radius: 4px;\n    width: 160px;\n    height: 45px;\n    line-height: 45px;\n    border: 1px solid #5272e9;\n}\n.footer-btn-div .cancel-btn {\n    background-color: #fff;\n    border: 1px solid #5272e9;\n    color: #5272e9;\n}\n.footer-btn-div .cancel-btn:hover {\n      background-color: rgba(82, 114, 233, 0.9);\n      border: 1px solid rgba(82, 114, 233, 0.9);\n      color: #fff;\n}\n.footer-btn-div button + button {\n    margin-left: 104px;\n}\n.el-table--fit {\n  height: 486px !important;\n}\n.el-table--enable-row-transition .el-table__body td {\n  padding: 2px 0;\n}\n.animate_td .cell {\n  top: 2px;\n  right: 0;\n}\n.el-table__body tr.hover-row > td {\n  background-color: #d2e4f8;\n}\n.el-table--striped .el-table__body tr.el-table__row--striped td {\n  background: #eef7ff;\n}\n.width100 {\n  width: 100px !important;\n}\n.width-full {\n  width: 100% !important;\n}\n#qrcode {\n  text-align: center;\n  position: relative;\n}\n.dialogQrcode {\n  width: 350px;\n  margin-top: 23vh !important;\n  border-radius: 8px;\n}\n.dialogQrcode .el-dialog__body {\n    text-align: center;\n    padding: 15px 20px;\n}\n.dialogQrcode .el-dialog__body .channel-box {\n      margin: 6px 0 15px 0;\n      border-bottom: 2px solid #ccc;\n      padding-bottom: 16px;\n}\n.dialogQrcode .el-dialog__body .channel-box .unionpay-img {\n        margin-bottom: 1px;\n}\n.dialogQrcode .el-dialog__body .channel-box img + img {\n        margin-left: 16px;\n}\n.dialogQrcode .el-dialog__body .termId {\n      color: #666;\n      font-size: 20px;\n      padding: 0;\n      margin: 0;\n}\n.dialogQrcode .el-dialog__header {\n    padding: 0;\n    height: 55px;\n    line-height: 55px;\n    background-color: #4f6ee1;\n    text-align: center;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n}\n.dialogQrcode .el-dialog__header .el-dialog__title {\n      line-height: 24px;\n      font-size: 15px;\n      font-weight: 700;\n      color: white;\n}\n.dialogQrcode .el-dialog__header .el-dialog__headerbtn {\n      top: 0px;\n      font-size: 20px;\n}\n.dialogQrcode .el-dialog__header .el-dialog__headerbtn .el-dialog__close {\n      color: white;\n      font-weight: bold;\n}\n#qrcode {\n  display: none;\n}\n.el-dialog-refund .el-dialog__headerbtn {\n  top: 0;\n}\n.el-dialog-refund .el-dialog__headerbtn .el-icon-close {\n    color: white;\n}\n.el-dialog-progress .el-dialog__body {\n  padding: 35px 20px 20px 20px;\n}\n.el-dialog-feed .el-dialog__header .el-dialog__title {\n  font-weight: bold;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  word-break: break-word;\n  padding: 5px 15px;\n}\n.handle_box {\n  position: fixed;\n  left: 223px;\n  top: 78px;\n  width: calc(100vw - 242px);\n  min-width: 908px;\n  height: 76px;\n  z-index: 1000;\n  background-color: #f6f6f6;\n  padding: 0 37px 0 44px;\n}\n.handle_box .anchors_ul {\n    list-style: none;\n    width: 70%;\n    overflow: hidden;\n    margin: 0;\n    padding: 0;\n    float: left;\n    font-size: 15px;\n}\n.handle_box .anchors_ul li {\n      height: 42px;\n      line-height: 40px;\n      text-align: center;\n      border-radius: 28px;\n      float: left;\n      border: 2px solid #5272e9;\n      padding: 0 18px;\n      margin-top: 10px;\n      color: #4964cf;\n      cursor: pointer;\n}\n.handle_box .anchors_ul a {\n      margin-right: 10px;\n      float: left;\n}\n.handle_box .anchors_ul .active {\n      background-color: #5272e9;\n      color: #fff;\n}\n.handle_box .button_box {\n    list-style: none;\n    width: 340px;\n    overflow: auto;\n    margin: 0;\n    padding: 0;\n    float: right;\n    font-size: 15px;\n}\n.handle_box .button_box li {\n      float: right;\n      height: 42px;\n      line-height: 38px;\n      text-align: center;\n      border-radius: 30px;\n      border: 2px solid #5272e9;\n      padding: 0 15px;\n      margin-top: 10px;\n      color: #4964cf;\n}\n.handle_box .button_box li + li {\n      margin-right: 2%;\n}\n.handle_box .button_box .cancel {\n      background-color: #ccc;\n      color: #fff;\n      border: 2px solid #ccc;\n}\n.handle_box .button_box .confirm {\n      background-color: #02cc0c;\n      color: #fff;\n      border: 2px solid #02cc0c;\n}\n.handle_box .button_box .cancel,\n    .handle_box .button_box .confirm {\n      cursor: pointer;\n}\n.handle_box .button_box .icon-btn {\n      margin-right: 8px;\n      margin-top: -4px;\n}\n.el-date-picker__editor-wrap .el-input {\n  width: auto;\n}\n.el-time-spinner.has-seconds .el-time-spinner__wrapper {\n  width: 31.3%;\n}\n.el-time-panel__content::after,\n.el-time-panel__content::before {\n  margin-top: -6px;\n}\n.table-space-div {\n  height: 80px;\n}\n#textareaRight .textareaStyle {\n  height: 100%;\n  width: 100%;\n  border: 1px solid #dcdfe6;\n  border-radius: 4px;\n  padding-top: 4px;\n  resize: none;\n}\n#textareaRight .closeStyle {\n  outline: none;\n  border: 0;\n}\n.table-space-div_cn {\n  height: 120px;\n}\n.handle_box_cn {\n  height: 110px;\n}\n.table-space-div_en {\n  height: 120px;\n}\n.handle_box_en {\n  height: 110px;\n}\n.shrink-style {\n  left: 100px;\n  width: calc(100vw - 100px);\n}\n@media screen and (min-width: 1800px) {\n.table-div .content .image-item .img-div {\n    width: 260px !important;\n    height: 307px !important;\n}\n.table-div .content .image-item .img-div .show-div {\n      height: 270px !important;\n}\n.table-div .content .image-item .img-div .show-div img {\n        height: 270px !important;\n}\n.table-div .content .image-item .img-div .show-group-div {\n      height: 270px !important;\n}\n.table-div .content .image-item .img-div .show-group-div img {\n        height: 270px !important;\n}\n.table-div .content .image-item .img-div .file-group-div {\n      height: 270px !important;\n}\n.table-div .content .image-item .img-group-div {\n    height: 270px !important;\n}\n.table-div .content .image-item .file-div {\n    height: 270px !important;\n}\n}\n.table-div {\n  overflow: hidden;\n  border-radius: 6px;\n  -webkit-box-shadow: 0px 0px 16px 0px rgba(109, 140, 255, 0.16);\n          box-shadow: 0px 0px 16px 0px rgba(109, 140, 255, 0.16);\n  background-color: #fff;\n  width: 99%;\n  min-width: 1190px;\n  margin: 0 auto;\n}\n.table-div .title {\n    height: 60px;\n    line-height: 60px;\n    background: #cbd4f8;\n    color: #4964cf;\n    font-size: 22px;\n    padding-left: 40px;\n    position: relative;\n}\n.table-div .title::before {\n    content: ' ';\n    width: 4px;\n    height: 24px;\n    background-color: #5272e9;\n    position: absolute;\n    left: 28px;\n    top: 18px;\n}\n.table-div .image-group-title {\n    background-color: #f5f5f5;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n}\n.table-div .content {\n    margin: 0;\n    padding: 20px 15px;\n    overflow: hidden;\n    list-style: none;\n    position: relative;\n}\n.table-div .content .channelLine {\n      background-color: #dedede;\n      height: 1px;\n      float: left;\n      width: 100%;\n      margin: 20px 0;\n}\n.table-div .content .item {\n      float: left;\n      width: 33.3333%;\n      height: 40px;\n      overflow: hidden;\n}\n.table-div .content .item .left-div {\n        text-align: right;\n        width: 40%;\n        float: left;\n        height: 40px;\n        line-height: 18px;\n        overflow: hidden;\n        position: relative;\n}\n.table-div .content .item .left-div .cont {\n          position: absolute;\n          right: 4px;\n          top: 50%;\n          -webkit-transform: translateY(-50%);\n                  transform: translateY(-50%);\n}\n.table-div .content .item .left-div .typeTitle {\n          padding: 6px 14px;\n          border-radius: 30px;\n          min-width: 100px;\n          text-align: center;\n          float: left;\n          position: inherit;\n          left: 0;\n          margin-left: 20px;\n          color: #676767;\n          background-color: #d9d9d9;\n          font-weight: bold;\n}\n.table-div .content .item .left-div .typeTitle-Selection {\n          color: #5272e9;\n          background-color: #cbd4f8;\n}\n.table-div .content .item .center-div {\n        text-align: center;\n        width: 100%;\n        font-weight: bold;\n        float: left;\n        height: 40px;\n        overflow: hidden;\n        position: relative;\n}\n.table-div .content .item .center-div .cont {\n          width: 100%;\n          height: 100%;\n          line-height: 40px;\n}\n.table-div .content .item .right-div1 {\n        text-align: left;\n        width: 50%;\n        float: left;\n        line-height: normal;\n}\n.table-div .content .item .right-div1 input {\n          width: 96%;\n          height: 30px !important;\n          line-height: 30px;\n          margin: 5px 0;\n          -webkit-appearance: none;\n          background-color: #fff;\n          border-radius: 4px;\n          border: 1px solid #dcdfe6;\n          -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n          color: #333;\n          outline: 0;\n          padding: 0 0 0 32px;\n}\n.table-div .content .item .right-div1 .view-input {\n          border: 0;\n}\n.table-div .content .item .right-div1 .view-input input {\n            border-color: transparent;\n            cursor: initial;\n}\n.table-div .content .item .right-div1 .view-input span {\n            display: none;\n}\n.table-div .content .item .right-div1 .el-date-editor.el-input,\n        .table-div .content .item .right-div1 .el-input {\n          width: 100%;\n}\n.table-div .content .item .right-div1 .el-input__inner {\n          font-size: 16px;\n}\n.table-div .content .item .right-div {\n        text-align: left;\n        width: 50%;\n        float: left;\n        line-height: normal;\n}\n.table-div .content .item .right-div input {\n          width: 96%;\n          height: 30px !important;\n          line-height: 30px;\n          margin: 5px 0;\n          -webkit-appearance: none;\n          background-color: #fff;\n          border-radius: 4px;\n          border: 1px solid #dcdfe6;\n          -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n          color: #333;\n          outline: 0;\n          padding: 0 0 0 6px;\n}\n.table-div .content .item .right-div .view-input {\n          border: 0;\n}\n.table-div .content .item .right-div .view-input input {\n            border-color: transparent;\n            cursor: initial;\n}\n.table-div .content .item .right-div .view-input span {\n            display: none;\n}\n.table-div .content .item .right-div .el-date-editor.el-input,\n        .table-div .content .item .right-div .el-input {\n          width: 100%;\n}\n.table-div .content .item .right-div .el-input__inner {\n          font-size: 16px;\n}\n.table-div .content .item .date-input .el-input__inner {\n        padding-left: 30px;\n}\n.table-div .content .item .left-div-else {\n        width: 99%;\n}\n.table-div .content .item .right-div-else {\n        width: 1%;\n}\n.table-div .content .item-color {\n      color: #999999;\n}\n.table-div .content .image-item {\n      float: left;\n      width: 20%;\n      overflow: hidden;\n      min-width: 206px;\n      margin-top: 10px;\n}\n.table-div .content .image-item .img-title {\n        text-align: center;\n        height: 35px;\n        line-height: 35px;\n        border-bottom: 1px solid #d8d8d8;\n}\n.table-div .content .image-item .file-div {\n        background-color: #f5f5f5;\n        width: 100%;\n        height: 203px;\n        position: relative;\n        margin: 0 auto;\n}\n.table-div .content .image-item .file-div .el-upload,\n        .table-div .content .image-item .file-div #merElupload,\n        .table-div .content .image-item .file-div i {\n          width: 100%;\n          height: 100%;\n}\n.table-div .content .image-item .file-div .el-icon-plus:before {\n          content: ' ';\n}\n.table-div .content .image-item .file-div input {\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          left: 0;\n          top: 0;\n          opacity: 0;\n          cursor: pointer;\n}\n.table-div .content .image-item .file-div div {\n          width: 100%;\n          height: 100%;\n}\n.table-div .content .image-item .file-div:active {\n          border: 1px solid #d8d8d8;\n}\n.table-div .content .image-item .file-div::before {\n        content: ' ';\n        width: 120px;\n        height: 6px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        -webkit-transform: translate(-50%, -50%);\n                transform: translate(-50%, -50%);\n        background-color: #d8d8d8;\n}\n.table-div .content .image-item .file-div::after {\n        content: ' ';\n        width: 6px;\n        height: 120px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        -webkit-transform: translate(-50%, -50%);\n                transform: translate(-50%, -50%);\n        background-color: #d8d8d8;\n}\n.table-div .content .image-item .img-div {\n        width: 200px;\n        min-width: 200px;\n        max-width: 260px;\n        height: 240px;\n        border: 1px solid #d8d8d8;\n        margin: 0 auto;\n        overflow: hidden;\n}\n.table-div .content .image-item .img-div .show-div {\n          overflow: hidden;\n          position: relative;\n          height: 203px;\n}\n.table-div .content .image-item .img-div .show-div img {\n            width: 100%;\n            height: 203px;\n}\n.table-div .content .image-item .img-div .show-div .btn-div {\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            overflow: hidden;\n            background-color: rgba(0, 0, 0, 0.4);\n}\n.table-div .content .image-item .img-div .show-div .btn-div .view,\n            .table-div .content .image-item .img-div .show-div .btn-div .del {\n              float: left;\n              width: 50%;\n              height: 30px;\n              line-height: 30px;\n              text-align: center;\n              color: #fff;\n              position: relative;\n              cursor: pointer;\n}\n.table-div .content .image-item .img-div .show-div .btn-div .view-single {\n              width: 100%;\n}\n.table-div .content .image-item .img-div .show-div .btn-div .view:hover {\n              background-color: #5272e9;\n}\n.table-div .content .image-item .img-div .show-div .btn-div .del:hover {\n              background-color: #ff3b30;\n}\n.table-div .content .image-item .img-div .show-div .btn-div .del::before {\n              content: ' ';\n              width: 1px;\n              height: 18px;\n              background-color: #fff;\n              position: absolute;\n              left: 0;\n              top: 6px;\n}\n.table-div .content .image-item .img-div .show-group-div {\n          height: 203px;\n}\n.table-div .content .image-item .img-div .show-group-div img {\n            height: 203px;\n}\n.table-div .content .image-item .img-div .file-group-div {\n          height: 203px;\n}\n.table-div .content .image-item .img-group-div {\n        height: 203px;\n}\n.table-div .content-group {\n    float: left;\n    padding: 0 0 0 15px;\n}\n.table-div .circle-title {\n    width: 170px;\n    height: 40px;\n    line-height: 40px;\n    background-color: #f7f7f7;\n    color: #999;\n    text-align: center;\n    border-top-right-radius: 50px;\n    border-bottom-right-radius: 50px;\n}\n.table-div + .table-div {\n  margin-top: 30px;\n}\n.el-dialog-recharge .el-dialog__header .el-dialog__headerbtn {\n  top: 0px;\n  font-size: 20px;\n}\n.el-dialog-recharge .el-dialog__header .el-dialog__headerbtn i {\n    color: #fff !important;\n}\n.recharge-div .title {\n  color: #5272e9;\n}\n.recharge-div .withdraw-item {\n  height: auto;\n  padding: 0px 30px;\n  height: 35px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.recharge-div .withdraw-item .left-div {\n    line-height: 35px;\n    margin-right: 16px;\n}\n.recharge-div .withdraw-item .right-div {\n    width: 200px;\n    height: 35px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.recharge-div .withdraw-item .right-div span {\n      line-height: 35px;\n      font-weight: bold;\n}\n.recharge-div .recharge-item .right-div {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.recharge-div .withdraw-item2 {\n  padding: 0px 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.recharge-div .withdraw-item2 .top-div {\n    width: 100%;\n}\n.recharge-div .withdraw-item2 .bottom-div {\n    width: 100%;\n}\n.recharge-div .withdraw-item2 .bottom-div .content {\n      margin: 0;\n      padding: 10px 0px;\n      overflow: hidden;\n      list-style: none;\n      position: relative;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item {\n        width: 30%;\n        overflow: hidden;\n        min-width: 110px;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div {\n          width: 125px;\n          height: 130px;\n          border: 1px solid #d8d8d8;\n          overflow: hidden;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div {\n            overflow: hidden;\n            position: relative;\n            height: 110px;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div img {\n              width: 100%;\n              height: 110px;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div {\n              position: absolute;\n              left: 0;\n              bottom: 0;\n              width: 100%;\n              overflow: hidden;\n              background-color: rgba(0, 0, 0, 0.4);\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .view,\n              .recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .del {\n                float: left;\n                width: 50%;\n                height: 24px;\n                line-height: 24px;\n                text-align: center;\n                color: #fff;\n                position: relative;\n                cursor: pointer;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .view-single {\n                width: 100%;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .view:hover {\n                background-color: #5272e9;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .del:hover {\n                background-color: #ff3b30;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .show-div .btn-div .del::before {\n                content: ' ';\n                width: 1px;\n                height: 18px;\n                background-color: #fff;\n                position: absolute;\n                left: 0;\n                top: 3px;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .img-title {\n            text-align: center;\n            height: 20px;\n            line-height: 20px;\n            border-bottom: 1px solid #d8d8d8;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div {\n            background-color: #f5f5f5;\n            width: 100%;\n            height: 110px;\n            position: relative;\n            margin: 0 auto;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div div {\n              width: 100%;\n              height: 100%;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div div .el-upload {\n                width: 100%;\n                height: 100%;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div div .el-upload input {\n                  width: 100%;\n                  height: 100%;\n                  position: absolute;\n                  left: 0;\n                  top: 0;\n                  opacity: 0;\n                  cursor: pointer;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div:active {\n              border: 1px solid #d8d8d8;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div::before {\n            content: ' ';\n            width: 70px;\n            height: 4px;\n            position: absolute;\n            left: 50%;\n            top: 50%;\n            -webkit-transform: translate(-50%, -50%);\n                    transform: translate(-50%, -50%);\n            background-color: #d8d8d8;\n}\n.recharge-div .withdraw-item2 .bottom-div .content .image-item .img-div .file-div::after {\n            content: ' ';\n            width: 4px;\n            height: 70px;\n            position: absolute;\n            left: 50%;\n            top: 50%;\n            -webkit-transform: translate(-50%, -50%);\n                    transform: translate(-50%, -50%);\n            background-color: #d8d8d8;\n}\n.mar10 {\n  margin-left: 40px;\n}\n.notify-dialog .el-dialog__headerbtn {\n  top: 0px;\n  font-size: 20px;\n}\n.notify-dialog .el-dialog__headerbtn .el-dialog__close {\n    color: #fff;\n    font-weight: bold;\n}\n.notify-dialog .el-dialog__headerbtn:focus .el-dialog__close,\n.el-dialog__headerbtn:hover .el-dialog__close {\n  color: #fff;\n}\n.notify-dialog .el-dialog {\n  width: 700px;\n}\n.notify-dialog .el-dialog__body {\n  height: 400px;\n  overflow-y: auto;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.notify-dialog .el-dialog__body .notify-ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    background-color: #F5F5F5;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item {\n      margin-bottom: 10px;\n      padding: 10px 25px;\n      background-color: #fff;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div {\n        color: #333333;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div .nofity-title {\n          font-weight: bold;\n          color: #333333;\n          font-size: 16px;\n          margin-right: 5px;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div .nofity-time {\n          color: #999;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div:nth-child(1) {\n        margin-top: 10px;\n        margin-bottom: 7px;\n        position: relative;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div:nth-child(1) i {\n          position: absolute;\n          width: 5px;\n          height: 5px;\n          background-color: red;\n          top: 7px;\n          left: -8px;\n          border-radius: 50%;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item div:nth-child(2) {\n        margin-bottom: 10px;\n        font-size: 16px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n        word-break: break-all;\n}\n.notify-dialog .el-dialog__body .notify-ul .notify-item:hover {\n      background-color: #FAFAFA;\n}\n.notify-dialog .el-dialog__header {\n  background-color: #5272e9;\n  text-align: center;\n  padding: 0px;\n  height: 55px;\n  line-height: 55px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  font-weight: bold;\n}\n.notify-dialog .el-dialog__header .el-dialog__title {\n    color: #fff;\n}\n.notify-dialog .el-dialog__footer {\n  padding: 0;\n  background-color: #F5F5F5;\n  line-height: 50px;\n  height: 50px;\n  text-align: center;\n}\n.notify-dialog .el-dialog__footer .footer_ok {\n    background-color: #5272E9;\n    color: #fff;\n    height: 32px;\n    line-height: 30px;\n    padding: 0;\n    width: 80px;\n    border-radius: 8px;\n    border: none;\n}\n.notify-dialog .el-dialog__footer .footer_ok:hover {\n    border: none;\n}\n.notify-detail-dialog .el-dialog__body {\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.notify-detail-dialog .el-dialog__footer {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.message-dialog {\n  margin-top: 0 !important;\n  border-radius: 8px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  background-color: transparent;\n}\n.message-dialog .el-dialog__body {\n    padding: 0px;\n    background-color: #fff;\n}\n.detail-dialog .el-dialog {\n  width: 1330px !important;\n}\n.el-dialog-column .el-dialog {\n  width: 470px !important;\n}\n.notify-detail {\n  margin-bottom: 10px;\n  padding: 10px 25px;\n  background-color: #fff;\n}\n.notify-detail div {\n    color: #333333;\n}\n.notify-detail div span:nth-child(1) {\n      font-weight: bold;\n      color: #333333;\n      font-size: 16px;\n      margin-right: 5px;\n}\n.notify-detail div span:nth-child(2) {\n      color: #999;\n}\n.notify-detail div:nth-child(1) {\n    margin-top: 10px;\n    margin-bottom: 7px;\n    position: relative;\n}\n.notify-detail div:nth-child(1) i {\n      position: absolute;\n      width: 5px;\n      height: 5px;\n      background-color: red;\n      top: 8px;\n      left: -8px;\n      border-radius: 50%;\n}\n.notify-detail div:nth-child(2) {\n    margin-bottom: 10px;\n    font-size: 16px;\n    word-break: break-word;\n}\n.riskcontrol-dialog .remark-div {\n  margin-bottom: 18px;\n}\n.riskcontrol-dialog .remark-div textarea {\n    width: 100%;\n    border: 1px solid #f5f5f5;\n    background-color: #f5f5f5;\n    resize: none;\n    padding: 15px;\n    outline: none;\n    color: #333;\n    border-radius: 3px;\n}\n.riskcontrol-dialog .remark-div textarea:focus {\n      border: 1px solid #dcdfe6;\n}\n.riskcontrol-dialog .footer-btns {\n  padding: 0 20px 38px 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  text-align: center;\n}\n.riskcontrol-dialog .footer-btns .el-button {\n    width: 120px;\n    padding: 10px 20px;\n}\n.riskcontrol-dialog .footer-btns .el-button + .el-button {\n    margin-left: 50px;\n}\n.riskcontrol-dialog .footer-btns .cancel-btn {\n    background-color: #fff;\n    color: #5272e9;\n    border: 1px solid #5272e9;\n}\n.riskcontrol-dialog .footer-btns .cancel-btn:hover {\n      background-color: #5272e9;\n      color: #fff;\n}\n.reasons-dialog {\n  width: 400px !important;\n}\n.reasons-dialog .footer-btns {\n    padding: 0 0 12px;\n}\n.reasons-dialog .footer-btns .el-button {\n      padding: 8px 20px;\n}\n.reasons-dialog .footer-btns .cancel-btn {\n      height: 34px;\n}\n.reasons-dialog .footer-btns .el-button + .el-button {\n      height: 34px;\n}\n.trade-dialog {\n  width: 1100px !important;\n}\n.trade-dialog .footer-btns {\n    margin-top: 35px;\n    padding-bottom: 35px;\n}\n.trade-dialog .footer-btns .el-button {\n      width: 180px;\n}\n.roster-dialog {\n  width: 470px !important;\n}\n.roster-dialog .footer-btns .el-button {\n    width: 160px;\n}\n.roster-dialog .el-dialog__headerbtn {\n    top: 0;\n}\n.roster-dialog .el-dialog__headerbtn .el-dialog__close {\n    color: #fff;\n    font-size: 20px;\n    line-height: inherit;\n}\n.el-dialog-trade .el-dialog__body {\n  padding: 0;\n}\n.el-dialog-trade .el-dialog__body .list-box {\n    overflow: hidden;\n    height: 270px;\n}\n.el-dialog-trade .el-dialog__body .list-box .title-list {\n      height: 45px;\n      line-height: 45px;\n      font-size: 16px;\n      color: #5272e9;\n      overflow: hidden;\n      position: absolute;\n      top: 55px;\n      left: 0;\n      width: 100%;\n      background-color: #fff;\n}\n.el-dialog-trade .el-dialog__body .list-box .title-list span {\n        float: left;\n        width: 25%;\n        text-align: center;\n}\n.el-dialog-trade .el-dialog__body .list-box .cont-list-wrapper {\n      overflow: auto;\n      margin-top: 45px;\n      height: 225px;\n}\n.el-dialog-trade .el-dialog__body .list-box .cont-list {\n      height: 45px;\n      line-height: 45px;\n      font-size: 14px;\n      color: #333;\n      overflow: hidden;\n      background-color: #eef7ff;\n}\n.el-dialog-trade .el-dialog__body .list-box .cont-list:nth-child(odd) {\n        background-color: #fff;\n}\n.el-dialog-trade .el-dialog__body .list-box .cont-list:hover {\n        background-color: #d2e4f8;\n}\n.el-dialog-trade .el-dialog__body .list-box .cont-list span {\n        float: left;\n        width: 25%;\n        text-align: center;\n        padding: 0 12px;\n}\n.el-dialog-trade .el-dialog__body .roster-box {\n    padding: 20px 0;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item {\n      overflow: hidden;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .left,\n      .el-dialog-trade .el-dialog__body .roster-box .item .right {\n        float: left;\n        height: 50px;\n        line-height: 50px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .left {\n        text-align: right;\n        width: 130px;\n        color: #333;\n        font-size: 15px;\n        font-weight: bold;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .right {\n        width: 275px;\n        margin-left: 10px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .right-multiple {\n        height: 77px;\n        line-height: normal;\n        margin-top: 5px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .right-multiple textarea {\n          resize: none;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list {\n        overflow: hidden;\n        padding: 0 15px 30px 15px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .rule-item {\n          position: relative;\n          border: 1px solid #ccc;\n          color: #999;\n          text-align: center;\n          border-radius: 3px;\n          float: left;\n          width: 190px;\n          height: 50px;\n          line-height: 48px;\n          cursor: pointer;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .rule-item img {\n            position: absolute;\n            right: -1px;\n            top: -1px;\n            width: 26px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .rule-item:nth-child(even) {\n          margin-left: 19px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .rule-item:nth-child(3) {\n          margin-top: 10px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .rule-item:nth-child(4) {\n          margin-top: 10px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item .rule-list .selected {\n          border-color: #5272e9;\n          color: #5272e9;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long {\n      padding: 0 44px 0 10px;\n      position: relative;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long .right-multiple {\n        height: 50px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long .right-multiple .TradLimit, .el-dialog-trade .el-dialog__body .roster-box .item-long .right-multiple .TimeMode, .el-dialog-trade .el-dialog__body .roster-box .item-long .right-multiple .singleOrder {\n          width: 30%;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long .right-textarea {\n        height: auto;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long .icon-addDOM, .el-dialog-trade .el-dialog__body .roster-box .item-long .icon-DeleteDOM {\n        position: absolute;\n        right: 0px;\n        top: 16px;\n}\n.el-dialog-trade .el-dialog__body .roster-box .item-long .icon-addDOM .svg-new-icon, .el-dialog-trade .el-dialog__body .roster-box .item-long .icon-DeleteDOM .svg-new-icon {\n          width: 20px;\n          height: 20px;\n}\n.svg-new-icon {\n  width: 30px;\n  height: 30px;\n}\n.svg-record-icon, .svg-new-icon {\n  width: 25px;\n  height: 25px;\n}\n.concentBox img {\n  max-width: 100%;\n}\n.rule-select .el-input {\n  min-width: auto !important;\n  width: auto !important;\n}\n.search-inps .el-select {\n  width: 180px;\n}\n.search-inps .el-select .el-date-editor.el-input, .search-inps .el-select .el-input {\n    width: 180px;\n}\n.search-inps .el-select .el-date-editor.el-input .el-input__inner, .search-inps .el-select .el-input .el-input__inner {\n      height: 35px;\n}\n.search-inps .date-select {\n  width: 100px;\n  margin-right: 15px !important;\n}\n.search-inps .date-select .el-date-editor.el-input, .search-inps .date-select .el-input {\n    width: 100px;\n}\n.search-inps .el-date-editor.el-input, .search-inps .el-input {\n  width: 180px;\n}\n.search-inps .el-date-editor.el-input .el-input__inner, .search-inps .el-input .el-input__inner {\n    height: 35px;\n}\n.list-date-picker .el-input__icon {\n  color: #fff;\n}\n.list-date-picker .el-input__inner {\n  background-color: #5272e9;\n  border: 1px solid #5272e9;\n  color: #fff;\n}\n.list-date-picker .el-input__suffix {\n  width: 0;\n  height: 0;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  border-top: 6px solid #fff;\n  position: absolute;\n  right: 32px;\n  top: 28px;\n}\n.changePHcolor .el-input .el-input__inner::-webkit-input-placeholder {\n  color: #333333;\n}\n.recharge-div .recharge-input .el-input__inner {\n  height: 35px !important;\n}\n.recharge-div .recharge-input .el-textarea__inner {\n  height: 35px !important;\n}\n.recharge-div .recharge-input .el-input__suffix .el-input__suffix-inner i {\n  line-height: 30px;\n  font-weight: bold;\n  color: #333;\n}\n.el-dialog-recharge .el-dialog {\n  width: 520px !important;\n}\nbody .el-table th.gutter {\n  display: table-cell !important;\n}\nbody .el-table colgroup.gutter {\n  display: table-cell !important;\n}\ntable {\n  width: 100% !important;\n}\n.list-date-picker .el-date-picker {\n  position: absolute;\n  right: 0px;\n}\n.registration-dialog .footer-btns {\n  padding: 20px;\n}\n", ""]);

// exports


/***/ }),

/***/ "SM0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),

/***/ "TAmc":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("vuLS"),
  /* template */
  __webpack_require__("KqwA"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\AppMain.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AppMain.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50d0e037", Component.options)
  } else {
    hotAPI.reload("data-v-50d0e037", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getToken */
/* harmony export (immutable) */ __webpack_exports__["b"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'Admin-Token';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, 111);
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ }),

/***/ "TuQf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.bug-svg[data-v-3fd14bea] {\r\n\twidth: 1em;\r\n\theight: 1em;\r\n\tvertical-align: -0.15em;\r\n\tfill: currentColor;\r\n\toverflow: hidden;\n}\r\n", ""]);

// exports


/***/ }),

/***/ "U/Dg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = searchDistributor;
/* harmony export (immutable) */ __webpack_exports__["t"] = addMerchant;
/* harmony export (immutable) */ __webpack_exports__["x"] = findMerchant;
/* harmony export (immutable) */ __webpack_exports__["s"] = merchantDetail;
/* unused harmony export merchantShop */
/* harmony export (immutable) */ __webpack_exports__["g"] = merchantShopNew;
/* harmony export (immutable) */ __webpack_exports__["e"] = addShopAjax;
/* unused harmony export queryAgent */
/* harmony export (immutable) */ __webpack_exports__["y"] = mercUpdateIsEnabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = queryIndustry;
/* harmony export (immutable) */ __webpack_exports__["z"] = delMer;
/* harmony export (immutable) */ __webpack_exports__["f"] = delShop;
/* harmony export (immutable) */ __webpack_exports__["v"] = reauditMer;
/* harmony export (immutable) */ __webpack_exports__["d"] = reauditShop;
/* harmony export (immutable) */ __webpack_exports__["k"] = checkMerchantName;
/* harmony export (immutable) */ __webpack_exports__["l"] = checkPhone;
/* harmony export (immutable) */ __webpack_exports__["m"] = checkSubMerchantNo;
/* unused harmony export checkHkNo */
/* harmony export (immutable) */ __webpack_exports__["n"] = checkAlipayHkNo;
/* harmony export (immutable) */ __webpack_exports__["o"] = checkAlipayNo;
/* harmony export (immutable) */ __webpack_exports__["p"] = checkAlipayOnlineNo;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkShopName;
/* unused harmony export AU_BD_list */
/* harmony export (immutable) */ __webpack_exports__["B"] = AU_State_list;
/* harmony export (immutable) */ __webpack_exports__["q"] = checkUnionPayNo;
/* harmony export (immutable) */ __webpack_exports__["r"] = checkAugsUserName;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMccCode;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveData;
/* harmony export (immutable) */ __webpack_exports__["A"] = fintData;
/* harmony export (immutable) */ __webpack_exports__["u"] = deleteData;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateData;
/* harmony export (immutable) */ __webpack_exports__["w"] = exportExcelMc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_fetch__ = __webpack_require__("Vo7i");


function searchDistributor(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/distributor/getRoleFindDistributor',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function addMerchant(merchantFormData) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/create',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: merchantFormData
  });
}

function findMerchant(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/merchant/findMerchant',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function merchantDetail(merchantId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/merchant/merchantDetail/' + merchantId,
    method: 'get'
  });
}

function merchantShop(merchantId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/shop/getMerchantIdShop/' + merchantId,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function merchantShopNew(merchantId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/shop/getShopListByMerchantId/' + merchantId,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function addShopAjax(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/merc/viceShop/create',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function queryAgent(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/selectAllDistributor',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function mercUpdateIsEnabled(merchantId, enabled) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/merchant/updateIsEnabled/' + merchantId + '/' + enabled,
    method: 'get'
  });
}

function queryIndustry(locale) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/share/industry/findIndustry/' + locale,
    method: 'get'
  });
}

function delMer(merId, userId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/merchant/deleteMerchant/ ' + merId + '/' + userId,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function delShop(shopId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/shop/deleteShop/' + shopId,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function reauditMer(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/reaudit',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function reauditShop(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/merc/viceShop/reauditShop',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkMerchantName(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkMerchantName',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkPhone(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/auth/user/checkPhone',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkSubMerchantNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkSubMerchantNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkHkNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkHkNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkAlipayHkNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkAlipayHkNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkAlipayNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkAlipayNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkAlipayOnlineNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkAlipayOnlineNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkShopName(shopName, merchantId, shopId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/merc/viceShop/checkShopName',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: {
      shopName: shopName,
      merchantId: merchantId,
      shopId: shopId
    }
  });
}

function AU_BD_list() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/salesman/getAustraliaDefaultSalesman',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function AU_State_list(companyId, language) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/share/region/findRegionList/' + companyId + '/' + language,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function checkUnionPayNo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkUnionPayNo',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function checkAugsUserName(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/checkAugsUserName',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function getMccCode() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/merchant/getMccCode',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: {}
  });
}

function saveData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/saveData',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function fintData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/findData',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function deleteData(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/deleteData/' + id,
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'get'
  });
}

function updateData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/viceMerchant/updateData',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    method: 'post',
    data: data
  });
}

function exportExcelMc(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/merchant/merc/download',
    method: 'post',
    responseType: 'blob',
    data: data
  });
}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  isShrinkage: function isShrinkage(state) {
    return state.app.isShrinkage;
  },
  visitedViews: function visitedViews(state) {
    return state.app.visitedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  status: function status(state) {
    return state.user.status;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  menus: function menus(state) {
    return state.user.menus;
  },
  elements: function elements(state) {
    return state.user.elements;
  },
  setting: function setting(state) {
    return state.user.setting;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },

  userId: function userId(state) {
    return state.user.userId;
  },
  distributorId: function distributorId(state) {
    return state.user.distributorId;
  },
  companyId: function companyId(state) {
    return state.user.companyId;
  },
  currency: function currency(state) {
    return state.user.currency;
  },

  isRouterAlive: function isRouterAlive(state) {
    return state.app.isRouterAlive;
  },
  tinymce: function tinymce(state) {
    return state.app.tinymce;
  } };
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "UsXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__("gwsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_TW__);


var _hint, _mer, _mec, _inputBox, _newcash, _cash, _notify;


/* harmony default export */ __webpack_exports__["a"] = ({
  message: '系統登錄',
  welecome: '歡迎',
  layer: {
    toggle: '您確定要切換語言版本嗎?',
    tips: '語言切換',
    welcome: '歡迎使用！'
  },

  button: {
    humilis: '保存成功',
    search: '搜尋',
    Reset: '清空',
    New: '新增',
    New1: '新增',
    NewMer: '新增',
    NewDevice: '新增',
    NewAgent: '新增',
    NewSalesman: '新增',
    Modify: '修改',
    OK: '確定',
    Cancel: '取消',
    Shops: '店鋪',
    Shops1: '店鋪',
    Shops2: '店鋪列表',
    Merchant: '商戶',
    Enabled: '啟用',
    Enabled1: '啟用',
    Enabled2: '啟用',
    Suspended: '停用',
    Suspended1: '停用',
    Suspended2: '停用',
    Suspended3: '停用',
    Approval: '審批',
    Approve: '核准',
    Approve1: '核准',
    Reject: '拒絕',
    Reject1: '拒絕',
    EnterDetail: '進入詳情',
    Return: '返回',
    RefreshStatus: '更新',
    SaveResult: '蓄存結果',
    delete: '刪除',
    Resubmit: '重新提交',
    Manage: '管理',
    Refresh: '更新',
    Close: '關閉',

    view: '查看大圖',

    loading: '載入中',
    sending: '發送中',
    colon: '：',
    save: '保存',
    saveTime: '保存時間',
    saveMer: '已保存商戶',
    cancelMer: '未保存商戶',
    edit: '編輯'
  },
  search: {
    RefNo: '系統單號',
    RefNo1: '系統單號',
    SubAccountNo: '子商戶號',

    WechatRMBWallet: '微信支付',
    WechatMOPWallet: '微信支付 MO',
    WechatHKDWallet: '微信支付 HK',
    WeChatPayCatering: ' 微信支付（餐飲）',
    AlipayHK: '支付寶 HK',
    Alipay: '支付寶',
    Conditions: '暫無結果，請重置條件查找',
    SubAccountNo3: '支付寶HK商戶號',
    SubAccountNo4: '支付寶商戶號',
    ServiceChargeRate2: '支付寶HK手续费率（%）',
    ServiceChargeRate3: '支付寶手续费率（%）',
    channelInfo: '通道資料',
    channelInfo1: '通道資料',
    SubAccountNo2: '微信支付商戶號',
    HKSubAccountNo: '微信支付 HK 商戶號',
    WalletType: '錢包類別',
    RMBWallet: '人民幣錢包',
    HKDWallet: '港幣錢包',
    RMBOrHKD: '人民幣錢包商戶號或港幣錢包商戶號',
    Channel: '通道',
    PursePain: '前寶通機構',
    wherewithal: 'Allinpay機構',

    CrossBorderWallet: '跨境錢包',
    HongKongWallet: '香港錢包',
    SweepPay: '刷卡支付',
    ScanPay: '掃碼支付',
    Review: '微信審核狀態',
    wereNot: "未審核",
    associates: "審核通過",
    Audit: "審核中",
    partnership: "審核駁回",

    SweepPay1: '付款碼支付',

    SubAccountNo1: '子商戶號',
    AgentName: '所屬代理商',
    AgentName2: '所屬代理商',
    MerchantName: '商戶名稱',
    MerchantName1: '商戶名稱',
    MerchantName2: '商戶名稱',
    TransactionCompleted: '交易结果',
    TransactionCompleted1: '交易结果',
    TransactionCompleted2: '交易结果',
    Select: '選擇通道',
    YES: '是',
    NO: '否',
    Yes: '成功',
    No: ' 失敗',
    refunding: '處理中',
    remarks: '用戶備註',
    Institutional: '機構模式',
    TransactionType: '交易類型',
    TransactionType1: '交易類型',
    WeChatPaySweep: '微信刷卡支付',
    WeChatPayScan: '微信掃碼支付',
    OAPayment: '公眾號支付',
    SelectBeginTime: '交易時間',
    SelectBeginTime1: '订单时间',
    SelectEndTime: '',
    TransactionStatus: '結算狀態',
    TransactionStatus1: '結算狀態',
    SettledDone: '已結算',
    NotSettled: '未結算',

    AgentName1: '代理商名稱',

    AccountStatus: '商戶狀態',
    Pending: '待批核',
    Rejected: '拒絕批核',
    EstablishmentDate: '入網時間',

    levelID: '代理商編號',
    levelID1: '代理商編號',
    UpperLevel: '上級代理名稱',
    UpperLevel1: '上級代理名稱',
    UpperLevel2: '上級代理',
    Status: '代理商狀態',
    Status1: '代理商狀態',
    Status2: '帳戶狀態',

    websitePayment: '網頁支付',
    PC2Mobile: '網頁支付',
    WAPPayment: 'WAP 支付',
    APPPayment: 'APP 支付',
    bankCardPayment: '銀行卡支付',

    Undeclared: '未申報',
    DeclarationSubmit: '申報已提交',
    Reporting: '申報中',
    DeclarationSuccess: '申報成功',
    DeclarationFail: '申報失敗',
    ApiError: '海關接口異常'
  },
  placeH: {
    All: '所有',
    Please: '請選擇',
    Required: '(必填)'
  },
  hint: (_hint = {
    supplement: '請補充商戶通道號',
    ThePictureSizeMustNotExceed5M: '上次圖片大小不能超過 5MB',
    MandatoryFieldsAreNotFilledIn: '必填項未填寫',
    usernameDoesNotExist: '用戶不存在',
    pwdErr: '密碼錯誤，請重新登入',
    loading: '請稍後再試',
    pleaseRelogin: '閒置時間過長，請重新登入',
    BuildFailed: '生成失敗',
    NoData: '無數據',
    Alert: '提示',
    Success: '成功',
    Success1: '成功',
    Fail: '失敗',
    Fail1: '失敗',
    SureTo: '确定',
    SuccessfullyModified: '修改成功',
    FailToEdit: '修改失敗',
    ThisAgent: '該代理商嗎?',
    TheAdditonOf: '該店鋪的進件申請嗎?',
    TheAdditonOf1: '確定核準該商户的信息修改嗎?',
    TheAdditonOf3: '確定拒絕該商户的信息修改嗎?',

    TheAdditonOf4: '確定核準該商户的進件申請嗎?',
    TheAdditonOf5: '確定拒絕該商户的進件申請嗎?',

    TheAdditonOf6: "確定核準該店鋪的信息修改嗎?",
    TheAdditonOf7: "確定拒絕該店鋪的信息修改嗎?",
    TheAdditonOf8: "確定核準該店鋪的進件申請嗎?",
    TheAdditonOf9: "確定拒絕該店鋪的進件申請嗎?",

    TheAdditonOf2: '該代理商的進件申請嗎?',
    TheShopInfoChange: '該店鋪的信息修改嗎?',
    TheMerchantInfoChange: '該商戶的信息修改嗎?',
    TheAgentInfoChange: '該代理商的信息修改嗎?',
    Approved: '審批成功',
    Rejected: '審批失敗',
    OperationSuccess: '操作成功',
    OperationFail: '操作失敗',
    CreateOK: '提交成功',
    CreateFailed: '提交失敗',
    ChangeOK: '修改成功',
    ChangeFailed: '修改失敗',

    PleaseEnterName: '請輸入姓名',
    PleaseEnterBDStaffNumber: '請輸入業務員編號',
    PleaseEnterIDNumber: '請輸入身份證號碼',
    PleaseEnterPhoneNumber: '請輸入聯絡電話',
    PleaseEnterEmail: '請輸入電郵',
    BDStaffNumberIsValid: '業務員編號驗證通過',
    BDStaffNumberExistsPleaseReEnter: '業務員編號已存在，請重新輸入',
    BDRecordCreated: '新增業務員成功',
    BDCreateFailed: '新增業務員失敗',
    LengthIsMax25Characters: '長度為25個字以下',
    LengthIsMax10Characters: '長度為10個字以下',
    LengthIsMax20Characters: '長度為20個字以下',
    LengthIsMax11Characters: '長度為11個字以下',
    LengthIsMax50Characters: '長度為50個字以下',

    SureToChangeInfoOfTheMerchant: '確定修改該商戶信息嗎?',
    SureToAddThisMerchant: '確定增加該商戶嗎?',
    SureToEnableThisMerchant: '確定啓用該商戶嗎?',
    SureToSuspendThisMerchant: '確定停用該商戶嗎?',
    PhoneNumberAlreadyExists: '手機號碼已存在',
    PhoneNumberAlreadyExists1: '座機已存在',
    OfficePhoneNumberAlreadyExists: '公司號碼已存在',
    TheMerchantIsDisabled: '商戶已停用',
    TheMerchantIsEnabled: '商戶已啟用',

    SureToChangeInfoOfTheShop: '確定修改店鋪信息嗎?',
    SureToSuspendThisShop: '確定停用該店鋪嗎?',
    SureToEnableThisShop: '確定啟用該店鋪嗎?',
    SureToApproveTheShopInfoChange: '確定核準該店鋪的信息修改嗎?',
    SureToRejectTheShopInfoChange: '確定拒絕該店鋪的信息修改嗎?',
    SureToApproveTheAdditonOfTheShop: '確定核準該店鋪的進件申請嗎?',
    SureToRejectTheAdditionOfTheShop: '確定拒絕該店鋪的進件申請嗎?',
    SureToAddThisShop: '確定新增該店鋪嗎?',

    SureToEnableThisAgent: '確定啟用該代理商嗎?',
    SureToSuspendThisAgent: '確定停用該代理商嗎?',
    SureToChangeInfoOfTheSalesman: '確定修改該業務員信息嗎?',
    SureToAddThisAgent: '確定新增該代理商嗎?',
    SureToChangeInfoOfTheAgent: '確定修改該代理商信息嗎?',
    ApproveChangeOfInformation: '確認通過資料修改?',
    ApproveRegistration: '確認通過注冊申請?',
    SureToRejectThisAgentInfoChange: '確定拒絕該代理商的信息修改嗎?',
    SureToRejectTheAdditionOfThisAgent: '確定拒絕該代理商的進件申請嗎?',
    SubmittedApprovalPending: '已提交，審批中',
    TheAgentIsDisabled: '代理已停用',
    TheAgentIsEnabled: '代理已啟用',

    SureToAddThisOrganization: '確定新增該機構嗎?',
    SureToChangeInfoOfTheOrganization: '確定修改該機構信息嗎?',
    ThisOrganization: '該機構嗎?',

    MerchantNameAlreadyExists: '商戶名稱已存在',
    AgentNameAlreadyExists: '代理商名稱已存在',
    SubaccountAlreadyExists: '子商戶號已存在',

    accountAlreadyExists: '人民幣錢包商戶號已存在',
    HKaccountAlreadyExists: '港幣錢包商戶號已存在'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PhoneNumberAlreadyExists', '手機號碼已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ShopNameAlreadyExists', '店鋪名稱已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CompanyNameAlreadyExists', '公司名稱已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'InstitutionNameAlreadyExists', '機構名稱已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', '業務員電郵已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ContactPersonsEmailAlreadyExists', '聯繫人郵箱地址已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailAlreadyExists', '郵箱地址已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'EmailFormatIncorrect', '郵箱格式不正確,請重新輸入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseEnter', '請輸入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInput', '請填寫'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseAddMerchantOrShopPhoto', "請添加公司或店鋪照片"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'addImage', '上傳圖片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToLaunchThisAdvertisement', '確定發佈該廣告嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAdvertisementLink', '廣告圖片路徑'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'paymentPage', '付款成功頁'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'aPPHomePage', 'APP首頁'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToDisableThisMcompany', '確定停用該公司嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToEnableThisMcompany', '確定啟用該公司嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToMakeTheChanges', '確定修改該公司信息嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'TheCompanyIsDisabled', '公司已停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ThecompanyIsEnabled', '公司已啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToAddThisCompany', '確定新增該公司嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveChangeOfInformationC', '確認通過資料修改?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'ApproveRegistrationC', '確認通過注冊申請?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectThisCompanyInfoChange', '確定拒絕該公司的信息修改嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SureToRejectTheAdditionOfThisCompany', '確定拒絕該公司的信息修改嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmToWithdraw', '確定兌現HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'doubt', '嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'withdrawAmountShouldBeNoLessThan', '兌現金額不能小于HK$ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputAccountNo', '請輸入商戶號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate', '請填寫微信支付手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseSelectServiceChargeBearer', '請選擇手續費承擔方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRateHK', '請填寫微信支付HK手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate2', '請填寫支付寶HK手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate3', '請填寫支付寶手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayAccountAlreadyExists', '支付寶商戶號已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayHKAccountAlreadyExists', '支付寶HK商戶號已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmthewithdrawalrequestof', '確認'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'hasbeenpaid', '的提現申請已打款?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PaymentConfirmation', '確認打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'CancelConfirmation', '取消確認'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'Confirmtogiveuptheexport', '確認放棄導出嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'alipayDirectHasAlreadyExist', '支付寶(直連)商戶號已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'WeChatPayHKNoHasAlreadyExist', '微信支付 HK商戶號已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'feeRateFormatIncorrect', '手續費率格式錯誤'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'confirmRefund', '確認退款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseInputMerchantName', '請填寫商戶名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'PleaseSelectPassingRules', '請選擇放行規則'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'notice', '提示：銀聯訂單當天退款只支持全額退款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputServiceChargeRate4', '請填寫支付寶(線上)手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'SubAccountNo5', '支付寶(線上)商戶號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hint, 'pleaseInputRejectReasons', '請填寫駁回原因'), _hint),
  login: {
    User: '用户',
    pwd: '密碼',
    Login: '登入',
    PasswordShouldBeAtLeast6Characters: '密碼不可少於6個字符'
  },
  index: {
    UniversalPocketPaymentManagement: '前寶通支付管理',
    Welcome: '歡迎您,',
    Number: '序號',
    Operation: '操作',
    UnipockPaymentSystemAdministration: '前寶通支付管理系統',
    Location: '當前位置',
    Entrance: '歡迎頁',
    Logout: '退出登録',
    MiPay: 'MiPay支付管理系統',
    MerchantOrders: '企業商戶交易報表.xls',
    amendmentApprovalPending: '修改信息審批中',
    newShopApprovalPending: '新增店鋪審批中',
    Salesman: '業務員管理',
    Device: "設備管理",
    searchResults: '搜索結果',
    approval: '審批管理',
    personnel: '人員管理',
    fund: '資金管理',
    name: "名稱",
    name1: "商戶名稱",
    status: '商戶狀態',
    MerchantInfoExcel: '商戶資料'
  },

  trade: {
    jumped: '交易時段',
    stock: '交易筆數',
    WeChatPay: '微信支付',
    MerchantRef: '交易記錄',
    MerchantRef1: '交易記錄',
    TransactionNo: '交易記錄',
    MerchantRefNo: '商戶編號',
    Agent: '所屬代理商',
    Time: '交易時間',
    PaymentTime: '支付時間',
    originated: '交易金額',
    AmountCNY: '金額(CNY)',
    TransactionType: '交易類型',
    Payment: '付款',
    Refund: '退款',
    PaymentMethod: '支付方式',
    Device: '設備',
    DeviceID: '設備編號',
    Staff: '交易操作員',
    OrderNumber: '訂單號',
    Box: '派派小盒',
    AppPay: 'APP支付',
    MiniProgram: '小程序支付',
    SubordinateMerchant: 'API支付',
    OriginalTransactionNumber: '原系統單號',
    MerchantTransactionNumber: '商戶單號',
    LANDIA8: '聯迪A8',

    merchantNumber: '商戶編號',
    fee: '手續費',
    receivableAmount: '實收金額',
    totalAmount: '總交易金額',
    totalFee: '總手續費',
    totalorder: '總交易筆數',
    totalsuccess: '交易成功筆數',
    volume: '總數',
    tabulation: '已添加商戶列表',
    utilization: '交易成功率',
    blanking: '成功交易最大間隔',
    between: '成功交易最小間隔',
    business: '添加統計商戶',
    Remarks: '備註',
    rejectReasons: '駁回原因:',
    transaction: '交易管理',
    frozenAmount: '凍結金額',

    TransactionNumber: '原交易單號',
    Refundable: '可退款額',
    RefundAmount: '退款額',
    Amount: '金額',
    PleaseEnterRefundAmount: '請輸入退款金額',
    ExceededMaximum50Refunds: '該比訂單退款已達到 50 次',
    InsufficientBalanceForThisRefund: '帳戶餘額不足以支持退款',
    CannotRefundUnfinishedTransaction: '未完成交易不可退款',
    ExceededRefundablePeriodOf365Days: '退款已超過上限的365天',
    ExceededRefundablePeriodOf540Days: '退款已超過上限的540天',
    ExceededRefundablePeriodOf24Hours: '該筆微信支付退款已超過上限的24小時',
    onlyOfflineBankCardRefundIsSupported: '僅支持綫下銀行卡付款',
    Maximum: '最大值',
    Minimum: '最小值',
    export: '導出',

    Unionpay: '銀聯',
    H5Payment: 'H5 支付',
    HideTestMer: '隱藏測試商戶',

    failureReason: '失敗原因',
    userRemarks: '用戶備註',
    merchantRemark: '商戶備註',

    transactionDetails: '交易詳情',
    Details: '詳情',
    merInfo: '商戶信息',
    orderInfo: '訂單信息',
    deviceInfo: '設備信息',
    remarksInfo: '備註信息',
    CustomColumns: '自定義列',
    Pay: '支付',
    SerialNumber: '流水號',
    WalletType: '錢包類型',

    Administration: '報關管理',
    RecordName: '備案名稱',
    CustomsDeclarationTime: '報關時間',
    CustomsDeclarationNo: '報關編號',
    CustomsDeclarationStatus: '報關狀態',
    customsList: '報關列表',
    CustomsFailureReason: '報關失敗原因'
  },

  mer: (_mer = {
    Registration: '登记',
    Amendment: '修改',
    PendingMerchantApproval: '待審批商戶',
    MerchantAddress: '商戶地址',
    AccountBalance: '帳戶結餘',
    AvailableBalance: '可用結餘',
    OutstandingAmount: '待結算金額',
    ApprovalItem: '審批事項',
    mchtApproval: '商戶審批',

    Client: "商戶管理",

    CompanyInfo: '公司資料',
    Merchant: '商戶名稱',
    Merchant1: '商戶名稱',
    BusinessAddress: '業務地址',
    MailAddress: '郵寄地址',
    BRNo: '商業登記號碼',
    Capital: '資本',
    YearsOfBusiness: '成立年數',
    IncorporationCountry: '成立地點',
    EmployeeNo: '僱員人數',
    MerchantType: '商戶類型',
    MerchantCategory: '商戶類目',
    OnlineMerchants: '线上商戶',
    UnderLineMerchant: '线下商戶',
    OwnershipType: '公司類別',
    LimitedCompany: '有限公司',
    Partnership: '合夥',
    SoleProprietor: '獨資',
    Contractperson: '聯絡人 ',
    Contractperson1: '聯絡人 ',
    Email: '電郵地址',
    Position: '職位',
    Position1: '職位',
    OfficePhone: '公司電話',
    Mobile: '手機號碼',
    Fax: '傳真號碼',
    Director: '董事',
    DirectorHKID: '董事身份證號碼',
    DirectorPassport: '董事護照號碼',
    overdue: '公司註冊過期時間',
    Nationality: '國籍',

    ContactInfo: '聯絡資料',
    URL: '網址',
    TargetLaunchDate: '預定服務推出日期',
    TechnicalContact: '技術聯絡人'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Email', '電郵'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PhoneNo', '聯絡電話'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OperationContact', '營運聯絡人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FinanceContact', '財務聯絡人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessInfo', '業務資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BusinessNature', '業務性質'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ProductsServices', '產品 / 服務類別'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TargetCustomers', '目標顧客'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'provider', '現在/曾經使用的支付服務'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Turnover', '過去兩年營業額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'LastYearSalesVol', '去年度營業額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'YearBeforeSales', '前年度營業額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'OnlineBusiness', '網上業務資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DeliveryProvider', '送貨供應商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CustomerHotline', '客戶服務熱線'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReturnRefundPolicy', '退換貨政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'FulfuillmentTime', '收單至送貨需時'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ReceiptProvided', '有否簽收'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ForecastMonthlySales', '預算每月營業額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After3Months', '三個月後'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After6Months', '六個月後'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'After1Year', '一年後'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NoOfTransactions', '每月交易宗數'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SalesVolume', '每月營業總額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AvgTransactionAmount', '每宗交易平均金額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MinTransactionAmount', '每宗交易最低金額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MaxTransactionAmount', '每宗交易最高金額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SettlementInfo', '清/結算資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountName', '帳戶名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AccountNo', '帳戶號碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankName', '銀行名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode', '銀行編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankCode1', '銀行編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BranchCode', '分行編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Address', '銀行地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SWIFT', '銀行國際代碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate', '手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate1', '微信支付手續費率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRate2', '微信支付MO手續費率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeRateHK', '微信支付HK手續費率（%）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer', '微信支付手續費承擔方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ServiceChargeBearer1', '手續費承擔方'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Customer', '顧客'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Consumer', '消費者'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Attachments', '附件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BR', '商業登記證'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'CertOfIncoporation', '公司註冊證明'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectorHKID1', '董事身份証或護照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'BankStatement', '公司銀行月結單'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Photos', '公司或店鋪照片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Logo', '商戶圖標'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopInfo', '店鋪資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopModiify', '店铺修改'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShortName', '簡稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ShopPhotos', '店鋪相片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NewShop', '新店'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'PendingShopApproval', '待審批店鋪'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'Sector', '行業'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'company', '公司名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'companyID', '公司編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'firm', '公司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'WhiteLable', '白標'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DescriptionOfGoods', "商品名稱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNo', '銀聯商戶號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpayFeeRate', '銀聯手續費率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'TerminalNo', '終端號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsername', 'AugsPay用戶名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'NotifyKey', '回調密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'APIKey', '接口密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'SignKey', '簽名密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayFeeRate', 'AugsPay手續費率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayFeeRate', '請填寫銀聯手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputTerminalNo', '請填寫終端號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputNotifyKey', '請填寫回調密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAPIKey', '請填寫接口密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputSignKey', '請填寫簽名密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputUnionpayKey', '請填寫銀聯密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'pleaseInputAugsPayFeeRate', '請填寫AugsPay手續費率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'UnionpaMerchantNoAlreadyExists', '銀聯商戶號已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPayUsernameAlreadyExists', 'AugsPay用戶名已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'MopPayUsernameAlreadyExists', 'MopPay用戶名已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayMerchantNo', '支付寶(直連)商戶號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayFeeRate', '支付寶(直連)手續費率(%)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayDirect', '支付寶(直連)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOnline', '支付寶直連(綫上)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'DirectOffline', '支付寶直連(綫下)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'key', '密鈅'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merchantNo', '商戶號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'AugsPay', 'AugsPay'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'userName', '用戶名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOnline', '支付寶(線上)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'alipayOffline', '支付寶(線下)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'ConfirmToReset', '確定重置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'sPassword', '的密碼嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'resetPassword', '重置密碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'abbreviation', '簡稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'merDescription', '商戶簡介'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooShort', '商戶簡介過短'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'tooLong', '商戶簡介過長'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'delete', '確定刪除該商戶嗎'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'channelRegistration', '自動進件中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'deviceNumber', '設備號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'shopNumber', '店鋪門牌號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mer, 'mcInformationForm', '商戶信息表'), _mer),

  agent: {
    certificate: "公司註冊文件證明",
    agent: '代理商',
    DirectMerchants: '直營商戶',
    BDStaff: '業務員',
    SubordinateAgents: "下級代理商",
    agentApproval: '代理商審核',
    agentApproval1: '代理商審核',

    BasicInfo: '基本資料',
    CompanyInfo: "公司資料",
    Name: '名稱',
    Type: '類型',
    Address: "地址",
    MailAddr: '郵寄地址',
    Contact: '聯絡人',
    PhoneNo: '電話',
    MobileNo: '手機',
    UpperLevelAgent: '上級代理商名稱',
    UpperLevelID: '上級代理編號',

    SettlementInfo: '結算資料',
    Method: '結算方式',
    Bank: '銀行',

    CommissionInfo: '佣金資料',
    Scanner: '掃碼器',
    SubscriptionFee: '加盟費',
    OfflineBase: '線下基率(%)',
    OfflineComm: '線下佣金(%)',
    OnlineBase: '線上基率(%)',
    OnlineComm: '線上佣金(%)',
    EndDate: '終結日期',
    BDStaffNo: '業務員編號',
    commissionRatio: '業務員佣金(%)',
    hintInfo: "基率為手續費不參與分傭計算的部分，其余手續費將按所填寫的傭金比例與代理商進行分傭。例如，某個商戶的手續費率為 1.5%，其代理商的基率為 1%，傭金比例為 50%，那麽（1.5% - 1%）即為參與分傭的手續費率，代理商獲得其中傭金的 50%，即（1.5% - 1%）* 50% = 0.25%，則該代理商可獲得的傭金為其發展的商戶的交易額的 0.25%",

    POS: 'POS 採購',
    POSmargin: 'POS 按金',
    POSrentalMonth: 'POS 租金/月',
    ScannerPurchase: '掃碼器採購',
    ScannerMargin: '掃碼器按金',
    ScannerRentalMonth: '掃碼器租金/月',
    AlipayCross: '支付寶(跨境錢包)',
    AlipayHK: '支付寶(本地錢包)',

    WithdrawalRatio: '最低不可提現比例'
  },

  salesman: {
    Salesman: '業務員',
    Name: '姓名',
    ID: '身份證號碼',
    ID1: '身份證號碼',
    OK: '新增',
    Status: '當前狀態',
    NewBDStaff: '新增業務員',
    ModifyTheSalesmanInformation: '修改業務員信息',
    theSalesman: '該業務員嗎?',
    delete: '確定刪除該業務員嗎'
  },

  mec: (_mec = {
    Name1: '機構名稱',
    Status: '機構狀態',
    Contact: '聯繫人名稱',
    Phone: "聯繫人電話",
    Detail: '機構詳情',

    OrganizationInfo: '機構信息',
    RegisterAddress: '機構註冊地址',
    businessLicenseNo: "營業執照號",
    validityTime: '營業執照有效期',
    LegalPerson: '法人姓名',
    certificateType: '法人證件類型',
    certificateNo: '法人證件號碼',
    PhoneNo: '法人聯繫電話',
    CreationTime: '創建時間',
    CreationTime1: '帳戶建立時間'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Contact', '聯繫人信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Name', '姓名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhoneNo', '電話'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhoneNo1', '電話'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'Email', '電郵'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementInfo', '結算信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'SettlementBank', '清算銀行名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'City', '銀行所在城市'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountType', '賬戶類型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountName', '開戶人名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'AccountNo', '結算賬戶號碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'PhotoInfo', '照片資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDFrontPicture', '法人身份證正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonIDReversePicture', '法人身份證反面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardFrontPicture', '法人銀行卡正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'LegalPersonBankcardReversePicture', '法人銀行卡反面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'BusinessLicense', '營業執照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'TaxRegistrationCertificate', '稅務登記證照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'OrganizationCodeCertificate', '機構代碼證'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyFrontPicture', '公司正面照'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'CompanyLogo', '公司Logo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mec, 'other', '其他'), _mec),

  AuMer: {
    CompanyInfomation: '公司信息',
    RegistrationName: '公司名稱',
    AustraliaBusinessNumber: '澳洲商業註冊號',
    BusinessInfomation: '業務範圍',
    Website: '公司網站',
    ContactNumber: '公司電話',
    CompanyDescripption: '公司簡介',
    Address: '公司地址',
    City: '城市',
    Postcode: '郵編',
    State: '州',
    ContactInfomation: '聯繫方式',
    FullNmae: '全名',
    JobTitle: '職稱',
    TelephoneNo: '電話號碼',
    EmailAddress: '郵箱地址',
    BillingInfomation: '公司銀行賬戶信息',
    BankName: '銀行名稱',
    CompanyAccountNmae: '賬戶名',
    BSB: '分行代碼',
    AccountNumber: '賬戶',
    Rate: '費率',
    SettlementPeriod: '結算週期',
    OtherInformation: '其他資料'
  },

  inputBox: (_inputBox = {
    merchantName: '商戶名稱',
    exchangeRate: '匯率',
    deviceNum: '設備編號',
    bindingsStartDate: '綁定時間',
    endDateOfBinding: '',
    query: '查詢',
    add: '添加',
    empty: '清空',
    serialNumber: '序號',
    merchantNumber: '商戶編號',
    shopNumber: '店鋪編號',
    shopName: '店鋪名稱',
    deviceState: '設備狀態',
    weChatSonMerchant: '微信子商戶號',
    storageTime: '入庫時間',
    bindingTime: '綁定時間',
    modificationTime: '修改時間',
    operation: '操作',
    modify: '修改',
    cancel: '取消',
    ok: '確定',
    deviceAdd: '設備添加',
    deviceModify: '設備修改',
    newDeviceNumber: '新設備號',
    pleaseEnterTheNewDeviceNumber: '請輸入新設備號',
    pleaseEnterTheStoreNumber: '請輸入店鋪編號',
    pleaseEnterTheDeviceNumber: '請輸入設備編號',

    pleaseEnterTheWalletType: '請選擇錢包類別',
    pleaseEnterTheChannel: '請選擇通道',
    success: '成功',
    fail: '失敗',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    addFail: '添加失敗',
    queryErr: '查詢條件輸入錯誤或查詢結果不存在',

    QRcode: '固碼',
    fixedCodeID: '固碼ID',
    codeNo: '碼號',
    generationDate: '生成日期',
    bindingDate: '綁定日期',
    currentState: '當前狀態',
    paymentChannel: '支付通道',
    channelNumber: '通道編號',
    companyNumber: '公司編號',
    channelState: '通道狀態',
    costRate: '成本費率(%)',
    typeOfTransaction: '交易類型',
    settlementType: '結算類型',
    fixedFee: '固定手續費',
    priorityLevel: '優先級別',
    dateOfEntry: '錄入日期',
    remarks: '備註',
    remarks1: '備註',
    channelRegistrationDate: '通道註冊日期',
    autograph: '簽名',
    adapterOrder: '適配器下單URL',
    paymentAdapter: '適配器代付URL',
    adapterCallback: '適配器回調URL',

    startDate: '開始日期',
    endDate: '結束日期',
    unbound: '未綁定',
    bindings: '已綁定',
    disable: '停用',
    enable: '啟用',
    minimumExchangeRate: '最小匯率',
    maximumExchangeRate: '最大匯率',
    receivablesArea: '收款區域',
    Australia: '澳大利亞',
    HongKong: '香港',
    pleaseEnterTheMerchantName: '請輸入商戶名稱',
    chooseBranch: '選擇分店',
    bindingNumber: '綁定數量',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: '分配固碼',
    toTheMerchant: '給商戶',
    toTheAgent: '給代理'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheMerchantName', '請輸入商戶名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingAndBindingSolidCode', '生成並綁定固碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseEnterTheAgentNumber', '請輸入代理商編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'generatingFixedCode', '生成固碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceID', '設備編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceType', '設備類型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scanner', '掃碼器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deviceStatus', '設備狀態'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'enabled', '已啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'disabled', '已停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'merchant', '所屬商戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'shop', '所屬店鋪'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'deploymentDate', '投用日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'search', '搜索'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'clear', '清空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'status', '狀態'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'change', '修改'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'cancelBinding', '取消綁定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisable', '確定停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnable', '確定啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToUnbind', '確定取消綁定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToEnableS', '確定啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'confirmToDisableS', '確定停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'QRCodeOf', '的固碼?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'scannerOf', '的掃碼器?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_inputBox, 'pleaseChooseMerchant', '請先選擇所屬商戶'), _inputBox),

  device: {
    newDevice: '新增設備',
    merchant: '所屬商戶',
    shop: '所屬店鋪',
    type: '設備類型',
    scanner: '掃碼器',
    QRCode: '固碼',
    deviceID: '設備編號',
    OK: '確定',
    cancel: '取消',
    deviceNAE: '設備編號已存在'
  },

  newcash: (_newcash = {
    requestDate: '申請時間',
    merchantName: '商戶名稱',
    bankName: '銀行名稱',
    agentName: '代理商名稱',
    bankAccount: '銀行帳戶',
    accountName: '帳戶名稱',
    withdrawAmount: '兌現金額',
    Arrived: "到賬金額",
    withdrawAmount2: '兌現金額',
    withdrawType: '兌現方式',
    withdrawFee: '兌現手續費',
    remitAmount: '轉帳金額',
    status: '狀態',
    pending: '未審核',
    approved: '審核通過',
    rejected: '審核被拒',
    rejected1: '審核駁回',
    paid: '已轉款',
    operation: '操作',
    approve: '通過',
    reject: '拒絕'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paid', '已轉款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToApprove', '確定通過'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'confirmToRefuse', '確定拒絕'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawRequestFrom', '的兌現申請嗎?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'merchantName', '商戶名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawStatus', '兌現狀態'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'approvalTime', '審核時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'paymentTime', '轉款時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal', "兌現"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'Withdrawal1', "財務"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'WithdrawalRecord', "兌現記錄"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'pendingWithdrawalApproval', '兌現審批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantName', '代理商/商戶名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'agentOrMerchantID', '代理商/商戶編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawErrorTitle', '提示'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawError', '以下商戶提現失敗，請重試：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'none', '無'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newcash, 'withdrawalConfirmation', '提現確認'), _newcash),

  cloudAccount: {
    switchInstitution: '切換機構',
    pleaseSelectInstitution: '請選擇機構'
  },

  fund: {
    withdrawAmount: '兌現賬戶及金額',
    enterAmount: '輸入金額',
    withdraw: '兌現',
    cheque: '支票付款',
    bankTransfer: '銀行轉賬',
    transferTip: '建設/中銀轉帳免手續費，跨行轉帳每筆HK$ 50',
    withdrawMethod: '兌現方式',
    warning: '溫馨提示',
    warningTitle: '提現時間（按工作日計算）：',
    warningText: '上午9:00前的申請當天出票或轉帳；其後的第二天處理',
    withdrawLimit: '兌現金額不能小於500',
    confirmWithdraw: '確定兌現 ',
    confirmWithdrawSuffix: '嗎?',
    success: '兌現成功',
    failed: '兌現失敗',
    pending: '未審批',
    approved: '審批通過',
    rejected: '審批駁回',
    paid: '已轉款',

    WithdrawalAmount: '可提現金額',
    warningContent: '可提現金額根據上月退款金額決定，如有疑問請聯系工作人員',
    Withdrawable: "(1)港幣5元每筆匯款 (匯款金額少於或等於港幣500,000元),",
    WithdrawableT: "(2)港幣10元每筆匯款(匯款金額大於港幣500,000元)",

    see: '查看',
    rechargeRecord: '備用金充值記録',
    refundRecord: '備用金退款記録',
    imprestAudit: '備用金充值審核',
    please: '請',
    confirmRecharge: '確定充值 ',
    reserveMoney: '備用金余額',
    recharge: '充值',
    rechargeTime: '充值時間',
    refundTime: '退款時間',
    rechargeRecords: '充值記錄',
    refundRecords: '退款記錄',
    rechargeAmount: '充值金額',
    refundAmount: '退款金額',
    rechargeNotes: '充值備註',
    rechargeVoucher: '充值憑證',
    fillRemarks: '填寫備註',
    rechargeRechargeInfo: '備用金充值信息',
    reserveWarningTitle: '備用金余額僅用作商戶退款使用,充值後不可提現,如需提現，請聯系工作人員;',
    reserveWarningText: '如需充值備用金，請提前打款並保留打款憑證;',
    reserveWarningContent: '充值金額需與憑證中金額相符,提交充值後將有工作人員審核憑證信息,審核通過方可使用備用金余額進行退款。'
  },

  profit: {
    profit: '分潤',
    countDate: '結算日期',
    date: '日期',
    acquirerFee: '機構手續費',
    channel: '渠道',
    channelFee: '渠道手續費',
    agentComm: '代理佣金',
    BDComm: '業務員佣金',
    settlement: '結算金額',
    acquirerFeeTotal: '機構總手續費',
    agentCommTotal: '代理佣金總額',
    BDCommTotal: '業務員總佣金',
    wx: '微信',
    payment: '結算收款',
    settlementDateRefund: '結算退款'
  },

  firm: {
    companyName: '公司名稱',
    companyID: '公司編號',
    agent: '代理名稱',
    companyStatus: '公司狀態',
    establishmentDate: '登記日期',

    name: '公司名稱',
    ID: '公司編號',
    status: '狀態',
    merchantQty: '商戶數量',
    registrationDate: '登記日期',
    companyApproval: '公司審批'
  },

  cash: (_cash = {
    userNumber: '用戶編號',
    auditStatus: '審批狀態',
    unaudited: '未審批',
    reviewAndPassThrough: '審批通過',
    reviewAndDismissal: '審批駁回',
    alreadyMadeMoney1: '已打款',
    presentType: '提現類型',
    check: '電子支票',
    onlineBanking: '銀行轉賬',
    applicationStartDate: '申請時間',
    applicationEndDate: ''
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'userNumber', '用戶編號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'companyName', '公司名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'applicationTime', '申請時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditStatus', '審批狀態'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'presentType', '提現類型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'amountOfCash', '提現金額'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'cankCardNumber', '銀行卡號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'cardholder', '持卡人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'bankName', '銀行名稱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditTime', '審批日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'remittanceDate', '匯款日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notes', '備注'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'examine', '審批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'adopt', '通過'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'reject', '駁回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'playMoney', '打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'auditHasPassed', '審批已通過,可打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'theAuditHasBeenRejected', '審批已駁回,無法進行操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'errOperation', '錯誤操作!已打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'alreadyPassed', '審批已通過,不能駁回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notRepeatOperation', '審批已駁回,請勿重復操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'audit', '審批中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'notMakeMoney', '審批已駁回,無法打款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'alreadyMadeMoney', '已打款,請勿重復操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'query', '查詢'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cash, 'empty', '清空'), _cash),

  shop: {
    Phone: "聯繫人電話",
    Phone1: "聯繫人電話*",
    Email: '電郵地址',
    Email1: '電郵地址*',
    shopApproval: '店鋪審批',
    shopName: '店鋪名稱'
  },

  modifyPwd: {
    PasswordChange: '修改密碼',
    OriginalPassword: '原密碼',
    NewPassword: '新密碼',
    Confirm: '確認密碼',
    OK: '確定',
    Cancel: '取消',
    PasswordIncorrect: '密碼輸入錯誤',
    NewPasswordLessThan6Digits: '新密碼少於6個字符',
    TheTwoPasswordsDoNotMatch: '兩次密碼不一致',
    TheNewPasswordIsTheSameAsTheOldOne: '新密碼與舊密碼相同',
    PleaseInputMoreThan6DigitsPassword: '(請輸入6位以上密碼)',
    PleaseBeTheSameAsOriginalPassword: '(請與新密碼一致)',
    PleaseInputOriginalPassword: '請輸入原密碼',
    PleaseInputPasswordAgain: '請再次輸入密碼',
    PleaseInputPassword: '請輸入密碼',

    formatError: '圖片格式不正確'
  },
  other: {
    PhoneNumberAlreadyExist: '業務員聯絡電話已存在',
    InformationChange: '修改資料',
    ConfirmToMakeTheChanges: '確定修改資料?',
    ConfirmToRegisterTheShop: '確定新增該店鋪?',
    ConfirmToDeleteTheShop: '確定刪除該店鋪?',
    MerchantLogo: '商户標志',
    MerchantInfo: '商戶信息登記表',
    PasswordShouldBeAtLeast6Characters: '密碼不可少於6個字符',
    EmailAlreadyExists: '業務員郵箱已存在',
    EstablishmentFrom: '服務登記時間',
    EstablishmentFrom1: '服務登記',
    EstablishmentFrom2: '帳戶建立時間',
    EstablishmentFrom3: '登記日期',
    EstablishmentTo: ''
  },
  modifyShop: {
    ShopDetail: '店鋪詳情',
    New: '新增',
    Back: '返回',
    Rejected: '審核被拒!',
    ApprovalPending: '審核中...',
    AmendmentApprovalPending: '修改審核中...',
    UploadPhoto: '上傳圖片',
    ShopNumber: '店鋪編號',
    Edit: '修改',
    Suspended: '已停用!',
    ClickToAddPhotos: '點擊添加圖片',
    ShopName: '填寫店名',
    OK: '完成',
    OK1: '提交',
    delete: '刪除店鋪'
  },
  ad: {
    typeOne: '類型一',
    typeTwo: '類型二',
    typeThree: '類型三',
    advertisingPosition: '廣告位',
    resolution: '大小',
    link: '連結',
    adMgmt: '廣告管理',
    adSetup: '廣告編輯',

    NewAdvertisement: '添加廣告',
    BusinessNature: '廣告行業',
    ConfirmtodeletetheAdvertisement: '確定刪除該條廣告嗎?',
    ConfirmtomodifytheAdvertisement: '確定修改該條廣告嗎?',
    Replacethepicture: '更換圖片',
    Uploadpicture: '上傳圖片',
    AdvertisementName: '廣告名稱',
    Link: '跳轉鏈接',
    PleaseAddAdvertisementPicture: '請添加廣告圖片',

    adData: '廣告數據',
    Display: '曝光量',
    Click: '點擊量',
    ClickRate: '點擊率'
  },

  settlement: {
    Date: '結算日期',
    Merchant: '商戶名稱',
    MerchantID: '商戶編號',
    SettlementPeriod: '結算週期',
    TransactionAmount: '交易總額',
    Fee: '手續費',
    SettlementAmount: '結算總額',
    Settlement: '商戶結算',

    refundRemarks: '退款備註'
  },

  opinion: {
    Date: '日期',
    SuggestionList: '意見列表',
    SuggestionList1: '意見列表',
    SuggestionList2: '意見列表',
    Time: '時間',
    Shop: '店鋪',
    Account: '帳戶',
    AcountName: '帳戶名稱',
    Role: '角色',
    Subject: '主題',
    Content: '內容',
    Suggestion: '意見詳情'
  },

  notify: (_notify = {
    title: '通告主題',
    content: '',
    content1: '通知內容',
    NotificationHistory: '通告記錄',
    Recipients: '接收人',
    Details: '詳情',
    EditNotification: '通告編輯',
    SelectRecipients: '選擇收件人',
    SendTo: '發送至:',
    Send: '發送',
    All: '全部',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商戶',
    Finance: '財務',
    BD: '業務員',
    AllAgent: '所有代理商',
    AllCompany: '所有公司',
    AllMerchant: '所有商戶',
    AllMerchantAdministrator: '所有商戶管理員',
    AllShop: '所有店鋪',
    AllStaff: '所有員工',
    AllFinance: '所有財務',
    AllBD: '所有業務員',
    Administrator: '管理員',
    MerchantsOf: '直屬商戶',
    ConfirmToSend: '確定發送?',
    Notification: '通告',
    AlreadyExists: '已存在',
    PleaseSelectRecipients: '請選擇收件人',
    Notifications: '消息通告',
    NotificationList: '消息列表',
    NofiticationDetails: '消息詳情',
    contentExceeding: '內容超過2000字符,請刪減內容',
    Only10Images: '每篇通知只允許上傳 10 張圖片',
    pleaceSelectOrEnputMerchantName: '請選擇/輸入商戶名',
    addPicture: '添加圖片'

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Merchant', '商戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Agent', '代理商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Company', '公司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'Shop', '店鋪'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationApproved', '進件審批通過'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationRejected', '進件審批駁回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationApproved', '修改信息審批通過'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationRejected', '修改信息審批駁回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationApproved', '兌現申請審批通過'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'withdrawalApplicationRejected', '兌現申請審批駁回'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'the', '您提交的'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenApproved', '進件申請已通過審批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'registrationYouSubmittedHasBeenRejectedRejectReason', '進件申請被駁回，駁回原因：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenApproved', '修改信息申請已通過審批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'informationModificationYouSubmittedHasBeenRejectedRejectReason', '修改信息申請被駁回，駁回原因：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'theWithdrawalApplicationOf', '您于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'on', '提交的'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenApproved', '兌現申請已通過審批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_notify, 'youSubmittedHasBeenRejectedRejectReason', '兌現申請被駁回，駁回原因：'), _notify),

  risk: {
    report: '交易報告',
    automated: '報告列表',
    should: '報告日期',
    Type: '風控類型',
    Edit: '修改',
    Remove: '移除',
    NewWhiteList: '新增白名單',
    Configuration: '規則設置',
    PassingRules: '放行規則',
    DayAmountLimit: '單日限額',
    HourAmountLimit: '小時限額',
    PerTransactionLimit: '單筆限額',
    MinuteVolumeLimit: '分鐘限量',
    ConfirmWhiteRemoving: '確定從白名單中移除',
    FromWhiteList: '嗎?',
    Abnormalty: '異常交易',
    BlackListed: '轉為黑名單',
    OrderNumber: '訂單號',
    ConfirmGreyRemoving: '確定從灰名單中移除',
    fromGreyList: '嗎?',
    ConfirmMoving: '確定將',
    toBlackList: '轉移到黑名單嗎?',
    GreyListed: '轉為灰名單',
    ConfirmBlackRemoving: '確定從黑名單中移除',
    fromBlackList: '嗎?',
    toGreylist: '轉移到灰名單嗎',
    ConfirmChanging: '確定修改',
    ConfirmChangingRiskControlfactors: '確定修改該行業的風控參數嗎?',
    RiskControl: '风险控制',
    whiteListEdit: '白名單修改',
    whiteList: '白名單',
    greyList: '灰名單',
    blackList: '黑名單',
    items: '筆',

    riskMerchant: '商戶風控',
    riskTime: '風控時間',
    singleDayLimit: '單日限額',
    singleLimit: '單筆限額',
    addRiskMerchant: '添加風控商戶',
    removeRiskMerchant: '移除風控商戶',
    modifyRiskMerchant: '修改風控商戶',
    isDeleteRiskMerchant: '是否確認從風控列表中移除該商戶？',
    adder: '添加者',
    verifyIsEmpty: '商戶名稱/編號不得為空',
    minLimitRules: '請至少輸入一項限額規則',
    VerifyDcMcName: '該商戶已存在，請重新選擇',

    TradingLimit: '交易限頻',
    pen: '筆'
  },

  History: {
    Applicant: '申請人',
    ApplicantAccount: '申請人帳戶',
    ApprovalHistory: '審核記錄',
    Approver: '審核人',
    ApproverAccount: '審核人帳戶',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商戶',
    shop: '店鋪 ',
    refusalReasons: '駁回原因'
  },

  count: {
    month: '月',
    week: '周',
    day: '日',
    hour: '時',
    pleaceSelectTime: '請選擇時間',
    endTimeError: '結束時間錯誤',
    pleaseSearchLessThan24Months: '搜索時間請勿超過24個月',
    pleaseSearchLessThan16Weeks: '搜索時間請勿超過16周',
    pleaseSearchSessThan62Days: '搜索時間請勿超過62天',
    pleaseSearchSessThan48Hours: '搜索時間請勿超過48小時',
    todayReceiptAmount: '今日收款總額',
    todayUnionPayAmount: '今日銀聯收款總額',
    todayWeChatAmount: '今日微信收款總額',
    todayHongKongAmount: '今日香港微信總額',
    todayWalletAmount: '今日跨境微信總額',
    todayAlipayAmount: '今日支付寶收款總額',
    todayTransactionVolume: '今日交易量',
    transactionAmount: '交易額',
    transactionVolume: '交易量',
    newMerchant: '新增商戶',
    date: '日期',
    amount: '交易额',
    top10Merchant: 'Top10商戶',
    Month: '月度',
    sinceEstablishment: '開通以來',
    dataSheet: '數據表',
    ranking: '排行',
    failureRate: '失敗率'
  },

  user: {
    title: '用戶信息',
    tips: '(點擊編輯用戶名和頭像)',
    placeholder: '請輸入（回車確認）',
    qualified1: '請輸入用戶名',
    qualified2: '請正確輸入用戶名',
    qualified3: '用戶名不得含有中英文的特殊字符',
    OK: '確定',
    Cancel: '取消'
  },
  zhTWLocale: __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_TW___default.a });

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_auth__ = __webpack_require__("TIfe");


var _this = this;






var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: '',
  timeout: 30000 });

service.interceptors.request.use(function (config) {
  if (sessionStorage.getItem('access-token')) {
    config.headers['access-token'] = sessionStorage.getItem('access-token');
  }

  if (!localStorage.getItem('companyId') && config.url != '/auth/token') {
    var timeMsg = void 0;
    if (localStorage.getItem('locale') === 'zh_cn') {
      timeMsg = '闲置时间过长，请重新登录';
    } else if (localStorage.getItem('locale') === 'zh_tw') {
      timeMsg = '閒置時間過長，請重新登入';
    } else {
      timeMsg = 'Idle for too long, please re-login';
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: timeMsg, duration: 2 * 1000 });
    setTimeout(function () {
      sessionStorage.removeItem('access-token');
      localStorage.clear();
      location.reload();
    }, 3000);
    _this.$router.push({ name: '登录' });
  }
  return config;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  if (!localStorage.getItem('companyId') && response.config.url != '/auth/token') {
    var timeMsg = void 0;
    if (localStorage.getItem('locale') === 'zh_cn') {
      timeMsg = '闲置时间过长，请重新登录';
    } else if (localStorage.getItem('locale') === 'zh_tw') {
      timeMsg = '閒置時間過長，請重新登入';
    } else {
      timeMsg = 'Idle for too long, please re-login';
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: timeMsg, duration: 2 * 1000 });
    setTimeout(function () {
      sessionStorage.removeItem('access-token');
      localStorage.clear();
      location.reload();
    }, 3000);
    _this.$router.push({ name: '登录' });
  }

  var res = response.data;
  if (response.status == 401 || res.status == 401 || res.status == 403 || res.status == 440) {
    sessionStorage.removeItem('access-token');
    _this.$router.push({ name: '登录' }).then(function () {
      sessionStorage.removeItem('access-token');

      location.reload();
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error');
  }
  if (response.status !== 200 && res.status !== 200) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
      message: res.message,
      type: 'error',
      duration: 5 * 1000
    });
  } else {
    return response.data;
  }
}, function (error) {
  console.log('err' + error);
  var errMsg = void 0;
  var timeMsg = void 0;
  if (localStorage.getItem('locale') === 'zh_cn') {
    errMsg = '请稍候再试';
    timeMsg = '闲置时间过长，请重新登录';
  } else if (localStorage.getItem('locale') === 'zh_tw') {
    errMsg = '請稍後再試';
    timeMsg = '閒置時間過長，請重新登入';
  } else {
    errMsg = 'Please try again later';
    timeMsg = 'Idle for too long, please re-login';
  }
  if (error.message === 'Request failed with status code 500') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: errMsg, duration: 3 * 1000 });
  } else if (error.message === 'Request failed with status code 504') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: errMsg + '   100504', duration: 3 * 1000 });
  } else if (error.message === 'timeout of 5000ms exceeded') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: errMsg + '   100100', duration: 3 * 1000 });
  } else if (error.message === 'Request failed with status code 401') {
    sessionStorage.removeItem('access-token');

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ message: timeMsg, duration: 3 * 1000 });
    setTimeout(function () {
      window.location.href = window.location.origin + "/login";
    }, 2000);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "Vq+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchTree;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["f"] = addObj;
/* harmony export (immutable) */ __webpack_exports__["c"] = getObj;
/* harmony export (immutable) */ __webpack_exports__["d"] = delObj;
/* harmony export (immutable) */ __webpack_exports__["e"] = putObj;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_fetch__ = __webpack_require__("Vo7i");


function fetchTree(query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/menu/tree',
    method: 'get',
    params: query
  });
}

function fetchAll() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api' + '/admin/api/user/un/' + localStorage.getItem('access-userId') + '/menu',

    method: 'get'
  });
}
function addObj(obj) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/menu',
    method: 'post',
    data: obj
  });
}

function getObj(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/menu/' + id,
    method: 'get'
  });
}

function delObj(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/menu/' + id,
    method: 'delete'
  });
}

function putObj(id, obj) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: '/api/admin/menu/' + id,
    method: 'put',
    data: obj
  });
}

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




var app = {
  state: {
    sidebar: {
      opened: !+__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('sidebarStatus')
    },
    theme: 'default',
    livenewsChannels: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('livenewsChannels') || '[]',
    visitedViews: [],
    themeColor: '',
    isShrinkage: false,
    isRouterAlive: true,
    tinymce: ''
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('sidebarStatus', 1);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    TOGGLE_SHRINKAGE: function TOGGLE_SHRINKAGE(state) {
      state.isShrinkage = !state.isShrinkage;
    },
    TOGGLE_ROUTERALIVE: function TOGGLE_ROUTERALIVE(state) {
      state.isRouterAlive = !state.isRouterAlive;
    },
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      if (state.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      state.visitedViews.push({ name: view.name, path: view.path });
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var index = void 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var i = _ref2[0];
          var v = _ref2[1];
          if (v.path === view.path) {
            index = i;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.visitedViews.splice(index, 1);
    },
    SETTHEME_COLOR: function SETTHEME_COLOR(state, curcolor) {
      state.themeColor = curcolor;
    },
    SETTHEME_TINYMCE: function SETTHEME_TINYMCE(state, tinymce) {
      state.tinymce = tinymce;
    }
  },
  actions: {
    ToggleSideBar: function ToggleSideBar(_ref3) {
      var commit = _ref3.commit;

      commit('TOGGLE_SIDEBAR');
    },
    ToggleShrinkage: function ToggleShrinkage(_ref4) {
      var commit = _ref4.commit;

      commit('TOGGLE_SHRINKAGE');
    },
    addVisitedViews: function addVisitedViews(_ref5, view) {
      var commit = _ref5.commit;

      commit('ADD_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref6, view) {
      var commit = _ref6.commit;

      commit('DEL_VISITED_VIEWS', view);
    },
    setThemeColor: function setThemeColor(_ref7, curcolor) {
      var commit = _ref7.commit;

      commit('SETTHEME_COLOR', curcolor);
    },
    setTinymce: function setTinymce(_ref8, tinymce) {
      var commit = _ref8.commit;

      commit('SETTHEME_TINYMCE', tinymce);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "XWx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        visitedViews: function visitedViews() {
            return this.$store.state.app.visitedViews.slice(-6);
        }
    },
    methods: {
        closeViewTabs: function closeViewTabs(view, $event) {
            this.$store.dispatch("delVisitedViews", view);
            $event.preventDefault();
        },
        generateRoute: function generateRoute() {
            if (this.$route.matched[this.$route.matched.length - 1].name) {
                return this.$route.matched[this.$route.matched.length - 1];
            }
            this.$route.matched[0].path = "/";
            return this.$route.matched[0];
        },
        addViewTabs: function addViewTabs() {
            this.$store.dispatch("addVisitedViews", this.generateRoute());
        },
        isActive: function isActive(path) {
            return path === this.$route.path;
        }
    },
    watch: {
        $route: function $route() {
            this.addViewTabs();
        }
    }
});

/***/ }),

/***/ "YPbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("kzJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__("DOpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar__ = __webpack_require__("N2mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Levelbar__);
/* unused harmony reexport Levelbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain__ = __webpack_require__("TAmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__AppMain___default.a; });








/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asyncRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__ = __webpack_require__("AkUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__);


var _import = __webpack_require__("A66B");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);



var constantRouterMap = [{
  path: '/login',
  name: '登录',
  component: _import('login/index'),
  hidden: true
}, {
  path: '/authredirect',
  name: '',
  component: _import('login/authredirect'),
  hidden: true
}, {
  path: '/404',
  name: '404',
  component: _import('error/404'),
  hidden: true
}, {
  path: '/401',
  name: '401',
  component: _import('error/401'),
  hidden: true
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  redirect: '/welcome',
  name: '首页',
  hidden: true,
  children: [{
    path: 'dashboard',
    redirect: '/welcome',
    component: _import('dashboard/index')
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'welcome',
    component: _import('welcome/index')
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'shopAuditDetails',
    component: _import('z_auditManage/sonViews/shopAuditDetails'),
    name: '店铺审核详情'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'agentAuditDetails',
    component: _import('z_auditManage/sonViews/agentAuditDetails'),
    name: '代理商审核详情'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'firmAuditDetails',
    component: _import('z_auditManage/sonViews/firmAuditDetails'),
    name: '公司审核详情'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'merAuditDetails',
    component: _import('z_auditManage/sonViews/merAuditDetails'),
    name: '商户审核详情'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'handleAgent',
    component: _import('z_businessManagement/sonViews/agentManage'),
    name: '操作代理商'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'handleMer',
    component: _import('z_businessManagement/sonViews/merDetails'),
    name: '操作商户'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'handleShop',
    component: _import('z_businessManagement/sonViews/shop'),
    name: '操作店铺'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'handleFirm',
    component: _import('z_businessManagement/sonViews/firmDetails'),
    name: '操作公司'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'agentAuditRecord',
    component: _import('z_auditManage/sonViews/agentAuditRecord'),
    name: '代理商审核记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'firmAuditRecord',
    component: _import('z_auditManage/sonViews/firmAuditRecord'),
    name: '公司审核记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'merAuditRecord',
    component: _import('z_auditManage/sonViews/merAuditRecord'),
    name: '商户审核记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'shopAuditRecord',
    component: _import('z_auditManage/sonViews/shopAuditRecord'),
    name: '店铺审核记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'ruleSettings',
    component: _import('z_riskControl/ruleSettings/index'),
    name: '规则设置'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'editNotify',
    component: _import('z_businessManagement/sonViews/editNotify'),
    name: '编辑通知'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'adDetail',
    component: _import('z_advert/sonViews/adData'),
    name: '广告数据'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'fundRechargeRecord',
    component: _import('z_merchantWithdrawCash/sonViews/fundRechargeRecord'),
    name: '充值记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'fundRefundRecord',
    component: _import('z_merchantWithdrawCash/sonViews/fundRefundRecord'),
    name: '退款记录'
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '',
  hidden: true,
  children: [{
    path: 'riskReport',
    component: _import('z_riskControl/riskReport/index'),
    name: '交易报告'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
}));

var asyncRouterMap = [{
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '基础配置管理',
  authority: 'baseManager',
  children: [{
    path: 'user',
    component: _import('admin/user/index'),
    name: '用户管理',
    authority: 'userManager'
  }, {
    path: 'menu',
    component: _import('admin/menu/index'),
    name: '菜单管理',
    authority: 'menuManager'
  }, {
    path: 'group',
    component: _import('admin/group/index'),
    name: '角色权限管理',
    authority: 'groupManager'
  }, {
    path: 'group_type',
    component: _import('admin/groupType/index'),
    name: '角色类型管理',
    authority: 'groupTypeManager'
  }, {
    path: 'gate_log',
    component: _import('admin/gateLog/index'),
    name: '操作日志管理',
    authority: 'gateLogManager'
  }]
}, {
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '交易管理',
  authority: 'z_tradeManagement',
  children: [{
    path: 'tradingFlow',
    component: _import('z_tradeManagement/tradingFlow/index'),
    name: '交易流水',
    authority: 'tradingFlow'
  }, {
    path: 'customs',
    component: _import('z_tradeManagement/customs/index'),
    name: '报关管理',
    authority: 'customs'
  }]
}, {
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '客户管理',
  authority: 'z_businessManagement',
  children: [{
    path: 'agent',
    component: _import('z_businessManagement/agent/index'),
    name: '代理商',
    authority: 'agent'
  }, {
    path: 'firm',
    icon: 'cash-cny',
    component: _import('z_businessManagement/firm/index'),
    name: '公司',
    authority: 'firm'
  }, {
    path: 'merchant',
    component: _import('z_businessManagement/merchant/index'),
    name: '商户',
    authority: 'merchant'
  }, {
    path: 'opinion',
    icon: 'cash-cny',
    component: _import('z_businessManagement/opinion/index'),
    name: '意见',
    authority: 'opinion'
  }, {
    path: 'notify',
    icon: 'cash-cny',
    component: _import('z_businessManagement/notify/index'),
    name: '通知',
    authority: 'notify'
  }]
}, {
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '审核管理',
  authority: 'z_auditManage',
  children: [{
    path: 'agentAudit',
    component: _import('z_auditManage/agentAudit/index'),
    name: '代理商审核',
    authority: 'agentAudit'
  }, {
    path: 'firmAudit',
    icon: 'cash-cny',
    component: _import('z_auditManage/firmAudit/index'),
    name: '公司审核',
    authority: 'firmAudit'
  }, {
    path: 'merAudit',
    component: _import('z_auditManage/merAudit/index'),
    name: '商户审核',
    authority: 'merAudit'
  }, {
    path: 'shopAudit',
    component: _import('z_auditManage/shopAudit/index'),
    name: '店铺审核',
    authority: 'shopAudit'
  }, {
    path: 'withdrawAudit',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/withdrawAudit/index'),
    name: '兑现审核',
    authority: 'withdrawAudit'
  }, {
    path: 'imprestAudit',
    component: _import('z_auditManage/imprestAudit/index'),
    name: '备用金充值审核',
    authority: 'imprestAudit'
  }]
}, {
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '机构管理',
  authority: 'z_mechanism',
  children: [{
    path: 'mechanism',
    component: _import('z_mechanism/mechanism/index'),
    name: '机构管理',
    authority: 'mechanism'
  }]
}, {
  path: '',
  icon: 'Device',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '设备模块',
  authority: 'device_Modular',
  children: [{
    path: 'device',
    icon: 'Device',
    component: _import('z_deviceManagement/index'),
    name: '设备',
    authority: 'deviceManagement'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '兑现',
  authority: 'withdrawCash',
  children: [{
    path: 'merchantWithdrawCash',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/withdrawal/index'),
    name: '兑现',
    authority: 'merchantWithdrawCash'
  }, {
    path: 'profit',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/profit/index'),
    name: '分润',
    authority: 'profit'
  }, {
    path: 'fund',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/fund/index'),
    name: '资金管理',
    authority: 'fund'
  }, {
    path: 'settlement',
    icon: 'cash-cny',
    component: _import('z_merchantWithdrawCash/settlement/index'),
    name: '商户结算',
    authority: 'settlement'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '人员管理',
  authority: 'personnelManagement',
  children: [{
    path: 'salesmanManagement',
    icon: 'cash-cny',
    component: _import('z_SalesmanManage/index'),
    name: '业务员管理',
    authority: 'salesmanManagement'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '广告模块',
  authority: 'ad_management',
  children: [{
    path: 'ad',
    icon: 'cash-cny',
    component: _import('z_advert/index'),
    name: '广告',
    authority: 'ad_ad'
  }]
}, {
  path: '',
  icon: 'cash-cny',
  component: __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout___default.a,
  name: '风控模块',
  authority: 'riskControl_Modular',
  children: [{
    path: 'riskControl',
    icon: 'cash-cny',
    component: _import('z_riskControl/index'),
    name: '风控',
    authority: 'riskControl'
  }, {
    path: 'merchantControl',
    component: _import('z_riskControl/merchantControl/index'),
    name: '商戶风控',
    authority: 'merchantControl'
  }, {
    path: 'riskMonitoring',
    component: _import('z_riskControl/riskMonitor/index'),
    name: '交易监控',
    authority: 'riskMonitoring'
  }, {
    path: 'report',
    component: _import('z_riskControl/report/index'),
    name: '交易报告',
    authority: 'report'
  }]
}];

/***/ }),

/***/ "Z39e":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAvCAMAAAB9ntLFAAAApVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+4/eNVAAAANnRSTlMA85ztz1T85hoS6vhiSBDAJbGkkm5odHFLMigH2ruWjYF8eGs6Fgvg0cW2rIZPQC3Xyh9bWEQSOyxlAAAB7klEQVRIx63U53aCQBAF4EGjhCJFQLD33lPu+z9aXHV2wahZz8n3a1znijss0ANDo0GvGWBED7xLlNOOsGmTMt3WLrIdlatXB9WxXZsAzHA845UmJJKVL39/DWZO6GJm8pJBBpd1TiwB9EqoD0WXRxcLbiurRIkuXMCo0Rc+yVvZdf5fb08SpfPlGhDTtYg0EiNgbpGLmASdxNQ4RbYjjLUT1BQ7rsJcJ5ZmgqzIvH4bayWE9i6EL5o2egkhRYUGACbaiY2Y7gqIdBK74USc3fjcNtBIBKfanQ3hBv6p+tBIeOJcmSbOM870dj7gg7ra6053Vhsd4Y9bGvdcSfBJ9FKij82LiWba1E0o/5ewuVzTMx1us1V5pLNW6lZy3PR8198dbuuQz6VjkfDRQ0E0FavfuZdUSdZffLDqkLotHrba7jiXZtnieln5DNpgCbUg5e5AoyqOVcAfY0intQPYgpQgtMfEPKPQM4LUpxxLlV2wy3uvCimmO3g4aqARlCH90laj48fec6CELSravUFxPH4W8qL8of0OkZfwuo+CY8/dZllWiesHFHTV9MrQYXsk7asaAaewxYnzd2BCBfs5npvv6YYV4pnQo98S+/GeE7rL6hu4x+hb9Mg0XeLWMp3SU4Hb63ZsQ7A73Z4b0I0fK2TkMlycdxoAAAAASUVORK5CYII="

/***/ }),

/***/ "Z3Wo":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height + 'px',
      zIndex: _vm.zIndex
    })
  }, [_c('div', {
    class: _vm.className,
    style: ({
      top: _vm.stickyTop + 'px',
      zIndex: _vm.zIndex,
      position: _vm.position,
      width: _vm.width,
      height: _vm.height + 'px'
    })
  }, [_vm._t("default", [_c('div', [_vm._v("sticky")])])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fc9bdb4", module.exports)
  }
}

/***/ }),

/***/ "aacO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "SidebarItem",
    props: {
        routes: {
            type: Array
        }
    },
    data: function data() {
        return {
            toggleMer: true,
            active_id: undefined,
            userPhone: localStorage.getItem("phone"),
            userType: localStorage.getItem("userType")
        };
    },
    created: function created() {

        this.toggleMer = this.userPhone === "13501189583" || this.userPhone === "15018955912" ? false : true;
    },
    mounted: function mounted() {
        if (this.userType === "10") {
            $("#fund").hide();
        }
    },

    computed: {
        isShrinkage: function isShrinkage() {
            return this.$store.state.app.isShrinkage;
        }
    },
    methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ "afte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull__ = __webpack_require__("I95x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_screenfull__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hamburger',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data: function data() {
    return {
      isFullscreen: false
    };
  },

  methods: {
    click: function click() {
      if (!__WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.toggle();
    }
  }
});

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_layout__ = __webpack_require__("YPbV");




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "layout",
    data: function data() {
        return {
            toggleMer: true,
            active_id: undefined,
            companyId: localStorage.getItem("companyId"),
            whiteLabel: localStorage.getItem('whiteLabel')
        };
    },

    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_0_views_layout__["a" /* Navbar */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_0_views_layout__["b" /* Sidebar */],
        AppMain: __WEBPACK_IMPORTED_MODULE_0_views_layout__["c" /* AppMain */]
    },
    created: function created() {
        this.toggleMer = localStorage.getItem("phone") == "13501189583" || localStorage.getItem("phone") == "15018955912" ? false : true;
    },

    computed: {
        sidebar: function sidebar() {
            return this.$store.state.app.sidebar;
        },
        isShrinkage: function isShrinkage() {
            return this.$store.state.app.isShrinkage;
        },
        isRouterAlive: function isRouterAlive() {
            return this.$store.state.app.isRouterAlive;
        }
    },
    methods: {
        toggleSildeBar: function toggleSildeBar() {
            var _that = this;
            this.$store.commit("TOGGLE_SHRINKAGE");
            if (this.$store.state.app.isShrinkage) {
                $(".el-submenu__title i").hide();
                $(".svg-slide-icon").css("transform", "rotateZ(90deg)");
            } else {
                $(".el-submenu__title i").show();
                $(".svg-slide-icon").css("transform", "rotateZ(0deg)");
            }
            setTimeout(function () {
                for (var i = 0; i < $(".switch-el-menu-item").length; i++) {
                    $(".switch-el-menu-item")[i].classList.remove("is-active");
                }
                if (_that.$route.path == "/handleMer" || _that.$route.path == "/handleShop") {
                    $("#merchant").addClass("is-active");
                } else if (_that.$route.path == "/handleaAgent") {
                    $("#agent").addClass("is-active");
                } else if (_that.$route.path == "/handleFirm") {
                    $("#firm").addClass("is-active");
                } else if (_that.$route.path == "/editNotify") {
                    $("#notify").addClass("is-active");
                } else if (_that.$route.path == "/shopAuditDetails" || _that.$route.path == '/shopAuditRecord') {
                    $("#shopAudit").addClass("is-active");
                } else if (_that.$route.path == "/agentAuditDetails" || _that.$route.path == '/agentAuditRecord') {
                    $("#agentAudit").addClass("is-active");
                } else if (_that.$route.path == "/merAuditDetails" || _that.$route.path == '/merAuditRecord') {
                    $("#merAudit").addClass("is-active");
                } else if (_that.$route.path == "/firmAuditDetails" || _that.$route.path == '/firmAuditRecord') {
                    $("#firmAudit").addClass("is-active");
                } else if (_that.$route.path == "/ruleSettings") {
                    $("#riskControl").addClass("is-active");
                } else {
                    $("#" + _that.$route.path.replace("/", "")).addClass("is-active");
                }
            }, 300);
        },
        switchSystem: function switchSystem() {
            var _that = this;
            if ($(".unipay-div").css("top") == "0px") {
                localStorage.setItem("companyId", "2");

                $(".mipay-div").css({
                    "box-shadow": "0 2px 3px rgba(0,0,0,.23)",
                    "z-index": "2000"
                });
                $(".unipay-div").css({ "z-index": "1" });
                $(".mipay-div").animate({ top: "0px" }, function () {
                    $(".mipay-div").css("box-shadow", "none");
                    $(".unipay-div").css("top", "-78px");
                    _that.$store.commit("TOGGLE_ROUTERALIVE");
                    _that.$nextTick(function () {
                        return _that.$store.commit("TOGGLE_ROUTERALIVE");
                    });
                });

                setTimeout(function () {
                    _that.$router.push({ path: "/welcome" });
                    location.reload();
                }, 1000);
            } else {
                localStorage.setItem("companyId", "1");

                $(".unipay-div").css({
                    "box-shadow": "0 2px 3px rgba(0,0,0,.23)",
                    "z-index": "2000"
                });
                $(".mipay-div").css("z-index", "1");
                $(".unipay-div").animate({ top: "0px" }, function () {
                    $(".unipay-div").css("box-shadow", "none");
                    $(".mipay-div").css("top", "-78px");
                    _that.$store.commit("TOGGLE_ROUTERALIVE");
                    _that.$nextTick(function () {
                        return _that.$store.commit("TOGGLE_ROUTERALIVE");
                    });
                });
                setTimeout(function () {
                    _that.$router.push({ path: "/welcome" });
                    location.reload();
                }, 1000);
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64__ = __webpack_require__("xrTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_api_merchant_index__ = __webpack_require__("U/Dg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_api_agent_index__ = __webpack_require__("e9yK");









var user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: '',
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: undefined,
    elements: undefined,
    setting: {
      articlePlatform: []
    },
    userId: '',
    distributorId: '',
    companyId: '',
    currency: ''
  },

  mutations: {
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_MENUS: function SET_MENUS(state, menus) {
      state.menus = menus;
    },
    SET_ELEMENTS: function SET_ELEMENTS(state, elements) {
      state.elements = elements;
    },
    LOGIN_SUCCESS: function LOGIN_SUCCESS() {
      console.log('login success');
    },
    LOGOUT_USER: function LOGOUT_USER(state) {
      state.user = '';
    },

    SET_USERID: function SET_USERID(state, userId) {
      state.userId = userId;
    },
    SET_DISTRIBUTORID: function SET_DISTRIBUTORID(state, distributorId) {
      state.distributorId = distributorId;
    },
    SET_COMPANYID: function SET_COMPANYID(state, companyId) {
      state.companyId = companyId;
    },
    SET_CURRENCY: function SET_CURRENCY(state, currency) {
      state.currency = currency;
    },
    SET_PASSWORD: function SET_PASSWORD(state, password) {
      state.password = password;
    }
  },

  actions: {
    LoginByEmail: function LoginByEmail(_ref, userInfo) {
      var commit = _ref.commit;

      console.log('login-userInfo', userInfo);
      console.log('commit', { commit: commit });
      var phone = userInfo.phone.trim();
      console.log('login-phone', phone);
      console.log('login-userInfo.password', userInfo.password);
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_MENUS', undefined);
      commit('SET_ELEMENTS', undefined);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_auth__["a" /* removeToken */])();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_login__["f" /* loginByEmail */])(phone, userInfo.password).then(function (response) {
          if (response.code == '0') {
            var data = response;
            console.log('user-data', data);

            var access = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_js_base64__["Base64"].decode(data.value.split('.')[1]));
            console.log('user-access', access);

            if (access.userType == 4 || access.userType == 7) {
              var errMsg = void 0;
              if (localStorage.getItem('locale') === 'zh_cn') {
                errMsg = '账号不存在';
              } else if (localStorage.getItem('locale') === 'zh_tw') {
                errMsg = '賬號不存在';
              } else {
                errMsg = 'Account does not exist';
              }
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: errMsg, type: 'error', duration: 5 * 1000 });
            } else {
              sessionStorage.setItem("access-token", data.value);
              localStorage.setItem('access-userId', access.userId);

              localStorage.setItem("companyId", access.companyId);
              localStorage.setItem("userType", access.userType);

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_login__["g" /* getUserType */])(access.userId).then(function (res) {
                localStorage.setItem('userName', res.value.name);
                localStorage.setItem('whiteLabel', res.value.attr7);
                if (res.value.path) {
                  localStorage.setItem('userLoginImg', res.value.path);
                }
              });

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_auth__["b" /* setToken */])(data.value);
              commit('SET_TOKEN', data.value);

              if (access.userType == 2) {
                localStorage.setItem("distributorId", access.distributorId);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api_agent_index__["m" /* queryBD_grade */])(access.distributorId).then(function (res) {
                  localStorage.setItem('grade', res.value.grade);
                });
              } else {
                localStorage.removeItem('grade');
                localStorage.removeItem('distributorId');
              }

              if (access.userType == 8) {
                localStorage.setItem('salesmanId', access.salesmanId);
              } else {
                localStorage.removeItem('salesmanId');
              }

              if (access.userType == 10) {
                localStorage.setItem('firmId', access.firmId);
              } else {
                localStorage.removeItem('firmId');
              }

              if (access.userType == 1) {
                localStorage.setItem('merchantId', access.merchantId);
              } else {
                localStorage.removeItem('merchantId');
              }
            }
          } else if (response.code == '2' || response.code == '7') {
            var _errMsg = void 0;
            if (localStorage.getItem('locale') === 'zh_cn') {
              _errMsg = '账号不存在';
            } else if (localStorage.getItem('locale') === 'zh_tw') {
              _errMsg = '賬號不存在';
            } else {
              _errMsg = 'Account does not exist';
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: _errMsg, type: 'error', duration: 5 * 1000 });
          } else if (response.code == '11') {
            var timeMsg = void 0;
            if (localStorage.getItem('locale') === 'zh_cn') {
              timeMsg = '密码错误，请重新登录';
            } else if (localStorage.getItem('locale') === 'zh_tw') {
              timeMsg = '密碼錯誤，請重新登入';
            } else {
              timeMsg = 'Password incorrect, please re-enter';
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: timeMsg, type: 'error', duration: 5 * 1000 });
          } else if (response.code == '5') {
            var disabledMsg = void 0;
            if (localStorage.getItem('locale') === 'zh_cn') {
              disabledMsg = '该账号已被停用';
            } else if (localStorage.getItem('locale') === 'zh_tw') {
              disabledMsg = '該賬號已被停用';
            } else {
              disabledMsg = 'This account has been disabled';
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ message: disabledMsg, type: 'error', duration: 5 * 1000 });
          }
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    GetInfo: function GetInfo(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (sessionStorage.getItem("access-token")) {

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_api_merchant_index__["a" /* queryIndustry */])(localStorage.getItem("locale") === "en" ? "1" : "0").then(function (res) {
            res.value.forEach(function (element) {
              if (element.industryType && element.industryType == 1) element.disabled = false;else element.disabled = true;
            });
            localStorage.setItem('queryIndustryObj', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.value));

            res.value.push({
              'industryName': localStorage.getItem("locale") === "en" ? 'Other' : '其它',
              'industryCode': '1111'
            });

            localStorage.setItem('queryIndustryObj_ad', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.value));
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_api_merchant_index__["B" /* AU_State_list */])(localStorage.getItem("companyId"), localStorage.getItem("locale") === "en" ? "en" : "cn").then(function (res) {
            localStorage.setItem('queryAU_State_list', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.value));
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_login__["h" /* getInfo */])(sessionStorage.getItem("access-token")).then(function (response) {
            var data = response;

            commit('SET_ROLES', 'admin');
            commit('SET_NAME', data.value.username);
            commit('SET_AVATAR', 'http://git.oschina.net/uploads/42/547642_geek_qi.png?1499487420');
            commit('SET_INTRODUCTION', data.value.username);
            var menus = {};

            for (var i = 0; i < data.value.menus.length; i++) {
              menus[data.value.menus[i].code] = true;
            }

            commit('SET_MENUS', menus);
            var elements = {};
            for (var _i = 0; _i < data.value.elements.length; _i++) {
              elements[data.value.elements[_i].code] = true;
            }

            commit('SET_ELEMENTS', elements);
            resolve(data);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          return false;
        }
      });
    },
    LoginByThirdparty: function LoginByThirdparty(_ref3, code) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('SET_CODE', code);
        loginByThirdparty(state.status, state.email, state.code).then(function (response) {
          commit('SET_TOKEN', response.data.token);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_auth__["b" /* setToken */])(response.data.token);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    LogOut: function LogOut(_ref4) {
      var _this = this;

      var commit = _ref4.commit,
          state = _ref4.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push({ path: '/dashboard' });
      });
    },
    FedLogOut: function FedLogOut(_ref5) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('SET_TOKEN', '');
        commit('SET_MENUS', undefined);
        commit('SET_ELEMENTS', undefined);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_auth__["a" /* removeToken */])();
        resolve();
      });
    },
    ChangeRole: function ChangeRole(_ref6, role) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('SET_ROLES', [role]);
        commit('SET_TOKEN', role);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_auth__["b" /* setToken */])(role);
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "bvN3":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.name) + "\n        ")])], 1)
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73d89c54", module.exports)
  }
}

/***/ }),

/***/ "dahE":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("DxN1")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SM0Y"),
  /* template */
  __webpack_require__("5/oe"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c926d418",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\components\\Hamburger\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c926d418", Component.options)
  } else {
    hotAPI.reload("data-v-c926d418", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "e9yK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = createAgent;
/* harmony export (immutable) */ __webpack_exports__["l"] = agentAll;
/* harmony export (immutable) */ __webpack_exports__["i"] = agentDetails;
/* harmony export (immutable) */ __webpack_exports__["j"] = modifyAgent;
/* unused harmony export salesmanList */
/* harmony export (immutable) */ __webpack_exports__["a"] = salesmanAll;
/* harmony export (immutable) */ __webpack_exports__["b"] = querySuperiorAgent;
/* harmony export (immutable) */ __webpack_exports__["e"] = validateBDName;
/* harmony export (immutable) */ __webpack_exports__["f"] = validateBDNameModify;
/* harmony export (immutable) */ __webpack_exports__["g"] = validateBDPhone;
/* harmony export (immutable) */ __webpack_exports__["h"] = validateBDPhoneModify;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateBDEamil;
/* harmony export (immutable) */ __webpack_exports__["d"] = validateBDEamilModify;
/* harmony export (immutable) */ __webpack_exports__["m"] = queryBD_grade;
/* unused harmony export queryAgentAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_fetch__ = __webpack_require__("Vo7i");


function createAgent(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/create',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function agentAll(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/screenSelectDistributor',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function agentDetails(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/getDistributorIdFind/' + id + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function modifyAgent(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/update',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function salesmanList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/salesman/screenSelectSalesman',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function salesmanAll(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/salesman/getFindDistributorSalesman',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function querySuperiorAgent(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/getcompanyIdFindDistributor',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

function validateBDName(BD_name) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationDistributorName/s',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: {
      name: BD_name
    }
  });
}

function validateBDNameModify(BD_name, distributorId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationDistributorName/s',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: {
      name: BD_name,
      id: distributorId
    }
  });
}

function validateBDPhone(phone) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationPhone/' + phone + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function validateBDPhoneModify(phone, distributorId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationPhone/' + phone + '/' + distributorId + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function validateBDEamil(Eamil) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationEmail/' + Eamil + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function validateBDEamilModify(Eamil, distributorId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/verificationEmail/' + Eamil + '/' + distributorId + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function queryBD_grade(distributorId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/findDistributorGrade/' + distributorId + '/s',
    method: 'get',
    headers: { 'Content-type': 'application/json;charset=UTF-8' }
  });
}

function queryAgentAll(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_fetch__["a" /* default */])({
    url: 'api/admin/distributor/selectAllDistributor',
    method: 'post',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    data: data
  });
}

/***/ }),

/***/ "f8sx":
/***/ (function(module, exports) {

!function (c) {
  var h,
      _l,
      a,
      i,
      v,
      _o,
      z = '<svg><symbol id="icon-baogao" viewBox="0 0 1024 1024"><path d="M780.86564102 825.67658119V217.44275328c-0.5974792-13.74202165-2.98739601-36.44623134-17.32689686-50.7857322-10.15714644-10.15714644-25.0941265-14.93698005-44.81094017-14.93698006-40.62858576 0-60.94287863 30.47143932-60.94287864 90.81683876v111.72861082c0 13.74202165-11.35210484 25.6916057-25.69160569 25.69160569h-472.0085698v417.6379624c0 69.90506667 44.81094017 126.66559089 114.71600684 126.66559088h11.94958404l529.36657322-0.59747919C794.01018348 901.55643988 780.86564102 867.50012535 780.86564102 825.67658119z m-143.99248774-103.96138119H304.67471681c-16.72941766 0-30.47143932-13.74202165-30.47143932-30.47143932s13.74202165-30.47143932 30.47143932-30.47143931h332.19843647c16.72941766 0 30.47143932 13.74202165 30.47143932 30.47143931s-13.74202165 30.47143932-30.47143932 30.47143932z m0-162.51434302H304.67471681c-16.72941766 0-30.47143932-13.74202165-30.47143932-30.47143932s13.74202165-30.47143932 30.47143932-30.47143931h332.19843647c16.72941766 0 30.47143932 13.74202165 30.47143932 30.47143931s-13.74202165 30.47143932-30.47143932 30.47143932zM832.24885243 825.67658119c0 22.70420969 5.97479202 76.4773379 59.74792022 76.4773379 22.10673049 0 35.84875214-8.96218803 44.81094017-20.31429288 5.97479202-9.55966723 10.75462564-20.31429287 13.14454244-31.66639772v-1.1949584c0-1.19495841 0.5974792-2.98739601 0.59747921-4.18235442 0.5974792-5.97479202 1.19495841-11.35210484 1.1949584-14.93698006V678.69669744c0-9.55966723-7.16975043-17.32689687-17.32689686-17.32689687h-102.16894358v164.30678062z" fill="#ffffff" ></path><path d="M89.58220399 329.17136411h517.41698917V243.13435898c0-83.64708832 37.04371055-135.62777892 100.37650599-141.00509175-5.97479202-1.19495841-12.54706324-1.79243761-18.52185527-1.79243761H164.86458348c-50.78573219 0-92.60927635 38.23866894-92.60927635 85.43952593v130.2504661c0 5.97479202 7.16975043 13.14454244 17.32689686 13.14454246z" fill="#ffffff" ></path></symbol><symbol id="icon-huandong" viewBox="0 0 1024 1024"><path d="M512 42.666667C252.8 42.666667 42.666667 252.8 42.666667 512s210.133333 469.333333 469.333333 469.333333 469.333333-210.133333 469.333333-469.333333S771.2 42.666667 512 42.666667zM278.186667 457.6l152.106666-292.266667c11.733333-17.706667 39.04-9.386667 39.04 11.733334V469.333333c0 11.733333-9.6 21.333333-21.333333 21.333334h-152.106667c-17.066667 0-27.306667-18.986667-17.706666-33.066667zM490.666667 728.106667c0 17.066667-18.986667 27.306667-33.066667 17.706666l-292.266667-152.106666c-17.706667-11.733333-9.386667-39.04 11.733334-39.04H469.333333c11.733333 0 21.333333 9.6 21.333334 21.333333v152.106667z m255.146666-161.706667l-152.106666 292.266667c-11.733333 17.706667-39.04 9.386667-39.04-11.733334V554.666667c0-11.733333 9.6-21.333333 21.333333-21.333334h152.106667c17.066667 0 27.306667 18.986667 17.706666 33.066667zM846.933333 469.333333H554.666667c-11.733333 0-21.333333-9.6-21.333334-21.333333v-152.106667c0-17.066667 18.986667-27.306667 33.066667-17.706666l292.266667 152.106666c17.706667 11.733333 9.386667 39.04-11.733334 39.04z"  ></path></symbol><symbol id="icon-iconless" viewBox="0 0 1024 1024"><path d="M512.616942 64.186673c61.720553 0 119.790782 11.779813 174.211085 35.33944s101.706043 55.415428 141.857421 95.567405c40.151377 40.151977 72.007179 87.27183 95.567405 141.359758 23.560226 54.087729 35.340039 111.992269 35.33944 173.713422-0.0006 61.720953-11.780213 119.791381-35.33944 174.211085-23.559027 54.419703-55.415029 101.705444-95.567405 141.857421-40.152577 40.151977-87.438317 72.007779-141.857421 95.567405-54.419104 23.559627-112.489332 35.33944-174.211085 35.33944s-119.626094-11.779813-173.713422-35.33944c-54.087329-23.559627-101.207182-55.415428-141.359758-95.567405-40.152577-40.151977-72.008378-87.437717-95.567405-141.857421s-35.33884-112.489932-35.33944-174.211085c-0.0006-61.721153 11.779214-119.625494 35.33944-173.713422s55.416028-101.207781 95.567405-141.359758 87.27123-72.007779 141.359758-95.567405S450.896588 64.186873 512.616942 64.186673zM734.61083 570.891328c19.909701 0 37.828552-5.143313 53.756153-15.429939 15.927601-10.286626 23.891402-25.716564 23.891402-46.289816 0-19.909701-7.963801-34.676289-23.891402-44.299365-15.927601-9.623076-33.846252-14.434613-53.756153-14.434813L294.604154 450.437395c-19.909701 0-38.160527 4.811538-54.752278 14.434813-16.591751 9.623076-24.887526 24.389664-24.887526 44.299365 0 20.573251 8.295775 36.00319 24.887526 46.289816 16.591751 10.286626 34.842377 15.429939 54.752278 15.429939L734.61083 570.891328 734.61083 570.891328z" fill="#e6e6e6" ></path></symbol><symbol id="icon-tianjia1" viewBox="0 0 1024 1024"><path d="M512 0c282.752 0 512 229.248 512 512s-229.248 512-512 512S0 794.752 0 512 229.248 0 512 0z m0 213.333333a42.666667 42.666667 0 0 0-42.666667 42.666667v213.333333H256l-4.992 0.298667A42.666667 42.666667 0 0 0 256 554.666667h213.333333v213.333333l0.298667 4.992A42.666667 42.666667 0 0 0 554.666667 768v-213.333333h213.333333l4.992-0.298667A42.666667 42.666667 0 0 0 768 469.333333h-213.333333V256l-0.298667-4.992A42.666667 42.666667 0 0 0 512 213.333333z" fill="#008df0" ></path></symbol><symbol id="icon-fengxianfenxi" viewBox="0 0 1024 1024"><path d="M952.734 586.791l-0.054-0.009c0 0.028-0.008 0.057-0.013 0.086a30.015 30.015 0 1 1-59.167-10.117c0.1-0.586 0.221-1.162 0.353-1.734A389.324 389.324 0 0 0 899 511.98c0-213.736-173.266-387-387-387s-387 173.268-387 387 173.266 387.005 387 387.005v0.031a30 30 0 0 1 0 60c-0.279 0-0.549-0.034-0.826-0.042C264.684 958.527 65 758.58 65 511.985c0-246.872 200.129-447 447-447s447 200.128 447 447a449.817 449.817 0 0 1-6.266 74.806zM692 512.016a29.843 29.843 0 0 1-6.508 18.624l-148.04 256.413a30 30 0 1 1-51.961-30l124.152-215.037H363.106a29.591 29.591 0 0 1-3.456-0.119 29.976 29.976 0 0 1-20.75-49.021l147.591-255.63a30 30 0 1 1 51.961 30l-123.998 214.77H662a30 30 0 0 1 30 30z m8.781 294.906a30 30 0 0 1 30 30v91.813a30 30 0 0 1-60 0v-91.813a30 30 0 0 1 30-30z m114-130a30 30 0 0 1 30 30v221.813a30 30 0 0 1-60 0V706.922a30 30 0 0 1 30-30z m114 48a30 30 0 0 1 30 30v173.813a30 30 0 0 1-60 0V754.922a30 30 0 0 1 30-30z" fill="#ffffff" ></path></symbol><symbol id="icon-jiance" viewBox="0 0 1024 1024"><path d="M511.4 116.5L878 228.8v340.9c-4 6.9-18.3 27.5-66 73.6-34.8 33.5-81 74.7-137.5 122.2C611 819 548.7 868.7 513 896.8c-35.7-28.1-98-77.8-161.5-131.2C295 718 248.8 676.8 214 643.2c-47.7-46.1-62-66.7-66-73.6v-341l363.4-112.1m-0.1-52.3L98 191.8v384.3c0 63.9 415 384.2 415 384.2S928 640 928 576V191.7L511.3 64.2z" fill="#ffffff" ></path><path d="M634.6 737.8L508 327.5 392 592.2l-146.6-152H128v-50h138.7l109.5 113.6 140-319.4L645.7 604l107-213.8h143.5v50H783.6z" fill="#ffffff" ></path></symbol><symbol id="icon-fengkongkehu1" viewBox="0 0 1024 1024"><path d="M619.829719 501.593531a453.481768 453.481768 0 0 0-64.747681-22.776888 255.91474 255.91474 0 1 0-251.563762 0C127.96014 527.697403 0.00277 676.63967 0.00277 852.452804a25.591874 25.591874 0 1 0 51.182748 0c0-187.074079 169.672165-340.622323 378.242138-340.622323a409.463985 409.463985 0 0 1 169.416167 35.827823 25.591874 25.591874 0 0 0 20.984896-46.57677z m-395.134055-245.678791A204.731992 204.731992 0 1 1 429.427656 460.647733a204.731992 204.731992 0 0 1-204.731992-204.731993zM893.658372 739.850359H791.291875a25.591874 25.591874 0 0 0 0 51.182748H893.658372a25.591874 25.591874 0 0 0 0-51.182748z" fill="#FFFFFF" ></path><path d="M943.305127 558.150253a304.538501 304.538501 0 0 1-100.829504-51.182748 304.538501 304.538501 0 0 1-100.831503 51.182748 330.898371 330.898371 0 0 1-80.356605 15.610923v251.308763a127.95737 127.95737 0 0 0 31.989843 84.963582q9.979951 11.004946 20.983896 22.008892c10.23695 10.23695 20.729898 19.960902 31.221847 29.173856l13.307934 11.259945a464.741713 464.741713 0 0 0 68.072665 47.344767 32.244841 32.244841 0 0 0 31.733844 0 464.741713 464.741713 0 0 0 67.817666-47.343767l13.306935-11.259945a651.046796 651.046796 0 0 0 52.206743-51.183748 127.95737 127.95737 0 0 0 31.733844-84.963582V573.505177a330.898371 330.898371 0 0 1-80.357605-15.354924z m29.174857 132.819346v135.124335A76.774622 76.774622 0 0 1 953.798076 877.275682q-9.212955 10.23695-19.193906 20.216901c-8.956956 8.956956-18.425909 17.658913-28.661859 25.591874l-12.028941 10.236949a431.472876 431.472876 0 0 1-51.182748 36.851819 430.960879 430.960879 0 0 1-51.182748-36.851819l-12.027941-10.236949c-10.23695-8.956956-19.705903-17.657913-28.662859-25.591874s-13.050936-13.306935-19.192905-20.216901a76.774622 76.774622 0 0 1-18.681908-51.182748V618.290957a412.790968 412.790968 0 0 0 44.784779-11.516943 394.10906 394.10906 0 0 0 85.47558-38.386812 393.853062 393.853062 0 0 0 85.475579 38.386812 412.790968 412.790968 0 0 0 44.78478 11.516943z" fill="#FFFFFF" ></path></symbol><symbol id="icon-xinzeng" viewBox="0 0 1024 1024"><path d="M870.3 775V364.9c0-43.8-35.5-79.3-79.3-79.3H380.8c-43.8 0-79.3 35.5-79.3 79.3V775c0 43.8 35.5 79.3 79.3 79.3h410.1c43.8 0 79.4-35.5 79.4-79.3z m-325.2-42.7V610.5H423.7v-80.9h121.4V408.1H626v121.5h121.8v80.9H626.1v121.8h-81z" fill="#FFFFFF" ></path><path d="M284.6 685.1c-25.1 0-45.5-20.4-45.5-45.5V267.4c0-25.1 20.4-45.5 45.5-45.5h372.3c25.1 0 45.5 20.4 45.5 45.5v5.8h52.2V249c0-43.8-35.5-79.3-79.3-79.3H265.1c-43.8 0-79.3 35.5-79.3 79.3v410.1c0 43.8 35.5 79.3 79.3 79.3h24.4v-53.3h-4.9z" fill="#FFFFFF" ></path></symbol><symbol id="icon-beiyongjinshezhi" viewBox="0 0 1049 1024"><path d="M574.701 463.019a29.826 29.826 0 0 1 52.13 28.765l-1.823 3.281-62.072 97.499a29.826 29.826 0 0 1-47.456 3.778l-2.42-3.115-62.071-91.964a29.826 29.826 0 0 1 47.158-36.355l2.32 2.982 36.587 54.185 37.647-59.056z"  ></path><path d="M537.783 561.578a29.826 29.826 0 0 1 29.594 26.081l0.232 3.745v240.034a29.826 29.826 0 0 1-59.387 3.745l-0.265-3.745V591.404a29.826 29.826 0 0 1 29.826-29.826z"  ></path><path d="M633.624 664.445a29.826 29.826 0 0 1 3.745 59.42l-3.745 0.232H441.942a29.826 29.826 0 0 1-3.712-59.42l3.712-0.232h191.682z m0-102.867a29.826 29.826 0 0 1 3.745 59.42l-3.745 0.232H441.942a29.826 29.826 0 0 1-3.712-59.42l3.712-0.232h191.682z"  ></path><path d="M672.597 10.125c27.838-1.756 53.025 8.517 69.528 28.865l3.646 4.905 155.162 225.618a29.826 29.826 0 0 1-46.827 36.753l-2.32-2.983L696.657 77.698c-3.944-5.7-10.572-8.617-20.182-8.053a46.264 46.264 0 0 0-19.222 6.098l-4.805 2.982L305.14 316.837a29.826 29.826 0 0 1-36.653-46.893l2.95-2.32L618.611 29.612a108.269 108.269 0 0 1 53.985-19.487z"  ></path><path d="M123.034 129.165c17.034-21.74 41.69-33.67 68.036-32.478l6.098 0.53 283.216 36.72a29.826 29.826 0 0 1-3.943 59.387l-3.745-0.232-282.984-36.686c-7.06-0.862-13.92 2.187-19.62 9.412a47.722 47.722 0 0 0-8.417 18.525l-0.994 5.534-15.112 116.024a29.826 29.826 0 0 1-59.387-3.943l0.265-3.745 15.079-116.09c2.65-19.752 9.942-37.979 21.508-52.958zM184.078 230.706c0.1 0 0.1 0 0 0"  ></path><path d="M930.23 274.385H144.574c-60.315 0-108.17 42.088-108.17 98.725v526.53c0 56.637 47.822 98.659 108.17 98.659H930.99c60.25 0 108.104-42.088 108.104-98.658V373.706c0-57.001-48.153-99.288-108.932-99.288z m-785.622 59.652h785.621c29.429 0 49.28 17.465 49.28 39.702v525.902c0 21.773-19.553 39.006-48.485 39.006H144.608c-28.998 0-48.517-17.167-48.517-39.006V373.11c0-21.873 19.552-39.04 48.517-39.04z"  ></path></symbol><symbol id="icon-zidingyi" viewBox="0 0 1024 1024"><path d="M338.72213333 551.81198222c50.60266667 0 91.62524445 40.99640889 91.62524445 91.56835556v227.61244444c0 50.57080889-41.02257778 91.56721778-91.62524445 91.56721778H110.96746667C60.3648 962.56 19.34222222 921.56359111 19.34222222 870.99164445V643.3792c0-50.57080889 41.02257778-91.56721778 91.62524445-91.56721778h227.75466666z m502.6304 0c50.60266667 0 91.62524445 40.99640889 91.62524445 91.56835556v227.61244444C932.97777778 921.56245333 891.9552 962.56 841.35253333 962.56H613.59786667c-50.60266667 0-91.62524445-40.99640889-91.62524445-91.56835555V643.3792c0-50.57080889 41.02257778-91.56721778 91.62524445-91.56721778H841.35253333zM727.47576889 62.57777778C840.97137778 62.57777778 932.97777778 154.52728889 932.97777778 267.95121778c0 113.42506667-92.0064 205.37457778-205.50200889 205.37457777-113.49674667 0-205.50314667-91.94951111-205.50314667-205.37457777S613.97902222 62.57777778 727.47576889 62.57777778z m-388.75363556 0c50.60266667 0 91.62524445 40.99640889 91.62524445 91.56835555v227.61244445c0 50.57080889-41.02257778 91.56721778-91.62524445 91.56721777H110.96746667c-50.60266667 0-91.62524445-40.99640889-91.62524445-91.56835555V154.14613333c0-50.57080889 41.02257778-91.56835555 91.62524445-91.56835555h227.75466666z"  ></path></symbol><symbol id="icon-baoguandanguanli1" viewBox="0 0 1024 1024"><path d="M241.87025232 291.0654683h441.86906336v88.37381268h-441.86906336z m0 176.74762536h441.86906336v88.37381268h-441.86906336z"  ></path><path d="M109.3095333 70.13093663h706.9905014v559.70035332h88.37381267V70.13093663c0-48.60559698-39.7682157-88.37381268-88.37381267-88.37381268h-706.9905014c-48.60559698 0-88.37381268 39.7682157-88.37381268 88.37381268v883.73812674c0 48.60559698 39.7682157 88.37381268 88.37381268 88.37381268H433.34730672v-88.37381268H109.3095333V70.13093663z"  ></path><path d="M940.61299147 817.77339185l-95.73783679-95.73783677-62.745407 62.44990705 51.84504956 51.5523113H521.72111939v88.37381266h312.25367785L782.12974768 975.96251653l62.745407 62.45128792 158.1891247-158.18912468z"  ></path></symbol><symbol id="icon-xiangqing" viewBox="0 0 1024 1024"><path d="M512 952.32a440.32 440.32 0 1 0 0-880.64 440.32 440.32 0 0 0 0 880.64z m0 71.68C229.222 1024 0 794.778 0 512S229.222 0 512 0s512 229.222 512 512-229.222 512-512 512z m5.683-338.483a56.883 56.883 0 1 0 0 113.766 56.883 56.883 0 0 0 0-113.766z m0-455.117c-31.437 0-56.883 25.446-56.883 56.883V571.75a56.883 56.883 0 0 0 113.766 0V287.232c0-31.437-25.446-56.883-56.832-56.883z"  ></path></symbol><symbol id="icon-zhankai" viewBox="0 0 1024 1024"><path d="M516.096 84.65c236.773 0 428.715 191.943 428.715 428.715 0 236.773-191.942 428.715-428.715 428.715-236.773 0-428.715-191.942-428.715-428.715 0-236.772 191.942-428.714 428.715-428.714z m0 81.92c-191.53 0-346.795 155.266-346.795 346.795 0 191.53 155.266 346.795 346.795 346.795 191.53 0 346.795-155.265 346.795-346.795 0-191.53-155.266-346.794-346.795-346.794z m-153.7 260.783l0.678 0.708 153.628 164.467 152.332-164.07c15.168-16.338 40.559-17.509 57.16-2.807l0.726 0.659c16.338 15.168 17.508 40.559 2.807 57.16l-0.66 0.726-182.256 196.303c-15.95 17.18-42.972 17.455-59.276 0.795l-0.674-0.704L303.21 483.982c-15.442-16.532-14.559-42.451 1.972-57.893 16.292-15.218 41.702-14.581 57.215 1.264z"  ></path></symbol><symbol id="icon-shouqi" viewBox="0 0 1024 1024"><path d="M516.096 942.08c236.773 0 428.715-191.942 428.715-428.715 0-236.772-191.942-428.714-428.715-428.714-236.773 0-428.715 191.942-428.715 428.714 0 236.773 191.942 428.715 428.715 428.715z m0-81.92c-191.53 0-346.795-155.265-346.795-346.795 0-191.53 155.266-346.794 346.795-346.794 191.53 0 346.795 155.265 346.795 346.794 0 191.53-155.266 346.795-346.795 346.795z m-153.7-260.782l0.678-0.709 153.628-164.466 152.332 164.07c15.168 16.338 40.559 17.509 57.16 2.807l0.726-0.659c16.338-15.169 17.508-40.56 2.807-57.16l-0.66-0.726-182.256-196.303c-15.95-17.18-42.972-17.456-59.276-0.795l-0.674 0.704L303.21 542.749c-15.442 16.531-14.559 42.45 1.972 57.893 16.292 15.218 41.702 14.58 57.215-1.264z"  ></path></symbol><symbol id="icon-yonghu1" viewBox="0 0 1024 1024"><path d="M656.79 499.92A241.63 241.63 0 0 0 754 306c0-133.65-108.35-242-242-242S270 172.35 270 306a241.63 241.63 0 0 0 97.21 193.92C190.84 560.12 64 727.25 64 924a36 36 0 0 0 72 0c0-207.66 168.34-376 376-376s376 168.34 376 376a36 36 0 0 0 72 0c0-196.75-126.84-363.88-303.21-424.08zM342 306a170 170 0 1 1 170 170 170 170 0 0 1-170-170z" fill="#2C2C2C" ></path></symbol><symbol id="icon-ketixian" viewBox="0 0 1084 1024"><path d="M493.923159 105.409891c-183.71481 57.82494-337.91465 105.409891-341.529647 105.409891-4.215996 0-7.829992 3.011997-7.829992 6.023994 0 4.215996 136.129859 5.420994 405.377581 4.818995l404.775581-1.806999v-69.269928c-0.601999-60.836937-1.806998-72.280925-13.853986-93.362903-7.829992-13.251986-23.490976-30.719968-34.935964-38.54996-42.163956-29.514969-46.982951-28.309971-412.003573 86.73691zM99.388567 258.405733c-45.175953 11.443988-68.06493 30.719968-86.73791 74.689922C0.603669 361.406626 0.00067 372.851614 0.00067 641.497336c0 302.376687-0.601999 299.36469 34.333964 340.324648 9.034991 10.841989 27.105972 24.695974 40.959958 30.719968 22.888976 10.239989 50.596948 11.443988 468.623515 11.443988 486.693496 0 460.190524 1.806998 499.945482-35.537963 31.923967-28.91297 40.356958-54.210944 40.356959-117.457879v-57.22194l-166.849828-1.806999-167.450826-1.806998-32.526967-18.069981c-37.344961-20.479979-68.666929-59.029939-79.509917-98.182898-10.841989-37.947961-4.215996-100.591896 14.456985-136.731859 17.467982-35.538963 33.730965-51.199947 70.473927-70.474927 26.502973-13.250986 32.526966-13.852986 194.557798-15.659984l166.849828-1.807998v-57.22194c0-77.70292-18.070981-115.64988-69.269929-143.357852-24.093975-12.649987-26.503973-12.649987-460.793523-13.853986-240.335751-0.602999-444.52954 1.203999-454.769529 3.613997z" fill="#1AFA29" ></path><path d="M755.942887 562.589418c-33.730965 15.058984-63.245935 60.836937-63.245934 98.181898 0 50.596948 53.608945 100.591896 107.819888 100.591896 78.906918-0.602999 127.093868-83.123914 89.749907-152.393842-24.696974-46.379952-86.135911-67.46193-134.323861-46.379952z" fill="#1AFA29" ></path></symbol><symbol id="icon-wenhao" viewBox="0 0 1024 1024"><path d="M511.514 63.894c-114.532 0-229.062 43.51-316.72 131.168-174.677 174.676-174.677 458.764 0 633.44 87.658 87.659 202.188 131.168 316.72 131.168s229.063-43.51 316.72-131.168c174.677-174.676 174.677-458.764 0-633.44-87.657-87.659-202.189-131.168-316.72-131.168z m0 44.79c52.467 0 103.654 10.236 151.642 29.432 49.907 20.475 94.695 49.907 133.086 88.937 39.03 38.39 68.463 83.18 88.937 133.086 19.195 47.988 29.433 99.175 29.433 151.642s-10.238 103.654-29.433 151.642c-20.474 49.907-49.907 94.695-88.937 133.086-38.39 39.03-83.18 68.463-133.086 88.937-47.988 19.196-99.175 29.433-151.642 29.433s-103.654-10.237-151.642-29.433c-49.907-20.475-94.696-49.907-133.086-88.937-39.03-38.39-68.463-83.18-88.937-133.086-19.196-47.988-29.433-99.175-29.433-151.642s10.237-103.654 29.433-151.642c20.475-49.907 49.907-94.695 88.937-133.086 38.39-39.03 83.18-68.463 133.086-88.937 47.988-19.196 99.175-29.433 151.642-29.433z"  ></path><path d="M511.514 674.3c-18.556 0-34.551 15.356-34.551 34.551 0 18.556 15.996 33.912 34.55 33.912 19.196 0 34.552-15.356 34.552-33.912 0-19.194-15.356-34.55-34.551-34.55z m0.64-393.5c-42.23 0-76.14 10.877-101.734 33.91-25.593 22.395-41.589 55.027-46.707 97.896l58.225 7.039c4.479-31.992 15.356-55.666 31.352-70.382 15.996-15.356 35.83-22.394 59.505-22.394 24.953 0 46.068 8.317 63.344 24.953 16.636 15.996 24.953 35.191 24.953 57.585 0 11.518-2.56 23.035-8.317 33.272-5.758 10.237-18.556 23.674-37.751 40.95-19.835 17.275-33.272 30.073-40.95 39.03-9.597 12.157-17.275 24.314-21.754 36.47-6.399 15.997-9.598 35.192-9.598 56.946l0.64 17.276h53.746c0.64-22.394 1.92-39.03 4.479-48.628 3.199-10.237 7.038-19.195 12.796-26.873 5.758-7.678 17.276-19.834 35.831-35.83 26.873-24.315 45.429-44.79 55.027-61.426 8.958-16.636 14.076-35.191 14.076-55.026 0-34.55-13.437-63.984-40.31-88.298-26.233-24.314-62.064-36.47-106.852-36.47z"  ></path></symbol><symbol id="icon-Devices" viewBox="0 0 1024 1024"><path d="M185.984 633.392h240.288l-12.672 67.92h196.704l-12.672-67.92h240.288c30.048 0 54.384-25.248 54.384-56.496V88.544C892.304 57.344 867.968 32 837.92 32H185.984c-30 0-54.288 25.344-54.288 56.544v488.4c0 31.2 24.288 56.448 54.288 56.448zM170.72 69.008h679.92V578.72H170.72V69.008zM989.36 945.872c-7.152-32.928-106.8-148.512-137.616-196.128a12.72 12.72 0 0 0-10.656-5.952H182.912a12.768 12.768 0 0 0-10.656 5.952c-30.816 47.616-130.464 163.2-137.568 196.128-4.224 13.44-0.816 22.752 2.88 28.176 8.496 12.624 26.064 17.952 58.608 17.952h831.6c32.64 0 50.16-5.328 58.704-17.952 3.696-5.376 7.104-14.736 2.88-28.176z m-25.584 14.16c-0.48 0.72-3.696 5.184-36 5.184H96.176c-32.256 0-30.816-2.16-34.944-4.752-0.288-0.192-3.072-3.696-2.064-6.672a16.176 16.176 0 0 0 0.576-2.64c1.296-7.968 22.416-38.208 47.616-77.136h808.848c25.68 39.408 46.656 69.168 47.952 77.088 0.096 0.96 0.288 1.824 0.624 2.688 1.008 3.024-0.816 5.952-1.008 6.24z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Auditing" viewBox="0 0 1024 1024"><path d="M272 219.824h305.472a21.36 21.36 0 0 0 21.792-20.88 21.36 21.36 0 0 0-21.792-20.88H272a21.408 21.408 0 0 0-21.84 20.88c0 11.52 9.84 20.88 21.84 20.88m87.264 500.88h-196.32a21.456 21.456 0 0 0-21.888 20.976c0 11.472 9.792 20.784 21.888 20.784h196.32a21.264 21.264 0 0 0 21.84-20.784 21.36 21.36 0 0 0-21.84-20.976m0 104.304h-196.32c-12.048 0-21.888 9.36-21.888 20.928s9.792 20.832 21.888 20.832h196.32c12.096 0 21.84-9.264 21.84-20.832s-9.744-20.928-21.84-20.928M815.744 44.72A21.936 21.936 0 0 0 795.632 32H53.792A21.36 21.36 0 0 0 32 52.88v834.816C32 945.296 80.864 992 141.056 992h741.84C943.136 992 992 945.296 992 887.648V365.936a21.312 21.312 0 0 0-21.792-20.88h-152.784V52.88a19.248 19.248 0 0 0-1.68-8.16M141.056 950.288c-36.096 0-65.424-27.984-65.424-62.64V73.712h698.16v813.936c0 23.616 8.544 45.12 22.272 62.64H141.056z m807.312-563.52v500.88c0 34.656-29.28 62.64-65.424 62.64-36.192 0-65.472-27.984-65.472-62.64V386.768h130.896zM446.528 334.592c0 17.328 14.64 31.296 32.736 31.296A31.968 31.968 0 0 0 512 334.592c0-17.28-14.64-31.296-32.736-31.296-18.096 0-32.736 14.016-32.736 31.296M242.912 506.048l116.352-111.312 116.4 111.312a21.936 21.936 0 0 0 30.096 0 19.728 19.728 0 0 0 0-28.848l-7.296-6.96 35.328-33.792 72.816 69.6c8.256 7.968 21.792 7.968 30.096 0s8.304-20.88 0-28.848l-85.2-81.456c-0.72-1.008-1.104-2.112-2.112-3.024a21.888 21.888 0 0 0-15.6-5.904 21.984 21.984 0 0 0-15.552 5.952c-0.912 0.912-1.344 2.016-2.064 3.024l-47.808 45.648-91.392-87.456c-0.72-0.96-1.152-2.064-2.064-2.976a21.984 21.984 0 0 0-15.648-5.904 21.84 21.84 0 0 0-15.6 5.904c-0.864 0.912-1.344 2.016-2.064 2.976L212.768 477.2a19.824 19.824 0 0 0 0 28.848 21.984 21.984 0 0 0 30.144 0m443.664 110.304H490.208c-12.048 0-21.84 9.36-21.84 20.928s9.744 20.832 21.84 20.832h196.368c12.048 0 21.792-9.264 21.792-20.832s-9.744-20.928-21.792-20.928m0 208.656H490.208c-12.048 0-21.84 9.36-21.84 20.928s9.744 20.832 21.84 20.832h196.368c12.048 0 21.792-9.264 21.792-20.832s-9.744-20.928-21.792-20.928m0-104.304H490.208a21.408 21.408 0 0 0-21.84 20.976c0 11.472 9.744 20.784 21.84 20.784h196.368a21.264 21.264 0 0 0 21.792-20.784 21.36 21.36 0 0 0-21.792-20.976m-327.312-104.352h-196.32c-12.048 0-21.888 9.36-21.888 20.928s9.792 20.832 21.888 20.832h196.32c12.096 0 21.84-9.264 21.84-20.832s-9.744-20.928-21.84-20.928" fill="#FFFFFF" ></path></symbol><symbol id="icon-Settlement" viewBox="0 0 1024 1024"><path d="M512 32C246.944 32 32 246.944 32 512s214.944 480 480 480 480-214.944 480-480S777.056 32 512 32m0 900a420 420 0 1 1 0-840 420 420 0 0 1 0 840" fill="#ffffff" ></path><path d="M512 311.984c44.112 0 80.016 35.856 80.016 80.016h79.968a159.648 159.648 0 0 0-120-154.32v-45.696H472.016v45.648a159.648 159.648 0 0 0-120 154.32A159.984 159.984 0 0 0 512 551.936a80.064 80.064 0 0 1 0 160.08A80.064 80.064 0 0 1 431.984 632H352.016a159.6 159.6 0 0 0 120 154.32v45.696h80.016v-45.696a159.648 159.648 0 0 0 120-154.32 159.984 159.984 0 0 0-159.984-159.984A80.064 80.064 0 0 1 512 311.984" fill="#ffffff" ></path></symbol><symbol id="icon-Merchants" viewBox="0 0 1024 1024"><path d="M939.5 917H84.5a22.5 22.5 0 0 0 0 45h855a22.5 22.5 0 0 0 0-45zM152 377a45 45 0 0 0-45 45v405a45 45 0 0 0 45 45h45a45 45 0 0 0 45-45V422a45 45 0 0 0-45-45H152z m45 450H152V422h45v405zM377 377a45 45 0 0 0-45 45v405a45 45 0 0 0 45 45h45a45 45 0 0 0 45-45V422a45 45 0 0 0-45-45H377z m45 450H377V422h45v405zM602 377a45 45 0 0 0-45 45v405a45 45 0 0 0 45 45h45a45 45 0 0 0 45-45V422a45 45 0 0 0-45-45h-45z m45 450h-45V422h45v405zM827 377a45 45 0 0 0-45 45v405a45 45 0 0 0 45 45h45a44.955 44.955 0 0 0 44.955-45V422c0-24.885-20.07-45-44.955-45h-45z m45 450h-45V422h45v405zM107 332h809.955a45 45 0 0 0 18.315-86.13l-405-180a45.315 45.315 0 0 0-36.54 0l-405 180A45.09 45.09 0 0 0 107 332z m405-225l404.955 180H107l405-180z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Gnucash" viewBox="0 0 1024 1024"><path d="M783.549457 368.492716l-211.188067-211.188068 112.121665-112.121665s11.519349-13.157657 4.863725-29.131154C682.639959 0.027134 661.341962 0.027134 661.341962 0.027134H364.705922s-22.014756-1.331125-30.001505 14.642373 4.812528 30.513476 4.812528 30.513476l112.172863 112.121665-211.188068 211.188068a383.978305 383.978305 0 1 0 543.047717 0M408.018675 42.674325h208.013847L512 146.041285 408.018675 42.674325z m331.706059 829.956307a322.081002 322.081002 0 0 1-455.500665-455.500664L512 189.354037l227.724734 227.775931a322.029805 322.029805 0 0 1 0 455.500664" fill="#FFFFFF" ></path><path d="M512 425.628688c47.050142 0 85.345578 38.244239 85.345578 85.345578h42.64719a127.583192 127.583192 0 0 0-85.345578-120.159611v-50.531545H469.35281v50.480348A127.634389 127.634389 0 0 0 512 638.915837c47.050142 0 85.345578 38.244239 85.345578 85.345578s-38.295436 85.345578-85.345578 85.345578-85.345578-38.193042-85.345578-85.294381H384.007232c0 55.702453 35.684384 102.496609 85.345578 120.108414v50.480348h85.345578v-50.480348a127.480797 127.480797 0 0 0 85.345578-120.108414 127.992768 127.992768 0 0 0-127.992769-127.992768A85.345578 85.345578 0 1 1 512 425.628688" fill="#FFFFFF" ></path></symbol><symbol id="icon-Selfmanagement" viewBox="0 0 1024 1024"><path d="M512 736.955c149.085 0 270.045-151.11 270.045-337.455C782.045 213.11 661.085 62 512 62 362.87 62 242 213.11 242 399.5c0 186.345 120.87 337.455 270 337.455zM512 107c124.11 0 225.045 131.22 225.045 292.5S636.11 691.955 512 691.955c-124.065 0-225-131.175-225-292.455S387.935 107 512 107z" fill="#FFFFFF" ></path><path d="M708.56 697.85a326.79 326.79 0 0 1-38.34 31.905c42.795 19.935 80.415 36.54 112.545 50.445 119.16 52.02 134.145 62.28 134.145 91.755 0 20.43-20.07 45.045-44.91 45.045H152c-24.885 0-45-24.615-45-45.045 0-29.475 14.985-39.735 134.19-91.755 32.13-13.95 69.705-30.51 112.545-50.445a319.185 319.185 0 0 1-38.295-31.905C128.06 783.62 62 795.095 62 871.955 62 917 102.275 962 152 962h720.045C921.68 962 962 917 962 871.955c0-76.86-66.105-88.335-253.44-174.105z" fill="#FFFFFF" ></path></symbol><symbol id="icon-FlowId" viewBox="0 0 1024 1024"><path d="M870.4 153.6h-102.4a51.1488 51.1488 0 0 0-51.2-51.1488h-51.2V51.2c0-28.2624-22.9888-51.2-51.2-51.2H409.6a51.2 51.2 0 0 0-51.2 51.2v51.2512H307.2A51.2 51.2 0 0 0 256 153.6H153.6a51.2 51.2 0 0 0-51.2 51.2v768a51.2 51.2 0 0 0 51.2 51.2h716.8a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2zM307.2 153.6h102.4V51.2h204.8v102.4h102.4v51.2H307.2V153.6z m563.2 819.2H153.6V204.8h102.4c0 28.2624 22.9376 51.2512 51.2 51.2512h409.6A51.2 51.2 0 0 0 768 204.8h102.4v768z" fill="#FFFFFF" ></path><path d="M256 358.4h512v51.2H256zM256 512h512v51.2512H256z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Listaudit" viewBox="0 0 1024 1024"><path d="M587.0020775 377.0103725h-419.98341094a15.02340656 15.02340656 0 0 0 0 29.998815h419.98341094a15.02340656 15.02340656 0 1 0 0-29.998815zM601.97748594 527.0044475a14.97540844 14.97540844 0 0 0-15.02340657-15.02340656h-419.98341093a14.97540844 14.97540844 0 1 0 0.04799812 29.998815h419.98341094c8.25567375 0 14.97540844-6.71973469 14.97540844-14.97540844zM167.01866656 278.95024531h135.01866656a14.92741031 14.92741031 0 0 0 15.02340657-14.97540844 15.02340656 15.02340656 0 0 0-15.02340657-15.02340656H167.01866656a15.02340656 15.02340656 0 0 0-15.02340656 15.02340656c0 8.35167001 6.71973469 14.97540844 15.02340656 14.97540844z" fill="#FFFFFF" ></path><path d="M442.71977657 961.96326688H61.998815V62.04681313h412.9756875v201.92802374c0 8.35167001 6.76773281 14.97540844 15.02340656 14.97540844h202.02402v238.16659219c9.26363437-5.95176469 19.48723031-9.59962125 29.998815-10.991565V263.97483687a15.16740094 15.16740094 0 0 0-4.41582562-10.65557906L500.60548999 36.41582563a16.12736343 16.12736343 0 0 0-4.84780874-3.31186969A16.84733438 16.84733438 0 0 0 489.94991094 32H47.02340656A14.97540844 14.97540844 0 0 0 32 47.02340656v929.91526875c0 8.25567375 6.71973469 15.02340656 15.02340656 15.02340656h396.17635125a43.82226938 43.82226938 0 0 1-0.47998126-29.998815zM504.9733175 83.16597875l165.78545156 165.73745344H504.9733175V83.16597875z" fill="#FFFFFF" ></path><path d="M965.6111225 495.32569906c-34.07865375-34.03065563-93.30831469-34.03065563-127.29097219 0l-63.69348375 63.54948938-10.55958281-10.60758094a45.11821781 45.11821781 0 0 0-63.69348469 0l-84.81264937 84.81264937a15.07140469 15.07140469 0 0 0 0 21.26316094c5.85576844 5.85576844 15.35939344 5.85576844 21.16716375 0l84.90864562-84.86064843a14.87941219 14.87941219 0 0 1 21.16716375 0l10.65558 10.60758093-254.58194437 254.53394624a89.32447125 89.32447125 0 0 0-9.55162313 115.67543064l-16.03136625 16.03136719a14.92741031 14.92741031 0 0 0 0 21.16716375 14.97540844 14.97540844 0 0 0 21.26316 0.04799812l16.03136625-16.03136719a88.79649281 88.79649281 0 0 0 51.98194688 16.75133813c24.04705031 0 46.65415687-9.3116325 63.59748843-26.30296031l339.44259188-339.44259282c16.99132875-16.99132875 26.35095938-39.55043812 26.35095937-63.5974875s-9.35963062-46.65415687-26.35095937-63.5974875z m-148.50613406 63.5974875l84.8606475 84.81265031-21.21516188 21.26316-84.8606475-84.86064843 21.21516188-21.21516188z m42.43032375 127.24297407l-233.36678157 233.31878343-84.86064843-84.86064749 233.27078625-233.31878438 84.95664375 84.86064844z m-339.39459375 254.62994156a59.70964125 59.70964125 0 0 1-17.56730625-42.47832188c0-15.98336906 6.23975344-31.10277188 17.56730625-42.47832187l84.86064843 84.95664375c-22.70310281 22.55910938-62.20554281 22.55910938-84.86064843 0z m424.25524218-339.49059l-21.21516187 21.16716375-84.86064844-84.81264938 21.11916563-21.16716375a59.99763001 59.99763001 0 1 1 84.95664468 84.81264938zM377.0103725 796.9937825c-26.54295187 0-41.99834062-46.75015312-45.26221219-63.02151a14.97540844 14.97540844 0 0 0-26.3989575-6.43174594l-43.8702675 54.8618325c-12.91148999-33.64667062-34.41464063-95.90021156-34.41464062-135.45064969a15.02340656 15.02340656 0 1 0-30.04681313 0c0 56.15778187-43.29428999 158.05775625-43.77427031 159.06571688a15.02340656 15.02340656 0 0 0 27.55091156 11.80753406c1.15195406-2.73589219 18.19128187-42.67031438 31.1987672-87.5485425 13.00748625 44.92622531 30.04681312 84.86064844 31.19876812 87.5485425a15.02340656 15.02340656 0 0 0 25.48699312 3.50386125l42.3343275-52.98990656c10.17559781 25.438995 30.28680375 58.65368345 65.94939563 58.6536825H391.98578094a15.02340656 15.02340656 0 0 0 15.02340656-15.02340656 14.92741031 14.92741031 0 0 0-15.02340656-14.97540844h-14.97540844z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Merchantslist" viewBox="0 0 1024 1024"><path d="M407.648 512v159.168c0 12.48 9.36 22.752 20.88 22.752h166.992c11.52 0 20.88-10.272 20.88-22.752V512c0-12.576-9.312-22.752-20.88-22.752H428.528c-11.52 0-20.88 10.176-20.88 22.752m41.76 22.752h125.232v113.664H449.408v-113.664zM908.528 80H198.944a20.064 20.064 0 0 0-16.176 8.976L40.208 244.256a21.84 21.84 0 0 0-5.616 7.296c-0.096 0.144-0.288 0.288-0.336 0.48A24.048 24.048 0 0 0 32 261.872v68.256c0 42.288 26.64 77.568 62.592 87.696v435.216c0 50.256 37.392 90.96 83.472 90.96H908.48c46.176 0 83.52-40.704 83.52-91.008V170.96C992 120.752 954.656 80 908.528 80m-258.384 45.504l-104.352 113.664H478.208l104.352-113.664h67.584z m-117.264 159.12v45.504c0 25.056-18.72 45.456-41.712 45.456-23.04 0-41.76-20.4-41.76-45.456v-45.504h83.472z m-7.968-159.12L420.56 239.168H353.024l104.352-113.664h67.536zM407.648 284.624v45.504c0 25.056-18.72 45.456-41.76 45.456s-41.76-20.4-41.76-45.456v-45.504h83.52z m-7.92-159.12L295.376 239.168H227.792l104.352-113.664h67.584zM282.416 284.624v45.504c0 25.056-18.72 45.456-41.76 45.456-22.992 0-41.76-20.4-41.76-45.456v-45.504h83.52zM206.912 125.504h67.584L170.144 239.168H102.56l104.352-113.664z m-91.44 250.08c-23.04 0-41.76-20.4-41.76-45.456v-45.504h83.472v45.504c0.048 25.056-18.672 45.456-41.712 45.456m208.704 522.96H240.704V693.92h83.472v204.624z m354.816-45.552c0 25.152-18.72 45.504-41.76 45.504H365.936v-227.328c0-12.624-9.36-22.8-20.88-22.8H219.824c-11.52 0-20.88 10.176-20.88 22.8v227.328h-20.88c-23.04 0-41.76-20.352-41.76-45.504V417.824c16.512-4.656 30.864-14.784 41.76-28.176 15.264 19.056 37.536 31.392 62.64 31.392s47.328-12.288 62.64-31.344c15.264 19.056 37.536 31.344 62.592 31.344s47.328-12.288 62.592-31.344c15.264 19.056 37.536 31.344 62.64 31.344 46.08 0 83.472-40.704 83.472-90.912V270.56l104.352-113.712v696.144z m271.296 0c0 25.152-18.768 45.504-41.76 45.504h-199.392c7.152-13.392 11.568-28.848 11.568-45.504V125.504h187.824c22.992 0 41.76 20.352 41.76 45.456v682.032z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Advertisement" viewBox="0 0 1024 1024"><path d="M449.456 637.04a20.544 20.544 0 0 0 13.008-4.896l166.176-103.872a20.448 20.448 0 0 0 8.448-16.368 20.688 20.688 0 0 0-13.92-19.44L461.216 390.992a20.736 20.736 0 0 0-11.76-3.984 20.784 20.784 0 0 0-20.832 20.784v208.512c0 11.472 9.36 20.736 20.832 20.736M908 136.832H116c-46.032 0-83.376 37.344-83.376 83.376V803.84c0 46.032 37.344 83.328 83.376 83.328h792c46.032 0 83.376-37.296 83.376-83.328V220.208c0-46.032-37.344-83.376-83.376-83.376m-375.168 41.712h187.584v83.328h-187.584V178.544z m-229.296 0h187.632v83.328H303.536V178.544z m-229.248 41.664c0-22.992 18.672-41.664 41.664-41.664h145.92v83.328H74.288v-41.664zM261.92 845.456H116a41.664 41.664 0 0 1-41.664-41.616v-41.712H261.92v83.328z m229.248 0H303.536v-83.328h187.632v83.328z m229.248 0h-187.584v-83.328h187.584v83.328z m229.248-41.616a41.664 41.664 0 0 1-41.664 41.616h-145.872v-83.328h187.536v41.712z m0-83.424H74.288V303.584h875.376v416.832z m0-458.544h-187.536V178.544h145.872c22.992 0 41.664 18.672 41.664 41.664v41.664z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Transaction" viewBox="0 0 1024 1024"><path d="M969.39127063 32.09791531c-0.47997469 0-0.91195219 0.23998781-1.29593251 0.287985L967.99934281 32.00192l-4.79975062 1.2959325c-1.0079475 0.287985-2.20788562 0.38398031-3.167835 0.863955l-157.76779594 42.81377344 0.0959953 0.38398031c-35.66214563 12.19136625-61.53280031 45.21364875-61.5328003 84.42760969v560.94683062h-205.66930594c-63.11671781 0-114.33005437 50.20538906-114.33005437 112.17016782v44.92566375c0 61.96477781 51.16533938 112.17016688 114.33005437 112.17016687h137.12886938c63.11671781 0 114.28205719-50.20538906 114.28205812-112.17016687V161.78717094c0-19.34299406 12.47935125-35.66214563 29.95044188-41.99781563l0.7199625-0.91195312v0.1439925L976.54289844 75.67964844V75.53565594A22.22284406 22.22284406 0 0 0 992.23808281 54.51274906a22.60682437 22.60682437 0 0 0-22.84681218-22.41483375m-228.56411438 847.68391969c0 37.15006781-30.67040531 67.29250125-68.54043656 67.29250125h-137.12886938c-37.87003031 0-68.58843375-30.1424325-68.58843281-67.29250125v-44.92566375c0-37.15006781 30.7184025-67.29250125 68.58843281-67.29250031h205.66930594v112.21816406zM55.13481219 632.97866937h525.7166625c12.62334375 0 22.89480938-10.03147875 22.89480937-22.46283187s-10.27146562-22.41483469-22.89480937-22.41483469H55.13481219c-12.57534563 0-22.84681219 9.98348063-22.84681219 22.41483469s10.27146562 22.46283187 22.84681219 22.46283187m0-358.97333343h525.7166625a22.70281969 22.70281969 0 0 0 22.89480937-22.46283188 22.65482156 22.65482156 0 0 0-22.89480937-22.41483468H55.13481219A22.65482156 22.65482156 0 0 0 32.288 251.54250406c0 12.38335594 10.27146562 22.46283187 22.84681219 22.46283188m0 179.46266812h525.7166625a22.65482156 22.65482156 0 0 0 22.89480937-22.41483468 22.70281969 22.70281969 0 0 0-22.89480937-22.46283188H55.13481219A22.65482156 22.65482156 0 0 0 32.288 431.05316937c0 12.38335594 10.27146562 22.41483469 22.84681219 22.41483469m0 359.02133063h205.71730218c12.67134094 0 22.89480938-10.03147875 22.89480938-22.46283188s-10.22346844-22.46283187-22.89480937-22.46283187H55.13481219c-12.57534563 0-22.84681219 10.03147875-22.84681219 22.46283187s10.27146562 22.46283187 22.84681219 22.46283188" fill="#FFFFFF" ></path></symbol><symbol id="icon-Salesman" viewBox="0 0 1024 1024"><path d="M416 722.672c123.744 0 224.016-125.328 224.016-279.984S539.744 162.656 416 162.656 191.984 288.032 191.984 442.688c0 154.608 100.272 279.984 224.016 279.984zM416 210.656c97.056 0 176.016 104.064 176.016 232.032 0 127.92-78.96 231.984-176.016 231.984s-176.016-104.064-176.016-231.984S318.944 210.656 416 210.656z" fill="#FFFFFF" ></path><path d="M653.456 152c80.352 0 145.68 87.072 145.68 194.064 0 96.624-53.328 176.256-122.784 191.04-4.416 17.472-10.08 34.176-16.704 50.304 104.016-4.224 187.44-110.256 187.44-241.344 0-133.68-86.736-242.064-193.68-242.064-42.672 0-81.696 17.76-113.712 46.992 13.68 8.448 26.688 18.384 38.928 29.472 22.032-17.664 47.376-28.464 74.832-28.464zM877.856 579.392c-15.552-7.2-34.128-15.84-55.584-26.064a255.696 255.696 0 0 1-36.96 35.568C919.424 653.216 944 657.008 944 685.04c0 32.304-32.304 32.304-64.56 32.304h-104.928c22.992 13.872 41.136 29.184 53.664 48h51.216c27.84 0 112.56 0 112.56-80.304 0.048-52.656-35.712-69.264-114.096-105.648zM672.368 719.312c-20.16-9.36-44.688-20.832-73.488-34.608-11.808 13.008-24.48 24.72-37.968 35.04C722.576 797.696 752 801.632 752 834.656c0 37.344-37.296 37.344-74.688 37.344H154.64c-37.344 0-74.64 0-74.64-37.344 0-33.024 29.472-36.96 191.136-114.864a290.112 290.112 0 0 1-38.016-35.04c-28.8 13.776-53.328 25.2-73.536 34.608C69.344 761.168 32 778.544 32 834.656 32 920 121.088 920 154.688 920h522.672c33.552 0 122.688 0 122.688-85.344-0.048-56.112-37.392-73.488-127.68-115.344z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Companywidget" viewBox="0 0 1024 1024"><path d="M968 944H56a24 24 0 0 0 0 48h912a24 24 0 0 0 0-48zM512 272v624h432V272h-432z m192 576h-144v-144h144v144z m0-192h-144v-144h144v144z m0-192h-144V320h144v144z m192 384h-144v-144h144v144z m0-192h-144v-144h144v144z m0-192h-144V320h144v144zM464 896V32H80v864h384z m-288-48H128V80h48v768z m144 0H224v-144h96v144z m0-192H224V80h96v576zM368 80h48v768H368V80z" fill="#FFFFFF" ></path></symbol><symbol id="icon-AuditSettings" viewBox="0 0 1024 1024"><path d="M973.43952031 378.10117906l-431.98509656-335.98840781a47.95034531 47.95034531 0 0 0-58.94196656 0l-431.98509657 335.98840781c-16.17544219 12.62356406-22.55922187 34.07882438-15.93544968 53.51815406S59.50305125 464.01821562 79.99834437 464.01821562h47.99834344v527.98178438h287.99006438v-383.98675219h191.99337656v383.98675219h287.99006437V464.01821562h47.99834438a47.99834438 47.99834438 0 0 0 29.47098281-85.91703656zM847.97184875 416.01987125v527.98178437h-191.99337562v-335.98840781a47.99834438 47.99834438 0 0 0-47.99834438-47.99834437H415.98675219a47.99834438 47.99834438 0 0 0-47.99834344 47.99834437v335.98840781H175.99503219V416.01987125H79.99834437l431.98509657-335.98840875 431.98509656 335.98840875h-95.99668875z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Merchantsbank" viewBox="0 0 1024 1024"><path d="M512 320c84.624 0 153.168-64.464 153.168-144S596.624 32 512 32C427.424 32 358.832 96.464 358.832 176S427.424 320 512 320z m0-240c56.256 0 102.096 43.056 102.096 96S568.256 272 512 272c-56.256 0-102.096-43.056-102.096-96S455.744 80 512 80zM614.144 368H409.904c-24.672 0-45.84 16.56-50.304 39.408l-51.024 264a46.08 46.08 0 0 0 11.04 39.312c9.696 10.992 24.096 17.28 39.216 17.28h32.64l18.624 219.792c2.064 24.96 24.24 44.208 50.88 44.208h102.048c26.688 0 48.816-19.248 50.928-44.208l18.672-219.792h32.592c15.12 0 29.52-6.336 39.216-17.28a46.08 46.08 0 0 0 10.992-39.312l-51.072-264C659.984 384.56 638.864 368 614.144 368z m-28.752 311.952l-22.368 264H460.976l-22.368-264H358.832L409.904 416h76.608v144c0 13.296 11.424 24 25.536 24s25.536-10.752 25.536-24V416h76.56l51.024 263.952h-79.776zM828.656 310.4c67.68 0 122.592-51.6 122.592-115.2C951.2 131.6 896.336 80 828.656 80c-67.728 0-122.592 51.552-122.592 115.152 0 63.696 54.864 115.248 122.592 115.248z m0-192c45.024 0 81.696 34.464 81.696 76.8 0 42.336-36.672 76.8-81.696 76.8-45.072 0-81.744-34.464-81.744-76.8 0-42.336 36.624-76.8 81.744-76.8zM950.528 380.288c-3.504-18.24-20.448-31.488-40.176-31.488h-163.44a40.08 40.08 0 0 0-39.264 29.184c3.072 6.672 5.568 13.488 7.008 20.832l15.024 77.616 17.232-89.28h61.296v115.2c0 10.56 9.072 19.152 20.448 19.152 11.232 0 20.4-8.592 20.4-19.152v-115.2h61.296l40.896 211.2H887.36l-17.904 211.2h-81.696l-20.4-105.648L736.688 752l10.368 60.624c1.68 20.016 19.392 35.328 40.704 35.328h81.696c21.36 0 39.024-15.312 40.752-35.328l14.88-175.824h26.208c12.096 0 23.52-5.04 31.296-13.776a36.72 36.72 0 0 0 8.784-31.44l-40.848-211.296zM195.392 310.4c67.68 0 122.544-51.6 122.544-115.2C317.984 131.6 263.072 80 195.392 80S72.848 131.6 72.848 195.2c0 63.648 54.864 115.2 122.544 115.2z m0-192c45.024 0 81.744 34.464 81.744 76.8 0 42.336-36.672 76.8-81.744 76.8s-81.696-34.464-81.696-76.8c0-42.336 36.672-76.8 81.696-76.8zM195.392 521.552c11.28 0 20.448-8.592 20.448-19.152V387.2h61.296l17.232 89.28 15.072-77.616c1.392-7.344 3.936-14.16 7.008-20.832a40.272 40.272 0 0 0-39.312-29.232H113.696c-19.728 0-36.672 13.248-40.176 31.488l-40.848 211.248a36.576 36.576 0 0 0 8.832 31.44 41.904 41.904 0 0 0 31.344 13.824h26.112l14.88 175.824c1.728 20.016 19.44 35.328 40.752 35.328h81.696c21.312 0 39.024-15.312 40.704-35.328L287.312 752l-30.672-48.048-20.4 105.648H154.544l-17.856-211.2H72.848l40.848-211.2h61.296v115.2c0 10.56 9.12 19.152 20.4 19.152z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Finance" viewBox="0 0 1024 1024"><path d="M512 32C246.944 32 32 246.944 32 512s214.944 480 480 480 480-214.944 480-480S777.056 32 512 32m0 900a420 420 0 1 1 0.048-840.048A420 420 0 0 1 512 932" fill="#FFFFFF" ></path><path d="M656 224l-144 207.984L368 224H272l192 288H368v48h96v48H368v48h96v192h96v-192h96v-48h-96v-48h96v-48h-96l192-288z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Audits" viewBox="0 0 1024 1024"><path d="M892.544 131.408C830 68.864 746.912 34.448 658.448 34.448s-171.552 34.416-234.144 96.96A329.04 329.04 0 0 0 327.296 365.6c0 88.416 34.464 171.552 97.008 234.096 62.592 62.544 145.68 96.96 234.144 96.96s171.552-34.416 234.096-96.96a328.704 328.704 0 0 0 97.008-234.096 329.04 329.04 0 0 0-97.008-234.192z m-30.624 437.616c-54.384 54.336-126.624 84.24-203.472 84.24s-149.136-29.904-203.472-84.24A285.84 285.84 0 0 1 370.688 365.6c0-76.896 29.952-149.136 84.288-203.472C509.312 107.744 581.6 77.84 658.448 77.84s149.088 29.904 203.472 84.288a285.936 285.936 0 0 1 84.288 203.472 285.84 285.84 0 0 1-84.288 203.424z" fill="#FFFFFF" ></path><path d="M845.312 178.688a262.56 262.56 0 0 0-186.912-77.376 262.704 262.704 0 0 0-186.96 77.376A262.944 262.944 0 0 0 394.112 365.6c0 70.608 27.504 136.944 77.376 186.912a262.8 262.8 0 0 0 186.96 77.376 262.752 262.752 0 0 0 186.912-77.376 262.656 262.656 0 0 0 77.376-186.912 262.608 262.608 0 0 0-77.424-186.912z m-15.312 358.416a241.056 241.056 0 0 1-171.552 71.04 240.816 240.816 0 0 1-171.552-71.04A240.672 240.672 0 0 1 415.76 365.6c0-64.848 25.248-125.76 71.088-171.6a241.104 241.104 0 0 1 171.552-71.04c64.8 0 125.712 25.248 171.552 71.04a241.104 241.104 0 0 1 71.04 171.6 240.528 240.528 0 0 1-70.992 171.504z" fill="#FFFFFF" ></path><path d="M526.448 209.792a21.6 21.6 0 1 0 30.672 30.672 151.68 151.68 0 0 1 214.224 0 21.6 21.6 0 0 0 30.624 0 21.6 21.6 0 0 0 0-30.672 195.072 195.072 0 0 0-275.52 0zM291.728 618.08L58.112 851.696c-15.264 15.216-23.664 35.52-23.664 57.072s8.4 41.856 23.664 57.072c15.216 15.216 35.52 23.616 57.072 23.616s41.808-8.4 57.072-23.616l233.616-233.616a80.928 80.928 0 0 0 0-114.192c-30.528-30.432-83.664-30.432-114.144 0.048z m83.472 83.52l-233.568 233.616a38.352 38.352 0 0 1-52.896 0 37.248 37.248 0 0 1 0-52.896l233.568-233.616A37.392 37.392 0 0 1 375.2 701.6z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Sword" viewBox="0 0 1024 1024"><path d="M624.512 204.992c0-62.016-50.496-112.512-112.512-112.512S399.536 142.976 399.536 204.992c0 62.016 50.448 112.512 112.464 112.512s112.512-50.496 112.512-112.512z m-195.024 0A82.56 82.56 0 0 1 512 122.48c45.504 0 82.512 37.008 82.512 82.512a82.56 82.56 0 0 1-165.024 0z" fill="#FFFFFF" ></path><path d="M513.584 254.144l0.72-7.488a35.52 35.52 0 0 0 12.288-3.024 28.8 28.8 0 0 0 9.168-6.288 25.92 25.92 0 0 0 5.616-8.88 30.24 30.24 0 0 0 1.968-10.704c0-2.544-0.384-4.8-1.008-6.768a19.104 19.104 0 0 0-2.64-5.232 19.584 19.584 0 0 0-4.032-3.936 37.728 37.728 0 0 0-10.56-5.28 198.672 198.672 0 0 0-5.712-1.824l2.016-21.264c1.248 0.336 2.448 0.816 3.552 1.248 1.056 0.48 2.064 0.96 3.072 1.344 1.008 0.384 1.824 0.768 2.64 1.008a6.192 6.192 0 0 0 2.16 0.432c0.96 0 1.776-0.192 2.496-0.72a6.816 6.816 0 0 0 2.016-2.16l4.56-6.72a42.672 42.672 0 0 0-7.92-5.712 35.52 35.52 0 0 0-11.088-3.936l1.152-11.76h-6.912a4.368 4.368 0 0 0-3.36 1.344 4.944 4.944 0 0 0-1.536 3.12l-0.672 6.72a30.816 30.816 0 0 0-12.384 2.352 33.984 33.984 0 0 0-8.928 6.048 23.856 23.856 0 0 0-7.536 17.376c0 4.272 0.768 7.872 2.112 10.752a20.736 20.736 0 0 0 5.616 7.008 26.304 26.304 0 0 0 7.68 4.416c2.832 1.056 5.712 2.064 8.544 2.832l-2.256 22.656a18.864 18.864 0 0 1-4.8-1.824 36.576 36.576 0 0 1-3.84-2.208 47.712 47.712 0 0 0-3.264-1.776 6.288 6.288 0 0 0-2.976-0.72 4.416 4.416 0 0 0-2.544 0.672 5.76 5.76 0 0 0-2.016 1.728l-5.76 8.304c2.88 2.736 6.432 4.992 10.656 6.864 4.128 1.968 8.544 3.216 13.152 4.032l-1.248 12.288h6.912a4.32 4.32 0 0 0 3.36-1.392 4.752 4.752 0 0 0 1.536-2.928z m4.08-42.432c2.4 0.864 4.368 2.064 5.808 3.36a6.912 6.912 0 0 1 2.16 5.424c0 6.192-3.312 9.84-9.888 10.992l1.92-19.776z m-9.216-20.592a15.936 15.936 0 0 1-5.904-3.696 7.392 7.392 0 0 1-2.304-5.664 9.12 9.12 0 0 1 0.576-3.024 8.16 8.16 0 0 1 1.728-2.592 9.36 9.36 0 0 1 3.024-1.92 18.336 18.336 0 0 1 4.608-1.2l-1.728 18.096z" fill="#FFFFFF" ></path><path d="M357.392 580.928c-26.64-42.48-37.392-94.32-41.424-121.68 37.2 7.008 120.144 28.368 159.408 84.384 17.808 25.344 24 55.632 19.68 89.808 11.184 7.344 21.936 15.6 31.92 24.864v-73.536c7.296 0.96 14.688 2.256 21.648 2.256h0.048c115.488 0 154.032-131.04 158.256-200.352a14.64 14.64 0 0 0-4.608-11.76 14.832 14.832 0 0 0-11.952-4.08c-4.656 0.528-110.256 12.912-163.44 77.76V375.44c88.032-7.728 157.536-81.024 157.536-170.928C684.512 109.376 607.088 32 512 32S339.536 109.376 339.536 204.512c0 89.952 69.504 163.2 157.488 170.928v147.216C436.496 441.776 306.032 427.04 300.416 426.512a14.832 14.832 0 0 0-16.512 15.792 356.16 356.16 0 0 0 35.616 132.816c12.048 1.344 24.816 3.312 37.872 5.808z m187.44-107.52c31.584-45.024 97.536-63.216 129.936-69.648-6.96 44.784-33.408 153.216-126.096 153.216a140.16 140.16 0 0 1-19.2-1.392c-5.904-31.68-0.672-59.28 15.36-82.176zM369.488 204.512A142.704 142.704 0 0 1 512 62a142.704 142.704 0 0 1 142.512 142.512A142.608 142.608 0 0 1 512 346.928a142.608 142.608 0 0 1-142.512-142.416z" fill="#FFFFFF" ></path><path d="M986.432 706.592a60.192 60.192 0 0 0-79.776-28.992l-170.688 79.536c0.144-1.776 1.008-3.312 1.008-5.136 0-33.072-26.928-60-60-60h-158.208c-80.784-87.792-228.096-91.872-276.768-90.672v-14.352a15.024 15.024 0 0 0-15.024-15.024H46.976a15.072 15.072 0 0 0-14.976 15.072v345.024c0 8.304 6.72 15.024 14.976 15.024h180.048c8.256 0 15.024-6.72 15.024-15.024v-24.576l266.544 83.808c1.392 0.48 2.88 0.72 4.416 0.72a15.84 15.84 0 0 0 6.336-1.44l438-204.192c29.904-13.92 43.008-49.728 29.088-79.776zM212 917.024H62v-314.976H212v314.976z m732.72-157.872l-432.768 201.792-269.952-85.008v-244.56c44.496-1.008 187.776 2.688 258.576 85.296 2.88 3.312 7.056 5.232 11.376 5.232h165.024a29.76 29.76 0 1 1 13.728 56.256l-3.696 1.728a31.104 31.104 0 0 1-10.032 2.016H422a15.024 15.024 0 0 0 0 30.048h255.024c1.584 0 2.976-0.816 4.512-0.912a14.976 14.976 0 0 0 10.944-0.576l6.336-2.976a34.896 34.896 0 0 0 3.6-1.68l216.96-101.088a30.048 30.048 0 1 1 25.344 54.432z" fill="#FFFFFF" ></path></symbol><symbol id="icon-Agents" viewBox="0 0 1024 1024"><path d="M987.536 450.848l-339.36-339.312a14.784 14.784 0 0 0-21.12 0l-82.32 82.176a14.736 14.736 0 0 0 0 21.216l42.048 42.048-149.664 0.096 42.192-42.144a15.168 15.168 0 0 0 0-21.216L397.04 111.488a14.736 14.736 0 0 0-21.072 0L36.416 450.848a14.88 14.88 0 0 0 0 21.216l82.224 82.224a15.072 15.072 0 0 0 21.312 0l21.264-21.264 53.904 53.952-14.448 14.448a63.792 63.792 0 0 0 0 90.144c12.432 12.384 28.8 18.576 45.168 18.576 2.16 0 4.224-1.008 6.48-1.248-0.288 2.208-1.296 4.08-1.296 6.336-0.096 17.136 6.576 33.216 18.528 45.168 12.144 12.144 28.08 18.768 45.216 18.768h0.096c2.208 0 4.224-1.056 6.432-1.296-0.24 2.256-1.296 4.368-1.296 6.672a63.552 63.552 0 0 0 63.648 63.552h0.096c2.256 0 4.272-1.008 6.336-1.2-1.776 18.432 3.36 37.44 17.424 51.6a64.032 64.032 0 0 0 90.144 0l14.4-14.448 14.4 14.448c12.432 12.384 28.752 18.528 45.024 18.528s32.736-6.144 45.12-18.672c12.048-11.76 18.576-27.744 18.672-44.784 0-1.872-0.096-3.744-0.192-5.616 18.288 1.536 36.72-4.656 50.448-18.48 12-12.048 18.72-28.08 18.576-45.12l-0.144-5.424c18.192 1.536 36.72-4.56 50.496-18.336 13.872-13.824 19.968-32.496 18.528-50.544 1.728 0.144 3.312 0.048 5.376 0.192 17.04 0 33.072-6.624 45.168-18.576a64.128 64.128 0 0 0 0-90.144l-14.448-14.448 53.904-53.856 21.168 21.168a14.976 14.976 0 0 0 21.264 0l82.176-82.224a14.976 14.976 0 0 0-0.048-21.312zM129.248 522.512L68.192 461.408l318.384-318.144 60.96 61.056-318.288 318.192z m92.64 147.792a33.84 33.84 0 0 1 0-47.76l24.96-24.912 0.096-0.048v-0.048l27.456-27.504a34.656 34.656 0 0 1 47.616 0.048 33.936 33.936 0 0 1 0 47.76v0.096l-52.176 52.416a34.272 34.272 0 0 1-47.952-0.048z m92.976 78.768a33.888 33.888 0 0 1-33.84-33.84 33.12 33.12 0 0 1 9.888-23.616l73.632-73.824c6.288-6.336 14.784-9.744 23.808-9.744s17.472 3.408 23.856 9.696a33.936 33.936 0 0 1 0 47.856l-73.584 73.68a33.6 33.6 0 0 1-23.76 9.792z m68.832 68.976a33.216 33.216 0 0 1-23.952-10.032 33.552 33.552 0 0 1 0.096-47.52l52.368-52.416 0.144-0.096a33.024 33.024 0 0 1 23.76-9.792c9.12 0 17.52 3.36 23.664 9.792a33.12 33.12 0 0 1 9.936 23.904 33.072 33.072 0 0 1-9.648 23.76L407.36 808.256a33.264 33.264 0 0 1-23.664 9.792z m92.784 59.04a34.08 34.08 0 0 1-47.904-0.048 33.84 33.84 0 0 1 0-47.616l34.128-33.984a32.976 32.976 0 0 1 23.76-9.84 34.56 34.56 0 0 1 23.856 9.84 34.08 34.08 0 0 1 0 47.664l-33.84 33.984z m325.776-206.736a33.984 33.984 0 0 1-23.952 9.744h-0.048a33.408 33.408 0 0 1-23.664-9.696 14.784 14.784 0 0 0-21.12-0.096 14.736 14.736 0 0 0-0.096 21.264 33.648 33.648 0 0 1-0.096 47.616 34.08 34.08 0 0 1-47.952 0.144 14.976 14.976 0 0 0-21.12 0.048 15.264 15.264 0 0 0 0.048 21.264 32.832 32.832 0 0 1 9.84 23.712 33.744 33.744 0 0 1-57.456 23.952 14.928 14.928 0 0 0-25.536 10.656c0 3.792 1.44 7.68 4.368 10.608a33.072 33.072 0 0 1 9.84 23.856 32.256 32.256 0 0 1-9.84 23.568 33.792 33.792 0 0 1-47.712 0.144l-14.88-14.736a63.456 63.456 0 0 0-1.344-88.128 62.784 62.784 0 0 0-37.008-17.04c3.36-7.872 5.376-16.464 5.376-25.248 0-17.136-6.768-33.168-18.72-45.216a63.168 63.168 0 0 0-36.528-16.896c11.904-23.808 8.64-53.28-11.232-73.2-19.104-19.008-49.296-22.272-73.056-10.944a61.296 61.296 0 0 0-17.04-36.624c-24-24.096-66.096-24.096-89.952-0.144l-17.184 16.8-53.856-53.952 224.88-224.736h107.856L414.56 387.488a64.08 64.08 0 0 0 0.096 90.24c12.384 12.384 28.704 18.528 45.072 18.528a63.84 63.84 0 0 0 45.504-18.96l76.992-77.04c19.776 7.488 44.448 3.936 57.984 1.008 8.736 12 12.096 27.648 0.768 38.928a15.168 15.168 0 0 0 0 21.264l161.28 161.088a34.08 34.08 0 0 1 0 47.808z m-14.496-104.592l-117.264-117.264c12.288-22.848 7.872-52.272-14.304-74.592a15.168 15.168 0 0 0-14.976-3.744c-12.288 3.648-41.184 8.448-53.04-0.288a14.88 14.88 0 0 0-19.44 1.44L483.488 456.512l-0.192 0.288a34.08 34.08 0 0 1-47.52-0.288 33.936 33.936 0 0 1 0-47.76l121.632-121.728h59.328l225.024 224.928-54 53.808z m106.992-43.248L735.68 363.392l-137.904-137.856h-0.144l-21.12-21.216 61.056-61.056 318.144 318.144-60.96 61.104z" fill="#FFFFFF" ></path></symbol><symbol id="icon-CompanyType" viewBox="0 0 1024 1024"><path d="M378.4192 578.816h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.288 9.984 22.272 22.272 22.272h22.272c12.288 0 22.272-9.9328 22.272-22.272v-22.272a22.3232 22.3232 0 0 0-22.3232-22.272m200.3968 333.8752h22.272c12.288 0 22.272-9.9328 22.272-22.272v-22.3232a22.272 22.272 0 0 0-22.272-22.272h-22.272a22.272 22.272 0 0 0-22.272 22.272v22.3232c0 12.3392 9.9328 22.272 22.272 22.272m-311.7056-467.456h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.2368 9.9328 22.2208 22.272 22.2208h22.272c12.288 0 22.272-9.984 22.272-22.272V467.456a22.3232 22.3232 0 0 0-22.3232-22.2208m111.3088 400.64h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.3232c0 12.288 9.984 22.272 22.272 22.272h22.272c12.288 0 22.272-9.9328 22.272-22.272v-22.3232a22.3744 22.3744 0 0 0-22.3232-22.272m0-133.5296h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.288 9.984 22.3232 22.272 22.3232h22.272c12.288 0 22.272-9.984 22.272-22.3232v-22.272a22.3744 22.3744 0 0 0-22.3232-22.272m200.3968 66.816h22.272c12.288 0 22.272-9.984 22.272-22.3232v-22.272a22.272 22.272 0 0 0-22.272-22.272h-22.272a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.288 9.9328 22.3232 22.272 22.3232M378.4192 445.2352h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.2368 9.984 22.2208 22.272 22.2208h22.272c12.288 0 22.272-9.984 22.272-22.272V467.456a22.3744 22.3744 0 0 0-22.3232-22.2208m400.7424 467.456h22.272a22.272 22.272 0 0 0 22.272-22.272v-22.3232a22.3232 22.3232 0 0 0-22.272-22.272h-22.272a22.3232 22.3232 0 0 0-22.3232 22.272v22.3232c0 12.3392 10.0352 22.272 22.3232 22.272M267.1104 578.816h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.288 9.984 22.272 22.272 22.272h22.272c12.288 0 22.272-9.9328 22.272-22.272v-22.272a22.3232 22.3232 0 0 0-22.3232-22.272m512.0512 200.3456h22.272a22.3232 22.3232 0 0 0 22.272-22.3232v-22.272a22.3232 22.3232 0 0 0-22.272-22.272h-22.272a22.3232 22.3232 0 0 0-22.3232 22.272v22.272c0 12.288 10.0352 22.3232 22.3232 22.3232m133.5296-311.7056h-22.272V400.6912h-133.5808V467.456h-88.9856v133.5808H512V422.9632a89.088 89.088 0 0 0-89.0368-89.0368V244.8896a44.544 44.544 0 0 0-44.544-44.544h-44.4928V22.272a22.272 22.272 0 0 0-44.544 0v178.1248h-44.544a44.544 44.544 0 0 0-44.544 44.544v89.0368c-49.152 0-89.0368 39.8336-89.0368 89.0368V1024h801.3824V467.456zM244.8896 267.1104c0-12.288 9.984-22.272 22.272-22.272h89.0368c12.288 0 22.272 9.984 22.272 22.272v66.816H244.8896V267.1104zM467.456 979.5072H155.8016V422.9632c0-24.576 19.968-44.544 44.544-44.544h222.6176c24.576 0 44.544 19.968 44.544 44.544v556.544z m200.3968 0H512v-333.9264h155.8528v333.9264z m200.2944 0h-155.8016V512h155.8016v467.5072z m-88.9856-333.9776h22.272a22.272 22.272 0 0 0 22.272-22.272v-22.272a22.272 22.272 0 0 0-22.272-22.272h-22.272a22.3232 22.3232 0 0 0-22.3232 22.272v22.272c0 12.3392 10.0352 22.272 22.3232 22.272M267.1104 712.3456h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.272c0 12.288 9.984 22.3232 22.272 22.3232h22.272c12.288 0 22.272-9.984 22.272-22.3232v-22.272a22.3232 22.3232 0 0 0-22.3232-22.272m0 133.5296h-22.2208a22.272 22.272 0 0 0-22.272 22.272v22.3232c0 12.288 9.984 22.272 22.272 22.272h22.272c12.288 0 22.272-9.9328 22.272-22.272v-22.3232a22.3744 22.3744 0 0 0-22.3232-22.272" fill="#FFFFFF" ></path></symbol><symbol id="icon-loading" viewBox="0 0 1024 1024"><path d="M142.127 867.831l48.29-48.289a443.163 443.163 0 0 1-121.922-273.98H0a511.315 511.315 0 0 0 142.127 322.27z" fill="#E5E5E5" ></path><path d="M68.495 477.753a442.82 442.82 0 0 1 105.482-255.144l-48.289-48.632A510.973 510.973 0 0 0 0 477.753z m154.114-303.776A442.82 442.82 0 0 1 477.753 68.495V0a510.973 510.973 0 0 0-303.776 125.688z" fill="#DFDFDF" ></path><path d="M546.247 0v68.495a443.163 443.163 0 0 1 273.98 121.921l48.29-48.289A511.315 511.315 0 0 0 546.246 0z m255.144 850.023a442.82 442.82 0 0 1-255.144 105.482V1024a510.973 510.973 0 0 0 303.776-125.688z m112.675-657.21l-48.974 48.632a442.478 442.478 0 0 1 90.413 236.308H1024a510.63 510.63 0 0 0-109.934-284.94z m41.439 353.434a442.82 442.82 0 0 1-105.482 255.144l48.289 48.29A510.973 510.973 0 0 0 1024 545.904z" fill="#EFEFEF" ></path><path d="M477.753 955.505a442.478 442.478 0 0 1-236.308-90.413l-48.632 48.974A510.63 510.63 0 0 0 477.753 1024z" fill="#ECECEC" ></path></symbol><symbol id="icon-baocun" viewBox="0 0 1024 1024"><path d="M614.117 348.004c22.207 0 40.209-18.003 40.209-40.209V188.213c0-22.207-18.002-40.209-40.209-40.209s-40.209 18.002-40.209 40.209v119.582c0 22.206 18.002 40.209 40.209 40.209z"  ></path><path d="M924 0H100C44.771 0 0 44.771 0 100v824c0 55.229 44.771 100 100 100h824c55.229 0 100-44.771 100-100V100c0-55.229-44.771-100-100-100zM296.729 80.418h430.543v301.385c0 18.662-16.298 33.787-36.402 33.787H333.13c-20.104 0-36.401-15.125-36.401-33.787V80.418z m646.853 763.164c0 55.229-44.771 100-100 100H180.418c-55.229 0-100-44.771-100-100V180.418c0-55.229 44.771-100 100-100h35.893v365.59c0 27.615 22.386 50 50 50H757.69c27.614 0 50-22.385 50-50V80.418h35.893c55.229 0 100 44.771 100 100v663.164z"  ></path></symbol><symbol id="icon-shanchu1" viewBox="0 0 1024 1024"><path d="M344.4593 791.382c15.4235 0 27.902-12.4795 27.902-27.902V456.558592c0-15.4225-12.4795-27.902-27.902-27.902-15.4225 0-27.902 12.4805-27.902 27.902v306.92249599999997C316.5573 778.9036 329.0368 791.382 344.4593 791.382zM511.872 791.382c15.4235 0 27.902-12.4795 27.902-27.902V456.558592c0-15.4225-12.4795-27.902-27.902-27.902s-27.902 12.4805-27.902 27.902v306.92249599999997C483.969 778.9036 496.4485 791.382 511.872 791.382zM679.2837 791.382c15.4235 0 27.902-12.4795 27.902-27.902V456.558592c0-15.4225-12.4795-27.902-27.902-27.902s-27.902 12.4805-27.902 27.902v306.92249599999997C651.3818 778.9036 663.8602 791.382 679.2837 791.382zM818.7935 149.6361H703.2340479999999c-12.4795-48.0113-55.8039-83.7059-107.6572-83.7059H428.16512000000006c-51.8533 0-95.1777 35.6946-107.6572 83.7059H204.949504c-61.5526 0-111.6078 50.0828-111.6078 111.6078v27.902976h27.901952v27.901952h55.803904v530.138112c0 61.526 50.0552 111.6078 111.6078 111.6078h446.432256c61.5547 0 111.6078-50.0818 111.6078-111.6078V317.047808h55.803904v-27.901952h27.901952v-27.902976C930.4013 199.7179 880.3482 149.6361 818.7935 149.6361zM428.1651 121.7341h167.411712c20.5445 0 38.3652 11.308 48.0389 27.902H380.12723200000005C389.801 133.0422 407.6206 121.7341 428.1651 121.7341zM790.8915 847.1859c0 30.7896-25.0399 55.8039-55.8039 55.8039H288.65536000000003c-30.763 0-59.6726-25.0143-59.6726-55.8039l3.8687-530.1381h558.040064V847.1859199999999zM149.1446 261.2439c0-30.7896 25.0419-55.8039 55.8039-55.8039H818.793472c30.7651 0 55.8039 25.0143 55.8039 55.8039H149.144576z"  ></path></symbol><symbol id="icon-gouxuan" viewBox="0 0 1024 1024"><path d="M198.79680166 448.03806612L392.8807127 642.15435518l427.90558008-430.86547354 83.82946376 83.80607959-514.66525664 517.61705538L119.38334434 542.14486191 198.79680166 448.03806612 198.79680166 448.03806612zM198.79680166 448.03806612" fill="#f6f6f6" ></path></symbol><symbol id="icon-gou1" viewBox="0 0 1024 1024"><path d="M388 858.9L64.1 477l128-108.5L397 610l442.5-451.7 119.8 117.5z" fill="#f6f6f6" ></path></symbol><symbol id="icon-fangxing" viewBox="0 0 1024 1024"><path d="M39.314 39.357h946.87v946.831H39.314V39.358z"  ></path></symbol><symbol id="icon-gou" viewBox="0 0 1024 1024"><path d="M0 0v1024h1024V0H0z m462.5 709.7L389.2 783 166.1 559.9l73.3-73.3 149.9 149.9L784.6 241l73.3 73.3-395.4 395.4z"  ></path></symbol><symbol id="icon-zhongzhimima" viewBox="0 0 1024 1024"><path d="M490.913 594.147v35.012c0 14.443 11.751 26.195 26.194 26.195 14.444 0 26.196-11.752 26.196-26.195V594.17c13.266-8.723 21.27-23.314 21.27-39.449 0-26.173-21.294-47.466-47.467-47.466-26.175 0-47.468 21.293-47.468 47.466 0.001 15.865 8.172 30.709 21.275 39.425z" fill="#FFFFFF" ></path><path d="M310.129 474.95v212.693c0 23.24 18.908 42.147 42.15 42.147h319.038c23.233 0 42.132-18.907 42.132-42.147V474.95c0-23.233-18.9-42.133-42.132-42.133H375.8a26.342 26.342 0 0 0 9.318-10.833l0.221 0.017 0.27-1.138a26.687 26.687 0 0 0 1.902-8.036c6.621-27.305 22.363-52.043 44.385-69.72 22.872-18.359 50.498-28.063 79.893-28.063 45.198 0 87.436 24.323 110.351 63.507a26.29 26.29 0 0 0 23.765 15.08c14.485 0 26.268-11.784 26.268-26.268a26.1 26.1 0 0 0-4.54-14.76c-15.57-26.788-37.845-49.257-64.44-64.995-27.584-16.325-59.192-24.953-91.405-24.953-41.96 0-82.697 14.286-114.708 40.225-31.774 25.747-53.764 61.937-61.928 101.917-0.095 0.413-0.177 0.828-0.25 1.247l-0.048 0.225c-0.064 0.316-0.13 0.634-0.19 0.953l-2.051 11.353 3.123 0.205a26.424 26.424 0 0 0 6.529 10.689 26.777 26.777 0 0 0 4.64 3.705c-20.71 2.644-36.776 20.364-36.776 41.776z m52.39 191.42V496.223c0-7.347 0.769-9.472 1.042-9.993 0.521-0.272 2.643-1.04 9.973-1.04h276.51c7.356 0 9.471 0.772 9.989 1.045 0.272 0.516 1.045 2.633 1.045 9.988V666.37c0 7.353-0.772 9.471-1.044 9.988-0.519 0.273-2.636 1.045-9.99 1.045H373.532c-7.33 0-9.452-0.768-9.973-1.04-0.272-0.522-1.04-2.646-1.04-9.993z" fill="#FFFFFF" ></path><path d="M993.161 417.967a15.359 15.359 0 0 0-13.243-7.579h-0.09l-60.602 0.353c-11.767-40.767-29.541-79.42-52.919-115.053-25.15-38.332-56.111-72.168-92.025-100.568-36.27-28.681-76.587-51.014-119.83-66.376-44.742-15.895-91.644-23.955-139.402-23.955h-2.439c-112.438 0.651-217.897 45.432-296.948 126.095C136.664 311.508 93.51 418.332 94.15 531.677c0.65 113.35 45.026 219.667 124.95 299.366 79.297 79.081 184.352 122.633 295.814 122.633h2.548c134.858-0.798 262.156-67.479 340.522-178.37 4.87-6.89 3.27-16.418-3.582-21.34l-22.63-16.257a15.355 15.355 0 0 0-11.505-2.674 15.366 15.366 0 0 0-10.001 6.284c-67.496 95.504-177.087 152.93-293.061 153.612h-2.234c-95.937 0-186.377-37.49-254.656-105.564-68.867-68.69-107.103-160.324-107.662-258.022-0.56-97.718 36.625-189.786 104.707-259.247C325.4 202.656 416.172 164.1 512.867 163.536h2.183c40.513 0 80.322 6.744 118.324 20.045 36.753 12.863 71.112 31.591 102.125 55.661 30.718 23.841 57.351 52.294 79.162 84.566 18.35 27.156 32.888 56.439 43.353 87.292l-59.577 0.35a15.36 15.36 0 0 0-13.197 23.065l91.599 157.932a15.393 15.393 0 0 0 13.375 7.654 15.36 15.36 0 0 0 13.287-7.806l89.791-158.991a15.361 15.361 0 0 0-0.13-15.337zM514.915 938.315z" fill="#FFFFFF" ></path></symbol><symbol id="icon-tuichu" viewBox="0 0 1024 1024"><path d="M514.304 958.977c-57.876 0-114.084-10.893-166.954-32.489-51.101-20.758-96.927-50.515-136.313-88.434-39.386-37.919-70.293-82.105-91.922-131.269-22.363-50.902-33.711-104.984-33.711-160.737 0-66.712 16.989-132.941 49.098-191.619 31.041-56.686 76.133-106.462 130.439-143.931 15.086-10.412 36.047-7.037 46.828 7.455 10.781 14.493 7.344 34.642-7.743 44.989-45.894 31.749-83.979 73.717-110.146 121.565-27.47 50.162-41.388 104.502-41.388 161.541 0 93.061 37.65 180.563 106.007 246.342 68.324 65.812 159.177 102.059 255.805 102.059 96.595 0 187.482-36.248 255.839-102.06 68.357-65.78 105.974-153.281 105.974-246.342 0-56.975-13.885-111.411-41.388-161.54-26.167-47.816-64.285-89.816-110.179-121.502-15.054-10.346-18.558-30.495-7.744-44.989 10.814-14.492 31.743-17.898 46.795-7.454 54.339 37.469 99.498 87.245 130.507 143.93 32.142 58.678 49.131 124.907 49.131 191.619 0 55.754-11.348 109.836-33.744 160.769-21.597 49.166-52.537 93.351-91.923 131.269-39.385 37.919-85.212 67.643-136.313 88.499-52.903 21.466-109.078 32.327-166.954 32.327h-0.001v0.002z m10.08-448.084c-18.524 0-33.544-14.397-33.544-32.264V96.164c0-17.803 15.02-32.296 33.544-32.296 18.525 0 33.578 14.493 33.578 32.296v382.465c0 17.867-15.052 32.264-33.578 32.264z"  ></path></symbol><symbol id="icon-mima" viewBox="0 0 1024 1024"><path d="M524.195 560.771c-47.157 0-85.375 38.204-85.375 85.346 0 33.965 20.021 63.06 48.787 76.784v93.869c0 20.181 16.4 36.577 36.588 36.577 20.189 0 36.59-16.396 36.59-36.577v-93.872c28.767-13.725 48.787-42.817 48.787-76.783 0-47.14-38.219-85.344-85.377-85.344z m353.662-170.656H146.18c-40.415 0-73.18 32.715-73.18 73.118v487.614c0 40.4 32.765 73.153 73.18 73.153h731.678c40.377 0 73.143-32.753 73.143-73.153V463.233c0-40.402-32.766-73.118-73.144-73.118z m0 511.963c0 40.4-8.37 48.77-48.786 48.77H194.927c-40.414 0-48.747-8.368-48.747-48.77V512.002c0-40.401 8.333-48.769 48.747-48.769h634.145c40.415 0 48.786 8.367 48.786 48.769v390.076zM166.286 353.313c20.313 0 36.833-16.184 37.39-36.356l0.077 0.004C236.819 177.243 362.118 73.155 512 73.155c117.157 0 219.136 63.737 273.948 158.252 5.702 12.906 18.61 21.917 33.632 21.917 20.302 0 36.76-16.452 36.76-36.747a36.565 36.565 0 0 0-6.774-21.244C782.132 78.711 656.454 0 512 0 323.242 0 166.046 129.487 129.854 307.395c-0.171 0.733-0.32 1.473-0.447 2.223-0.176 0.89-0.367 1.773-0.537 2.665l0.177 0.011a37.844 37.844 0 0 0-0.177 3.614c-0.002 20.659 16.751 37.405 37.416 37.405z"  ></path></symbol><symbol id="icon-tongzhi" viewBox="0 0 1024 1024"><path d="M511.84917535 94.06492175c45.09656746 0 88.98653777 8.89865377 130.16166459 26.39431203 39.96852969 17.04318435 75.86479406 41.32595145 106.93466997 72.24500271 31.06987589 31.06987589 55.20181835 66.96614029 72.2450027 106.93466997 17.49565827 41.32595145 26.39431205 85.06509714 26.39431206 130.16166458V818.1740198H175.96270143V429.95139567c0-45.09656746 8.89865377-88.98653777 26.39431203-130.16166457 17.04318435-39.96852969 41.32595145-75.86479406 72.24500272-106.93466998 31.06987589-31.06987589 66.96614029-55.20181835 106.93466995-72.24500269 41.47677609-17.64648292 85.21592177-26.54513668 130.31248922-26.54513668m0-72.39582736c-224.57788941 0-408.13147665 183.70441187-408.13147664 408.13147665v432.56506837c0 15.53493795 12.66926978 28.20420773 28.20420774 28.20420773h760.00536246c15.53493795 0 28.20420773-12.66926978 28.20420774-28.20420773V429.95139567c-0.15082465-224.57788941-183.70441187-408.28230129-408.2823013-408.28230128z m0 0"  ></path><path d="M1012.58698115 818.02319517h-1001.47561158v72.69747662h1001.47561158v-72.69747662zM658.75237502 970.0544326H364.79515106V1042.90273386h293.95722396v-72.84830126z m-82.95355217-986.54397219h-127.89929498v91.70138129h127.89929498v-91.70138129z m0 0"  ></path></symbol><symbol id="icon-zhuanblack" viewBox="0 0 1024 1024"><path d="M874.54151147 627.3251552c-32.31288853-32.31288853-75.3664-50.1532448-121.05955627-50.24426667-94.48106667 0-171.3948448 76.8227552-171.39484373 171.30382294 0.09102187 45.78417813 17.93137813 88.74666667 50.24426666 121.15057706 32.31288853 32.31288853 75.3664 50.1532448 121.15057707 50.24426667 45.78417813-0.09102187 88.74666667-17.93137813 121.15057813-50.24426667 32.31288853-32.40391147 50.1532448-75.3664 50.1532448-121.15057706-0.1820448-45.78417813-17.93137813-88.74666667-50.24426666-121.05955627z m-121.15057814 0.72817813c24.576 0 47.42257813 7.46382187 66.5372448 20.20693334L652.0832 813.2835552c-12.1059552-18.75057813-19.11466667-41.05102187-19.11466667-64.89884373 0-66.3552 53.97617813-120.33137813 120.4224-120.33137814z m0 240.75377814c-24.12088853 0-46.5123552-7.1907552-65.3539552-19.38773334l167.38986667-164.56817813c11.55982187 18.47751147 18.29546667 40.23182187 18.29546667 63.62453333 0 66.26417813-53.97617813 120.2403552-120.33137814 120.33137814zM456.02133333 542.58346667c51.6096 0.72817813 102.12693333 14.65457813 146.36373334 40.41386666 12.19697813 7.09973333 27.76177813 2.91271147 34.86151146-9.28426666 7.09973333-12.19697813 2.91271147-27.76177813-9.28426666-34.86151147-18.8416-10.92266667-38.6844448-20.02488853-59.1644448-27.30666667 18.0224-10.37653333 34.86151147-23.1196448 49.9712-38.22933333 44.69191147-44.69191147 69.26791147-104.12942187 69.26791146-167.29884373s-24.576-122.60693333-69.26791146-167.2988448c-44.69191147-44.69191147-104.12942187-69.26791147-167.2988448-69.26791147s-122.60693333 24.576-167.29884374 69.26791147c-44.69191147 44.69191147-69.26791147 104.12942187-69.26791146 167.2988448s24.576 122.60693333 69.26791146 167.29884373c15.10968853 15.10968853 31.85777813 27.94382187 49.9712 38.22933333-6.64462187 2.36657813-13.2892448 4.9152-19.75182293 7.64586667-41.9612448 17.74933333-79.6444448 43.14453333-111.95733333 75.45742293s-57.70808853 69.99608853-75.45742187 111.95733334c-18.38648853 43.4176-27.6707552 89.56586667-27.6707552 137.17048853 0 14.1084448 11.37777813 25.48622187 25.48622187 25.48622187s25.48622187-11.37777813 25.48622186-25.48622187c0-80.4636448 31.3116448-156.19413333 88.20053334-213.08302187 55.97866667-55.97866667 130.16177813-87.19928853 209.2600896-88.20053333 1.27431147 0 2.54862187 0.09102187 3.7319104 0.09102187 1.54737813 0.09102187 3.0947552 0.09102187 4.55111146 0zM265.96693333 306.10773333c0-102.30897813 83.28533333-185.59431147 185.59431147-185.59431146s185.59431147 83.28533333 185.5943104 185.59431146c0 100.85262187-80.9187552 183.22773333-181.22524373 185.50328854h-9.10222294c-100.1244448-2.4576-180.8611552-84.74168853-180.8611552-185.50328854z"  ></path></symbol><symbol id="icon-zhuangrey" viewBox="0 0 1024 1024"><path d="M874.54151147 627.3251552c-32.31288853-32.31288853-75.3664-50.1532448-121.05955627-50.24426667-94.48106667 0-171.3948448 76.8227552-171.39484373 171.30382294 0.09102187 45.78417813 17.93137813 88.74666667 50.24426666 121.15057706 32.31288853 32.31288853 75.3664 50.1532448 121.15057707 50.24426667 45.78417813-0.09102187 88.74666667-17.93137813 121.15057813-50.24426667 32.31288853-32.40391147 50.1532448-75.3664 50.1532448-121.15057706-0.1820448-45.78417813-17.93137813-88.74666667-50.24426666-121.05955627z m-121.15057814 0.72817813c58.07217813 0.09102187 106.76906667 41.5971552 117.9648 96.39253334L635.79022187 722.5344c11.92391147-53.97617813 60.07466667-94.48106667 117.60071146-94.48106667z m0 240.75377814c-57.70808853-0.09102187-106.13191147-41.05102187-117.7827552-95.30026667l235.01937707 2.00248853C858.3395552 828.75733333 810.46186667 868.71608853 753.39093333 868.80711147zM456.02133333 542.58346667c51.6096 0.72817813 102.12693333 14.65457813 146.36373334 40.41386666 12.19697813 7.09973333 27.76177813 2.91271147 34.86151146-9.28426666 7.09973333-12.19697813 2.91271147-27.76177813-9.28426666-34.86151147-18.8416-10.92266667-38.6844448-20.02488853-59.1644448-27.30666667 18.0224-10.37653333 34.86151147-23.1196448 49.9712-38.22933333 44.69191147-44.69191147 69.26791147-104.12942187 69.26791146-167.29884373s-24.576-122.60693333-69.26791146-167.2988448c-44.69191147-44.69191147-104.12942187-69.26791147-167.2988448-69.26791147s-122.60693333 24.576-167.29884374 69.26791147c-44.69191147 44.69191147-69.26791147 104.12942187-69.26791146 167.2988448s24.576 122.60693333 69.26791146 167.29884373c15.10968853 15.10968853 31.85777813 27.94382187 49.9712 38.22933333-6.64462187 2.36657813-13.2892448 4.9152-19.75182293 7.64586667-41.9612448 17.74933333-79.6444448 43.14453333-111.95733333 75.45742293s-57.70808853 69.99608853-75.45742187 111.95733334c-18.38648853 43.4176-27.6707552 89.56586667-27.6707552 137.17048853 0 14.1084448 11.37777813 25.48622187 25.48622187 25.48622187s25.48622187-11.37777813 25.48622186-25.48622187c0-80.4636448 31.3116448-156.19413333 88.20053334-213.08302187 55.97866667-55.97866667 130.16177813-87.19928853 209.2600896-88.20053333 1.27431147 0 2.54862187 0.09102187 3.7319104 0.09102187 1.54737813 0.09102187 3.0947552 0.09102187 4.55111146 0zM265.96693333 306.10773333c0-102.30897813 83.28533333-185.59431147 185.59431147-185.59431146s185.59431147 83.28533333 185.5943104 185.59431146c0 100.85262187-80.9187552 183.22773333-181.22524373 185.50328854h-9.10222294c-100.1244448-2.4576-180.8611552-84.74168853-180.8611552-185.50328854z"  ></path></symbol><symbol id="icon-guizeshezhi" viewBox="0 0 1024 1024"><path d="M849.834667 780.032H535.722667c-8.704-43.605333-46.762667-76.544-92.245334-76.544-45.568 0-83.626667 32.938667-92.330666 76.544H150.186667c-10.410667 0-18.858667 8.533333-18.858667 19.114667 0 10.581333 8.448 19.114667 18.858667 19.114666h201.045333c8.704 43.605333 46.762667 76.544 92.330667 76.544 45.568 0 83.541333-32.938667 92.245333-76.544H849.92c10.410667 0 18.858667-8.533333 18.858667-19.114666-0.085333-10.581333-8.533333-19.114667-18.944-19.114667z m-406.357334 76.458667c-31.232 0-56.576-25.685333-56.576-57.344s25.344-57.344 56.576-57.344c31.146667 0 56.490667 25.685333 56.490667 57.344s-25.258667 57.344-56.490667 57.344zM849.834667 206.165333h-418.986667c-8.704-43.605333-46.677333-76.458667-92.245333-76.458666-45.568 0-83.541333 32.938667-92.245334 76.544H150.186667c-10.410667 0-18.858667 8.618667-18.858667 19.114666 0 10.581333 8.448 19.114667 18.858667 19.114667h96.085333c8.704 43.690667 46.677333 76.544 92.245333 76.544 45.568 0 83.541333-32.853333 92.245334-76.544h419.072c10.410667 0 18.858667-8.533333 18.858666-19.114667 0-10.581333-8.448-19.2-18.858666-19.2z m-511.317334 76.544c-31.232 0-56.490667-25.685333-56.490666-57.344s25.344-57.429333 56.490666-57.429333c31.232 0 56.490667 25.685333 56.490667 57.429333 0 31.658667-25.258667 57.344-56.490667 57.344zM849.834667 493.141333h-58.453334c-8.704-43.690667-46.677333-76.544-92.245333-76.544-45.568 0-83.541333 32.853333-92.245333 76.544H150.186667c-10.410667 0-18.858667 8.533333-18.858667 19.114667 0 10.581333 8.448 19.114667 18.858667 19.114667h456.704c8.704 43.605333 46.762667 76.544 92.245333 76.544 45.568 0 83.541333-32.938667 92.245333-76.544h58.453334c10.410667 0 18.858667-8.533333 18.858666-19.114667 0-10.581333-8.448-19.114667-18.858666-19.114667z m-150.698667 76.458667c-31.232 0-56.490667-25.685333-56.490667-57.429333 0-31.658667 25.258667-57.429333 56.490667-57.429334s56.490667 25.685333 56.490667 57.429334c0 31.744-25.258667 57.429333-56.490667 57.429333z"  ></path></symbol><symbol id="icon-shenhejilu" viewBox="0 0 1024 1024"><path d="M627.18980528 331.4930705H229.17363452c-19.94907242 0-36.19791367-16.24884125-36.19791368-36.19791369s16.24884125-36.19791367 36.19791368-36.19791366h398.01617076c19.94907242 0 36.19791367 16.24884125 36.19791367 36.19791366 0 19.78819281-16.40972085 36.19791367-36.19791367 36.19791369z m0 217.02660241H229.17363452c-19.94907242 0-36.19791367-16.24884125-36.19791368-36.19791368s16.24884125-36.19791367 36.19791368-36.19791366h398.01617076c19.94907242 0 36.19791367 16.24884125 36.19791367 36.19791366s-16.40972085 36.19791367-36.19791367 36.19791368z m-108.11110217 217.02660242H229.17363452c-19.94907242 0-36.19791367-16.24884125-36.19791368-36.19791368s16.24884125-36.19791367 36.19791368-36.19791367h289.90506859c19.94907242 0 36.19791367 16.24884125 36.19791367 36.19791367s-16.08796163 36.19791367-36.19791367 36.19791368z m0 0"  ></path><path d="M156.77780718 902.93746766c-19.94907242 0-36.19791367-16.24884125-36.19791367-36.19791369V157.74308487c0-19.94907242 16.24884125-36.19791367 36.19791367-36.19791369h542.64694583c19.94907242 0 36.19791367 16.24884125 36.19791368 36.19791369v318.3807607h72.39582734V157.74308487c0-59.84721727-48.58564413-108.59374101-108.59374102-108.59374102H156.77780718c-59.84721727 0-108.59374101 48.58564413-108.59374101 108.59374102v708.9964691c0 59.84721727 48.58564413 108.59374101 108.59374101 108.59374102h318.38076068v-72.39582733H156.77780718z m0 0"  ></path><path d="M438.96065419 939.13538133c0 19.94907242 16.24884125 36.19791367 36.19791367 36.19791366s36.19791367-16.24884125 36.19791367-36.19791366-16.24884125-36.19791367-36.19791367-36.19791367-36.19791367 16.24884125-36.19791367 36.19791367z m0 0M735.62266669 476.12384557c0 19.94907242 16.24884125 36.19791367 36.19791367 36.19791366s36.19791367-16.24884125 36.19791367-36.19791366-16.24884125-36.19791367-36.19791367-36.19791368-36.19791367 16.24884125-36.19791367 36.19791368z m0 0M593.56596546 975.33329499h352.00460052c23.32754437 0 28.95833093-4.50462927 28.95833094-18.50115588v-48.4247645c0-8.52661966-6.43518466-15.60532277-14.64004509-15.60532279H882.02311754c-70.14351271-72.87846619-31.37152518-65.15624461-4.82638849-110.84605563 4.82638849-6.27430503 9.65277699-12.70948969 13.19212852-20.27083166 10.7789343-20.27083165 16.89235971-43.27661678 16.89235972-68.53471655 0-78.831012-60.00809689-143.66549738-135.62151655-143.6654974-74.32638274 0-135.62151657 63.54744844-135.62151656 143.6654974 0 33.14120095 10.7789343 63.54744844 28.79745132 87.67939089 28.79745131 48.2638849 75.61341968 49.87268107 0 112.13309256h-72.39582735c-11.10069353 0-20.10995203 9.65277699-20.10995202 21.23610937v43.598376c0 8.52661966 7.23958273 17.53587819 21.23610933 17.53587819z m0 0"  ></path></symbol><symbol id="icon-fasongtongzhi" viewBox="0 0 1024 1024"><path d="M854.4256 202.24s-4.608-9.216-18.432-9.216c-13.824-4.608-32.256 0-50.688 13.824L186.6752 524.5952c-4.608 0-18.432 9.216-18.432 23.04 0 9.216 9.216 18.432 23.04 23.04l188.8256 64.512 27.648 13.824L716.288 345.088 476.7744 676.5568l36.864 13.824 188.8256 64.512c4.608 0 9.216 4.608 13.824 4.608s9.216 0 13.824-4.608c13.824-4.608 18.432-23.04 23.04-41.472l101.2736-501.9648v-9.216zM490.5984 833.1264h-4.608c-4.608 0-9.216-4.608-9.216-9.216v-96.6656c0-4.608 0-9.216 4.608-9.216 4.608-4.608 4.608-4.608 9.216 0l73.728 18.432c4.608 0 9.216 4.608 9.216 9.216s0 9.216-4.608 13.824l-73.728 69.12c0-0.1024-4.608-0.1024-4.608 4.5056z m0 0"  ></path></symbol><symbol id="icon-tongzhiguanli" viewBox="0 0 1024 1024"><path d="M511.8976 228.2496c30.6176 0 60.416 6.0416 88.3712 17.92 27.136 11.5712 51.5072 28.0576 72.6016 49.0496 21.0944 21.0944 37.4784 45.4656 49.0496 72.6016 11.8784 28.0576 17.92 57.7536 17.92 88.3712V719.872H283.8528V456.2944c0-30.6176 6.0416-60.416 17.92-88.3712 11.5712-27.136 28.0576-51.5072 49.0496-72.6016 21.0944-21.0944 45.4656-37.4784 72.6016-49.0496 28.16-11.9808 57.856-18.0224 88.4736-18.0224m0-49.152c-152.4736 0-277.0944 124.7232-277.0944 277.0944v293.6832c0 10.5472 8.6016 19.1488 19.1488 19.1488h515.9936c10.5472 0 19.1488-8.6016 19.1488-19.1488V456.2944c-0.1024-152.4736-124.7232-277.1968-277.1968-277.1968z m0 0"  ></path><path d="M851.8656 719.7696h-679.936v49.3568h679.936v-49.3568zM611.6352 822.9888H412.0576V872.448h199.5776v-49.4592z m-56.32-669.7984h-86.8352v62.2592h86.8352v-62.2592z m0 0"  ></path></symbol><symbol id="icon-fengxiankongzhi-beizhu" viewBox="0 0 1024 1024"><path d="M888.20695314 536.40007567L702.3909963 391.74248681l185.81595684-144.65758887 2.54726164-4.0219904c11.26157314-17.96489102 11.9319054-40.89023634 1.47472876-59.52545805-9.78684279-17.56269197-27.21546895-28.15393285-46.78915455-28.15393286H231.28185368v-56.30786571c0-17.83082363-14.34509965-32.17592326-32.17592325-32.17592325s-32.17592326 14.34509965-32.17592327 32.17592325v825.84869816c0 17.83082363 14.34509965 32.17592326 32.17592327 32.17592325s32.17592326-14.34509965 32.17592325-32.17592325V628.10145696h614.29200113c19.57368717 0 37.00231174-10.45717506 46.78915612-28.15393284 10.32310924-18.63522169 9.78684279-41.42650122-1.47473033-59.52545805l-2.68132746-4.0219904z m-43.16936318 38.07484148H231.28185368V209.01005647h613.75573628c0.40219903 0.53626486 0.93846389 1.60879617 0.9384639 2.9494591L615.11380443 391.74248681l230.86224943 179.78297124c0 1.34066295-0.40219903 2.41319424-0.9384639 2.9494591z"  ></path></symbol><symbol id="icon-fengxiankongzhi" viewBox="0 0 1024 1024"><path d="M475.44223881 300.00641305v242.4411271c0 20.91973806 14.6023917 35.52212977 35.52213097 35.52212977 20.91973806 0 35.52212977-14.6023917 35.52212977-35.52212977V300.00641305c0-20.91973806-14.6023917-35.52212977-35.52212977-35.52213099-20.91973806 0.10356266-35.52212977 14.70595436-35.52213097 35.52213099zM510.96436978 628.09419261c-20.91973806 0-35.52212977 14.6023917-35.52213097 35.52212976s14.6023917 35.52212977 35.52213097 35.52212977c20.91973806 0 35.52212977-14.6023917 35.52212977-35.52212977s-14.70595436-35.52212977-35.52212977-35.52212976z"  ></path><path d="M864.42509866 152.94686459l-20.50548622 20.50548622 20.50548622-20.50548622-4.3496486-4.3496486-5.79953065-2.1748243c-61.62002132-23.50881541-118.37257955-39.87177836-173.67525451-50.22808413-54.26704475-10.14918045-108.11983645-14.80951823-169.63629512-14.80951823s-115.36925036 4.76390044-169.6362951 14.80951823c-55.19911231 10.35630577-112.05523319 26.71926992-173.67525452 50.22808413l-5.79953186 2.1748243-4.3496486 4.3496486c-6.93872473 6.93872473-19.98767051 19.98767051-19.98767051 43.49648592v361.64221155c0 74.6689671 44.22142695 152.65195259 131.52508799 231.77413216 85.54308859 77.56873364 184.549376 130.80014697 223.17839763 150.06287644l6.11022104 3.10689185h25.165824l6.11022105-3.10689185c38.62902162-19.26272948 137.63530903-72.59770668 223.17839762-150.06287644 87.30366103-79.12217956 131.52508799-157.00160117 131.52508799-231.77413216V196.44335051c0-23.50881541-12.94538311-36.55776119-19.88410785-43.49648592z m-38.11120591 405.13869747c0 39.66465305-19.46985601 104.49512889-112.46948504 188.79546194-75.39390934 68.35162075-162.49044385 116.81913363-202.98360179 137.53174638-40.49315673-20.71261275-127.58969245-69.2836883-202.98360059-137.53174638-92.99962902-84.19676918-112.46948503-149.13080889-112.46948503-188.79546194V197.78967111c110.91603911-41.52878816 202.88003792-58.51312947 315.45308562-58.51313067 112.57304769 0 204.43348385 16.98434253 315.45308683 58.51313067v360.29589095z"  ></path></symbol><symbol id="icon-weiyincangceshishanghu" viewBox="0 0 1024 1024"><path d="M744.533333 895.744H278.528c-83.029333 0-150.613333-67.584-150.613333-150.613333V279.125333c0-83.029333 67.584-150.613333 150.613333-150.613333h466.005333c83.029333 0 150.613333 67.584 150.613334 150.613333v466.005334c0.085333 83.029333-67.498667 150.613333-150.613334 150.613333zM278.528 196.693333c-45.397333 0-82.346667 36.949333-82.346667 82.346667v466.005333c0 45.397333 36.949333 82.346667 82.346667 82.346667h466.005333c45.397333 0 82.346667-36.949333 82.346667-82.346667v-465.92c0-45.397333-36.949333-82.346667-82.346667-82.346666H278.528z"  ></path></symbol><symbol id="icon-yincangceshishanghu" viewBox="0 0 1024 1024"><path d="M744.533333 895.744H278.528c-83.029333 0-150.613333-67.584-150.613333-150.613333V279.125333c0-83.029333 67.584-150.613333 150.613333-150.613333h466.005333c83.029333 0 150.613333 67.584 150.613334 150.613333v466.005334c0.085333 83.029333-67.498667 150.613333-150.613334 150.613333zM278.528 196.693333c-45.397333 0-82.346667 36.949333-82.346667 82.346667v466.005333c0 45.397333 36.949333 82.346667 82.346667 82.346667h466.005333c45.397333 0 82.346667-36.949333 82.346667-82.346667v-465.92c0-45.397333-36.949333-82.346667-82.346667-82.346666H278.528z"  ></path><path d="M424.874667 692.48L265.813333 533.418667l54.954667-54.869334 104.106667 104.106667 266.24-266.24 54.954666 54.954667z"  ></path></symbol><symbol id="icon-circleclose" viewBox="0 0 1024 1024"><path d="M266.73880768 268.20651244c-135.18333434 135.18333434-135.18333434 354.25758362 0 489.44091799s354.25758362 135.18333434 489.44091798 0 135.18333434-354.25758362-2e-8-489.44091799-354.25758362-135.10608672-489.44091796 0z m398.05698397 92.54264832c9.0379715 9.0379715 9.0379715 23.79226683 0 32.75299073L544.59849548 513.69944763 664.95028688 634.05123901c9.0379715 9.0379715 9.0379715 23.79226683 0 32.75299074l-2.16293335 2.16293334c-9.0379715 9.0379715-23.79226683 9.0379715-32.75299072 0L509.60532378 548.69261933 389.33078003 668.96716309c-9.0379715 9.0379715-23.79226683 9.0379715-32.75299073 0l-2.16293334-2.16293334c-9.0379715-9.0379715-9.0379715-23.79226683 0-32.75299074l120.35179138-120.35179138-120.27454379-120.19729614c-9.0379715-9.0379715-9.0379715-23.79226683 3e-8-32.75299073l2.16293335-2.16293334c9.0379715-9.0379715 23.79226683-9.0379715 32.75299073 0L509.60532378 478.78352356l120.19729616-120.19729614c9.0379715-9.0379715 23.79226683-9.0379715 32.75299071 0l2.240181 2.16293334z" fill="#CCCCCC" ></path></symbol><symbol id="icon-shanchuguanggao" viewBox="0 0 1024 1024"><path d="M546.00574086 511.18646491l129.02656391-129.02656389c9.27429278-9.27429278 9.27429278-24.56873989 0-33.8430327-9.27429278-9.27429278-24.56873989-9.27429278-33.84303273 0l-129.02656578 129.02656389-129.02656391-129.02656389a23.75520671 23.75520671 0 0 0-16.92151727-6.99639758c-6.508275 0-12.3657231 2.44060336-16.92151542 6.99639758a23.75520671 23.75520671 0 0 0-6.99639757 16.9215154c0 6.508275 2.44060336 12.3657231 6.99639757 16.9215173l129.02656391 129.02656389-129.02656391 128.86385765a23.75520671 23.75520671 0 0 0-6.99639757 16.92151729c0 6.508275 2.44060336 12.3657231 6.99639757 16.92151732 4.55579231 4.55579231 10.57594852 6.99639567 16.92151542 6.99639568 6.508275 0 12.3657231-2.44060336 16.92151727-6.99639568l129.02656391-129.02656584 129.02656578 129.02656584c4.71850048 4.71850048 10.73865482 6.99639567 16.92151541 6.99639568 6.1828625 0 12.3657231-2.27789711 16.92151732-6.99639568 9.27429278-9.27429278 9.27429278-24.56873989 0-33.84303461l-129.02656391-128.86385765z m0 0" fill="" ></path></symbol><symbol id="icon-tianjia" viewBox="0 0 1024 1024"><path d="M941.44810344 538.9976106c-0.45247391-20.96462501-5.73133634-41.77842537-15.23328868-60.48068075-11.6134973-22.4728714-29.41080486-41.17512681-51.28037769-53.99522123-20.21050179-11.91514658-43.13584711-18.4006061-66.66449101-18.70225539H556.84527067c-73.45159984 0-133.17815739 59.72655756-133.17815739 133.17815737v251.42467541c0.30164928 23.37781925 6.63628417 46.45398922 18.7022554 66.51366635 12.82009443 22.02039749 31.67317446 39.66688039 54.2968705 51.2803777 18.55143076 9.50195234 39.36523111 14.78081473 60.17903149 15.23328868h188.681625c108.14126709 0 196.07203239-87.93076529 196.07203239-196.07203239V539.14843525l-0.15082462-0.15082465z m-77.8255144 0.15082465v188.53080037c0 65.15624461-52.93944874 118.09569335-118.09569337 118.09569335h-188.53080035c-30.46657735 0-55.35264298-24.88606564-55.35264299-55.35264296V539.14843525c0-30.46657735 24.88606564-55.35264298 55.35264299-55.35264298H808.26994606c30.46657735 0.15082465 55.35264298 24.88606564 55.35264298 55.35264298z" fill="#333333" ></path><path d="M776.89842088 630.39734265h-59.87738222v-59.8773822c0-19.00390467-15.3841133-34.38801799-34.38801798-34.38801801s-34.38801799 15.3841133-34.38801798 34.38801801v59.8773822h-59.8773822c-19.00390467 0-34.38801799 15.3841133-34.388018 34.38801796s15.3841133 34.38801799 34.388018 34.38801799h59.8773822v59.87738221c0 19.00390467 15.3841133 34.38801799 34.38801798 34.38801797s34.38801799-15.3841133 34.38801798-34.38801797v-59.87738221h59.87738222c19.00390467 0 34.38801799-15.3841133 34.38801797-34.38801799s-15.3841133-34.38801799-34.38801797-34.38801796z" fill="#333333" ></path><path d="M745.37607104 84.11049547H305.4205953c-109.80033812 0-199.08852519 89.28818705-199.08852521 199.0885252V723.15449641c0 109.80033812 89.28818705 199.08852519 199.08852521 199.0885252h63.49717356c19.90885252 0 37.1028615-14.02669155 41.17512681-33.63389477l0.15082463-1.05577248c0.30164928-2.56401887 0.30164928-5.2788624 0-7.84288131-0.15082465-11.01019874-4.52473921-21.41709892-12.21679587-29.10915557-7.99370593-7.99370593-18.4006061-12.36762051-29.71245414-12.36762052h-62.89387499c-63.49717356 0-115.07920055-51.58202698-115.07920056-115.07920055V283.3498453c0-63.49717356 51.58202698-115.07920055 115.07920056-115.07920054h439.95547574c63.49717356 0 115.07920055 51.58202698 115.07920054 115.07920054V346.09289568c0 11.16102338 4.37391457 21.7187482 12.36762052 29.71245413 7.8428813 7.8428813 18.09895683 12.21679586 29.10915558 12.21679586 2.56401887 0.30164928 5.2788624 0.15082465 7.84288128 0l1.05577249-0.15082464c19.75802788-4.07226528 33.93554407-21.56792356 33.6338948-41.92925v-62.74305036c0-109.64951349-89.28818705-199.08852519-199.08852521-199.0885252z" fill="#333333" ></path></symbol><symbol id="icon-shangchuantupian" viewBox="0 0 1103 1024"><path d="M936.22784202 59.41773468H166.15074522c-70.64402764 0-128.27468074 57.91666189-128.27468072 128.70369306v643.94747759c0 70.78703118 57.77365833 128.84669661 128.27468072 128.84669662h769.93409326c70.64402764 0 128.27468074-57.91666189 128.27468074-128.84669662V188.12142774c0.14300355-70.78703118-57.63065311-128.70369303-128.1316772-128.70369306z m64.06583944 699.43306916l-154.01541937-197.20265748c-19.30555395-32.17592326-57.77365833-32.17592326-83.37139338-6.43518465L583.29371595 735.54113554 397.10237332 497.29629984c-19.30555395-25.7407386-51.33847366-25.7407386-76.93620873 0L101.94190394 761.1388706V188.12142774c0-38.61110791 25.59773505-64.35184654 64.20884128-64.35184653h769.93409326c32.03291971 0 64.20884297 32.17592326 64.20884298 64.35184653v570.7293761z m-220.65533267-478.0627171c-9.00925852-9.00925852-19.59156272-16.01645902-31.17489341-20.87859964-11.72633593-4.86213894-24.16769291-7.29320927-36.89505869-7.29320927-12.58436052 0-25.16872275 2.43107031-36.89505867 7.29320927-11.72633593 4.86213894-22.30864012 12.01234468-31.17489508 20.87859964-8.86625497 9.00925852-16.01645902 19.59156272-20.87859968 31.31789865-4.86213894 11.72633593-7.29320927 24.31069814-7.29320927 36.89505868 0 12.72736576 2.57407386 25.31172629 7.29320927 36.89505869 4.86213894 11.72633593 11.86934114 22.30864012 20.87859968 31.31789862 8.86625497 9.00925852 19.59156272 16.01645902 31.17489508 20.87859966 11.72633593 4.86213894 24.16769291 7.29320927 36.89505867 7.29320927 12.58436052 0 25.16872275-2.57407386 36.89505869-7.29320927 11.72633593-4.86213894 22.30864012-12.01234468 31.17489341-20.87859966 8.86625497-9.00925852 16.01645902-19.59156272 20.87859965-31.31789862 4.86213894-11.72633593 7.29320927-24.31069814 7.2932093-36.89505869s-2.57407386-25.31172629-7.2932093-36.89505868c-4.86213894-11.58333237-11.86934114-22.30864012-20.87859965-31.31789865z m0 0"  ></path></symbol><symbol id="icon-tupianxiugai" viewBox="0 0 1024 1024"><path d="M688.78214637 384.30674489h-48.46751289c-5.28171615 0-11.90975169-3.62470756-14.80951823-8.07791881l-23.71594073-37.38626489c-5.90309452-9.32067555-19.26272948-16.67365334-30.0332883-16.67365334H454.31537422c-10.66699495 0-24.13019378 7.45654045-29.92972444 16.67365334l-23.30168889 37.38626489c-2.79620267 4.45321125-9.42423822 8.07791882-14.80951823 8.07791881H336.97842608c-21.54111644 0-39.04327468 17.39859437-39.04327467 38.9397108v234.67389869c0 21.54111644 17.39859437 38.93971081 38.83614814 38.9397108h352.01084682c10.35630577 0 20.19479703-4.03895941 27.54777482-11.39193719 7.24941392-7.35297778 11.39193719-17.19146784 11.39193598-27.54777361V423.24645569c0-10.35630577-4.14252206-20.19479703-11.39193598-27.54777361-7.35297778-7.35297778-17.29503171-11.39193719-27.54777482-11.39193719z m9.63136474 273.61360949c0 5.28171615-4.24608594 9.63136475-9.63136474 9.63136473H336.77129955c-2.58907614 0-4.97102697-1.03563022-6.83516207-2.79620266-1.76057245-1.86413511-2.79620267-4.24608594-2.79620266-6.83516207V423.24645569c0-5.28171615 4.34964859-9.63136475 9.7349274-9.63136474h49.29601778c15.53445925 0 31.58673423-8.80285984 39.66465305-21.85180562l23.09456236-37.07557569c1.44988327-1.44988327 3.31401838-2.58907614 5.28171614-3.21045572h117.02626016c2.1748243 0.51781571 4.14252206 1.55344592 5.69596799 3.10689185l23.61237808 37.28270222c8.28504534 13.04894578 24.13019378 21.74824297 39.56108917 21.74824296h48.46751289c5.28171615 0 9.63136475 4.34964859 9.63136475 9.63136474l0.20712652 234.67389869z m0 0"  ></path><path d="M512.8285049 439.29873067c-35.21144059-0.41425184-67.9373689 18.12353539-85.64665245 48.46751288-17.70928355 30.44754015-17.70928355 68.04093155 0 98.38490906 17.70928355 30.44754015 50.43521066 48.88176473 85.64665245 48.46751288 53.43853985-0.72494102 96.52077394-44.22142695 96.41721007-97.76353067 0-53.33497719-42.97867022-96.83146311-96.41721007-97.55640415z m0 166.11515141c-37.69695406 0-68.35162075-30.65466668-68.35162074-68.35162074s30.65466668-68.35162075 68.35162074-68.35162073c37.69695406 0.10356266 68.35162075 30.65466668 68.35162074 68.35162073-0.10356266 37.69695406-30.65466668 68.24805808-68.35162074 68.35162074z m117.12982281-146.54173275c0.31068918 10.5634323 8.90642371 19.05560295 19.57341867 19.05560296 10.5634323 0 19.26272948-8.388608 19.57341867-19.05560296 0-10.77055883-8.69929718-19.57341867-19.57341867-19.57341866-10.77055883 0-19.57341867 8.80285984-19.57341867 19.57341866z m0 0"  ></path></symbol><symbol id="icon-guanggaoxiugai" viewBox="0 0 1024 1024"><path d="M452.73641618 524.2545025l181.81439014-179.33992479 62.68649204 64.57179959-179.33992477 182.40354936-65.16095741-67.63542416zM502.22575126 600.60947664L403.12924978 642.79324276l38.29531837-101.92446349 60.80118311 59.74069737z"  ></path><path d="M722.45329247 718.08773117c0 5.42026005-4.47760697 9.89786702-9.89786703 9.89786701H323.00365916c-5.53809273 0-9.89786702-4.47760697-9.89786701-9.89786701v-386.48814031c0-5.53809273 4.35977431-9.89786702 9.89786701-9.89786703h276.78678131L559.25631792 364.71031175H364.59826745c-4.47760697 0-8.24822206 3.77061647-8.24822342 8.36605472v303.77025164c0 4.59543826 3.6527838 8.24822206 8.24822342 8.24822344h306.12688712c4.59543826 0 8.24822206-3.6527838 8.24822206-8.24822344v-194.42238788l43.36208453-40.18062591 0.11783131 275.84412685zM748.84760497 360.11487348c-8.48388603 9.54437177-36.17434687 37.47049658-36.17434824 37.47049659l-65.63228395-65.3966214 32.28589909-32.28589909s14.72896923-14.02197874 33.81771279 0c19.08874354 13.90414608 35.70302032 32.2858991 35.70302031 32.28589909s8.6017173 18.38175303 0 27.92612481z"  ></path></symbol><symbol id="icon-jiaoyiliushuituikuan" viewBox="0 0 1024 1024"><path d="M937.813333 509.44v-1.877333c-0.341333-6.570667-2.986667-12.629333-6.912-17.408-0.085333-0.256-0.341333-0.341333-0.512-0.597334-0.085333-0.085333-0.256-0.341333-0.341333-0.512-5.632-6.229333-13.568-9.984-22.528-9.984H474.197333l90.624-90.624c11.776-11.776 11.776-31.232 0-43.093333-11.776-11.776-31.232-11.776-43.093333 0l-142.506667 142.592c-4.693333 4.693333-7.509333 10.581333-8.448 16.810667v0.085333c0 0.341333-0.085333 0.853333-0.085333 1.194667v0.341333c0 0.341333 0 0.682667-0.085333 1.109333v3.925334c0 0.341333 0 0.853333 0.085333 1.194666v0.256c0.682667 6.656 3.584 13.141333 8.704 18.261334 0.853333 0.853333 1.706667 1.536 2.645333 2.304L522.24 673.621333c11.776 11.776 31.232 11.776 43.093333 0 11.776-11.776 11.776-31.232 0-43.093333L474.624 539.818667h401.408c-15.36 187.392-173.397333 337.834667-364.373333 337.664-201.301333-0.341333-365.653333-165.034667-365.226667-366.165334 0.512-200.362667 167.338667-364.288 367.616-364.288h-1.536c16.810667 0 30.549333-13.738667 30.549333-30.549333 0-16.810667-13.738667-30.549333-30.549333-30.549333h-0.512c-234.24 0-424.874667 189.013333-426.666667 422.826666-1.877333 235.093333 188.330667 428.117333 423.424 429.653334C744.96 939.946667 937.813333 748.032 937.813333 512.256V509.44z m0 0"  ></path></symbol><symbol id="icon-yijianguanli" viewBox="0 0 1024 1024"><path d="M936.6528 351.232l1.024-2.1504-101.0688-46.6944V147.2512c0-24.4736-19.8656-44.3392-44.3392-44.3392H250.1632c-24.4736 0-44.3392 19.8656-44.3392 44.3392v155.7504l-100.9664 45.9776 1.2288 2.7648-2.2528-1.3312v516.608c0 30.4128 24.7808 55.0912 55.0912 55.0912h724.48c30.4128 0 55.0912-24.7808 55.0912-55.0912V350.0032l-1.8432 1.2288z m-47.0016 29.3888L836.608 413.696v-57.6512l53.0432 24.576z m-101.7856-228.9664v292.4544l-248.832 155.3408c-9.3184 5.8368-20.8896 5.8368-30.3104 0.1024L254.5664 443.1872V151.6544h533.2992zM205.824 356.5568v56.5248l-52.8384-32.4608 52.8384-24.064z m688.4352 510.464c0 5.9392-4.8128 10.752-10.752 10.752H159.0272c-5.9392 0-10.752-4.8128-10.752-10.752v-437.248l337.3056 207.6672c23.7568 14.6432 53.3504 14.5408 77.0048-0.2048l331.776-207.0528v436.8384z" fill="" ></path><path d="M365.568 318.464h282.624c12.4928 0 22.528-10.0352 22.528-22.528s-10.0352-22.528-22.528-22.528H365.568c-12.4928 0-22.528 10.0352-22.528 22.528s10.0352 22.528 22.528 22.528zM365.568 435.2h210.8416c12.4928 0 22.528-10.0352 22.528-22.528s-10.0352-22.528-22.528-22.528H365.568c-12.4928 0-22.528 10.0352-22.528 22.528s10.0352 22.528 22.528 22.528z" fill="" ></path></symbol><symbol id="icon-tijiao" viewBox="0 0 1024 1024"><path d="M731.7504 903.2704H200.704c-67.584 0-122.5728-54.9888-122.5728-122.5728V249.7536c0-67.584 54.9888-122.5728 122.5728-122.5728h318.5664c22.528 0 40.8576 18.3296 40.8576 40.8576S541.7984 208.896 519.2704 208.896H200.704c-22.528 0-40.8576 18.3296-40.8576 40.8576v530.944c0 22.528 18.3296 40.8576 40.8576 40.8576h530.944c22.528 0 40.8576-18.3296 40.8576-40.8576V535.6544c0-22.528 18.3296-40.8576 40.8576-40.8576s40.8576 18.3296 40.8576 40.8576v245.0432c0 67.584-54.8864 122.5728-122.4704 122.5728z m0 0" fill="" ></path><path d="M907.0592 203.0592c-21.9136-21.9136-57.4464-21.9136-79.2576 0L511.1808 519.5776 373.4528 381.8496c-21.9136-21.9136-57.4464-21.9136-79.2576 0-21.9136 21.9136-21.9136 57.4464 0 79.2576l177.4592 177.4592c21.9136 21.9136 57.4464 21.9136 79.2576 0l0.1024-0.1024 0.1024-0.1024 355.9424-355.9424c21.9136-22.016 21.9136-57.4464 0-79.36z" fill="" ></path></symbol><symbol id="icon-xiugai" viewBox="0 0 1024 1024"><path d="M752.2304 903.2704H221.184c-67.584 0-122.5728-54.9888-122.5728-122.5728V249.7536c0-67.584 54.9888-122.5728 122.5728-122.5728h318.5664c22.528 0 40.8576 18.3296 40.8576 40.8576S562.2784 208.896 539.7504 208.896H221.184c-22.528 0-40.8576 18.3296-40.8576 40.8576v530.944c0 22.528 18.3296 40.8576 40.8576 40.8576h530.944c22.528 0 40.8576-18.3296 40.8576-40.8576V535.6544c0-22.528 18.3296-40.8576 40.8576-40.8576s40.8576 18.3296 40.8576 40.8576v245.0432c0 67.584-54.8864 122.5728-122.4704 122.5728z m0 0" fill="" ></path><path d="M507.1872 619.2128l38.1952-14.4384-115.5072-115.5072-14.4384 38.1952v0.1024L373.9648 636.928c-7.9872 20.992 2.7648 31.744 23.7568 23.7568l42.9056-16.1792 5.12-1.9456 61.44-23.3472zM458.752 460.3904l299.9296-299.9296 115.5072 115.5072-299.9296 299.9296L458.752 460.3904z m465.6128-350.1056c-31.9488-31.9488-83.6608-31.9488-115.5072 0l-21.2992 21.2992 115.5072 115.5072 21.2992-21.2992c31.8464-31.8464 31.8464-83.5584 0-115.5072z m0 0" fill="" ></path></symbol><symbol id="icon-shanghujiesuan" viewBox="0 0 1024 1024"><path d="M311.1936 913.408c-1.024-0.8192-2.048-2.2528-3.1744-2.4576-86.2208-14.2336-113.8688-80.0768-115.0976-154.5216-0.3072-20.2752 8.704-31.5392 24.2688-31.232 19.5584 0.4096 24.3712 13.5168 25.4976 30.3104 5.4272 84.1728 28.672 105.7792 113.3568 105.7792 111.9232 0 223.744 0.1024 335.6672-0.1024 12.9024 0 26.112 0.1024 38.7072-2.4576 45.056-9.216 67.4816-40.0384 68.096-95.3344 0.9216-80.4864 0.4096-160.9728 0.512-241.5616 0-88.064 0.1024-176.0256 0-264.0896-0.1024-67.7888-43.4176-111.3088-111.0016-111.4112-111.9232-0.2048-223.744-0.2048-335.6672 0-66.048 0.1024-109.568 44.4416-109.568 110.8992-0.1024 118.6816 0 237.4656 0 356.1472 0 30.208-6.4512 41.1648-24.1664 41.7792-18.5344 0.6144-25.7024-11.0592-25.7024-42.1888 0-116.0192 1.536-232.0384-0.512-347.9552-1.4336-81.92 47.3088-151.552 126.0544-167.936 1.8432-0.4096 3.4816-1.9456 5.12-3.072h397.312c6.144 2.56 12.0832 5.7344 18.3296 7.68 62.464 19.7632 107.3152 73.4208 107.9296 138.9568 1.536 177.2544 1.536 354.6112 0 531.968-0.6144 68.3008-35.7376 124.6208-109.3632 137.3184-1.7408 0.3072-3.1744 2.3552-4.7104 3.584-140.6976-0.1024-281.2928-0.1024-421.888-0.1024z" fill="" ></path><path d="M497.5616 647.2704v-42.2912c-26.8288 0-53.0432 0.4096-79.2576-0.1024-19.2512-0.4096-29.9008-10.5472-28.9792-26.8288 0.9216-16.4864 10.5472-24.576 26.5216-24.8832 18.944-0.4096 37.9904-0.1024 61.0304-0.1024-18.2272-28.7744-34.816-54.8864-51.3024-80.9984-5.4272-8.6016-11.3664-16.9984-16.0768-26.112-7.3728-14.1312-4.608-26.9312 9.1136-35.4304 13.824-8.6016 25.3952-2.2528 33.28 9.6256 20.992 31.8464 41.2672 64.1024 61.8496 96.256 2.56 3.8912 5.3248 7.5776 8.8064 12.5952C545.792 492.544 567.808 456.4992 591.872 421.888c5.12-7.4752 17.7152-13.5168 26.7264-13.312 6.656 0.2048 16.4864 10.8544 18.432 18.432 1.9456 7.7824-2.2528 18.5344-6.7584 26.2144-15.9744 26.9312-33.3824 53.0432-50.0736 79.4624-3.584 5.632-6.8608 11.3664-12.1856 20.1728 21.504 0 40.2432 0.3072 58.88-0.1024 17.7152-0.4096 29.2864 6.9632 31.232 24.9856 1.7408 15.7696-11.264 26.7264-31.232 27.0336-25.1904 0.3072-50.2784 0.1024-76.9024 0.1024v42.1888c23.6544 0 47.9232-0.1024 72.192 0 23.4496 0.1024 36.5568 9.728 36.1472 26.4192-0.4096 16.896-12.6976 25.4976-37.0688 25.4976-23.1424 0.1024-46.2848 0-72.8064 0 0 19.6608 0.1024 38.4 0 57.2416-0.2048 21.8112-8.4992 33.1776-24.2688 33.6896-15.9744 0.4096-24.9856-10.6496-25.4976-32.4608-0.4096-18.3296-0.1024-36.6592-0.1024-58.4704-27.8528 0-54.0672 0.3072-80.2816-0.1024-19.2512-0.3072-29.9008-10.24-28.9792-26.624 0.9216-17.7152 11.6736-25.088 28.3648-25.1904 25.8048 0.1024 51.712 0.2048 79.872 0.2048zM515.3792 319.3856c-51.4048-0.512-114.5856-15.4624-175.2064-41.8816-3.072-1.3312-6.2464-2.7648-9.216-4.5056-15.2576-8.8064-21.7088-24.7808-13.9264-37.7856 9.0112-14.848 21.6064-15.7696 37.0688-8.6016 54.3744 25.1904 111.5136 38.8096 171.6224 40.1408 57.7536 1.2288 112.0256-11.264 163.4304-37.5808 20.2752-10.3424 34.304-7.4752 41.5744 7.68 6.8608 14.4384 0.9216 27.4432-18.0224 37.5808-56.832 30.8224-117.8624 45.3632-197.3248 44.9536z" fill="" ></path></symbol><symbol id="icon-quxiao" viewBox="0 0 1024 1024"><path d="M778.8544 924.8768H218.4192C147.1488 924.8768 89.088 866.816 89.088 795.5456V235.008c0-71.2704 58.0608-129.3312 129.3312-129.3312h336.2816c23.8592 0 43.1104 19.3536 43.1104 43.1104 0 23.8592-19.3536 43.1104-43.1104 43.1104H218.4192c-23.7568 0-43.1104 19.3536-43.1104 43.1104v560.5376c0 23.7568 19.3536 43.1104 43.1104 43.1104h560.5376c23.7568 0 43.1104-19.3536 43.1104-43.1104V536.7808c0-23.8592 19.3536-43.1104 43.1104-43.1104 23.7568 0 43.1104 19.3536 43.1104 43.1104v258.6624c-0.1024 71.3728-58.0608 129.4336-129.4336 129.4336z m0 0" fill="" ></path><path d="M574.1568 540.8768l131.7888-131.7888c20.8896-20.8896 20.8896-54.6816 0-75.5712s-54.6816-20.8896-75.5712 0L498.5856 465.3056 366.7968 333.5168c-20.8896-20.8896-54.6816-20.8896-75.5712 0s-20.8896 54.6816 0 75.5712l131.7888 131.7888-131.7888 131.7888c-20.8896 20.8896-20.8896 54.6816 0 75.5712s54.6816 20.8896 75.5712 0L498.5856 616.448l131.7888 131.7888c20.8896 20.8896 54.6816 20.8896 75.5712 0s20.8896-54.6816 0-75.5712L574.1568 540.8768z" fill="" ></path></symbol><symbol id="icon-daochu" viewBox="0 0 1024 1024"><path d="M595.49652087 676.09720864h-157.82290361c-23.16666475 0-41.82870022-18.66203549-41.82870025-41.82870025v-8.20486042c0-23.16666475 18.66203549-41.82870022 41.82870025-41.82870025h157.82290361c23.16666475 0 41.82870022 18.66203549 41.82870024 41.82870025v8.20486042c0 23.00578513-18.66203549 41.82870022-41.82870024 41.82870025zM696.3680403 267.46298319l-154.12267244-188.87266954c-13.19212854-16.24884125-37.96758945-16.24884125-51.3205976 0L336.80209782 267.46298319c-17.69675779 21.7187482-2.25231462 54.05555109 25.74073861 54.05555109h83.81828011v104.73263022c0 19.46643358 15.76620238 35.07175636 35.07175636 35.07175635h70.30439233c19.30555395 0 35.07175636-15.60532277 35.07175637-35.07175635v-104.73263022h83.81828009c27.99305324 0 43.27661678-32.49768251 25.74073861-54.05555109z" fill="" ></path><path d="M859.66085087 919.82982737H173.50928726c-64.99536498 0-115.83332374-42.95485757-115.83332374-97.6539271V320.55325658c0-26.70601631 21.55786858-48.2638849 48.26388489-48.2638849s48.2638849 21.55786858 48.26388489 48.2638849v497.60065329c2.73495346 1.9305554 9.17013812 5.14814772 19.30555396 5.14814771h686.15156361c10.13541583 0 16.57060048-3.21759233 19.30555395-5.14814771V320.55325658c0-26.70601631 21.55786858-48.2638849 48.2638849-48.2638849s48.2638849 21.55786858 48.26388489 48.2638849v501.62264369c0 28.47569207-14.47916546 55.50346763-39.57638562 73.8437439-20.91435011 15.28356354-48.10300529 23.81018322-76.25693812 23.8101832z" fill="" ></path></symbol><symbol id="icon-houtaitixian" viewBox="0 0 1024 1024"><path d="M884.4541952 487.76624355c-0.74565405-1.98841078-1.98841078-3.8525459-3.47971888-5.2195783-0.99420539-1.36703242-2.23696213-2.48551348-3.60399454-3.3554432l-60.3979776-71.33423693-0.24855135-0.24855134c-5.59240533-6.2137837-11.68191337-9.32067555-18.01997274-9.32067556-6.46233505 0-14.78880522 3.23116752-19.01417814 10.43915663-4.84675129 5.84095668-7.33226477 12.67611875-7.33226477 19.88410785 0 7.70509179 2.8583405 14.91308089 8.2021945 21.00258892l18.76562677 21.9967943H667.84169529c-14.54025387 0-26.3464429 13.17322145-26.34644291 29.45333476s11.80618903 29.45333475 26.34644291 29.45333475h131.35938749l-19.26272948 22.61817269-0.37282702 0.62137837c-8.07791882 11.93046471-8.07791882 27.46492397 0 39.51966436l0.4971027 0.62137837 0.4971027 0.62137836c5.59240533 6.2137837 11.68191337 9.32067555 18.01997274 9.32067557s14.66452955-3.3554432 19.26272948-10.31488096l61.14363165-72.32844231 6.46233504-7.33226477V510.75724325c0.74565405-1.73985943 1.73985943-4.34964859 1.73985944-7.70509178 0-5.59240533 0-10.68770797-2.73406483-15.28590792zM489.87893002 483.66514631V417.5504877c21.00258892 3.10689185 34.42436172 15.90728628 40.76242109 39.02256167l1.11848107 3.85254588 48.71606424-11.30908633-1.36703242-4.3496486c-13.17322145-41.63235082-43.1236589-65.12045322-89.10565831-70.09148017v-35.0457401h-33.67870767v35.17001577c-25.84934021 2.8583405-46.23055075 11.30908635-60.27370193 24.97941049-14.91308089 14.54025387-22.49389701 32.93305363-22.49389701 54.80557227 0 15.41018358 3.60399455 28.95623205 10.81198364 40.51386974s15.65873493 19.51128083 24.85513483 23.61237808c8.45074583 3.60399455 23.86092942 8.69929718 47.10048047 15.41018358v57.5396371c-13.04894578-2.73406483-22.12106998-11.80618903-27.46492397-27.71347531l-1.24275675-3.47971888-46.23055075 9.81777826 1.36703242 4.34964858c10.43915662 33.92725902 35.17001577 54.05991822 73.57119905 60.02515058v27.58919964h33.554432v-27.71347532c52.94143715-7.45654045 79.78498275-33.30588065 79.78498275-76.6780909 0-17.15004302-5.34385398-32.18739958-16.03156195-44.61496698-10.31488095-12.05474038-31.19319419-21.74824297-63.7534208-29.57761044z m29.95043745 81.0277395c0 8.94784853-2.98261618 15.65873493-9.19639989 20.1326592-5.59240533 4.10109725-12.55184308 6.46233505-20.62976189 7.20798909v-53.81136687c10.81198365 1.86413511 29.82616178 7.2079891 29.82616178 26.47071858z m-96.68647444-115.07927419c0-9.69350258 3.3554432-17.2743187 10.43915662-23.23955105 6.2137837-5.34385398 13.67032415-8.32647017 22.6181727-9.07212422h0.12427567v62.26211272c-22.36962133-5.09530263-33.18160498-14.91308089-33.18160499-29.95043745z" fill="" ></path><path d="M752.10060231 663.86487372c-16.15583763-12.80039443-39.64394003-9.94205392-52.32005879 6.2137837-26.22216723 33.18160498-60.27370192 60.27370192-98.42633387 78.29367467-39.89249138 18.88990245-82.76759893 27.58919965-127.13401457 25.84934021-73.07409635-2.8583405-140.55578738-33.92725902-190.14178133-87.49007455-49.58599395-53.56281552-75.43533417-123.28146868-72.57699366-196.23128937 2.8583405-72.94982068 33.92725902-140.55578738 87.49007454-190.14178133 53.56281552-49.58599395 123.28146868-75.43533417 196.23128937-72.57699366 81.77339355 3.10689185 157.2087277 42.25372918 206.91899733 107.3741824 12.55184308 16.40438898 35.91566981 19.51128083 52.32005879 6.95943776 16.40438898-12.55184308 19.51128083-35.91566981 6.95943775-52.3200588-63.2563181-82.76759893-159.19713849-132.60214423-263.34015337-136.70324147-92.95820421-3.60399455-181.56675982 29.20478341-249.79410488 92.33682583-68.22734507 63.13204243-107.74700942 149.00653322-111.35100397 241.96473742-3.60399455 92.83392853 29.20478341 181.56675982 92.33682583 249.79410489 63.13204243 68.22734507 149.13080889 107.74700942 241.96473742 111.35100397 4.47392427 0.12427568 8.82357285 0.24855135 13.29749713 0.24855136 51.32585339 0 102.40315543-11.43336202 148.50943052-33.18160498 48.46751289-22.86672403 91.71544747-57.29108575 125.02132812-99.54481494 13.04894578-16.03156195 10.19060528-39.39538868-5.96523236-52.19578311z" fill="" ></path></symbol><symbol id="icon-shuaxin" viewBox="0 0 1024 1024"><path d="M269.77562767 276.41191186c62.59222574-67.11696494 149.46721854-105.12477428 242.22437233-105.12477429 73.30077519 0 142.68010973 23.37781925 200.89842089 67.72026349 56.25759083 42.83419783 98.18684082 103.61652788 117.79404406 171.03514209 5.73133634 19.75802788 23.83029316 32.5781223 43.4374964 32.57812231 4.22308994 0 8.44617986-0.60329857 12.6692698-1.80989569 23.98111781-6.93793346 37.70616007-32.12564838 30.76822661-56.10676619-25.03689029-85.97004496-78.27798832-163.1922608-149.91969246-217.79078058-74.05489838-56.40841547-162.43813761-86.12086961-255.6477653-86.12086961-65.75954317 0-128.80424281 14.6299901-187.1733786 43.73914567-44.19161961 21.86957285-84.76344785 51.88367627-119.0006412 87.9307653l-77.0713912-77.0713912L101.75697839 400.38976618l265.14971765-26.84678597-97.13106837-97.13106835zM751.66035343 732.50562412c-24.58441638 25.64018885-53.24109803 47.35893705-84.6126232 63.94964747-47.35893705 25.18771492-101.052509 38.46028327-155.04773023 38.46028328-72.84830127 0-142.07681116-23.22699461-199.99347303-66.96614029-56.10676619-42.38172394-98.03601619-102.71158004-118.09569335-169.82854497-7.08875809-23.98111781-32.27647302-37.55533545-56.25759085-30.46657734-23.98111781 7.08875809-37.55533545 32.42729765-30.46657733 56.25759083 25.4893642 85.3667464 78.73046224 162.13648832 150.0705171 215.98088491 73.7532491 55.80511692 161.83483904 85.3667464 254.59199281 85.36674641 68.77603598 0 137.09959803-16.89235971 197.5802788-49.01800809 39.21440646-20.81380035 75.11067087-47.96223561 106.18054677-79.93705936l75.11067087 75.11067086 26.84678597-265.14971764-264.99889301 26.9976106 99.09178868 99.24261333z" fill="" ></path></symbol><symbol id="icon-shibai" viewBox="0 0 1024 1024"><path d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m247.048707 707.326259l-35.213061 35.56136-206.193197-177.632653-181.115646 184.807619-71.57551-71.43619L455.54068 512 261.22449 344.990476l71.61034-71.157551L515.482993 459.755102l204.76517-178.607891L762.77551 316.325442l-193.863401 197.485714z" fill="#E53932" ></path></symbol><symbol id="icon-chenggong" viewBox="0 0 1024 1024"><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m305.834667-670.037333a27.306667 27.306667 0 0 0-38.570667-0.170667L463.701333 680.96 285.354667 501.930667a27.221333 27.221333 0 1 0-38.570667 38.4l197.802667 198.997333a27.306667 27.306667 0 0 0 38.570666 0L817.834667 392.533333a27.0848 27.0848 0 0 0 0-38.570666z" fill="#1BD08A" ></path></symbol><symbol id="icon-erweima" viewBox="0 0 1024 1024"><path d="M192 96h179.2c51.2 0 96 44.8 96 96v179.2c0 51.2-44.8 96-96 96H192c-51.2 0-96-44.8-96-96V192c0-57.6 38.4-96 96-96z m0 64c-19.2 0-32 12.8-32 32v179.2c0 12.8 12.8 32 32 32h179.2c12.8 0 32-19.2 32-32V192c0-19.2-12.8-32-32-32H192zM192 556.8h179.2c51.2 0 96 44.8 96 96V832c0 51.2-44.8 96-96 96H192c-51.2 0-96-44.8-96-96v-179.2c0-51.2 38.4-96 96-96z m0 64c-19.2 0-32 12.8-32 32V832c0 19.2 12.8 32 32 32h179.2c19.2 0 32-12.8 32-32v-179.2c0-19.2-12.8-32-32-32H192zM588.8 556.8H896c19.2 0 32 12.8 32 32s-12.8 32-32 32h-307.2c-19.2 0-32-12.8-32-32s12.8-32 32-32zM556.8 896v-166.4c0-19.2 12.8-32 32-32s32 12.8 32 32V896c0 19.2-12.8 32-32 32s-32-12.8-32-32zM697.6 832v-96c0-19.2 12.8-32 32-32s32 12.8 32 32v96c0 19.2-12.8 32-32 32s-32-19.2-32-32zM838.4 864v-134.4c0-19.2 12.8-32 32-32s32 12.8 32 32V864c0 19.2-12.8 32-32 32s-32-12.8-32-32zM652.8 160c-19.2 0-32 12.8-32 32v179.2c0 19.2 12.8 32 32 32H832c19.2 0 32-12.8 32-32V192c0-19.2-12.8-32-32-32h-179.2z m0-64H832c51.2 0 96 44.8 96 96v179.2c0 51.2-44.8 96-96 96h-179.2c-51.2 0-96-44.8-96-96V192c0-57.6 44.8-96 96-96z" fill="" ></path></symbol><symbol id="icon-dizhi" viewBox="0 0 1024 1024"><path d="M512.002558 608.259344c-105.96438 0-192.141088-86.173638-192.141088-192.132902 0-105.96438 86.175685-192.141088 192.141088-192.141088 105.960287 0 192.134949 86.176708 192.134949 192.141088C704.137507 522.086729 617.962845 608.259344 512.002558 608.259344L512.002558 608.259344zM512.002558 288.032042c-70.647013 0-128.095423 57.44841-128.095423 128.095423 0 70.640873 57.44841 128.089283 128.095423 128.089283 70.640873 0 128.089283-57.44841 128.089283-128.089283C640.091842 345.480452 582.643432 288.032042 512.002558 288.032042L512.002558 288.032042zM512.002558 960.517153c-7.945973 0-15.920598-2.946099-22.096251-8.839319-12.778024-12.230556-13.262048-32.504298-1.061169-45.281299 86.591147-90.782609 311.3624-355.838358 311.3624-490.270093 0-158.898986-129.278365-288.210098-288.206004-288.210098-158.898986 0-288.210098 129.310088-288.210098 288.210098 0 75.6694 72.595388 206.224852 204.40439 367.68722 11.209296 13.739932 9.157567 33.911344-4.548596 45.056172-13.706163 11.175527-33.911344 9.155521-45.057195-4.549619C233.36856 646.466528 159.746796 509.117346 159.746796 416.127466c0-194.22147 158.033269-352.254739 352.254739-352.254739 194.217377 0 352.250646 158.034293 352.250646 352.254739 0 187.491185-315.6521 520.403391-329.070714 534.461571C528.873808 957.185268 520.455067 960.517153 512.002558 960.517153L512.002558 960.517153zM512.002558 960.517153"  ></path></symbol><symbol id="icon-dianhua" viewBox="0 0 1024 1024"><path d="M368.68085 828.082912l0 1.184989c-6.487761 0-11.257391 0.517793-14.039761 0.517793l-3.290953 0c-69.213361 0-124.926244-55.570643-126.875642-124.994806-1.052982-34.084283 11.192923-67.069535 34.44551-91.836615 23.248494-24.76708 54.691623-39.288818 88.593757-40.253796 0.314155 0 3.742231-0.188288 4.02978-0.188288 26.580379 0 52.034097 8.353248 73.945129 24.385387 30.736025 10.890025 61.786205-4.345981 92.134397-45.206598 30.196743-40.567951 36.558637-72.719208 18.872836-95.594195-6.29845-4.569062-12.341073-9.961886-18.358113-16.386202-1.052982-1.022283-2.043542-2.155083-2.971681-3.307326-19.86135-22.518876-31.244608-51.012837-32.145118-80.375585-1.918699-70.439282 53.349045-129.292692 123.165134-131.278929 0.324388 0 3.584642-0.068562 3.90903-0.068562 58.753125 0 110.687962 41.820478 123.480312 99.457176 10.334369 31.989575 36.684504 158.781306-90.127693 329.09732C526.135952 811.024397 412.240949 828.082912 368.68085 828.082912L368.68085 828.082912 368.68085 828.082912zM364.592742 763.737418c18.960841 0.418532 118.522394-2.248204 227.490178-148.992359 111.300922-149.498896 85.968977-254.348895 79.731926-273.874601-7.100722-31.287587-32.779567-51.981908-61.84965-51.981908-36.684504 1.031493-64.062038 30.264281-63.134923 65.24498 0.577145 18.567891 9.302877 32.088836 16.533558 40.123836 0.220011 0.255827 0.477884 0.550539 0.671289 0.801249 4.02978 4.365424 7.803733 7.677866 11.55108 10.114358 2.362814 1.577938 4.569062 3.443425 6.42534 5.597485 19.6045 22.194488 57.56302 84.159772-13.275351 179.309852-45.766346 61.514006-92.654236 74.396407-123.930567 74.432223-16.093537 0-32.077579-3.312442-47.50085-9.768481-2.65241-1.121544-5.176906-2.605338-7.447623-4.402263-7.965415-6.294356-21.078061-13.814634-38.413891-13.814634-18.964934 0.550539-34.540677 7.546883-46.022173 19.788695-11.513218 12.300141-17.588587 28.398794-17.074887 45.293579 0.953721 34.536584 28.618804 61.488423 62.934355 61.488423 0.162706 0 0.199545 0.026606 0.068562 0.063445 1.184989-0.198521 2.488681-0.355087 3.26537-0.418532C358.031303 762.710019 361.390817 762.967892 364.592742 763.737418L364.592742 763.737418 364.592742 763.737418zM511.609097 961.619254c-60.182684 0-118.553093-11.786441-173.501566-35.017538-16.282848-6.90834-23.917736-25.726941-17.042141-42.083467 6.843872-16.376992 25.611308-23.990391 41.893132-17.147542 47.046502 19.882839 97.067756 30.002314 148.69253 30.002314 211.628932 0 383.788943-172.919305 383.788943-385.480468 0-212.56014-172.160012-385.480468-383.788943-385.480468-211.633025 0-383.798153 172.920328-383.798153 385.480468 0 72.66702 20.24509 143.425573 58.526975 204.689892 9.369392 15.035438 4.863774 34.859949-10.072403 44.267203-14.971993 9.44307-34.703383 4.915963-44.10552-10.119475-44.744064-71.541383-68.347644-154.132426-68.347644-238.842737 0-247.955278 200.858634-449.720561 447.75479-449.720561 246.912529 0 447.766047 201.734584 447.766047 449.720561C959.37412 759.853971 758.521626 961.619254 511.609097 961.619254L511.609097 961.619254 511.609097 961.619254zM511.609097 961.619254"  ></path></symbol><symbol id="icon-youxiang" viewBox="0 0 1024 1024"><path d="M901.564483 201.260793 122.329093 201.260793c-31.013341 0-56.20714 25.614377-56.20714 57.143465l0 513.5104c0 31.527041 25.193799 57.146535 56.20714 57.146535l779.236414 0c31.013341 0 56.313563-25.619494 56.313563-57.146535L957.87907 258.511705C957.878047 226.986711 932.577824 201.260793 901.564483 201.260793zM898.429073 769.272481 125.570927 769.272481 125.570927 261.050528l772.857123 0L898.42805 769.272481zM490.585271 634.419144c0.068562 0.061398 0.145309 0.119727 0.214894 0.180102 10.707876 11.771091 27.288506 14.133905 37.148062 5.244444L823.146483 372.373962c9.914814-8.93858 12.590759-29.179576 1.889023-41.12156-10.701736-11.94096-30.728862-11.060917-40.643676-2.122337L512.032746 575.763233 240.618173 332.74336c-9.927093-9.927093-31.615045-11.460006-42.322921 0.452301-10.707876 11.912307-7.390317 31.751145 3.545756 42.687218L490.585271 634.419144z"  ></path></symbol><symbol id="icon-lianxiren" viewBox="0 0 1024 1024"><path d="M620.744191 538.879184c82.736353-40.523949 140.308583-124.785028 140.308583-222.936465 0-137.367601-111.714338-249.080915-249.02668-249.080915-137.367601 0-249.080915 111.713314-249.080915 249.080915 0 98.151437 57.57223 182.412516 140.363841 222.936465C235.330238 586.429153 111.796714 740.736565 111.796714 923.694503c0 18.464537 15.032368 33.443693 33.496905 33.443693 18.464537 0 33.497928-14.979156 33.497928-33.443693 0-183.774537 149.46001-333.343017 333.234547-333.343017 183.77556 0 333.234547 149.568481 333.234547 333.343017 0 18.464537 14.978133 33.443693 33.443693 33.443693 18.519796 0 33.496905-14.979156 33.496905-33.443693C912.20124 740.736565 788.668739 586.429153 620.744191 538.879184zM329.886801 315.942719c0-100.438527 81.70179-182.194552 182.140317-182.194552 100.384291 0 182.086082 81.756025 182.086082 182.194552 0 100.384291-81.702813 182.086082-182.086082 182.086082C411.587568 498.0288 329.886801 416.32701 329.886801 315.942719z"  ></path></symbol><symbol id="icon-idcad" viewBox="0 0 1024 1024"><path d="M846.994122 894.601908 175.445336 894.601908c-61.812811 0-111.923092-50.457182-111.923092-112.718201l0-507.201717c0-62.259996 50.110281-112.717178 111.923092-112.717178L846.994122 161.964812c61.824067 0 111.923092 50.457182 111.923092 112.717178l0 507.201717C958.917214 844.144726 908.818189 894.601908 846.994122 894.601908zM902.955668 274.680966c0-31.140231-25.058722-56.358589-55.961546-56.358589L175.445336 218.322377c-30.900777 0-55.961546 25.218358-55.961546 56.358589l0 507.201717c0 31.119765 25.059745 56.358589 55.961546 56.358589L846.994122 838.241272c30.901801 0 55.961546-25.238824 55.961546-56.358589L902.955668 274.680966zM791.033599 528.307408 679.110507 528.307408c-30.900777 0-55.972802-25.282826-55.972802-56.409754L623.137705 359.199918c0-31.120788 25.072025-56.358589 55.972802-56.358589l111.923092 0c30.901801 0 55.961546 25.238824 55.961546 56.358589l0 112.697735C846.994122 503.024581 821.9354 528.307408 791.033599 528.307408zM791.033599 387.359258c0-15.540951-12.539594-28.160363-27.981285-28.160363l-55.961546 0c-15.441691 0-27.981285 12.619412-27.981285 28.160363l0 56.359612c0 15.579837 12.539594 28.178783 27.981285 28.178783l55.961546 0c15.441691 0 27.981285-12.598946 27.981285-28.178783L791.033599 387.359258zM539.194874 753.703901 203.426621 753.703901c-15.46011 0-27.981285-12.598946-27.981285-28.160363s12.521175-28.177759 27.981285-28.177759l335.768253 0c15.451924 0 27.980261 12.616342 27.980261 28.177759S554.646797 753.703901 539.194874 753.703901zM539.194874 641.025609 203.426621 641.025609c-15.46011 0-27.981285-12.638855-27.981285-28.178783 0-15.579837 12.521175-28.177759 27.981285-28.177759l335.768253 0c15.451924 0 27.980261 12.598946 27.980261 28.177759C567.175135 628.386754 554.646797 641.025609 539.194874 641.025609z"  ></path></symbol><symbol id="icon-hangye" viewBox="0 0 1109 1024"><path d="M775.209929 25.615459H306.096508a52.36339 52.36339 0 0 0-52.120718 52.471244v136.328168H85.426072a70.80652 70.80652 0 0 0-70.50992 70.914375v639.388811c0 39.097279 31.628351 70.914375 70.50992 70.914375h910.454292a70.779557 70.779557 0 0 0 70.482957-70.914375V285.329246c0-39.097279-31.628351-70.914375-70.482957-70.914375h-168.549718V78.086703A52.36339 52.36339 0 0 0 775.209929 25.615459zM303.939417 76.06443h473.454566v138.350441H303.939417V76.06443zM1016.426658 924.718057a20.519331 20.519331 0 0 1-20.546294 20.465404H85.426072a20.519331 20.519331 0 0 1-20.546294-20.465404V607.38297h189.096012v39.151206c0 13.913239 11.189911 25.237968 24.968332 25.237968 13.77842 0 24.995295-11.324729 24.995295-25.237968v-39.151206h473.454566v37.425533c0 13.913239 11.189911 25.211004 24.968332 25.211004a25.103149 25.103149 0 0 0 24.968331-25.211004v-37.425533h189.096012v317.335087z m-20.546294-659.881178c11.324729 0 20.546294 9.194601 20.546294 20.492367v271.631716h-189.096012v-37.425533a25.130113 25.130113 0 0 0-24.968331-25.237968 25.130113 25.130113 0 0 0-24.968332 25.237968v37.425533H303.939417v-35.645933a25.130113 25.130113 0 0 0-24.995295-25.211004 25.103149 25.103149 0 0 0-24.968332 25.211004v35.645933H64.879778V285.329246c0-11.297765 9.221565-20.492367 20.546294-20.492367h910.454292z"  ></path></symbol><symbol id="icon-zhipiao" viewBox="0 0 1024 1024"><path d="M958.464 392.704v-194.56c-1.024-43.008-35.328-77.312-78.336-78.848H139.776c-42.496 1.536-76.8 36.352-77.824 78.848v197.12c63.488 1.536 114.176 52.736 115.712 115.712 1.536 65.024-50.176 119.296-115.2 120.832h-0.512v197.12c1.024 43.008 35.328 77.312 78.336 78.848h739.328c43.008-1.536 77.312-35.84 78.336-78.848v-197.12c-65.536-4.096-115.2-60.416-111.104-125.952 3.584-59.904 51.2-107.52 111.104-111.104v-2.048z m-415.232 83.968c-6.144 5.12-13.824 7.68-22.016 7.168H400.384v75.264h99.84c8.704 0 16.896 3.072 23.04 9.216 4.608 5.632 7.168 12.288 6.144 19.456 0.512 7.168-2.048 14.336-6.656 19.456-6.656 5.12-14.848 7.68-23.04 6.656H400.384v110.08c0.512 10.24-2.048 20.992-6.144 30.208-5.632 5.632-13.312 8.192-20.992 7.168-7.68 1.024-15.36-1.536-20.992-7.168-4.096-9.216-6.656-19.456-6.144-29.696v-110.592H264.704c-8.704 0.512-16.896-2.048-23.04-7.68-4.608-5.632-6.656-12.8-6.144-19.456-0.512-7.168 1.536-14.336 6.144-19.456 6.144-5.632 14.336-8.704 22.528-8.192h80.896V483.84H244.224c-8.192 0.512-16.896-2.048-23.04-7.168-4.608-5.632-6.656-12.8-6.144-19.456-0.512-6.656 1.536-13.312 5.632-18.944 6.144-6.144 14.848-9.728 23.552-9.216h55.296L226.816 304.128c-4.096-7.168-6.656-15.36-6.144-23.552 0.512-7.168 4.096-13.312 10.24-16.896 5.632-3.584 12.8-5.632 19.456-5.12 8.192 1.536 15.36 7.168 18.432 14.848l87.04 156.672H409.6l84.48-152.064c2.56-5.12 6.656-9.728 10.752-13.312 4.096-3.072 8.192-5.12 13.312-6.144 3.584-1.024 7.168-1.024 10.24 0 3.072 0.512 5.632 1.536 8.192 3.072 6.144 3.584 9.728 10.24 10.24 17.408-0.512 8.704-3.072 16.896-7.168 24.064L468.48 430.592h52.224c8.192 0 16.384 3.072 22.528 9.216 4.608 5.632 7.168 12.288 6.144 19.456 0.512 7.168-1.536 13.824-6.144 18.944v-1.536z m131.584 410.624h-36.864v-35.328h36.864v35.328z m0-72.704h-36.864v-36.864h36.864v36.864z m0-72.704h-36.864v-36.864h36.864v36.864z m0-73.728h-36.864v-36.864h36.864v36.864z m0-74.24h-36.864v-34.304h36.864v34.304z m0-72.704h-36.864v-37.376h36.864v37.376z m0-72.192h-36.864v-35.84h36.864v35.84z m0-74.24h-36.864v-36.352h36.864v36.352z m0-72.192h-36.864V266.24h36.864v36.352z m0-74.752h-36.864v-36.352h36.864v36.352z m0-72.192h-36.864v-36.352h36.864v36.352z" fill="#5272E9" ></path><path d="M209.408 232.96h373.248v542.72H209.408z" fill="#5272E9" ></path><path d="M425.472 764.416v-46.08c39.936-1.536 72.192-12.8 97.28-33.792s37.376-47.616 37.376-78.848c0-14.336-3.072-27.648-9.216-39.936-6.144-12.288-14.336-23.04-25.6-31.744-11.264-8.704-25.6-16.384-43.008-23.04-9.216-3.072-28.16-7.68-56.832-13.312V365.568c18.432 3.072 33.28 9.216 43.52 18.944 10.752 9.728 17.408 23.04 20.992 40.96l58.88-7.168c-5.12-28.672-19.968-51.712-44.544-68.096-19.456-12.8-45.568-20.992-78.336-23.04v-22.016h-33.28v22.016c-37.888 3.072-66.048 11.264-84.992 24.576-28.672 19.968-43.008 46.592-43.008 78.848 0 18.432 5.12 34.304 14.848 48.64s23.552 25.6 41.984 33.792c24.576 10.752 48.128 18.432 71.68 22.016v144.896c-22.528-2.048-41.472-10.752-57.344-27.136-11.264-11.264-18.944-29.696-23.552-53.76l-57.344 8.704c2.048 23.552 9.728 43.52 22.528 59.904 12.8 16.384 28.16 28.16 46.08 35.84 17.92 7.168 40.96 12.288 69.12 15.36v45.568h32.768zM392.192 491.52c-25.6-6.144-44.032-14.848-54.784-25.088-10.752-10.24-16.384-23.552-16.384-38.912 0-15.872 6.144-29.184 18.944-40.96 12.8-11.264 30.208-18.432 52.224-21.504V491.52z m33.28 50.176c30.72 8.192 50.688 16.896 60.928 27.136s15.36 23.552 15.36 39.936c0 19.456-7.168 35.84-21.504 48.64-14.336 13.312-32.768 20.992-54.784 23.04v-138.752z" fill="#FFFFFF" ></path></symbol><symbol id="icon-availablebalance" viewBox="0 0 1397 1024"><path d="M691.43025141 505.78854089m-566.17423942 0a566.17423943 566.17423943 0 1 0 1132.34847888 0 566.17423943 566.17423943 0 1 0-1132.34847888 0Z" fill="#5272E9" ></path><path d="M779.61360458 200.54829202l61.92530745-149.12625058s-41.70479886 30.33076281-63.18908925 30.33076279c-21.48429035 0-56.8701803-30.33076281-56.87018027-30.33076279s-36.64967175 30.33076281-61.92530749 30.33076279c-25.2756357 0-60.66152565-30.33076281-60.66152563-30.33076279v3.79134534l64.45287098 145.33490524h116.26792421zM659.55433502 216.97745522h121.32305132v45.49614423H659.55433502v-45.49614423zM971.70843585 589.79308165c-42.96858067-165.55541377-190.83104943-310.89031898-190.83104951-310.89031899H659.55433502s-144.07112342 140.27977808-188.30348585 312.15410077c-45.49614425 170.61054089 65.71665275 295.72493756 248.96501152 295.72493755s294.4611558-131.43330559 251.49257516-296.98871933z m-170.61054094 60.66152564c-2.52756357 60.66152565-60.66152565 73.29934352-60.66152566 73.2993435v32.85832643h-27.80319924v-29.06698105s-69.50799818-1.26378178-72.03556175-30.33076282c-2.52756357-30.33076281 6.31890891-30.33076281 6.31890895-30.33076285s2.52756357 6.31890891 39.17723533 18.9567268c6.31890891 1.26378178 29.06698105 5.05512717 41.70479886 0 24.0118539-10.11025427 35.38588997-35.38588997 3.79134536-56.87018033-61.92530742-27.80319925-72.03556175-42.96858067-72.03556174-42.9685807s-27.80319925-36.64967175-10.11025425-74.56312527c18.95672674-37.91345351 59.39774385-39.17723532 59.39774388-39.17723533l2.52756356-31.5945446h29.06698104v31.5945446c31.5945446 1.26378178 44.23236245 16.42916319 44.23236243 16.42916322 7.5826907 36.64967175-6.31890891 35.38588997-6.3189089 35.38588993s-53.07883495-31.5945446-79.61825238-7.58269069c-25.2756357 35.38588997 25.2756357 53.07883495 37.91345349 56.87018033 13.90159965 5.05512717 66.9804346 25.2756357 64.45287102 77.09068883z" fill="#FFFFFF" ></path></symbol><symbol id="icon-withdrawamount" viewBox="0 0 1024 1024"><path d="M510.976 62.976c-247.296 0-448 200.704-448 448s200.704 448 448 448 448-200.704 448-448-200.704-448-448-448z m37.888 678.4v72.192H486.912v-69.632c-42.496-5.12-90.624-24.576-123.392-54.272l40.448-61.952c34.304 26.624 67.584 42.496 102.912 42.496 43.52 0 63.488-19.456 63.488-54.784 0-83.968-189.44-76.8-189.44-206.848 0-68.096 40.448-114.688 105.984-127.488V208.896h61.952v71.168c45.056 6.144 76.8 28.672 103.424 56.832l-46.08 52.224c-25.6-23.552-48.128-36.864-79.872-36.864-36.864 0-57.344 17.408-57.344 51.712 0 77.312 189.44 65.536 189.44 205.312 0 68.096-37.888 118.272-109.568 132.096z" fill="#F96269" ></path></symbol><symbol id="icon-bankaccount" viewBox="0 0 1024 1024"><path d="M102.912 349.184V243.712c0-29.184 23.552-52.736 52.736-52.736h738.304c29.184 0 52.736 23.552 52.736 52.736v105.472H102.912z m843.776 52.736v421.888c0 29.184-23.552 52.736-52.736 52.736H155.648c-29.184 0-52.736-23.552-52.736-52.736V401.92h843.776zM551.424 665.6H604.16c14.336 0 26.112-11.776 26.112-26.112s-11.776-26.112-26.112-26.112h-52.736c-14.336 0-26.112 11.776-26.112 26.112-0.512 14.336 11.264 26.112 26.112 26.112z m-369.152 105.472h210.944c14.336 0 26.112-11.776 26.112-26.112s-11.776-26.112-26.112-26.112H182.272c-14.336 0-26.112 11.776-26.112 26.112-0.512 14.336 11.264 26.112 26.112 26.112z m0-105.472h263.68c14.336 0 26.112-11.776 26.112-26.112s-11.776-26.112-26.112-26.112H182.272c-14.336 0-26.112 11.776-26.112 26.112-0.512 14.336 11.264 26.112 26.112 26.112z" fill="#F49902" ></path></symbol><symbol id="icon-bank" viewBox="0 0 1024 1024"><path d="M992.25813333 642.52586667c-4.36906667 12.56106667-15.29173333 21.2992-27.8528 21.2992h-126.15679999V921.6c0 18.56853333-13.65333333 33.31413333-30.03733333 33.31413333h-573.44000001c-16.384 0-30.03733333-14.7456-30.03733333-33.31413333v-257.77493333H63.83146667c-12.56106667 0-23.48373333-8.192-27.8528-21.2992-4.36906667-12.01493333-2.18453333-26.2144 6.00746667-35.49866667l164.93226666-192.23893333V182.13546667c0-18.56853333 13.65333333-33.31413333 30.03733333-33.31413334h106.496c16.384 0 30.03733333 14.7456 30.03733334 33.31413334v37.6832l120.14933334-140.9024c5.46133333-6.5536 13.65333333-9.8304 21.84533332-9.8304s16.384 3.82293333 21.84533334 9.8304l449.46773333 528.11093333c7.64586667 9.28426667 9.8304 23.48373333 5.46133333 35.49866667z m-373.00906666-165.4784c16.384 0 30.03733333-13.65333333 30.03733333-30.03733334s-13.65333333-30.03733333-30.03733333-30.03733333h-68.26666667v-28.39893333c0-16.384-13.65333333-30.03733333-30.03733333-30.03733334s-30.03733333 13.65333333-30.03733334 30.03733334v28.39893333h-14.7456c-52.4288 0-94.48106667 42.5984-94.48106666 94.48106667 0 52.4288 42.5984 94.48106667 94.48106666 94.48106666h14.7456V675.84H411.7184c-16.384 0-30.03733333 13.65333333-30.03733333 30.03733333s13.65333333 30.03733333 30.03733333 30.03733334h79.18933333v28.39893333c0 16.384 13.65333333 30.03733333 30.03733334 30.03733333s30.03733333-13.65333333 30.03733333-30.03733333V735.91466667h14.19946667c52.4288 0 94.48106667-42.5984 94.48106666-94.48106667 0-52.4288-42.5984-94.48106667-94.48106666-94.48106667h-14.19946667V477.04746667h68.26666667z m-19.11466667 163.84c0 19.11466667-15.29173333 34.4064-34.4064 34.4064h-14.7456v-69.35893334h14.7456c19.11466667 0.54613333 34.4064 15.83786667 34.4064 34.95253334z m-158.37866667-128.88746667c0-19.11466667 15.29173333-34.4064 34.4064-34.4064h14.7456v69.35893333h-14.7456c-19.11466667-0.54613333-34.4064-15.83786667-34.4064-34.95253333z" fill="#F59901" ></path></symbol><symbol id="icon-lock" viewBox="0 0 1024 1024"><path d="M768 383.296l-62.976 0L705.024 285.76C705.024 163.52 604.16 64 480.32 64c-123.84 0-224.64 99.52-224.64 221.76l0 97.536L192 383.296c-70.656 0-128 57.344-128 128l0 320c0 70.656 57.344 128 128 128l576 0c70.656 0 128-57.344 128-128l0-320C896 440.64 838.656 383.296 768 383.296zM319.872 285.76c0-87.296 72-158.4 160.448-158.4 88.512 0 160.512 71.04 160.512 158.4l0 97.536L319.872 383.296 319.872 285.76zM832 831.296c0 35.392-28.608 64-64 64L192 895.296c-35.392 0-64-28.608-64-64l0-320c0-35.392 28.608-64 64-64l576 0c35.392 0 64 28.608 64 64L832 831.296zM480 511.296c-52.992 0-96 28.608-96 64 0 27.84 26.816 51.264 64 60.096l0 99.904c0 17.664 14.336 32 32 32s32-14.336 32-32L512 635.392c37.184-8.832 64-32.256 64-60.096C576 539.968 532.992 511.296 480 511.296z"  ></path></symbol><symbol id="icon-dollar" viewBox="0 0 1024 1024"><path d="M597.333333 42.666667c-123.733333 0-232.533333 59.733333-302.933333 149.333333 23.466667-8.533333 49.066667-12.8 72.533333-17.066667C428.8 119.466667 507.733333 85.333333 597.333333 85.333333c187.733333 0 341.333333 153.6 341.333333 341.333333 0 89.6-34.133333 168.533333-89.6 230.4-4.266667 25.6-8.533333 49.066667-17.066667 72.533333 91.733333-70.4 149.333333-179.2 149.333333-302.933333C981.333333 215.466667 808.533333 42.666667 597.333333 42.666667zM488.533333 595.2c-6.4-6.4-14.933333-10.666667-25.6-14.933333-8.533333-4.266667-17.066667-6.4-25.6-8.533333l0-70.4c12.8 0 17.066667 2.133333 23.466667 8.533333 6.4 6.4 8.533333 14.933333 8.533333 25.6l36.266667 0c0-10.666667-2.133333-21.333333-6.4-29.866667-4.266667-8.533333-8.533333-14.933333-14.933333-21.333333-6.4-6.4-14.933333-8.533333-23.466667-12.8C454.4 471.466667 448 469.333333 437.333333 469.333333l0-21.333333-19.2 0 0 21.333333c-10.666667 0-17.066667 2.133333-25.6 4.266667-8.533333 2.133333-17.066667 6.4-23.466667 12.8-6.4 6.4-12.8 12.8-17.066667 21.333333-4.266667 8.533333-6.4 17.066667-6.4 27.733333 0 12.8 2.133333 23.466667 6.4 32 4.266667 8.533333 10.666667 14.933333 17.066667 21.333333 6.4 6.4 14.933333 10.666667 23.466667 12.8 8.533333 4.266667 14.933333 6.4 23.466667 8.533333l0 81.066667c-14.933333 0-23.466667-4.266667-29.866667-12.8-6.4-8.533333-10.666667-21.333333-8.533333-34.133333L341.333333 644.266667c0 12.8 2.133333 23.466667 6.4 34.133333 4.266667 10.666667 8.533333 17.066667 17.066667 25.6 6.4 6.4 14.933333 12.8 25.6 14.933333 10.666667 4.266667 17.066667 6.4 29.866667 6.4L420.266667 746.666667l19.2 0 0-23.466667c10.666667 0 19.2-2.133333 27.733333-6.4 8.533333-4.266667 17.066667-8.533333 25.6-14.933333 6.4-6.4 12.8-14.933333 17.066667-23.466667 4.266667-8.533333 6.4-21.333333 6.4-32 0-12.8-2.133333-23.466667-6.4-29.866667C501.333333 608 494.933333 601.6 488.533333 595.2zM418.133333 567.466667c-4.266667-2.133333-6.4-2.133333-10.666667-4.266667-4.266667-2.133333-8.533333-4.266667-12.8-6.4-4.266667-2.133333-6.4-6.4-8.533333-10.666667C384 544 384 539.733333 384 533.333333c0-12.8 4.266667-21.333333 10.666667-25.6 6.4-4.266667 12.8-8.533333 25.6-8.533333L420.266667 567.466667zM462.933333 682.666667c-8.533333 6.4-14.933333 10.666667-25.6 10.666667l0-78.933333c4.266667 2.133333 6.4 2.133333 12.8 4.266667 4.266667 2.133333 8.533333 4.266667 12.8 6.4 4.266667 2.133333 6.4 6.4 8.533333 10.666667 2.133333 4.266667 4.266667 8.533333 4.266667 14.933333C475.733333 665.6 471.466667 676.266667 462.933333 682.666667zM426.666667 213.333333c-211.2 0-384 172.8-384 384 0 211.2 172.8 384 384 384 211.2 0 384-172.8 384-384C810.666667 386.133333 637.866667 213.333333 426.666667 213.333333zM426.666667 938.666667c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333c187.733333 0 341.333333 153.6 341.333333 341.333333S614.4 938.666667 426.666667 938.666667z"  ></path></symbol><symbol id="icon-personinfo" viewBox="0 0 1329 1024"><path d="M1204.14781 14.461937l-1079.600005 0C55.826239 14.461937 0 74.185236 0 147.772046l0 729.786552c0 73.586811 55.708256 133.305244 124.547806 133.305244L1204.14781 1010.863842c68.721567 0 124.547806-59.718434 124.547806-133.305244l0-729.786552C1328.695616 74.185236 1272.869377 14.461937 1204.14781 14.461937L1204.14781 14.461937 1204.14781 14.461937 1204.14781 14.461937zM1272.137158 877.558598c0 31.135127-25.542529 73.462747-56.919702 73.462747L113.725071 951.021345c-31.50002 0-56.924567-42.328836-56.924567-73.462747L56.800504 147.647983c0-31.139992 25.542529-71.396235 56.924567-71.396235l1101.493601 0c31.50002 0 56.919702 40.256243 56.919702 71.396235L1272.138374 877.558598 1272.137158 877.558598 1272.137158 877.558598 1272.137158 877.558598zM1078.017584 293.605293l-225.01752 0c-12.529219 0-22.743798 9.364378-22.743798 21.043395l0 17.270399c0 11.679017 10.214579 21.043395 22.743798 21.043395l225.01752 0c12.647201 0 22.743798-9.364378 22.743798-21.043395l0-17.270399C1100.761382 302.969671 1090.546803 293.605293 1078.017584 293.605293L1078.017584 293.605293 1078.017584 293.605293 1078.017584 293.605293zM1078.017584 484.082015l-225.01752 0c-12.529219 0-22.743798 9.364378-22.743798 21.037314l0 15.085904c0 11.674152 10.214579 21.043395 22.743798 21.043395l225.01752 0c12.647201 0 22.743798-9.369243 22.743798-21.043395l0-15.085904C1100.761382 493.446393 1090.546803 484.082015 1078.017584 484.082015L1078.017584 484.082015 1078.017584 484.082015 1078.017584 484.082015zM1078.017584 671.877989l-225.01752 0c-12.529219 0-22.743798 9.488441-22.743798 21.043395l0 13.74553c0 11.674152 10.214579 21.03853 22.743798 21.03853l225.01752 0c12.647201 0 22.743798-9.364378 22.743798-21.03853l0-13.74553C1100.761382 681.36643 1090.546803 671.877989 1078.017584 671.877989L1078.017584 671.877989 1078.017584 671.877989 1078.017584 671.877989zM434.589108 324.745285c56.558458 0 102.536227 45.971688 102.536227 102.530145 0 27.366996-13.627548 55.224165-37.463593 76.509606-20.06913 18.002618-28.217197 45.853705-20.43524 71.638281 7.781957 25.666593 29.557572 44.519412 56.074366 48.168345 2.308558 0.36611 29.799618 5.10729 55.218083 18.002618 11.797 5.957491 20.919332 12.647201 26.392731 19.214064 4.865244 5.839509 5.839509 10.338643 5.839509 15.32795l0 26.75884L246.302961 702.895134l0-26.634777c0-5.112155 0-18.733621 31.990193-34.788925 25.300483-12.771265 52.543415-17.270399 54.851974-17.636508 26.75884-3.524869 48.534455-22.259706 56.558458-48.044281 8.030085-25.784575-0.117982-53.88379-20.311176-71.886408-23.836045-21.285441-37.463593-49.136529-37.463593-76.503524C332.052881 370.841036 378.03065 324.745285 434.589108 324.745285M432.522596 271.345587c-89.038825 0-161.161197 72.128454-161.161197 161.161197 0 47.802235 23.718063 90.739227 56.800504 120.296799 0 0-137.325152 19.336911-137.325152 113.47816l0 60.696348c0 13.863512 11.194926 25.053572 25.058438 25.053572l433.248733 0c13.869593 0 25.058438-11.188844 25.058438-25.053572l0-60.696348c0-93.166984-137.325152-113.47816-137.325152-113.47816 33.088522-29.557572 56.806585-72.494563 56.806585-120.296799C593.683792 343.474041 521.555339 271.345587 432.522596 271.345587L432.522596 271.345587 432.522596 271.345587 432.522596 271.345587 432.522596 271.345587zM432.522596 271.345587"  ></path></symbol><symbol id="icon-cash" viewBox="0 0 1024 1024"><path d="M632.99112 466.299145c25.160029 0 45.700855 20.458961 45.700855 45.700855 0 15.35164 12.389168 27.768437 27.714202 27.768437 15.378246 0 27.821649-12.416797 27.821649-27.768437 0-55.753815-45.429679-101.211123-101.237729-101.211123l-93.087095 0 0-40.782845c0-15.325034-12.390191-27.741831-27.714202-27.741831-15.379269 0-27.76946 12.417821-27.76946 27.741831L484.41934 410.788877l-93.087095 0c-55.863309 0-101.183494 45.347814-101.183494 101.211123l0 11.004635c0 55.781444 45.321208 101.2101 101.183494 101.2101l93.087095 0 0 111.019513-93.087095 0c-25.160029 0-45.700855-20.458961-45.700855-45.700855 0-15.35164-12.444427-27.740808-27.768437-27.740808-15.32401 0-27.714202 12.389168-27.714202 27.740808 0 55.781444 45.321208 101.238752 101.183494 101.238752l93.087095 0 0 33.799804c0 15.35164 12.390191 27.76946 27.76946 27.76946 15.32401 0 27.714202-12.417821 27.714202-27.76946l0-33.799804 93.087095 0c55.753815 0 101.237729-45.375443 101.237729-101.238752l0-19.698644c0-55.753815-45.429679-101.184517-101.237729-101.184517l-93.087095 0L539.903002 466.299145 632.99112 466.299145zM484.420363 568.650231l-93.087095 0c-25.160029 0-45.700855-20.48659-45.700855-45.728484l0-11.004635c0-25.160029 20.487613-45.728484 45.700855-45.728484l93.087095 0L484.420363 568.650231zM632.99112 624.133893c25.160029 0 45.700855 20.48659 45.700855 45.700855l0 19.698644c0 25.160029-20.487613 45.700855-45.700855 45.700855l-93.087095 0 0-111.100354L632.99112 624.133893z"  ></path><path d="M900.62253 610.005105c0.10847-186.717565-136.614447-341.563236-315.39832-369.81979l77.81732-79.094406c33.854039-34.452673 8.911974-94.228081-39.777959-94.228081L403.288554 66.862827c-48.689932 0-75.860758 59.775408-42.059931 94.228081l77.924767 79.094406c-178.892343 28.256554-315.561026 183.103248-315.561026 369.81979l0 37.712927c0 0.461511-0.216941 0.842181-0.216941 1.303692L123.375423 875.789447c0 44.858674 36.46347 81.34875 81.349773 81.34875l614.494349 0c44.886303 0 81.34875-36.490076 81.34875-81.34875L900.568295 741.565443l0.055259 0L900.623553 610.005105zM403.234319 124.573203l217.85575 0L518.819824 228.555439c-2.119267 2.254344-4.837168 2.716878-6.630001 2.716878-1.848091 0-4.455475-0.462534-6.684236-2.716878L403.234319 124.573203zM845.031421 875.789447c0 14.210653-11.57564 25.75764-25.812899 25.75764L204.725196 901.547087c-14.237259 0-25.811876-11.546987-25.811876-25.75764L178.913321 741.565443l0.216941 0L179.130262 610.005105c0-43.092447 8.368598-84.826967 25.050536-124.115785 16.031115-37.984103 39.017642-72.083735 68.307735-101.401458 29.344329-29.290093 63.416332-52.27662 101.401458-68.333318 39.288818-16.655332 81.023338-25.051559 124.116809-25.051559l28.256554 0c43.147706 0 84.881203 8.396227 124.171044 25.051559 37.929868 16.056698 72.057129 39.043225 101.347223 68.333318 29.344329 29.316699 52.330856 63.417355 68.360947 101.401458 16.57449 39.098483 24.888853 80.616062 24.997324 123.491569 0.272199 11.683087 0.326435 24.290219-0.216941 39.044248 0 0.216941 0.10847 0.38067 0.10847 0.597611L845.031421 875.789447z"  ></path></symbol><symbol id="icon-firm" viewBox="0 0 1024 1024"><path d="M32 928v-64h64v-640a128 128 0 0 1 128-128h320a128 128 0 0 1 128 128v192h128a128 128 0 0 1 128 128v320h64v64H32z m576-704a64 64 0 0 0-64-64h-320a64 64 0 0 0-64 64v640h448v-640z m256 320a64 64 0 0 0-64-64h-128v384h192v-320z m-640 0h256v64h-256v-64z m0-128h256v64h-256v-64z m0-128h256v64h-256v-64z"  ></path></symbol><symbol id="icon-wallet" viewBox="0 0 1024 1024"><path d="M900.89 67.56H123.11A111.23 111.23 0 0 0 12 178.67v666.66a111.22 111.22 0 0 0 111.11 111.11h777.78A111.22 111.22 0 0 0 1012 845.33V178.67A111.23 111.23 0 0 0 900.89 67.56z m55.56 527.78H512a55.62 55.62 0 0 1-55.56-55.56v-55.56A55.62 55.62 0 0 1 512 428.67h444.44zM512 373.11a111.23 111.23 0 0 0-111.11 111.11v55.56A111.23 111.23 0 0 0 512 650.89h444.44v194.44a55.63 55.63 0 0 1-55.56 55.56H123.11a55.63 55.63 0 0 1-55.56-55.56V178.67a55.62 55.62 0 0 1 55.56-55.56h777.78a55.62 55.62 0 0 1 55.56 55.56v194.44z"  ></path><path d="M539.78 512m-55.56 0a55.56 55.56 0 1 0 111.12 0 55.56 55.56 0 1 0-111.12 0Z"  ></path></symbol><symbol id="icon-daochu2" viewBox="0 0 1025 1024"><path d="M831.999095 961.537463l-639.994116 0c-105.879408 0-192.004989-87.454919-192.004989-194.967602L-1.0e-05 376.625446c0-35.923864 28.629387-64.991248 64.00678-64.991248 35.370229 0 63.993476 29.067384 63.993476 64.991248l0 389.945438c0 35.795945 28.688742 64.985107 64.004733 64.985107l639.994116 0c35.313944 0 64.00064-29.189163 64.00064-64.985107L895.999734 376.625446c0-35.923864 28.627341-64.991248 63.993476-64.991248 35.382509 0 64.00678 29.067384 64.00678 64.991248l0 389.945438C1024.001014 874.082544 937.872363 961.537463 831.999095 961.537463z"  ></path><path d="M534.623306 74.650698c-12.43172-12.633321-32.812864-12.633321-45.245607 0l-210.747741 214.011221c-12.432743 12.626158-8.249267 22.972279 9.375981 22.972279l63.995523 0c17.628318 0 32.007483 14.60021 32.007483 32.492554l0 129.985565c0 17.897461 14.368932 32.4946 31.99725 32.4946l191.990662 0c17.630365 0 32.007483-14.59714 32.007483-32.4946L640.00434 344.126752c0-17.892344 14.369955-32.492554 32.00032-32.492554l63.990406 0c17.629342 0 21.822028-10.346122 9.374958-22.972279L534.623306 74.650698z"  ></path><path d="M640.00434 604.093789c0 17.895414-14.31367 32.492554-32.007483 32.492554-17.685626 0-31.996226-14.59714-31.996226-32.492554 0-18.026403 14.309577-32.496647 31.996226-32.496647C625.690669 571.597142 640.00434 586.067386 640.00434 604.093789z"  ></path><path d="M448.000374 604.093789c0 17.895414-14.308554 32.492554-31.995203 32.492554-17.687673 0-31.99725-14.59714-31.99725-32.492554 0-18.026403 14.308554-32.496647 31.99725-32.496647C433.69182 571.597142 448.000374 586.067386 448.000374 604.093789z"  ></path><path d="M416.005171 571.597142l191.990662 0 0 64.989201-191.990662 0 0-64.989201Z"  ></path></symbol><symbol id="icon-jiaoyiguanli" viewBox="0 0 1155 1024"><path d="M404.222939 104.239521a32.781207 32.781207 0 0 1 30.7766-34.667895h281.588209a32.781207 32.781207 0 0 1 34.667895 34.667895v69.453708h69.453708V104.239521A106.715799 106.715799 0 0 0 716.587748 0.117918H439.008752a106.715799 106.715799 0 0 0-104.121603 104.121603v69.453708h69.453708z m104.121603 520.018425h138.907416a34.785813 34.785813 0 1 0 0-69.453708H508.344542a34.785813 34.785813 0 1 0 0 69.453708z"  ></path><path d="M1053.597421 208.243206H101.999079A104.475357 104.475357 0 0 0 0 310.242285v611.758636a104.475357 104.475357 0 0 0 101.999079 101.999079h951.598342A104.475357 104.475357 0 0 0 1155.596499 922.000921V310.242285a104.475357 104.475357 0 0 0-101.999078-101.999079z m33.960386 713.757715a32.191617 32.191617 0 0 1-30.18701 34.078305h-955.135882a32.191617 32.191617 0 0 1-34.078305-34.078305V480.162137h1019.519115v441.838784z m0-509.877476H67.920774v-101.88116a32.191617 32.191617 0 0 1 30.18701-34.078305h955.135883a32.191617 32.191617 0 0 1 34.078304 34.078305v101.999078z"  ></path></symbol><symbol id="icon-tonguo" viewBox="0 0 1024 1024"><path d="M512 960C264.6 960 64 759.4 64 512S264.6 64 512 64s448 200.6 448 448-200.6 448-448 448z m0-842.2c-217.7 0-394.2 176.5-394.2 394.2S294.3 906.2 512 906.2 906.2 729.7 906.2 512 729.7 117.8 512 117.8zM297 529.9l35.8-31.9 134.4 139.4 241.9-250.9 53.8 35.8-304.7 286.8L297 529.9z" fill="#ffffff" ></path></symbol><symbol id="icon-shenhe1" viewBox="0 0 1024 1024"><path d="M528.53134766 659.75732422a24.21650391 24.21650391 0 0 0 9.10722656 1.77539062c6.19453125 0 12.38818359-2.34667969 17.10703125-7.08925781l399.25195312-399.25195312c9.46054688-9.46054688 9.46054688-24.75263672 0-34.2140625-9.46142578-9.46054688-24.75439453-9.46054688-34.21582031 0L537.63945312 603.12148438 312.77480469 378.25859375c-9.46054688-9.46142578-24.75351562-9.46142578-34.2140625 0-9.46142578 9.46054688-9.46142578 24.75351562 0 34.2140625L520.53066406 654.44433594a24.14003906 24.14003906 0 0 0 8.0006836 5.31386718z m331.31513671 298.93974609H191.23349609C126.21552734 958.69707031 62.40869141 899.196875 62.40869141 838.53476562V169.94638672C62.40869141 106.21074219 129.02275391 63.40625 191.23349609 63.40625H788.31933594c13.35673828 0 24.19716797 10.84042969 24.19716797 24.19716797s-10.84042969 24.19628906-24.19628907 24.19628906H191.23261719c-37.96523438 0-80.43134766 24.87568359-80.43134766 58.14667969v668.58837891c0 34.2140625 42.103125 71.76796875 80.43134766 71.76796875h668.61298828c39.05332031 0 49.45869141-45.10283203 49.45869141-71.76796875v-412.171875c0-13.35761719 10.83955078-24.19804688 24.19628906-24.19804688 13.35761719 0 24.19716797 10.84042969 24.19716797 24.19716797v412.171875c0 70.75283203-40.23896484 120.16318359-97.85214844 120.16318359z" fill="" ></path></symbol><symbol id="icon-beizhu" viewBox="0 0 1024 1024"><path d="M187.5 969.419c-30.376 0-55-22.755-55-50.825V207.055c0-28.069 24.624-50.825 55-50.825h55v-50.824h-55c-60.752 0-110 45.509-110 101.648v711.539c0 56.14 49.249 101.649 110 101.649h110v-50.824h-110zM297.5 181.642c0.01 14.024 12.309 25.39 27.483 25.398 15.187 0.008 27.506-11.363 27.517-25.398V29.169c-0.01-14.022-12.31-25.388-27.483-25.397-15.187-0.009-27.507 11.363-27.517 25.397V181.642zM407.5 105.406h220v50.824h-220zM957.499 462.751c-0.544-6.876-4.106-13.247-9.863-17.637-11.644-8.878-28.871-7.354-38.481 3.406l-0.054 0.103-6.602 7.369L446.11 968.706c-0.225 0.234-0.445 0.472-0.661 0.713-9.002 10.89-7.11 26.404 4.291 35.17 11.589 8.94 28.824 7.504 38.5-3.203l0.109-0.151 28.326-31.815 385.824-433.43 48.786-54.791c3.573-3.997 5.744-8.909 6.214-14.078a23.627 23.627 0 0 0 0-4.37zM902.499 918.594c0 28.07-24.623 50.825-54.999 50.825h-220v50.824h220c60.752 0 109.999-45.51 109.999-101.649V613.647h-55v304.947z" fill="#ffffff" ></path><path d="M764.999 359.527H214.967c-15.188 0.008-27.493 11.392-27.483 25.427 0.009 14.035 12.328 25.406 27.518 25.397H765c15.177-0.009 27.476-11.375 27.484-25.397 0.009-14.035-12.296-25.418-27.485-25.427zM412.285 664.474H215.001c-15.189 0-27.501 11.377-27.501 25.41 0 14.035 12.312 25.414 27.501 25.414h197.284c15.188 0 27.5-11.379 27.5-25.414 0-14.033-12.312-25.41-27.5-25.41zM600.001 512h-385c-15.189 0-27.501 11.378-27.501 25.412s12.312 25.412 27.501 25.412h385c15.188 0 27.499-11.378 27.499-25.412S615.188 512 600.001 512zM682.5 181.642c0 14.035 12.312 25.413 27.501 25.413 15.185 0 27.499-11.378 27.499-25.413V29.169c0-14.034-12.314-25.412-27.499-25.412-15.189 0-27.501 11.377-27.501 25.412V181.642zM847.5 156.23c30.376 0 54.999 22.755 54.999 50.825v101.648h55V207.055c0-56.139-49.247-101.648-109.999-101.648h-55.001v50.824H847.5z" fill="#ffffff" ></path></symbol><symbol id="icon-hamburger" viewBox="0 0 1138 1024"><path d="M980.75000009 465.12499991L137.00000009 465.12499991C111.12499982 465.12499991 90.125 486.12499973 90.125 512 90.125 537.92187537 111.12499982 558.87500009 137.00000009 558.87500009L980.75000009 558.87500009C1006.62500037 558.87500009 1027.62500019 537.92187537 1027.62500019 512 1027.62500019 486.12499973 1006.62500037 465.12499991 980.75000009 465.12499991L980.75000009 465.12499991ZM980.75000009 840.12499981L137.00000009 840.12499981C111.12499982 840.12499981 90.125 861.12499963 90.125 886.99999991 90.125 912.92187527 111.12499982 933.875 137.00000009 933.875L980.75000009 933.875C1006.62500037 933.875 1027.62500019 912.92187527 1027.62500019 886.99999991 1027.62500019 861.12499963 1006.62500037 840.12499981 980.75000009 840.12499981L980.75000009 840.12499981ZM137.00000009 183.87500019L980.75000009 183.87500019C1006.62500037 183.87500019 1027.62500019 162.92187463 1027.62500019 137.00000009 1027.62500019 111.12499982 1006.62500037 90.125 980.75000009 90.125L137.00000009 90.125C111.12499982 90.125 90.125 111.12499982 90.125 137.00000009 90.125 162.92187463 111.12499982 183.87500019 137.00000009 183.87500019L137.00000009 183.87500019Z"  ></path></symbol><symbol id="icon-arrow_right" viewBox="0 0 1024 1024"><path d="M702.93333337 512a15.93600001 15.93600001 0 0 1-4.672 11.32800001l-307.19999999 307.2a16 16 0 1 1-22.65600003-22.656L664.27733337 512l-295.87199998-295.87200001a16 16 0 0 1 22.65599995-22.65599996l307.20000003 307.19999996a15.93600001 15.93600001 0 0 1 4.672 11.32800001z" fill="#4964CF" ></path></symbol><symbol id="icon-tianjiaxinchengyuan" viewBox="0 0 1024 1024"><path d="M960.28712656 717.08731346h-85.58282645v-86.82225785c0-22.97790586-16.08776272-41.55074029-39.06566978-41.55074151-22.97542277 0-39.06318548 18.57283444-39.06318549 41.55074151v86.82225785h-85.58158613c-22.97790586 0-41.54825721 18.57407719-41.54825721 41.54825721 0 22.97790586 18.57035135 37.82251254 41.54825721 37.82251254h85.58158613v83.0989975c0 22.97542277 16.08776272 41.54825721 39.06318549 41.5482572 22.97790586 0 39.06566978-18.57283444 39.06566978-41.5482572v-83.0989975h85.58282645c22.97542277 0 41.54701566-14.84460669 41.54701567-37.82251254 0-22.97418001-18.5715929-41.54825721-41.54701567-41.54825721z" fill="" ></path><path d="M544.79834681 588.7143141c160.33615781 0 290.84028351-130.46189989 290.84028352-290.84152505S705.13450462 7.03126399 544.79834681 7.03126399c-160.38086671 0-290.84400935 130.46314143-290.84400936 290.84152506 0 96.65201342 47.39643377 182.42485301 120.15524978 235.33787303-191.11577251 64.03312359-327.89901889 232.37838985-327.89901889 429.44293303 0 22.97914861 18.61381749 41.54825721 41.54825721 41.54825721h540.13479291c22.97790586 0 41.55074029-18.5691086 41.55074151-41.54825721 0-22.97542277-18.57283444-41.54825721-41.55074151-41.5482572H131.88281381c23.01888891-186.71939433 199.3943759-332.39102381 412.915533-332.39102381zM340.82130542 296.58989151c0-112.95587018 91.56761403-204.52348419 204.5234842-204.5234842 112.95711171 0 204.52472574 91.56761403 204.52472574 204.5234842s-91.56637249 204.5259685-204.52472574 204.52596728c-112.95462741 0-204.52348419-91.56885678-204.5234842-204.52596728z" fill="" ></path></symbol><symbol id="icon-bohui" viewBox="0 0 1024 1024"><path d="M512 933.875c-237.3046875 0-421.875-184.5703125-421.875-421.875 0-237.3046875 184.5703125-421.875 421.875-421.875 237.3046875 0 421.875 184.5703125 421.875 421.875C933.875 746.66796875 749.3046875 933.875 512 933.875zM512 142.859375c-208.30078125 0-369.140625 160.83984375-369.140625 369.140625s160.83984375 369.140625 369.140625 369.140625 369.140625-160.83984375 369.140625-369.140625S720.30078125 142.859375 512 142.859375z" fill="#ffffff" ></path><path d="M725.57421875 424.98828125c-34.27734375-71.19140625-100.1953125-118.65234375-171.38671875-129.19921875l73.828125-23.73046875-15.8203125-50.09765625-126.5625 39.55078125-26.3671875 7.91015625 50.09765625 150.29296875 50.09765625-15.8203125-18.45703125-60.64453125c58.0078125 7.91015625 113.37890625 44.82421875 142.3828125 102.83203125 44.82421875 92.28515625 5.2734375 205.6640625-87.01171875 250.48828125-60.64453125 31.640625-131.8359375 23.73046875-184.5703125-10.546875-10.546875 10.546875-23.73046875 21.09375-36.9140625 31.640625 68.5546875 50.09765625 160.83984375 60.64453125 242.578125 21.09375C733.484375 683.38671875 783.58203125 541.00390625 725.57421875 424.98828125z" fill="#ffffff" ></path></symbol><symbol id="icon-shanchu" viewBox="0 0 1024 1024"><path d="M122 270.12933781C122 251.68929219 136.99716969 236.83273437 155.61174781 236.83273437L858.89612563 236.83273437C877.35998 236.83273437 892.35714781 251.76395 892.35714781 270.12933781 892.35714781 288.42006781 877.35998 303.27662563 858.89612563 303.27662563L155.61174781 303.27662563C136.99716969 303.27662563 122 288.42006781 122 270.12933781ZM235.10975375 945.02005719C228.93001531 938.82360406 225.38797063 930.23815812 225.38797063 921.65271219L225.38797063 376.81283562 292.38537781 376.81283562 292.38537781 888.3561125 730.49543 888.3561125 730.49543 376.81283562 797.49283437 376.81283562 797.49283437 921.65271219C797.49283437 930.38747094 793.95078781 938.74894906 787.54496562 945.02005719 781.36522437 951.29116531 772.99997 954.8 763.95645219 954.8L258.84899281 954.8C250.03156062 954.8 241.51558063 951.14185344 235.10975375 945.02005719ZM392.54488344 381.50628781L459.46692875 381.50628781 459.46692875 832.87678719 392.54488344 832.87678719 392.54488344 381.50628781ZM560.66329063 381.41608437L627.73606062 381.41608437 627.73606062 832.78658187 560.66329063 832.78658187 560.66329063 381.41608437ZM357.04541937 237.39266L327.58934656 237.39266 327.58934656 125.29659219C327.58934656 116.56183437 331.13139219 107.97638562 337.31113063 101.85459219 343.56623094 95.50883 352.15757563 91.99999438 361.05036875 91.99999438L653.45750562 91.99999438C662.12421219 91.99999438 670.79091781 95.65814 677.04602 101.85459219 683.30112219 107.97638562 686.99388781 116.56183437 686.99388781 125.29659219L686.99388781 237.39266C653.45749437 237.39266 357.04541937 237.39266 357.04541937 237.39266ZM653.38214 270.05468L653.38214 236.90739219 653.38214 270.05468 653.38214 270.05468ZM394.51139281 236.90739219L619.77039406 236.90739219 619.77039406 158.44388 394.51139281 158.44388 394.51139281 236.90739219 394.51139281 236.90739219Z" fill="#ffffff" ></path></symbol><symbol id="icon-shenhe" viewBox="0 0 1024 1024"><path d="M477.08361038 378.59912873c-45.48317514 21.62938294-81.57374588 59.00164536-101.57571799 105.19059347-4.69672366 13.13227579 1.60633026 27.66007782 14.4198696 33.19664667 12.81353933 5.53572592 27.71657363 0.185508 34.08202552-12.23087559 14.92411404-34.49351596 41.86745672-62.4107752 75.80613537-78.59128408a26.36320853 26.36320853 0 0 0 15.74709411-21.81573386 26.38428909 26.38428909 0 0 0-11.57653838-24.27624482 26.4213902 26.4213902 0 0 0-26.88178766-1.49839782v0.02529602h-0.02108057z m270.84075568 161.24687896c-14.58429702 0.01686428-26.40789926 11.82950437-26.4188606 26.40789843-0.14419061 85.53265384-69.49211929 154.84601102-155.09307404 154.98429869-14.5733357 0-26.39778085 11.81011047-26.39778085 26.37670028 0 14.56827649 11.82360142 26.37838613 26.39778085 26.37838614 55.14476604 0.15936822 108.0642799-21.73731536 146.94590232-60.8086604 39.10844778-38.85716848 61.02621112-91.73958124 60.85082153-146.84808911a26.22070459 26.22070459 0 0 0-7.66316409-18.71859458 26.33285248 26.33285248 0 0 0-18.70426071-7.74074047h0.08263559v-0.03119898z m178.90470511 348.23719912L807.09634097 768.44154478a314.47981301 314.47981301 0 0 0 74.54805387-203.72735469c0.17538959-83.92716733-33.22615897-164.43930102-92.77926828-223.62055142-59.22172485-59.4966135-139.78698184-92.8770823-223.77064499-92.71771408a314.73783819 314.73783819 0 0 0-223.76980125 92.66121826c-59.5328725 59.19221256-92.93442105 139.70013081-92.76999361 223.61970849-0.185508 83.93138278 33.22615897 164.44520398 92.76999361 223.62223811 59.23352993 59.50082977 139.79710025 92.88214151 223.76980125 92.71771408a314.86937998 314.86937998 0 0 0 204.71644885-75.10373411l119.72345471 119.64925086c10.44409735 9.60931137 26.60352566 9.25853302 36.62517041-0.7723872 10.01152634-10.04103946 10.3108689-26.20046778 0.66951563-36.60409068v-0.08263559z m-361.7345896-59.84233264c-145.64734634-0.14503354-263.70207285-118.10447644-263.83614422-263.66244213 0.1956264-145.50231281 118.2402345-263.41284869 263.83614422-263.52499659 145.6169903 0.16948663 263.62028101 118.09014175 263.78470844 263.60257297-0.16442743 145.53098218-118.15759891 263.46091279-263.78470844 263.6666576v-0.08179185z m-211.83320819 52.90011997H205.64585626a62.74131674 62.74131674 0 0 1-44.32965271-18.33493057 62.70168521 62.70168521 0 0 1-18.39479974-44.28664948V205.48227176c0.06155502-34.59217209 28.11794485-62.61736377 62.72445245-62.67891797h560.73570749c34.59638837 0.06155502 62.63169846 28.09180508 62.66205368 62.67891797v76.36181562c0 14.57417862 11.81432676 26.38260242 26.3994667 26.38260323 14.5733357 0 26.39778085-11.80758087 26.39778086-26.38260323v-76.41831062c-0.11383457-63.66717005-51.75587302-115.23837799-115.45930124-115.29993383H205.64585626c-63.73378428 0.03119898-115.39774622 51.61168323-115.51073785 115.29993383v613.13495554c0.07167343 63.69246607 51.73479246 115.27210739 115.45930124 115.31342478h147.60445578c14.58429702 0 26.39778085-11.82275848 26.39778085-26.38513285 0-14.56490314-11.81348301-26.37838613-26.39778085-26.37838614h0.06155502v0.03035605h0.00084293z" fill="#ffffff" ></path></symbol><symbol id="icon-dakuan" viewBox="0 0 1024 1024"><path d="M499.64705878 160.08823496z" fill="#ffffff" ></path><path d="M948.47058828 676.99999971c-6.02941201-8.08823496-14.85294082-11.76470596-23.23529385-9.85294073-12.49999981 2.79411768-24.70588242 6.02941201-36.76470644 9.26470547-7.20588252 1.91176435-15.44117607 4.11764677-23.38235244 6.17647061l-9.11764688 2.35294101 3.82352872-8.67647021c35.44117646-79.85294121 44.70588193-169.70588261 26.0294124-252.94117676-19.85294092-92.05882383-74.11764727-178.23529424-148.97058838-236.61764648C664.94117656 129.79411807 576.11764707 98.61764698 486.26470567 98.61764698h-6.4705878c-66.61764668 0-133.08823565 16.91176465-192.20588261 48.82352958-90.58823526 48.23529433-161.76470625 131.61764707-195.00000029 228.52941152C62.44117666 463.47058848 62.44117666 559.35294102 92.58823496 645.6764709c26.32352959 76.91176494 76.91176494 146.3235293 142.50000059 195.44117608 70.44117627 53.08823497 158.8235291 82.50000029 246.32352949 82.50000029 9.41176494 0 18.82352901-0.29411807 28.23529394-1.02941191 75.29411778-4.41176484 148.82352979-30.44117636 212.79411739-75.29411778 4.85294151-3.38235293 7.79411778-8.67647021 8.38235303-14.55882364 0.44117666-5.88235254-1.61764717-11.61764737-5.73529395-15.73529414l-5.00000009-5.00000009c-6.91176445-6.91176445-17.4999999-7.79411778-25.29411768-2.35294102-43.82352949 31.17647021-93.23529433 52.49999971-142.79411778 61.61764746-81.76470557 15.88235273-170.14705839 1.91176435-242.4999999-38.23529414-74.99999971-40.73529375-135.44117666-109.55882373-165.58823496-188.97058828-32.3529416-83.38235273-32.3529416-178.97058809 0-262.3529417 27.94117676-73.6764706 80.73529453-137.35294102 148.38235225-179.11764668C360.97058867 159.64705918 443.47058809 141.11764737 524.49999981 150.23529424c68.97058857 7.05882393 136.61764717 35.44117646 190.58823545 79.70588261 73.52941201 59.26470557 121.61764688 147.35294121 132.05882372 241.3235294 7.05882393 68.23529385-2.64705908 133.6764709-28.38235341 189.26470547l-5.14705869 11.02941211-3.52941153-11.61764737c-2.94117627-9.8529416-5.73529394-20.14705898-8.38235303-29.99999971l-0.14705859-0.73529472c-3.52941152-13.23529453-7.20588252-26.91176484-11.61764737-39.9999999-2.49999961-8.23529443-11.02941211-14.70588223-20.58823476-15.58823467-7.05882393-0.58823526-14.26470557 2.79411768-19.26470654 8.97058741-4.85294151 5.88235254-6.76470586 13.38235312-4.85294063 19.85294179 6.76470586 26.32352959 13.97058838 53.08823497 21.02941143 78.8235293l0.14705859 0.44117665c6.3235292 23.52941191 12.94117646 47.79411768 19.11764707 71.61764679l0.14705947 0.58823524 0.58823526-0.14705859c49.26470625-9.8529416 96.91176445-23.08823526 149.70588222-37.94117695 8.23529443-2.49999961 13.38235312-5.73529394 16.02941133-10.29411738 5.29411729-9.26470547 2.05882383-21.02941143-3.52941152-28.52941201z" fill="#ffffff" ></path><path d="M613.91176455 364.3529416c-2.20588242-8.38235303-8.52941162-15.00000029-16.02941133-16.61764746-8.52941162-3.23529433-17.4999999 0.44117666-28.08823535 11.02941211-11.76470596 11.76470596-23.52941191 23.38235333-35.14705928 35.14705839-11.76470596 11.76470596-23.38235333 23.52941191-35.14705839 35.14705929l-3.676471 3.67647011-75.73529355-75.88235302c-6.76470586-7.20588252-17.94117656-13.82352979-27.5000001-8.82352969l-0.58823526 0.29411807c-7.20588252 2.64705908-12.79411787 9.55882354-14.70588222 17.94117656-1.61764717 7.64705918 0.14705859 14.70588223 4.99999922 19.55882373 14.70588223 15.29411748 29.55882393 30.14705918 44.55882422 45 10.44117685 10.29411738 20.88235283 20.73529424 31.17647021 31.17647021l3.67647099 3.67647099-14.85294169 14.70588224-2.05882295 0.14705859c-7.05882393 0.44117666-14.26470557 0.14705859-21.02941231 0-12.05882315-0.44117666-23.38235333-0.73529385-34.26470596 1.91176435-9.26470547 3.52941152-12.79411787 13.08823506-12.94117646 20.73529424 0 7.79411778 3.52941152 17.35294131 13.52941172 21.1764709 14.70588223 3.52941152 30.44117636 2.94117627 47.05882382 2.49999961 9.41176494-0.29411807 19.11764707-0.58823526 28.67647061 0l5.0000001 0.29411806v47.64705909l-5.1470587 0.14705859c-9.55882354 0.14705859-19.26470567 0.14705859-28.82353007 0-13.38235312-0.14705859-27.05882344-0.29411807-40.44117569 0.44117667-11.3235293 0.88235332-20.88235283 12.20588261-20.14705898 23.5294119 0 5.88235254 2.49999961 11.1764707 7.05882305 15.44117608 4.70588203 4.41176484 11.1764707 7.05882393 16.91176465 6.76470586 12.20588261 0.29411807 24.11764717 0.14705859 36.02941172 0.14705859h34.70588261v5.14705869c0.14705859 9.55882354 0 18.97058847 0 28.52941201-0.14705859 13.08823506-0.14705859 26.17647099 0.29411807 39.11764747 0.29411807 11.02941211 9.8529416 20.88235283 20.88235283 21.61764667 5.73529394 0.73529385 11.76470596-1.3235291 16.47058799-5.29411727 5.0000001-4.26470625 8.23529443-10.29411738 8.52941162-16.3235294 0.44117666-12.94117646 0.29411807-26.02941153 0.29411806-39.11764747 0-9.55882354-0.14705859-18.97058847 0-28.52941201l0.1470586-5.14705869h5.14705869c9.8529416-0.14705859 19.70588232 0 29.55882393 0 11.91176455 0 23.67647051 0.14705859 35.58823505-0.14705859 6.91176445 0.44117666 13.67647031-2.64705908 18.52941182-8.08823496 4.55882344-5.14705869 6.61764727-11.47058789 5.73529395-17.50000078-1.02941191-11.76470596-12.35294122-21.32352949-24.26470577-20.58823477-11.91176455-0.14705859-23.52941191-0.14705859-35.29411786-0.14705859-10.00000019 0-19.85294092 0.14705859-29.85294112 0h-5.14705868v-5.14705958-42.49999951l5.00000009-0.14705859c9.26470547-0.29411807 18.52941182-0.14705859 27.79411728 0 14.85294082 0.29411807 30.14705918 0.58823526 45-1.47058857 10.29411738-2.20588242 15.29411748-11.91176455 16.3235294-19.41176426 1.02941191-7.64705918-1.3235291-17.4999999-10.58823545-22.20588282-10.58823545-4.41176484-22.79411807-3.82352959-35.58823506-3.23529433-7.20588252 0.29411807-14.70588223 0.73529385-21.91176475 0.14705948l-2.20588242-0.14705948-12.20588174-15.44117607 3.23529346-3.23529434c13.38235312-13.97058838 27.20588203-27.64705869 40.88235323-41.32352901 12.05882315-12.05882315 24.26470576-23.97058857 36.02941172-36.32352977 4.85294151-5.0000001 6.61764727-12.35294122 4.55882343-19.99999952z" fill="#ffffff" ></path></symbol><symbol id="icon-stop" viewBox="0 0 1024 1024"><path d="M512 933.23140744C279.36023322 933.23140744 90.76859256 744.63976678 90.76859256 512 90.76859256 279.36023322 279.36023322 90.76859256 512 90.76859256 744.63976678 90.76859256 933.23140744 279.36023322 933.23140744 512 933.23140744 744.63976678 744.63976678 933.23140744 512 933.23140744ZM511.83910166 141.93421054C307.72400595 141.93421054 142.25600723 307.54637433 142.25600723 511.83910166 142.25600723 603.0789835 175.26362259 686.60122251 229.9757583 751.10272452L750.16790638 229.11109088C685.82247586 174.72043051 602.65646414 141.93421054 511.83910166 141.93421054ZM787.09339245 264.99814072L265.92298301 787.97125254C331.25278879 846.29490852 417.40860969 881.74399277 511.83910166 881.74399277 715.95419736 881.74399277 881.4221969 716.13182898 881.4221969 511.83910166 881.4221969 416.98287354 845.74431467 330.47018018 787.09339245 264.99814072Z" fill="#ffffff" ></path></symbol><symbol id="icon-bianji" viewBox="0 0 1024 1024"><path d="M881.140625 406.7v421.790625c0 28.940625-28.603125 53.071875-57.54375 53.071875H194.91875c-28.940625 0-52.396875-23.45625-52.396875-52.396875V200.15c0-28.940625 24.13125-57.0375 53.071875-57.0375h421.875V90.378125H195.59375C137.7125 90.378125 90.125 142.26875 90.125 200.15v628.93125C90.125 886.9625 137.0375 933.875 194.91875 933.875h628.678125c57.88125 0 110.278125-47.5875 110.278125-105.46875V406.7h-52.734375zM330.340625 540.265625l-113.4 229.5c-9.534375 25.81875 11.1375 48.9375 36.95625 36.95625L483.3125 693.321875c9.871875-1.940625 19.490625-5.7375 27.16875-13.415625l407.53125-407.7c20.41875-20.503125 20.41875-53.6625 0-74.08125L825.36875 105.48125c-20.503125-20.503125-53.6625-20.503125-74.08125 0l-407.53125 407.7c-7.678125 7.59375-11.475 17.2125-13.415625 27.084375zM769.765625 161.084375c10.209375-10.209375 26.83125-10.209375 37.040625 0l55.603125 55.603125c10.209375 10.209375 10.209375 26.83125 0 37.040625l-55.603125 55.603125-91.29375-93.99375 54.253125-54.253125zM676.53125 254.403125l93.234375 91.96875-296.325 296.49375-17.8875-17.8875-56.19375-56.278125-18.5625-18.5625L676.53125 254.403125zM427.2875 670.79375L285.621875 756.603125c-12.909375 5.990625-24.46875-6.4125-18.478125-18.478125l85.725-141.75 74.41875 74.41875z" fill="#ffffff" ></path></symbol><symbol id="icon-qiyong" viewBox="0 0 1024 1024"><path d="M681.47433388 161.54136494c67.63097549 33.02169697 126.21273575 86.52319629 164.79096856 150.97900869 5.71529355 9.68424786 11.43058711 20.00352833 16.51084892 30.6403251 3.8101957 7.93790771 11.5893457 12.85941094 20.16228604 12.85941094 3.01640537 0 6.03280987-0.63503261 8.89045664-1.90509785 5.55653584-2.54013047 10.00176416-7.14411739 12.06561973-12.85941094 2.06385644-5.55653584 1.74634013-11.5893457-0.79379033-16.82836523-5.71529355-11.90686201-12.06561973-23.65496543-18.73346309-34.60927852-43.97601006-73.18751133-107.47927354-131.29299668-183.84194707-168.28364795-3.01640537-1.42882383-6.19156846-2.06385644-9.36673154-2.06385556-8.89045664 0-16.98712295 5.23901953-20.47980234 13.33568495-4.92150322 10.7955545-0.15875859 23.49620771 10.79555448 28.73522637zM923.73928349 490.80578575c-12.22437832 0-22.22614248 10.00176416-22.22614159 22.22614248 0 215.43482109-175.26900674 390.70382783-390.70382784 390.70382782S120.10548623 728.46674932 120.10548623 513.19068594C120.10548623 297.59710713 295.37449297 122.32810039 510.80931406 122.32810039c12.22437832 0 22.22614248-10.00176416 22.2261416-22.22614248s-10.00176416-22.22614248-22.2261416-22.22614248C270.76697862 78.03457403 75.65320127 273.14835049 75.65320127 513.19068594c0 239.88357773 195.27253506 435.15611192 435.15611279 435.15611279 239.88357773 0 435.15611192-195.27253506 435.15611192-435.15611279 0-12.38313604-10.00176416-22.3849002-22.22614249-22.3849002zM606.06420927 138.20391583c12.22437832 0 22.22614248-10.00176416 22.22614161-22.22614161s-10.00176416-22.22614248-22.22614161-22.22614248-22.22614248 10.00176416-22.22614247 22.22614248 10.00176416 22.22614248 22.22614247 22.2261416zM885.63732559 417.77703301c0 12.22437832 10.00176416 22.22614248 22.22614248 22.22614248s22.22614248-10.00176416 22.22614248-22.22614249-10.00176416-22.22614248-22.22614248-22.22614247-22.22614248 10.00176416-22.22614249 22.22614247z" fill="#ffffff" ></path><path d="M438.89186797 352.20991396c-9.68424786 0-19.52725342 2.69888906-28.10019375 7.62039141-17.62215557 10.16052188-28.10019375 28.41771006-28.10019463 48.73875469v208.76697773c0 20.32104463 10.47803818 38.57823281 28.10019463 48.73875469 8.73169893 4.92150322 18.41594677 7.62039141 28.10019375 7.62039229 9.84300557 0 19.52725342-2.69888906 28.10019375-7.62039229L647.8176043 561.77068291c17.62215557-10.16052188 28.10019375-28.41771006 28.10019463-48.73875468s-10.47803818-38.57823281-28.10019463-48.73875469l-180.66678399-104.46286817c-8.73169893-4.92150322-18.41594677-7.62039141-28.25895234-7.62039141z m0.15875859 274.33409766c-2.06385644 0-3.8101957-0.79379122-4.7627455-1.27006524-1.42882383-0.79379122-4.60398691-3.01640537-4.60398604-7.93790859V408.56906006c0-4.76274463 2.85764677-6.98535879 4.76274463-8.09666631 0.63503261-0.31751631 2.38137276-1.27006523 4.60398691-1.27006523 1.58758154 0 3.01640537 0.4762749 4.60398604 1.27006523L624.16263886 504.93526191c4.12771201 2.38137276 4.60398691 6.03280987 4.60398692 8.09666631 0 2.38137276-0.79379122 5.71529355-4.60398692 7.93790772l-180.66678398 104.30411044c-1.42882383 0.95254893-2.85764677 1.27006523-4.44522832 1.27006524z" fill="#ffffff" ></path></symbol><symbol id="icon-dianpushenhe" viewBox="0 0 1024 1024"><path d="M932.00000029 835.39999971H91.99999971v-69.77999971c0-27.96000029 27.72-50.69999971 61.92-50.69999971h113.82000029c68.22-7.62000029 120.89999971-42.12 120.89999971-100.08 0-57.17999971-33.84-93.6-33.84-93.6C293.90000029 478.99999971 260 416.6 260 346.04 259.88000029 218.66000029 356.59999971 115.39999971 512 115.39999971s252 103.25999971 252 230.64000029c0 70.56-34.02 132.90000029-94.79999971 175.20000029 0 0-34.62000029 36.72-34.62000029 93.6 0 57.96 52.74 92.45999971 120.89999971 100.08h114.60000058c34.2 0 61.92 22.74000029 61.92 50.69999971v69.77999971z m-60.42000058 60.00000029H152.42000029c-0.24000029 0-0.42000029 0.18-0.42000029 0.47999971v59.52000058h720v-59.52000058c0-0.29999971-0.18-0.47999971-0.42000029-0.47999971z" fill="#ffffff" ></path></symbol><symbol id="icon-dailishangshenhe" viewBox="0 0 1091 1024"><path d="M204.532637 269.813751h427.780679v69.068756h-427.780679zM204.532637 422.879025h288.083551v69.068756H204.532637zM204.532637 597.333333h176.682333v69.068756H204.532637z" fill="#ffffff" ></path><path d="M710.071366 0H125.660574C56.369017 0 0 56.369017 0 125.660574v772.678852c0 69.51436 56.369017 125.660574 125.660574 125.660574h361.162751v-66.840731H125.660574c-32.529156 0-58.819843-26.290688-58.819843-58.819843V117.416884C66.840731 89.56658 89.56658 66.840731 117.416884 66.840731h592.654482c32.529156 0 58.819843 26.290688 58.819844 58.819843v232.605745h66.840731V125.660574c0-69.291558-56.369017-125.660574-125.660575-125.660574z" fill="#ffffff" ></path><path d="M610.255875 906.360313h432.905135c14.036554-1.336815 12.699739 2.896432 12.699738-12.699739v-35.202785c0-19.606614-4.233246-23.839861-23.83986-23.83986h-84.219321c-11.140122-8.466493-12.699739-19.606614-15.373369-22.503046-49.239339-54.809399-21.166232-91.348999 9.803308-141.925153 5.570061-7.129678 11.140122-14.036554 15.373368-22.503046 12.699739-22.503046 19.606614-47.679721 19.606614-75.975631 0-87.115753-70.182768-158.858138-158.858137-158.858137-87.115753 0-158.858138 70.182768-158.858138 158.858137 0 36.5396 12.699739 70.182768 33.643168 96.91906 33.643168 53.472585 88.452567 96.91906 0 165.765013h-84.442123c-15.373368 0-23.839861 8.466493-23.839861 23.839861v36.5396c0 14.482158 9.803307 11.585727 25.399478 11.585726z m469.444734 24.062664H561.016536c-7.129678 0-12.699739 5.570061-12.699739 12.699738v12.699739c0 7.129678 5.570061 12.699739 12.699739 12.699739h517.124456c7.129678 0 12.699739-5.570061 12.699739-12.699739v-12.699739c0-7.129678-5.570061-12.699739-11.140122-12.699738z m0 0" fill="#ffffff" ></path></symbol><symbol id="icon-dailishang" viewBox="0 0 1024 1024"><path d="M912.8 521.864l-19.296 19.296 14.448 14.448a29.9184 29.9184 0 0 1 6.5808 9.912c26.8176 35.232 25.5936 85.032-6.5808 117.2112-16.5408 16.5408-37.7232 24.6144-59.2032 25.1904-0.9744 21.6288-9.0384 43.0464-25.5456 59.5632-16.5408 16.5408-37.728 24.6096-59.2032 25.1904-0.9744 21.6288-9.0384 43.0512-25.5504 59.5632-16.5408 16.5408-37.7184 24.6096-59.1984 25.1952-0.984 21.624-9.0384 43.0464-25.5504 59.5536-32.1744 32.1792-81.9744 33.4032-117.2112 6.5856a29.808 29.808 0 0 1-9.912-6.5856l-15.384-15.3792-13.8 13.8048a30.0672 30.0672 0 0 1-9.912 6.5808c-35.2368 26.8176-85.0368 25.5936-117.2208-6.5808-16.5072-16.5168-24.5712-37.9344-25.5456-59.5632-21.48-0.5808-42.6624-8.6544-59.2032-25.1904-16.5168-16.5168-24.5712-37.9344-25.5456-59.5632-21.4848-0.5808-42.6624-8.6544-59.2032-25.1952-16.5168-16.5072-24.5712-37.9344-25.5456-59.5536-21.4848-0.5808-42.6624-8.6544-59.2032-25.1952-32.1792-32.1744-33.3984-81.984-6.5856-117.2112a29.9568 29.9568 0 0 1 6.5856-9.912l13.6944-13.6944-15.8592-15.864-0.0192 0.0192-2.6304-2.6304C5.888 416.5472 5.888 245.792 111.2 140.48 216.512 35.1632 387.2624 35.1632 492.5792 140.4848L512 159.9056l19.4304-19.4208c105.312-105.3168 276.0672-105.3168 381.3792 0 105.3072 105.3168 105.3072 276.0672-0.0096 381.3792z m-301.4784 372.744a29.9616 29.9616 0 0 0 0-42.3744l-18.816-18.816c-1.488 2.3664-2.0736 5.0832-3.7872 7.3344a30.0144 30.0144 0 0 1-6.5808 9.912l-28.5744 28.5648 15.384 15.3792a29.9616 29.9616 0 0 0 42.3744 0z m-198.6912-1.5696a29.9712 29.9712 0 0 0 42.3744 0l84.7536-84.7488a29.9712 29.9712 0 0 0-42.3744-42.3792l-84.7536 84.7536a29.9712 29.9712 0 0 0 0 42.3744z m-84.7536-84.7488a29.9712 29.9712 0 0 0 42.3744 0l84.7488-84.7536a29.9616 29.9616 0 1 0-42.3744-42.3744l-84.7488 84.7488a29.976 29.976 0 0 0 0 42.3792z m-84.7488-84.7584a29.9616 29.9616 0 0 0 42.3744 0l84.7488-84.7488a29.9616 29.9616 0 1 0-42.3744-42.3744l-84.7488 84.7488a29.9616 29.9616 0 0 0 0 42.3744z m-84.7488-84.7488a29.9616 29.9616 0 0 0 42.3744 0l84.7488-84.7488a29.9616 29.9616 0 1 0-42.3744-42.3744l-84.7488 84.7488a29.9616 29.9616 0 0 0 0 42.3744zM870.4256 182.864c-81.912-81.9168-214.7184-81.9168-296.6256 0l-19.4304 19.4208 0.8304 0.8256-42.3744 42.3744L450.2 182.864c-81.912-81.9168-214.7184-81.9168-296.6304 0-81.912 81.912-81.912 214.7184 0 296.6256l0.7776 0.7872c0.0192 0.0192 0.048 0.0048 0.0672 0.024l17.6688 17.6592 28.6752-28.6752a29.9184 29.9184 0 0 1 9.912-6.5808c35.2368-26.8176 85.032-25.6032 117.2112 6.5808 16.5408 16.5408 24.6096 37.7184 25.1904 59.2032 21.6288 0.9744 43.0512 9.0384 59.5632 25.5456 16.5408 16.5408 24.6144 37.728 25.1952 59.2032 21.624 0.9744 43.0464 9.0384 59.5632 25.5456 16.5408 16.5408 24.6048 37.7232 25.1904 59.2032 21.6288 0.9744 43.0464 9.0384 59.5632 25.5456 10.1712 10.1712 16.1568 22.3248 20.232 34.9968l51.3312 51.3264a29.9616 29.9616 0 1 0 42.3744-42.3744l-84.7488-84.7488a29.9616 29.9616 0 1 1 42.3744-42.3744l84.7488 84.7488a29.9664 29.9664 0 0 0 42.3792-42.3744l-84.7536-84.7488a29.9616 29.9616 0 1 1 42.3744-42.3744l84.7584 84.7488a29.9616 29.9616 0 1 0 42.3744-42.3744l-14.3184-14.3184-0.0096 0.0096-104.0016-104.0016c-0.0528-0.0576-0.2208 0.0432-0.2784-0.0096l-58.2288-58.2288h1.176l-50.2128-50.2128-50.2224 50.2128h0.072l-51.7728 51.7776c-46.8096 46.8048-122.6976 46.8048-169.5072 0-46.8048-46.8096-46.8048-122.6976 0-169.5072l100.5408-100.5408 42.3744 42.3744-100.5504 100.5456c-23.4 23.4096-23.4 61.3488 0 84.7584 23.4096 23.4 61.3488 23.4 84.7584 0l36.7776-36.7824c0.0336-0.0336 0.0192-0.0912 0.0528-0.1248l83.1264-83.1264c0.9696-1.3728 0.6096-3.216 1.8384-4.4496a29.9664 29.9664 0 0 1 42.3792 0l169.4976 169.5024c0.4128 0.4128 0.4416 0.984 0.6192 1.4976l21.432 21.432 19.296-19.296c81.9072-81.9072 81.9072-214.7136 0-296.6256h-0.0048z" fill="" ></path></symbol><symbol id="icon-yewuyuanguanli" viewBox="0 0 1024 1024"><path d="M633.735624 441.758704l-46.9829 0-22.518727-22.518727-29.129726-29.179691c107.431428-0.10073 194.776835-87.584441 194.776835-194.995483 0-107.516568-87.45713-195.055641-195.040852-195.055641-107.51497 0-195.01427 87.539073-195.01427 195.055641 0 107.436224 87.367392 194.823803 194.759048 194.954911l-29.157906 29.220263-22.578885 22.518727-46.881371 0c-139.533285 0-252.448496 113.127463-252.448496 252.539832l0 329.694333 702.5868 0 0-329.694333C886.124961 554.91115 773.079441 441.758704 633.735624 441.758704zM584.08658 817.727829l-49.246125 49.391823-49.263313-49.391823 38.638707-281.182097-38.638707-38.602133 49.263313-49.350052 49.246125 49.350052-38.601333 38.602133L584.08658 817.727829zM381.391056 195.064803c0-84.761406 68.880259-153.510757 153.449399-153.510757 84.681662 0 153.47758 68.74935 153.47758 153.510757 0 84.705845-68.795918 153.47638-153.47758 153.47638C450.2931 348.541183 381.391056 279.770648 381.391056 195.064803zM844.493736 982.341858l-98.075539 0 0-299.422402-41.611638 0 0 299.422402L360.897519 982.341858l0-299.422402-41.563272 0 0 299.422402-94.2532 0 0-288.043322c0.25842-116.512307 94.378912-210.716941 210.886023-210.909807l5.334487 0-14.556269 14.55507 29.41153 29.35337 24.041867 24.019682-35.803281 260.820869-2.858211 20.467754 14.619425 14.665992 49.292293 49.18097 29.41153 29.481481 29.397539-29.481481 49.246125-49.18097 14.575855-14.665992-2.792656-20.44557-35.894617-260.822468 24.047263-24.016485 29.395141-29.351371-14.514098-14.580852 5.414232 0c116.335431 0.192866 210.586232 94.397499 210.757912 210.909807L844.493137 982.341858z"  ></path></symbol><symbol id="icon-shanghutixian" viewBox="0 0 1024 1024"><path d="M251.1 721.7v-76l62.7-62.8-62.7-62.8v-76L352 544.7l38.2 38.2-38.2 38.2-100.9 100.6zM64.7 551.4h272v62.9h-272v-62.9z m836-75.6h-207c-33 0-59.7 26.7-59.7 59.7v101.8c0 33 26.7 59.7 59.7 59.7h207c33 0 59.7-26.7 59.7-59.7V535.5c-0.1-33-26.8-59.7-59.7-59.7z m26.7 138.3c0 26.3-21.3 47.7-47.7 47.7H714.5c-26.3 0-47.7-21.3-47.7-47.7V554c0-26.3 21.3-47.7 47.7-47.7h165.3c26.3 0 47.7 21.3 47.7 47.7v60.1z m-223.7-31.2c0 11.3 6 21.7 15.8 27.4 9.8 5.6 21.8 5.6 31.6 0s15.8-16.1 15.8-27.4c0-11.3-6-21.7-15.8-27.4-9.8-5.6-21.8-5.6-31.6 0-9.8 5.7-15.8 16.1-15.8 27.4z m-69.8-519L156 217.6v38.8h36.4l410.5-132 42.4 132h50.5L633.9 63.9zM240.6 844.1c-27.5 0-49.8-22.3-49.8-49.8V753h-23.5v55c0 33 26.7 59.7 59.7 59.7h114.4v-23.5H240.6zM851 815.9c0 57-36.6 98.4-93.6 98.4l-544.1 1.1c-57 0-98.3-42.4-98.3-99.4l-0.1-115.2-0.3-0.3v-38.9H64.7v178.5c0 66 53.5 119.4 119.4 119.4H781c65.9 0 119.4-53.5 119.4-119.4V697h-49l-0.4 118.9z m-70-602.7H184.1c-65.9 0-119.4 53.5-119.4 119.4v178.5h49.8l-0.1-159.9c0-57 39-95 96-95h549.3c57 0 90.8 40.6 90.8 97.6l0.9 121.9h49V332.6c0-65.9-53.5-119.4-119.4-119.4z m0 0"  ></path></symbol><symbol id="icon-shebeiguanli" viewBox="0 0 1243 1024"><path d="M1191.570286 845.677714h-438.125715a161.28 161.28 0 0 0-99.986285-99.913143V707.291429h338.212571c61.513143 0 115.346286-53.76 115.346286-115.273143V115.346286c0-61.44-53.833143-115.273143-115.346286-115.273143h-753.371428c-61.44 0-115.273143 53.833143-115.273143 115.273143V584.411429c0 61.44 53.76 115.273143 115.273143 115.273142h338.285714v38.473143c-46.08 15.36-84.553143 53.76-99.986286 99.913143H38.473143c-23.113143 0-38.473143 15.36-38.473143 38.473143 0 23.04 15.36 38.4 38.473143 38.4h438.125714c15.36 61.44 69.193143 107.593143 138.386286 107.593143s123.026286-46.08 138.386286-107.52h438.198857c23.04 0 38.4-15.433143 38.4-38.473143 0-23.113143-15.36-30.72-38.4-30.72zM238.299429 76.946286h791.844571v361.325714H199.899429v-361.325714h38.4z m-38.4 545.792V515.145143h830.171428v107.593143H199.972571z m415.085714 330.605714a68.900571 68.900571 0 0 1-69.193143-69.193143c0-38.473143 30.72-69.193143 69.193143-69.193143s69.193143 30.72 69.193143 69.193143c0 38.4-30.72 69.193143-69.193143 69.193143z"  ></path></symbol><symbol id="icon-caiwuguanli" viewBox="0 0 1024 1024"><path d="M845.03893333 51.3536H180.71893333c-61.7984 0-108.1344 58.9824-108.1344 128.6144v715.2128c0 69.6832 51.5072 128.6144 108.1344 128.6144h654.0288c61.7472 0 108.1344-58.9312 108.1344-128.6144V179.968c0-69.632-51.5072-128.6144-108.1344-128.6144h10.2912z m46.336 838.4512c0 37.5296-19.968 82.9952-50.8416 82.9952H174.93333333c-30.8736 0-51.2-13.6704-51.2-51.2V256h768l-0.3584 633.8048zM891.73333333 204.8H123.73333333l5.5296-24.832C129.26293333 142.4896 144.05973333 102.4 174.93333333 102.4h665.6c30.8736 0 50.8416 40.0896 50.8416 77.568L891.73333333 204.8z m-179.8144 357.7344c40.96 0 76.8-35.84 76.8-76.8s-35.84-76.8-76.8-76.8-76.8 35.84-76.8 76.8 35.84 76.8 76.8 76.8z m-25.6-102.4h51.2v51.2h-51.2v-51.2z m-384.0512 358.3488c40.96 0 76.8512-35.84 76.8512-76.7488 0-40.96-35.8912-76.8-76.8512-76.8-40.96 0-76.8 35.84-76.8 76.8 0 40.9088 35.84 76.7488 76.8 76.7488z m-25.6-102.3488h51.2512v51.1488H276.66773333v-51.1488z m25.6-153.6c40.96 0 76.8512-35.84 76.8512-76.8s-35.8912-76.8-76.8512-76.8c-40.96 0-76.8 35.84-76.8 76.8s35.84 76.8 76.8 76.8z m-25.6-102.4h51.2512v51.2H276.66773333v-51.2z m435.2512 358.3488c40.96 0 76.8-35.84 76.8-76.7488 0-40.96-35.84-76.8-76.8-76.8s-76.8 35.84-76.8 76.8c0 40.9088 35.84 76.7488 76.8 76.7488z m-25.6-102.3488h51.2v51.1488h-51.2v-51.1488z m-179.2-153.6c40.96 0 76.8-35.84 76.8-76.8s-35.84-76.8-76.8-76.8-76.8 35.84-76.8 76.8 35.84 76.8 76.8 76.8z m-25.6-102.4h51.2v51.2h-51.2v-51.2z m25.6 358.3488c40.96 0 76.8-35.84 76.8-76.7488 0-40.96-35.84-76.8-76.8-76.8s-76.8 35.84-76.8 76.8c0 40.9088 35.84 76.7488 76.8 76.7488z m-25.6-102.3488h51.2v51.1488h-51.2v-51.1488z"  ></path></symbol><symbol id="icon-caiwu" viewBox="0 0 1024 1024"><path d="M854.122469 0 197.1987 0c-65.967508 0-119.458135 57.265684-119.458135 127.968008l0 767.808048c0 70.702324 53.490627 127.968008 119.458135 127.968008l656.923769 0c65.967508 0 119.458135-57.265684 119.458135-127.968008l0-767.808048C973.516621 57.265684 920.089978 0 854.122469 0zM913.819545 895.776056c0 35.31917-26.745314 63.984004-59.697076 63.984004L197.1987 959.76006c-32.951762 0-59.697076-28.664834-59.697076-63.984004l0-639.84004L913.819545 255.936016 913.819545 895.776056zM913.819545 191.888028 137.501625 191.888028l0-63.984004c0-35.31917 26.745314-63.984004 59.697076-63.984004l656.923769 0c32.951762 0 59.697076 28.664834 59.697076 63.984004L913.819545 191.888028zM764.544864 575.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006s-40.117971-95.976006-89.577606-95.976006-89.577606 42.997251-89.577606 95.976006S715.021245 575.792052 764.544864 575.792052zM734.664334 447.824044l59.697076 0 0 63.984004L734.664334 511.808048 734.664334 447.824044zM286.776306 831.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006 0-53.042739-40.117971-95.976006-89.577606-95.976006-49.459635 0-89.577606 42.933267-89.577606 95.976006C197.1987 788.794801 237.316671 831.792052 286.776306 831.792052zM256.895776 703.824044l59.697076 0 0 63.984004L256.895776 767.808048 256.895776 703.824044zM286.776306 575.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006s-40.117971-95.976006-89.577606-95.976006c-49.459635 0-89.577606 42.997251-89.577606 95.976006S237.316671 575.792052 286.776306 575.792052zM256.895776 447.824044l59.697076 0 0 63.984004L256.895776 511.808048 256.895776 447.824044zM764.544864 831.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006 0-53.042739-40.117971-95.976006-89.577606-95.976006s-89.577606 42.933267-89.577606 95.976006C674.967258 788.794801 715.021245 831.792052 764.544864 831.792052zM734.664334 703.824044l59.697076 0 0 63.984004L734.664334 767.808048 734.664334 703.824044zM525.628593 575.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006s-40.117971-95.976006-89.577606-95.976006c-49.459635 0-89.577606 42.997251-89.577606 95.976006S476.168958 575.792052 525.628593 575.792052zM495.812047 447.824044 555.509123 447.824044l0 63.984004L495.812047 511.808048 495.812047 447.824044zM525.628593 831.792052c49.459635 0 89.577606-42.997251 89.577606-95.976006 0-53.042739-40.117971-95.976006-89.577606-95.976006-49.459635 0-89.577606 42.933267-89.577606 95.976006C436.050987 788.794801 476.168958 831.792052 525.628593 831.792052zM495.812047 703.824044 555.509123 703.824044l0 63.984004L495.812047 767.808048 495.812047 703.824044z"  ></path></symbol><symbol id="icon-renyuanguanli" viewBox="0 0 1025 1024"><path d="M752.798275 666.401556c-55.516408 0-100.68719 45.181015-100.68719 100.6964 0 55.533804 45.170782 100.714819 100.68719 100.714819 55.525618 0 100.6964-45.181015 100.6964-100.714819C853.494675 711.582571 808.323892 666.401556 752.798275 666.401556zM752.798275 815.919894c-26.916023 0-48.811706-21.895683-48.811706-48.820915 0-26.907836 21.894659-48.802496 48.811706-48.802496 26.917046 0 48.820915 21.894659 48.820915 48.802496C801.620213 794.023188 779.715321 815.919894 752.798275 815.919894zM1019.035942 714.490807c-3.777023-19.938098-16.572444-32.833803-32.998555-32.833803l-2.27788 0c-31.43392 0-57.015551-25.571399-57.015551-56.996109 0-8.249895 3.603061-18.383696 4.975315-21.565155 7.782244-17.523095 1.792832-39.035038-15.502066-51.015907L849.553922 515.166109c-5.222955-2.25025-10.865465-3.402493-16.783245-3.402493-12.071943 0-24.007787 4.920056-31.909757 13.114692-8.30413 8.56098-30.364565 26.230408-45.555545 26.230408-15.337313 0-37.534871-18.017352-45.848211-26.705222-7.946996-8.396227-19.984147-13.408381-32.193213-13.408381-5.853311 0-11.413957 1.116427-16.407692 3.27458l-1.243317 0.512676-67.844178 37.260625-1.609661 1.042749c-15.777335 10.974959-21.794375 32.467459-14.066367 49.845245 0.521886 1.243317 5.048993 12.273535 5.048993 21.729907 0 31.42471-25.580608 56.996109-57.024761 56.996109l-2.65241 0c-16.033162 0-28.837792 12.896728-32.614815 32.852222-0.576121 3.072989-5.625114 30.638811-5.625114 52.936653 0 22.296819 5.048993 49.862641 5.625114 52.955072 3.777023 19.939121 16.572444 32.833803 33.007765 32.833803l2.258437 0c31.44313 0 57.024761 25.571399 57.024761 56.997132 0 8.249895-3.603061 18.382673-4.975315 21.566178-7.774057 17.504676-1.802042 38.997176 15.429411 51.014884l65.410756 36.436864c5.213745 2.26867 10.856255 3.439332 16.783245 3.439332 12.301164 0 24.355711-5.139044 32.239262-13.736862 8.048303-8.743128 30.931476-27.895327 46.553269-27.895327 15.785521 0 38.402635 19.189038 46.863331 28.462239 7.9296 8.743128 20.067035 13.95585 32.467459 13.95585 5.825682 0 11.377118-1.116427 18.126846-4.097318l66.134233-36.547381 1.583055-1.042749c15.748682-10.956539 21.757536-32.431643 14.038738-49.826825-0.521886-1.24434-5.048993-12.273535-5.048993-21.73093 0-31.42471 25.580608-56.997132 57.015551-56.997132l2.62478 0c16.060791 0 28.873608-12.895705 32.632211-32.778544 0.054235-0.274246 5.643534-29.560246 5.643534-53.009308C1024.661056 745.149061 1019.612063 717.583239 1019.035942 714.490807zM969.483362 802.273083c-53.704133 7.02295-94.613868 52.882418-94.613868 107.957781 0 12.712533 3.064802 24.785499 5.770424 32.961716l-47.722908 26.376741c-4.2897-4.206812-11.139711-10.500145-19.627013-16.792455-21.090341-15.657608-41.521672-23.613814-60.709687-23.613814-19.024286 0-39.291888 7.810896-60.254316 23.174815-8.368598 6.145977-15.136745 12.236696-19.4991 16.46295l-45.620014-25.517163c2.707668-8.194636 5.799076-20.340257 5.799076-33.05279 0-55.075363-40.900525-100.93483-94.604658-107.957781-1.37123-8.890484-3.301186-23.376407-3.301186-34.827203 0-11.505032 1.920746-25.956162 3.301186-34.827203 53.695946-7.023974 94.604658-52.882418 94.604658-107.957781 0-12.675694-3.064802-24.749684-5.762237-32.9259l49.25889-27.034726c4.27128 4.02364 11.130502 10.078543 19.554358 16.078187 20.678972 14.743796 40.61707 22.225187 59.247382 22.225187 18.437931 0 38.2123-7.335059 58.753125-21.803585 8.359388-5.871731 15.127536-11.743462 19.435655-15.748682l47.165206 26.211988c-2.707668 8.176217-5.789866 20.286022-5.789866 32.999578 0 55.07741 40.900525 100.933807 94.604658 107.957781 1.399883 9.054213 3.311419 23.468504 3.311419 34.827203C972.785571 778.878257 970.883245 793.255709 969.483362 802.273083zM69.886697 949.71411l0-57.027831c0-193.891965 149.522432-353.693508 340.022137-371.700627l-0.080841-0.037862c0 0 0.192382 0.00307 0.496304 0.00614 11.67797-1.090844 23.49204-1.709945 35.452443-1.709945 1.801019 0 3.576455 0.098237 5.371334 0.124843 42.12747-3.272533 105.874329-13.170974 139.197272-42.910299l16.301268-12.707416c63.693648-49.740868 100.229772-124.051317 100.229772-203.864084 0-143.016251-117.146047-259.365142-261.150812-259.365142S184.575786 116.871801 184.575786 259.888052c0 79.812767 36.537148 154.122193 100.229772 203.864084l16.301268 12.707416-19.206434 7.626701C112.216781 551.457664 2.573615 711.836351 2.573615 892.686279l0 90.394776c0 18.400069 15.089673 33.375132 33.649378 33.375132l491.720118 0c-16.004509-20.50501-29.652344-42.865273-40.679491-66.741054L69.886697 949.71411 69.886697 949.71411zM251.888867 259.887029c0-106.222253 86.950328-192.634322 193.836707-192.634322 106.887402 0 193.855126 86.412069 193.855126 192.634322 0 106.223277-86.967724 192.634322-193.855126 192.634322S251.888867 366.110305 251.888867 259.887029z"  ></path></symbol><symbol id="icon-shanghuguanli" viewBox="0 0 1194 1024"><path d="M945.20576 1003.52h-775.68c-46.08 0-83.797333-36.437333-83.797333-81.322667v-231.253333c0-17.408 14.506667-31.402667 32.256-31.402667s32.256 13.994667 32.256 31.317334v231.338666c0 10.410667 8.533333 18.773333 19.285333 18.773334h775.68a19.029333 19.029333 0 0 0 19.285333-18.773334v-231.253333c0-17.408 14.421333-31.402667 32.170667-31.402667 17.834667 0 32.256 13.994667 32.256 31.317334v231.338666c0 44.885333-37.546667 81.322667-83.712 81.322667z m-59.221333-658.005333h-657.066667a31.829333 31.829333 0 0 1-32.341333-31.317334c0-17.322667 14.506667-31.317333 32.256-31.317333h657.066666c17.92 0 32.341333 13.994667 32.341334 31.317333a31.914667 31.914667 0 0 1-32.256 31.317334zM569.056427 590.848c-66.730667 0-129.024-36.266667-183.722667-74.24-65.706667 43.690667-127.146667 65.792-183.04 65.792a192 192 0 0 1-129.365333-48.469333 257.024 257.024 0 0 1-61.098667-81.493334C0.05376 428.032-3.444907 385.109333 3.808427 354.56c1.706667-6.912 12.8-42.666667 24.149333-69.717333 21.162667-51.2 71.765333-149.418667 108.885333-217.941334C166.70976 11.605333 203.06176 0 228.576427 0h662.186666c25.344 0 61.013333 11.776 88.405334 67.925333 10.410667 21.248 25.941333 51.968 42.496 84.650667 31.317333 61.781333 66.730667 131.669333 83.456 170.154667 8.704 20.053333 9.386667 41.472 9.642666 51.712a131.072 131.072 0 0 1-12.373333 65.792c-24.746667 48.042667-52.053333 82.858667-83.285333 106.496a166.826667 166.826667 0 0 1-102.997334 35.413333c-53.589333 0-111.274667-23.210667-184.490666-74.752-22.016 24.746667-44.885333 44.032-68.437334 57.6-29.866667 17.322667-61.44 25.856-94.122666 25.856zM385.504427 446.890667c6.826667 0 13.568 2.133333 19.114666 6.144 50.773333 36.437333 109.482667 75.52 164.352 75.52 45.568 0 88.405333-26.965333 130.730667-82.773334a32 32 0 0 1 21.504-12.288c8.533333-1.194667 17.322667 1.024 24.234667 6.314667 72.277333 54.613333 126.549333 80.128 170.325333 80.128 49.322667 0 91.306667-35.072 128.853333-107.434667a67.84 67.84 0 0 0 5.717334-31.146666l-0.170667-4.693334a84.906667 84.906667 0 0 0-4.693333-29.184c-15.957333-36.693333-51.029333-105.813333-81.92-166.912-16.725333-32.768-32.426667-63.829333-42.922667-85.504-5.888-12.032-17.493333-32.085333-30.122667-32.085333H228.235093c-14.506667 0-27.904 20.736-34.645333 33.28-36.266667 67.328-85.845333 163.242667-106.154667 212.224-9.984 23.893333-19.882667 55.552-21.077333 60.586667-4.522667 18.944-0.938667 47.701333 3.584 57.173333 13.568 28.330667 53.589333 93.952 132.266667 93.952 47.274667 0 102.4-22.528 164.010666-66.986667a31.488 31.488 0 0 1 19.285334-6.314666z"  ></path></symbol><symbol id="icon-shenheguanli" viewBox="0 0 1024 1024"><path d="M153.6 953.6c-38.4-12.8-70.4-38.4-83.2-76.8C64 857.6 64 806.4 64 512c0-384 0-364.8 32-403.2 12.8-12.8 25.6-25.6 38.4-32l19.2-12.8h652.8l25.6 12.8c19.2 12.8 32 19.2 44.8 38.4l19.2 32v64c0 76.8 0 83.2-25.6 83.2s-32-12.8-32-70.4c0-57.6-6.4-70.4-32-89.6-12.8-6.4-12.8-6.4-326.4-6.4-307.2 0-313.6 0-332.8 6.4 0 0-12.8 12.8-19.2 25.6l-12.8 19.2v665.6l12.8 19.2c19.2 32 25.6 38.4 134.4 38.4 102.4 0 102.4 0 102.4 25.6s-12.8 25.6-108.8 25.6c-51.2 6.4-89.6 0-102.4 0z m768 0c-6.4 0-38.4-32-70.4-64l-64-64-38.4 25.6c-25.6 12.8-57.6 32-76.8 38.4-38.4 6.4-44.8 6.4-108.8 6.4s-70.4 0-102.4-12.8c-57.6-19.2-83.2-38.4-128-83.2-44.8-44.8-64-76.8-83.2-134.4-12.8-25.6-12.8-38.4-12.8-96 0-64 0-70.4 12.8-102.4 19.2-51.2 38.4-89.6 83.2-134.4 44.8-44.8 76.8-64 134.4-83.2 32-12.8 44.8-12.8 102.4-12.8 64 0 70.4 0 102.4 12.8 51.2 19.2 89.6 38.4 134.4 83.2 64 64 96 128 96 217.6 6.4 76.8-12.8 140.8-51.2 198.4l-19.2 32 70.4 70.4c44.8 44.8 70.4 70.4 70.4 76.8 0 6.4-6.4 12.8-12.8 19.2-25.6 12.8-25.6 12.8-38.4 6.4z m-294.4-115.2c96-19.2 172.8-89.6 204.8-179.2 12.8-32 12.8-38.4 12.8-89.6 0-51.2 0-57.6-12.8-89.6-25.6-64-70.4-121.6-134.4-153.6-44.8-19.2-64-32-115.2-32-51.2-12.8-89.6 0-140.8 19.2-44.8 25.6-76.8 57.6-108.8 102.4-32 44.8-44.8 83.2-44.8 153.6 0 44.8 0 57.6 12.8 89.6 25.6 70.4 76.8 128 140.8 160 57.6 25.6 121.6 32 185.6 19.2z m-76.8-57.6c-12.8-6.4-12.8-32-6.4-38.4 6.4-6.4 19.2-6.4 32-12.8 38.4-6.4 70.4-19.2 96-44.8 32-25.6 44.8-57.6 51.2-102.4 6.4-38.4 12.8-44.8 32-38.4 19.2 0 25.6 19.2 19.2 57.6-12.8 89.6-83.2 160-172.8 179.2-25.6 6.4-38.4 6.4-51.2 0zM371.2 512c-12.8-12.8-12.8-19.2 0-44.8 19.2-44.8 83.2-96 108.8-96 19.2-6.4 32 12.8 32 25.6s-6.4 19.2-25.6 32c-25.6 19.2-51.2 44.8-64 70.4-12.8 19.2-32 25.6-51.2 12.8z m0 0"  ></path></symbol><symbol id="icon-menu" viewBox="0 0 1024 1024"><path d="M326.860373 615.405091c41.060161 0 74.464969 33.404808 74.464969 74.464969l0 167.546947c0 41.060161-33.404808 74.464969-74.464969 74.464969L159.313425 931.881976c-41.060161 0-74.464969-33.404808-74.464969-74.464969L84.848457 689.87006c0-41.060161 33.404808-74.464969 74.464969-74.464969L326.860373 615.405091M326.860373 559.556109 159.313425 559.556109c-71.970148 0-130.313951 58.343803-130.313951 130.313951l0 167.546947c0 71.971172 58.343803 130.313951 130.313951 130.313951l167.546947 0c71.970148 0 130.313951-58.34278 130.313951-130.313951L457.174324 689.87006C457.174324 617.900935 398.830521 559.556109 326.860373 559.556109L326.860373 559.556109z"  ></path><path d="M866.733187 615.405091c41.060161 0 74.464969 33.404808 74.464969 74.464969l0 167.546947c0 41.060161-33.404808 74.464969-74.464969 74.464969L699.18624 931.881976c-41.060161 0-74.464969-33.404808-74.464969-74.464969L624.721271 689.87006c0-41.060161 33.404808-74.464969 74.464969-74.464969L866.733187 615.405091M866.733187 559.556109 699.18624 559.556109c-71.970148 0-130.313951 58.343803-130.313951 130.313951l0 167.546947c0 71.971172 58.343803 130.313951 130.313951 130.313951l167.546947 0c71.970148 0 130.313951-58.34278 130.313951-130.313951L997.047138 689.87006C997.047138 617.900935 938.703335 559.556109 866.733187 559.556109L866.733187 559.556109z"  ></path><path d="M782.959202 112.765273c76.988442 0 139.621944 62.634526 139.621944 139.621944s-62.634526 139.621944-139.621944 139.621944S643.337257 329.374636 643.337257 252.387217 705.971783 112.765273 782.959202 112.765273M782.959202 56.916291c-107.955734 0-195.470927 87.516216-195.470927 195.470927 0 107.955734 87.515193 195.470927 195.470927 195.470927 107.955734 0 195.470927-87.515193 195.470927-195.470927C978.430128 144.432507 890.914936 56.916291 782.959202 56.916291L782.959202 56.916291z"  ></path><path d="M326.860373 94.149287c41.060161 0 74.464969 33.404808 74.464969 74.464969l0 167.546947c0 41.060161-33.404808 74.464969-74.464969 74.464969L159.313425 410.626171c-41.060161 0-74.464969-33.404808-74.464969-74.464969L84.848457 168.614256c0-41.060161 33.404808-74.464969 74.464969-74.464969L326.860373 94.149287M326.860373 38.300304 159.313425 38.300304c-71.970148 0-130.313951 58.343803-130.313951 130.313951l0 167.546947c0 71.971172 58.343803 130.313951 130.313951 130.313951l167.546947 0c71.970148 0 130.313951-58.34278 130.313951-130.313951L457.174324 168.614256C457.174324 96.644107 398.830521 38.300304 326.860373 38.300304L326.860373 38.300304z"  ></path></symbol><symbol id="icon-jia" viewBox="0 0 1024 1024"><path d="M509.726725 960.069969c-60.45079 0-119.112841-11.847839-174.36012-35.214013-53.340859-22.560832-101.239775-54.851259-142.359288-95.970772-41.122583-41.122583-73.40994-89.017406-95.970772-142.359288-23.366174-55.246255-35.214013-113.910353-35.214013-174.361143 0-60.46 11.847839-119.130238 35.211966-174.380586 22.560832-53.348022 54.851259-101.247962 95.970772-142.371568 41.122583-41.123606 89.017406-73.414033 142.361335-95.976912 55.244208-23.366174 113.908306-35.215036 174.36012-35.215036 60.45693 0 119.123075 11.847839 174.3724 35.215036 53.342906 22.560832 101.242845 54.852282 142.364405 95.975888 41.122583 41.12463 73.411987 89.024569 95.972818 142.372591 23.366174 55.250348 35.214013 113.920586 35.214013 174.380586 0 60.449767-11.847839 119.113865-35.214013 174.361143-22.562878 53.341882-54.851259 101.237729-95.972818 142.359288-41.12463 41.122583-89.021499 73.40994-142.364405 95.970772C628.8498 948.222129 570.181609 960.069969 509.726725 960.069969zM509.726725 146.08617c-201.834868 0-366.039697 164.223249-366.039697 366.079606 0 201.835891 164.204829 366.04072 366.039697 366.04072 201.845101 0 366.060163-164.204829 366.060163-366.04072C875.786888 310.308395 711.571826 146.08617 509.726725 146.08617z"  ></path><path d="M763.85254 491.819378c0 33.391505-27.079752 60.488653-60.490699 60.488653L296.325427 552.308031c-33.408901 0-60.488653-27.097148-60.488653-60.488653l0 0c0-33.391505 27.079752-60.488653 60.488653-60.488653l407.036413 0C736.772788 431.330726 763.85254 458.428897 763.85254 491.819378L763.85254 491.819378z"  ></path><path d="M509.736958 242.254439c33.391505 0 60.486606 27.079752 60.486606 60.491723l0 407.036413c0 33.408901-27.096125 60.488653-60.486606 60.488653l0 0c-33.391505 0-60.488653-27.079752-60.488653-60.488653L449.248306 302.746162C449.248306 269.334191 476.345454 242.254439 509.736958 242.254439L509.736958 242.254439z"  ></path></symbol><symbol id="icon-quanxianguanli" viewBox="0 0 1024 1024"><path d="M764.50474667 374.27063467H298.83323733V282.44923733c0-103.13728 98.93751467-190.21277867 205.996032-190.21277866 111.394816 0 197.38350933 88.899584 197.38350934 190.21277866v13.14542934c0 12.68667733 12.30984533 32.09079467 32.33655466 32.09079466 17.74933333 0 29.95541333-19.398656 29.95541334-32.09079466v-13.14542934c0-143.02139733-110.83229867-251.117568-258.244608-252.50474666h-2.8672c-149.880832 1.38717867-266.85713067 111.81533867-266.85713067 252.50474666v94.142464c-77.66562133 11.26126933-137.72936533 77.63285333-137.72936533 158.367744v298.418176c0 88.59374933 72.09506133 160.68881067 160.68881066 160.68881067h505.01495467c88.59374933 0 160.68881067-72.09506133 160.68881067-160.68881067v-298.418176c-0.00546133-88.59921067-72.10052267-160.68881067-160.694272-160.68881066z m98.39684266 442.71752533c0 63.307776-51.46760533 114.77538133-114.77538133 114.77538133H275.87925333c-63.307776 0-114.77538133-51.46760533-114.77538133-114.77538133v-265.650176c0-63.307776 51.46760533-114.77538133 114.77538133-114.77538133h472.24695467c63.307776 0 114.77538133 51.46760533 114.77538133 114.77538133v265.650176zM512 506.53866667c-75.95076267 0-137.72936533 61.784064-137.72936533 137.72936533 0 68.24482133 46.30664533 122.71616 111.53134933 133.53506133-0.08192 0.786432 0.08738133 1.92785067 0.08738133 2.736128l0.25668267 70.320128c0 12.68667733 13.16727467 22.953984 25.853952 22.953984s26.279936-10.26730667 26.279936-22.953984l-0.25668267-69.72484266c0-0.80827733 0.07645867-1.523712 0-2.310144 65.224704-10.81890133 111.706112-66.31697067 111.706112-134.561792C649.72936533 568.32273067 587.95076267 506.53866667 512 506.53866667z m0 217.26276266c-43.843584 0-79.53339733-35.68981333-79.53339733-79.53339733s35.68981333-79.53339733 79.53339733-79.53339733 79.53339733 35.68981333 79.53339733 79.53339733-35.68981333 79.53339733-79.53339733 79.53339733z m190.21277867-433.67355733"  ></path></symbol><symbol id="icon-yonghu" viewBox="0 0 1024 1024"><path d="M947.924 963.76c0 21.752-17.62 39.372-39.354 39.372-21.75 0-39.37-17.62-39.37-39.371l-0.354-3.655c0-1.554 0.283-3.054 0.442-4.59-24.576-172.792-172.72-299.768-353.104-301.763-1.447 0.036-2.825 0.23-4.29 0.23-1.43 0-2.807-0.194-4.237-0.23C329.34 655.731 182.607 779.9 155.56 949.69c0.9 3.337 1.536 6.78 1.536 10.4l0.37 3.707c0 22.086-17.902 39.989-39.97 39.989s-39.99-17.903-39.99-39.99l-0.035-0.352h-0.76c0.107-1.165 0.336-2.278 0.46-3.425 0-3.302 0.53-6.427 1.27-9.499C98.94 791.217 205.684 662.422 350.968 606.95c-84.586-54.2-139.74-149.963-139.74-259.372 0-169.224 131.478-306.405 300.702-306.405 169.208 0 300.703 137.18 300.703 306.405 0 109.374-55.102 205.118-139.652 259.32 144.278 55.03 250.544 182.325 272.19 340.038 1.465 4.131 2.436 8.528 2.436 13.17l0.318 3.656z m-204.43-616.094c0-127.947-103.706-231.654-231.653-231.654S280.188 219.736 280.188 347.666c0 127.929 103.724 231.636 231.653 231.636s231.654-103.707 231.654-231.636z"  ></path></symbol><symbol id="icon-plus-3" viewBox="0 0 1025 1024"><path d="M852.81189424 166.71324093C760.09732283 77.43254358 639.91176832 25.92444865 512.85846852 25.92444865S262.18574014 77.43254358 172.90504279 166.71324093c-188.86301409 188.86301409-188.86301409 491.04383738 0 679.90685148C262.18574014 935.90078976 385.80516777 987.40888469 512.85846852 987.40888469s250.67272836-51.50809492 339.95342572-140.78879228c188.86301409-188.86301409 188.86301409-491.04383738 0-679.90685148m-48.0742218 631.83262967C725.7585935 877.52494954 622.74240366 918.73142511 512.85846852 918.73142511s-212.90012499-41.20647556-291.87920394-120.18555451c-161.39203007-161.39203007-161.39203007-422.36637687 0-583.75840786C299.95834352 135.8083838 402.97453243 94.60190823 512.85846852 94.60190823s212.90012499 41.20647556 291.87920392 120.18555451c161.39203007 161.39203007 161.39203007 422.36637687 0 583.75840786" fill="#515151" ></path><path d="M547.19719783 472.32793641V297.2004148c0-20.60323778-13.73549154-34.33873026-34.33872931-34.33873026s-34.33873026 13.73549154-34.33873026 34.33873026V472.32793641H303.39221571c-20.60323778 0-34.33873026 13.73549154-34.33872932 34.33873026 0 10.30161935 3.43387312 17.16936466 10.30161842 24.0371109s13.73549154 10.30161935 24.0371109 10.30161936H478.51973826v175.12752161c0 10.30161935 3.43387312 17.16936466 10.30161936 24.0371109 6.86774624 6.86774624 13.73549154 10.30161935 24.0371109 10.30161936 20.60323778 0 34.33873026-13.73549154 34.33872931-34.33873026V541.00539693h175.12752255c20.60323778 0 34.33873026-13.73549154 34.33873025-34.33873026s-13.73549154-34.33873026-34.33873025-34.33873026H547.19719783z" fill="#515151" ></path></symbol><symbol id="icon-jiaoyiliushui" viewBox="0 0 1024 1024"><path d="M157.346345 1023.999989c-59.941463 0-104.89756-49.951219-104.89756-104.89756L52.448785 104.89756C52.448785 49.951219 102.400004 0 157.346345 0l704.312188 0c59.941463 0 104.89756 49.951219 104.89756 104.89756l0 814.20487c0 59.941463-49.951219 104.89756-104.89756 104.89756L157.346345 1023.999989zM157.346345 69.931707c-19.980488 0-39.960975 14.985366-39.960975 39.960975l0 814.20487c0 19.980488 14.985366 39.960975 39.960975 39.960975l704.312188 0c19.980488 0 39.960975-14.985366 39.960975-39.960975L901.619508 104.89756c0-19.980488-14.985366-39.960975-39.960975-39.960975L157.346345 64.936585z"  ></path><path d="M222.28293 204.799998l554.458531 0 0 69.931707-554.458531 0 0-69.931707Z"  ></path><path d="M222.28293 459.551215l439.570727 0 0 69.931707-439.570727 0 0-69.931707Z"  ></path><path d="M222.28293 734.282919l334.673167 0 0 69.931707-334.673167 0 0-69.931707Z"  ></path></symbol><symbol id="icon-chilun" viewBox="0 0 1024 1024"><path d="M645.3 959c-16.3 0-32.1-7.1-42.4-19.1-13.9-16.2-58.1-58.2-94.3-58.2-35.9 0-80.8 42.3-93.6 57.1-10.2 11.7-25.9 18.7-42.1 18.7-7.7 0-14.9-1.6-21.6-4.6l-1.2-0.5-109.9-65-1.1-0.8c-20-14.8-27.6-43.8-17.7-67.4 0.1-0.2 10.1-24.7 10.1-47.1 0-67.9-52.3-123.2-116.5-123.2h-4.6c-18.4 0-33.4-17.3-38.2-44.1-0.4-2.1-9.4-52.9-9.4-92.9 0-40 9-90.8 9.4-92.9 4.8-27.1 20.2-44.5 38.9-44h3.9c64.2 0 116.5-55.3 116.5-123.2 0-22.4-10-46.9-10.2-47.2-9.9-23.6-2.2-52.6 17.8-67.3l1.1-0.8 116-67.4 1.2-0.5c6.5-2.9 13.7-4.4 21.3-4.4 16.1 0 31.9 6.9 42.2 18.3 13.7 15.2 57.1 54.7 92.3 54.7 34.8 0 77.9-38.8 91.6-53.7 10.2-11.2 25.9-18 41.8-18 7.7 0 15 1.5 21.7 4.6l1.2 0.5 112 65.8 1.1 0.8c20 14.8 27.7 43.8 17.8 67.4-0.1 0.2-10.1 24.7-10.1 47.1 0 68 52.3 123.2 116.5 123.2h3.9c18.7-0.5 34 16.9 38.9 44 0.4 2.1 9.4 52.9 9.4 92.9 0 40-9 90.7-9.4 92.9-4.8 27.1-20.2 44.4-38.9 44.1h-3.9c-64.2 0-116.5 55.3-116.5 123.2 0 22.4 10.1 46.9 10.2 47.2 9.9 23.6 2.3 52.5-17.8 67.3l-1.1 0.8L667.7 954l-1.2 0.5c-6.5 3-13.7 4.5-21.2 4.5z m-3.5-56.8c0.5 0.4 2 1 3.5 1h0.2L751.9 841c-2.6-6.3-14.3-36.9-14.3-68.9 0-95.6 71.2-173.9 160.4-178.8 1.3-7.5 8.2-49.7 8.2-81.4 0-31.7-7-73.8-8.2-81.4-89.2-4.9-160.4-83.2-160.4-178.8 0-32 11.8-62.7 14.3-68.9l-104.7-61.5h-0.4c-1.8 0-3.4 0.7-4 1.1-1.8 1.9-16.9 18.2-38.7 34.4-32.3 24-62.8 36.2-90.7 36.2-28.2 0-59-12.4-91.4-36.9-21.9-16.5-37.2-33.1-38.9-35.1-0.6-0.4-2.2-1.1-4-1.1h-0.4l-108.4 63c2.6 6.4 14.3 37 14.3 68.9 0 95.6-71.2 173.9-160.4 178.8-1.3 7.5-8.3 49.7-8.3 81.4 0 31.7 7 73.8 8.3 81.4 89.2 4.9 160.4 83.2 160.4 178.8 0 32.1-11.8 62.8-14.4 69l102.6 60.7c1.3 0 2.5-0.3 3.7-0.9 1.9-2.2 17.3-19.3 39.3-36.5 32.9-25.5 64.2-38.5 93-38.5 29 0 60.6 13.2 93.7 39.2 22 17.3 37.4 34.8 39.3 37z"  ></path><path d="M509 675.4c-85.5 0-155.1-73.6-155.1-164.1S423.5 347.2 509 347.2c85.6 0 155.1 73.6 155.1 164.1 0.1 90.4-69.5 164.1-155.1 164.1z m0-272.4c-56.4 0-102.4 48.6-102.4 108.3 0 59.7 45.9 108.3 102.4 108.3 56.5 0 102.4-48.6 102.4-108.3 0-59.8-45.9-108.3-102.4-108.3z"  ></path></symbol><symbol id="icon-shanghushenhe" viewBox="0 0 1024 1024"><path d="M735.414459 619.253275c10.750925-14.027397 7.986401-33.993401-6.143386-44.744326-35.017298-26.314169-73.311069-46.382562-113.959804-59.693231 89.79582-44.437156 151.741626-136.792721 151.741626-243.278072C767.052895 121.843816 644.69713 0 494.388961 0S221.725027 121.843816 221.725027 271.537646c0 106.485351 61.945805 198.943306 151.844016 243.482852C218.141386 565.805819 105.512649 711.608839 105.512649 883.214079c0 17.611039 14.334567 31.945605 32.150385 31.945605 17.713429 0 32.150385-14.232177 32.150385-31.945605 0-178.465353 145.70063-323.551645 324.780322-323.551645 71.468053 0 139.352465 22.730527 196.178782 65.631837 13.822618 10.750925 33.891011 8.088791 44.641936-6.040996zM494.388961 479.286471c-114.983702 0-208.567943-93.277072-208.567943-207.748825 0-114.471753 93.584242-207.646435 208.567943-207.646435 114.983702 0 208.465553 93.174683 208.465554 207.646435 0 114.471753-93.481852 207.748825-208.465554 207.748825zM818.964504 853.111489h-71.160884v-71.160884c0-7.884012-6.348165-14.232177-14.232177-14.232177s-14.232177 6.348165-14.232177 14.232177v85.393061c0 7.884012 6.348165 14.232177 14.232177 14.232176h85.393061c7.884012 0 14.232177-6.348165 14.232176-14.232176 0-7.781622-6.450555-14.232177-14.232176-14.232177z" fill="" ></path><path d="M747.80362 682.427757c-94.30097 0-170.786121 76.485151-170.786122 170.786122 0 94.30097 76.485151 170.786121 170.786122 170.786121 94.30097 0 170.786121-76.485151 170.786121-170.786121-0.10239-94.40336-76.485151-170.786121-170.786121-170.786122z m1.331067 295.189681c-67.577242 0-122.253375-54.676132-122.253375-122.253374S681.659834 733.110689 749.134687 733.110689c67.577242 0 122.253375 54.778522 122.253374 122.253375 0 67.577242-54.778522 122.253375-122.253374 122.253374z" fill="" ></path></symbol><symbol id="icon-renyuanguanli1" viewBox="0 0 1024 1024"><path d="M571.2 507.936a277.888 277.888 0 0 1-89.952 67.264h86.4c63.552 0 115.264 51.072 115.264 113.792v137.568c0 62.72-51.712 113.76-115.264 113.76H183.776c-63.552 0-115.264-51.008-115.264-113.76v-137.568c0-62.72 51.712-113.792 115.264-113.792h74.176a278.528 278.528 0 0 1-88.992-66.144C74.656 516.672 0 593.984 0 689.024v137.568C0 926.592 82.432 1008 183.776 1008H567.68c101.344 0 183.776-81.408 183.776-181.408v-137.568c-0.032-98.848-80.576-179.168-180.256-181.088z"  ></path><path d="M369.6 16C216.736 16 92.384 147.04 92.384 308.096a299.2 299.2 0 0 0 76.576 200.992 278.176 278.176 0 0 0 88.992 66.144c34.208 15.936 71.936 24.96 111.648 24.96s77.472-9.024 111.648-24.96a279.488 279.488 0 0 0 89.952-67.264 299.36 299.36 0 0 0 75.616-199.872C646.816 147.04 522.464 16 369.6 16z m95.2 491.584c-28.576 15.84-60.896 24.96-95.2 24.96s-66.624-9.12-95.2-24.96c-67.296-37.28-113.504-112.64-113.504-199.52 0-123.776 93.632-224.448 208.704-224.448s208.704 100.704 208.704 224.448c0 86.88-46.208 162.24-113.504 199.52zM736 205.536h288v63.168h-288zM736 395.04h288v63.168h-288zM799.744 584.576H1024v63.168h-224.256zM799.744 774.08H1024v63.168h-224.256z"  ></path></symbol><symbol id="icon-shuaxin2" viewBox="0 0 1024 1024"><path d="M922.07109219 669.37745844l-182.93836782 33.05055093c-25.51198313 4.63941469-36.53203125 35.17743001-19.71079687 54.98703938l34.68816187 40.97382C596.0150375 931.93608311 359.64761469 912.22049094 226.00158687 754.323065c-54.20996531-64.07207906-82.92233906-140.89679156-87.65097281-218.59067531h-0.47487751c0-2.03286188 0-4.15974-0.29164217-6.18780469-3.39226031-22.80182063-24.65144625-38.36246999-47.44847063-34.88578781-22.71260063 3.48243938-38.37206343 24.64185281-34.99323469 47.44846968 0.10360969 0.48447187 0.29164219 0.87013031 0.29164313 1.25674875 6.29141438 94.1256225 41.27025844 187.18348969 106.8907275 264.78335625 163.50578343 193.07389594 452.44172438 217.14205781 645.61923 53.82430688l31.59617812 37.30430812c16.80780469 19.80960938 48.70042125 14.00746311 57.499575-10.44156093l62.80669688-174.90669282c8.80203187-24.44902313-12.16934906-49.18968938-37.7753475-44.55027468zM100.37284343 352.8966725l182.92493626-33.05055188c25.52157657-4.63941469 36.527235-35.17263281 19.72039032-54.98224218l-33.03136501-39.06087657-0.01822781 0.01534969-18.35523469-21.74365781 18.37442156 21.72734812C427.98688062 92.08214469 664.53849875 111.69796438 798.26894937 269.69708094c54.99087657 64.933575 83.68885875 143.21170219 87.74978626 222.06352125h0.47967468c0.09881344 1.25674781 0 2.61134906 0.20242219 3.86809781 3.47764219 22.70780438 24.74066625 38.36246999 47.44847063 34.88578687 20.67973875-3.09102469 35.26664906-21.06539812 35.16783562-41.35947843 0-0.39045563-0.10360969-0.87013031-0.10360969-1.25674782-0.08442281-1.64240625 0-3.18983719-0.27245531-4.83224343-0.10360969-0.38565844-0.20242313-0.67730062-0.29164219-1.06295907-6.08899125-94.60529719-40.87980375-188.24644875-106.8907275-266.13412125C698.35077406 22.69047219 409.21720719-1.26928375 216.13851406 162.13768625L182.89992969 123.00389938c-16.82123531-19.81440563-48.71001469-14.01705655-57.499575 10.43676375L62.59365781 308.34735689c-8.79915375 24.35404781 12.16839001 49.18393313 37.77918564 44.54931561z" fill="" ></path></symbol><symbol id="icon-agent" viewBox="0 0 1270 1024"><path d="M1242.169332 559.458895H812.27682A28.383233 28.383233 0 0 1 783.893587 531.157885v-11.72494a28.366788 28.366788 0 0 1 28.383233-28.366788h429.563621a28.366788 28.366788 0 0 1 28.38323301 28.366788V531.157885a27.955676 27.955676 0 0 1-28.03789801 28.366788z m0 198.781298H812.27682a28.366788 28.366788 0 0 1-28.383233-28.366789v-11.70849401a28.383233 28.383233 0 0 1 28.383233-28.38323299h429.563621a28.383233 28.383233 0 0 1 28.38323299 28.38323299v11.70849401a27.955676 27.955676 0 0 1-28.03789799 28.366789z m0 199.998191H812.27682a28.383233 28.383233 0 0 1-28.383233-28.383233v-11.708494a28.366788 28.366788 0 0 1 28.383233-28.366789h429.563621a28.366788 28.366788 0 0 1 28.38323299 28.366789v11.708494a27.955676 27.955676 0 0 1-28.03789799 28.383233z m23.515656 65.778061M654.49169801 593.64704199c-40.35484-27.39656199-46.94909001-45.205972-47.29442501-53.75712 1.381339-10.52448999 18.500079-55.039792 49.82688-99.20975899l0.115112-0.115112c45.436195-65.103835 45.551307-131.47389799 40.585063-182.106559-4.933355-64.133609-30.060573-123.021417-70.990971-166.500715-42.90374-45.551307-100.31154201-70.711415-161.53447099-70.711414-60.943373 0-118.055173 25.09432999-160.82735701 70.711414-40.585063 43.133963-66.024728 102.219105-71.681641 166.385603v0.345335c-3.979573 50.468217-2.828457 116.969835 40.19039401 181.267889l0.115112 0.345335c31.458357 45.896641 48.560653 89.72127399 49.941992 99.555094-0.345335 9.866709-8.781371 30.866355-59.775812 62.48915699-39.466836 24.40366-90.888835 47.17931399-140.71571501 67.86651401A140.255269 140.255269 0 0 0 85.51147799 685.538992h-1.97334199l-6.018692 3.815127C29.139681 720.582253 0 772.037141 0 826.945376v104.307559h697.247437a129.17166599 129.17166599 0 0 1-3.28890299-29.40279299V883.07050601H48.560653v-55.91135101c0-36.177933 18.269856-70.415413 49.481546-92.845732h0.805781l5.788469-3.700016c11.790717-7.169809 21.164091-11.330271 30.29079699-13.303612l2.08845301-0.575558 1.973342-0.805781C256.682435 667.038912 371.382927 613.05156999 371.382927 539.38014201c0-22.43031799-26.705892-80.364345-58.509584-126.37609801-27.39656199-41.111288-36.885047-86.02125801-32.033915-150.319312 4.933355-53.296673 25.554776-102.10399399 58.624696-137.36103399 33.875701-36.177933 77.289221-55.385127 125.455205-55.38512601 48.560653 0 92.089284 19.190749 126.145875 55.38512601 33.53036599 35.503708 54.118899 84.179472 58.04913801 137.13081099v0.65778101c6.248916 63.706051-3.12445801 108.533799-31.918804 149.64508599-34.53348199 48.790876-58.739808 105.919121-58.739808 126.62276601 0 32.26413801 22.43031799 63.245605 68.458516 94.58885099a598.728348 598.728348 0 0 0 67.86651399 38.8255c2.18712-19.73341799 8.584037-36.293045 17.217407-45.863753A514.927099 514.927099 0 0 1 654.49169801 593.64704199zM888.234035 406.080903l0.11511099-0.115111a219.139607 219.139607 0 0 0 36.769936-86.25148201c5.196467-26.590781 6.133804-55.154903 2.5489-89.95149699-4.73602-62.094489-29.254792-119.321401-68.80385099-161.304248C817.292397 24.28859799 761.742825 0.000049 702.427459 0.000049a212.232911 212.232911 0 0 0-66.139839 10.52449 24.354327 24.354327 0 0 0 15.26050999 46.258421 163.376257 163.376257 0 0 1 50.977996-7.97559001c46.258421 0 88.109712 18.384968 120.94940802 53.18156201 32.033915 33.990813 51.80022201 80.824791 55.61534999 131.70412v0.57555799c6.248916 61.272263-3.00934599 104.29111399-30.52102 143.84017301a434.776533 434.776533 0 0 0-31.836581 52.622448h55.51668301c4.818243-8.10714601 10.129821-16.329403 15.98406899-24.650328z" fill="" ></path></symbol><symbol id="icon-dingdanguanli" viewBox="0 0 1024 1024"><path d="M626 512H398c-19.9 0-36-16.1-36-36s16.1-36 36-36h228c19.9 0 36 16.1 36 36s-16.1 36-36 36zM626 692H398c-19.9 0-36-16.1-36-36s16.1-36 36-36h228c19.9 0 36 16.1 36 36s-16.1 36-36 36zM835 101c-102.2 0-185 82.8-185 185s82.8 185 185 185 185-82.8 185-185-82.8-185-185-185z m0 298c-62.4 0-113-50.6-113-113s50.6-113 113-113 113 50.6 113 113-50.6 113-113 113z"  ></path><path d="M865 548.5V864H160V264h415.1c19.3 0 34.9-15.6 34.9-34.9 0-20.5-16.6-37.1-37.1-37.1H159c-39.8 0-72 32.2-72 72v600c0 39.8 32.2 72 72 72h706c39.8 0 72-32.2 72-72V547.5c0-19.6-15.9-35.5-35.5-35.5-20.2 0-36.5 16.3-36.5 36.5z"  ></path></symbol><symbol id="icon-renzheng" viewBox="0 0 1024 1024"><path d="M896 194.048v384c-2.56 108.544-39.936 199.168-112.64 271.36-72.192 72.192-162.816 110.08-271.36 112.64-108.544-2.56-199.168-39.936-271.36-112.64-72.192-72.192-110.08-162.816-112.64-271.36v-384l384-128 384 128z m-72.192 53.76L512 138.24 200.192 247.808v330.24c2.048 88.576 32.256 162.304 91.136 221.184 58.88 58.88 132.096 89.088 221.184 91.136 88.576-2.048 162.304-32.256 221.184-91.136 58.88-58.88 89.088-132.096 91.136-221.184V247.808z m-340.992 334.336l197.12-197.12c6.656-6.656 14.336-10.24 23.552-10.24s17.408 3.584 24.576 10.24l3.072 3.072c6.656 6.656 10.24 14.848 10.24 24.064 0 9.216-3.584 17.408-10.24 24.064L506.88 658.944c-6.656 6.656-14.848 10.24-24.064 10.24-9.216 0-17.408-3.584-24.064-10.24L327.68 527.872c-7.168-7.168-10.752-15.872-10.752-25.6s3.584-17.92 10.752-25.088c7.168-7.168 15.872-10.752 25.088-10.752 9.216 0 17.408 3.584 25.088 10.24l104.96 105.472z"  ></path></symbol><symbol id="icon-hezi" viewBox="0 0 1024 1024"><path d="M512 27.648l-444.416 189.44v303.616h39.424V275.968L494.08 430.08v454.656l-387.072-161.792v-60.928h-39.424v83.968l444.416 188.928 444.416-188.928V217.088L512 27.648z m-399.36 209.92l399.36-172.032 403.456 167.936-403.456 163.84-399.36-159.744z m809.984 486.4l-387.072 159.744V429.056l387.072-161.792v456.704z" fill="" ></path><path d="M512 416.256l426.496-179.2v503.808L512 916.48z" fill="" ></path></symbol><symbol id="icon-jigouguanli" viewBox="0 0 1024 1024"><path d="M885.4 881.9h11.4c17.2 0 31.2 14 31.2 31.2s-14 31.2-31.2 31.2H127.2c-8.3 0-16.2-3.3-22.1-9.1-5.9-5.9-9.1-13.8-9.1-22.1 0-17.2 14-31.2 31.2-31.2h10.9V152.5c0-19.3 7.7-37.8 21.3-51.5 13.7-13.7 32.2-21.3 51.5-21.3h425.9c19.3 0 37.8 7.7 51.5 21.3 13.7 13.7 21.3 32.2 21.3 51.5V319h103c40.2 0 72.8 32.6 72.8 72.8v490.1z m-62.4 0V391.8c0-5.7-4.7-10.4-10.4-10.4h-103v500.5H823z m-622.5 0h446.7V152.5c0-2.8-1.1-5.4-3-7.4s-4.6-3.1-7.4-3.1H210.9c-2.8 0-5.4 1.1-7.4 3.1-1.9 2-3 4.6-3 7.4v729.4z m148.1-384.4c-11.2 0.1-21.6-5.8-27.3-15.5-5.6-9.7-5.6-21.7 0-31.4s16.1-15.6 27.3-15.5h159.7c17.1 0.2 30.9 14.1 30.9 31.2s-13.8 31-30.9 31.2H348.6z m0 228.8c-17.1-0.2-30.9-14.1-30.9-31.2s13.8-31 30.9-31.2h159.7c11.2-0.1 21.6 5.8 27.3 15.5 5.6 9.7 5.6 21.7 0 31.4s-16.1 15.6-27.3 15.5H348.6z"  ></path></symbol><symbol id="icon-shanghuliebiao" viewBox="0 0 1024 1024"><path d="M949.248 357.376c0 15.36-12.288 27.648-26.624 27.648H692.224c-14.336 0-26.624-12.288-26.624-27.648 0-15.36 12.288-27.648 26.624-27.648h230.4c14.336 0 26.624 12.288 26.624 27.648zM949.248 522.24c0 15.36-12.288 27.648-26.624 27.648H692.224c-14.336 0-26.624-12.288-26.624-27.648 0-15.36 12.288-27.648 26.624-27.648h230.4c14.336 0 26.624 12.288 26.624 27.648zM949.248 685.056c0 15.36-12.288 27.648-26.624 27.648H781.312c-14.336 0-26.624-12.288-26.624-27.648 0-15.36 12.288-27.648 26.624-27.648h141.312c14.336 0 26.624 12.288 26.624 27.648zM246.784 545.792c-58.368-43.008-96.256-111.616-96.256-190.464 0-129.024 103.424-234.496 230.4-234.496s230.4 105.472 230.4 234.496c0 78.848-37.888 147.456-96.256 190.464 122.88 62.464 210.944 200.704 210.944 318.464 0 21.504-17.408 38.912-38.912 38.912-21.504 0-37.888-17.408-37.888-38.912 0-108.544-120.832-274.432-268.288-274.432C232.448 589.824 112.64 755.712 112.64 864.256c0 21.504-17.408 38.912-38.912 38.912-21.504 0-37.888-17.408-37.888-38.912-1.024-117.76 88.064-256 210.944-318.464z m286.72-190.464c0-86.016-68.608-156.672-153.6-156.672s-153.6 70.656-153.6 156.672S294.912 512 379.904 512s153.6-70.656 153.6-156.672z" fill="" ></path></symbol><symbol id="icon-jigou1" viewBox="0 0 1157 1024"><path d="M0 1024v-60.238h86.817V120.476C86.817 53.96 138.641 0 202.574 0h405.148c63.933 0 115.756 53.96 115.756 120.476v240.951h231.513c63.934 0 115.757 53.916 115.757 120.476v481.86h86.817V1024H0z m665.6-903.524c0-33.302-25.912-60.238-57.878-60.238H202.574c-31.967 0-57.878 26.936-57.878 60.238v843.286H665.6V120.476z m347.27 361.427c0-33.302-25.912-60.238-57.879-60.238H723.478v542.097h289.392V481.903zM954.99 632.476H781.357v-60.238H954.99v60.238z m0 180.714H781.357v-60.238H954.99v60.238zM376.21 331.286H202.574v-60.238h173.635v60.238z m0 180.714H202.574v-60.238h173.635V512z m0 180.714H202.574v-60.238h173.635v60.238z m231.513-361.428H434.087v-60.238h173.635v60.238z m0 180.714H434.087v-60.238h173.635V512z m0 180.714H434.087v-60.238h173.635v60.238z" fill="#666666" ></path></symbol></svg>',
      m = (m = document.getElementsByTagName("script"))[m.length - 1].getAttribute("data-injectcss");if (m && !c.__iconfont__svg__cssinject__) {
    c.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }function t() {
    v || (v = !0, a());
  }h = function h() {
    var c, h, l, a;(a = document.createElement("div")).innerHTML = z, z = null, (l = a.getElementsByTagName("svg")[0]) && (l.setAttribute("aria-hidden", "true"), l.style.position = "absolute", l.style.width = 0, l.style.height = 0, l.style.overflow = "hidden", c = l, (h = document.body).firstChild ? (a = c, (l = h.firstChild).parentNode.insertBefore(a, l)) : h.appendChild(c));
  }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(h, 0) : (_l = function l() {
    document.removeEventListener("DOMContentLoaded", _l, !1), h();
  }, document.addEventListener("DOMContentLoaded", _l, !1)) : document.attachEvent && (a = h, i = c.document, v = !1, (_o = function o() {
    try {
      i.documentElement.doScroll("left");
    } catch (c) {
      return void setTimeout(_o, 50);
    }t();
  })(), i.onreadystatechange = function () {
    "complete" == i.readyState && (i.onreadystatechange = null, t());
  });
}(window);

/***/ }),

/***/ "fMQ+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1RDM5RUQ0RjVBNzExRTc4NTJDQjQ3MDVCQkJDMzMyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ1RDM5RUQ1RjVBNzExRTc4NTJDQjQ3MDVCQkJDMzMyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDVEMzlFRDJGNUE3MTFFNzg1MkNCNDcwNUJCQkMzMzIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDVEMzlFRDNGNUE3MTFFNzg1MkNCNDcwNUJCQkMzMzIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7n3hbgAAABY0lEQVR42rTUzStEURzG8TNjMjNCszDFFntENhLKSylr/4KsWCEbVhQprCxtrJS3WHgpStmwxAJ5yUgsZMFOfE89t263udcx5VefmmbOec7cc37nxszgjnGocnzgK2pQ/JeQEmzgHTdoKjQsjU2UIosF7KIubEIi5PtirCKJHnxiDkXYQxsuXcLshBVUoFtBXs3o0W1gO66jwmzQMmrRob0K1qQCD9CKh3xhMSyhQau+ReznCFIKtGNzwQOY11504dWhXYZwqEPJ+sMm0KdHezJu9Y0BnCkwFdc+jWMdvag07tWPE1TbP5NQV4+hUytd4FmDy9Do21t7ene+sCm8YM3unzdoVu4DK+8r0GuPGjTjyjdmGMdRTWt0WnZixtci22gJhDldp2TIpqcLveh/qn8Ne9Qxu1RG9zcXFjaNRZyqu/PVqH4/17vuNuyib6mv6nVXTeCtYRer0md75Y78k38EGACvHkWZfQtF8QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "fUFR":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": item.children[0].name
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      class: {
        'menu-center': _vm.isShrinkage
      },
      attrs: {
        "index": item.name,
        "id": item.authority
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": item.name
      }
    }, [(item.icon) ? _c('icon-svg', {
      class: {
        'clear-margin': _vm.isShrinkage
      },
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      class: {
        'hide-el': _vm.isShrinkage
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        ref: "child_el_menu_item",
        refInFor: true,
        class: [{
          'menu-item-width': _vm.isShrinkage
        }, 'switch-el-menu-item'],
        attrs: {
          "index": item.path + '/' + child.path,
          "id": child.path
        }
      }, [_c('a', {
        attrs: {
          "href": "javascript:void(0)",
          "title": child.name
        }
      }, [(child.icon) ? _c('icon-svg', {
        class: {
          'clear-margin': _vm.isShrinkage
        },
        attrs: {
          "icon-class": child.icon
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('span', {
        class: {
          'offset-margin': _vm.isShrinkage
        }
      }, [_vm._v(_vm._s(child.name))])])], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2320244c", module.exports)
  }
}

/***/ }),

/***/ "iMd8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.lavelbar-content[data-v-4a0c7aa2] {\n  height: 50px;\n  line-height: 50px;\n}\n.house[data-v-4a0c7aa2] {\n  display: inline-block;\n  margin-left: 35px;\n  font-size: 16px;\n  color: #006ab6;\n}\n.house .img-house[data-v-4a0c7aa2] {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    cursor: pointer;\n}\n.house img[data-v-4a0c7aa2] {\n    vertical-align: text-bottom;\n}\n.app-levelbar.el-breadcrumb[data-v-4a0c7aa2] {\n  height: 13px;\n  display: inline-block;\n  font-size: 16px;\n}\n.app-levelbar.el-breadcrumb .no-redirect[data-v-4a0c7aa2] {\n    color: #006ab6;\n    cursor: text;\n}\n.el-breadcrumb__item__inner[data-v-4a0c7aa2],\n.el-breadcrumb__item__inner a[data-v-4a0c7aa2] {\n  color: #006ab6;\n}\n", ""]);

// exports


/***/ }),

/***/ "jSdT":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("AqkB")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("XWx7"),
  /* template */
  __webpack_require__("bvN3"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73d89c54",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\TabsView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabsView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73d89c54", Component.options)
  } else {
    hotAPI.reload("data-v-73d89c54", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "jVa7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.menu-toggle[data-v-5fce90fd] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  border-left: none;\n  height: 70px;\n  width: 223px;\n  line-height: 70px;\n  text-align: right;\n  background-color: #5272e9;\n  cursor: auto;\n  z-index: 1999;\n  -webkit-transition: width 0.28s ease-out;\n  transition: width 0.28s ease-out;\n}\n.switch-img[data-v-5fce90fd] {\n  width: 45px;\n  height: 45px;\n  cursor: pointer;\n}\n.menu-logo-wrapper[data-v-5fce90fd] {\n  overflow: hidden;\n}\n.menu-logo-wrapper[data-v-5fce90fd]::after {\n    background-color: transparent;\n}\n.menu-logo[data-v-5fce90fd] {\n  height: 78px;\n  background: #5272e9;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  border-left: none;\n  color: #fff;\n  overflow: hidden;\n  margin-bottom: 4px;\n  position: fixed;\n  width: 223px;\n  z-index: 1999;\n  top: 0;\n  -webkit-transition: width 0.28s ease-out;\n  transition: width 0.28s ease-out;\n}\n.menu-logo .unipay-div[data-v-5fce90fd],\n  .menu-logo .mipay-div[data-v-5fce90fd] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #5272e9;\n    padding-left: 14px;\n}\n.menu-logo .logo-img[data-v-5fce90fd] {\n    float: left;\n    width: 50px;\n    height: 50px;\n    margin: 14px 6px;\n}\n.menu-logo .logo-shrink-img[data-v-5fce90fd] {\n    margin-right: 27px;\n    margin-left: 10px;\n}\n.menu-logo .divide-line[data-v-5fce90fd] {\n    float: left;\n    width: 1px;\n    height: 33px;\n    margin: 22px 7px 22px 0px;\n    background-color: #fff;\n}\n.menu-logo .divide-line[data-v-5fce90fd]::after {\n      background-color: transparent;\n}\n.menu-logo .logo-system[data-v-5fce90fd] {\n    float: left;\n    font-size: 36px;\n    color: #fff;\n    line-height: 78px;\n}\n.menu-logo .logo-system[data-v-5fce90fd]::after {\n      background-color: transparent;\n}\n.app-wrapper[data-v-5fce90fd] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.app-wrapper[data-v-5fce90fd]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.app-wrapper.hideSidebar .sidebar-container[data-v-5fce90fd] {\n    width: 100px;\n    overflow: inherit;\n}\n.app-wrapper.hideSidebar .main-container[data-v-5fce90fd] {\n    margin-left: 36px;\n}\n.app-wrapper .sidebar-container[data-v-5fce90fd] {\n    -webkit-transition: width 0.28s ease-out;\n    transition: width 0.28s ease-out;\n    background-color: #5272e9;\n    color: white;\n    border-right: 0;\n    width: 223px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1001;\n    overflow: auto;\n    height: 85%;\n    margin-top: 78px;\n    -webkit-box-shadow: 0px 1px 6px 1px rgba(45, 63, 130, 0.39);\n            box-shadow: 0px 1px 6px 1px rgba(45, 63, 130, 0.39);\n    padding-bottom: 70px;\n}\n.app-wrapper .sidebar-container[data-v-5fce90fd]::-webkit-scrollbar {\n      display: none;\n}\n.app-wrapper .sidebar-container-shrinkage[data-v-5fce90fd] {\n    width: 100px;\n    overflow: auto;\n}\n.app-wrapper .main-container[data-v-5fce90fd] {\n    min-height: 100%;\n    -webkit-transition: margin-left 0.28s ease-out;\n    transition: margin-left 0.28s ease-out;\n    margin: 78px 0 0 223px;\n}\n.app-wrapper .main-container-shrinkage[data-v-5fce90fd] {\n    margin: 78px 0 0 100px;\n}\n.slide-btn[data-v-5fce90fd] {\n  color: #fff;\n  position: fixed;\n  bottom: 0;\n  left: 178px;\n  background-color: #4964cf;\n  z-index: 10002;\n  width: 45px;\n  height: 45px;\n  border: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "k0sJ":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vQmt")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("afte"),
  /* template */
  __webpack_require__("qsTK"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bd3b246",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\components\\Screenfull\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7bd3b246", Component.options)
  } else {
    hotAPI.reload("data-v-7bd3b246", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "kLoR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("QQIG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("66697028", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eca5e0e0\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eca5e0e0\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "koFB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.tabs-view-container[data-v-73d89c54] {\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 10px;\n}\n.tabs-view-container .tabs-view[data-v-73d89c54] {\n    margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "kxI1":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e2c53ca", module.exports)
  }
}

/***/ }),

/***/ "kzJD":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("yfw2")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Hana"),
  /* template */
  __webpack_require__("9V4I"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ecfcee3",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\views\\layout\\Navbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Navbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ecfcee3", Component.options)
  } else {
    hotAPI.reload("data-v-3ecfcee3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "lKZY":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.path === '/welcome' ? false : true),
      expression: "this.$route.path === '/welcome' ? false : true"
    }],
    staticClass: "lavelbar-content"
  }, [_c('div', {
    staticClass: "house"
  }, [_c('div', {
    staticClass: "img-house",
    on: {
      "click": function($event) {
        _vm.toLayout()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("fMQ+"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.Location')) + "：")])]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a0c7aa2", module.exports)
  }
}

/***/ }),

/***/ "lbbG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pJuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'errLog',
  props: {
    logsList: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialogTableVisible: false
    };
  }
});

/***/ }),

/***/ "pkH5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jVa7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7b16f60c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5fce90fd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5fce90fd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qsTK":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon screenfull",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "t": "1497503607356",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "p-id": "4109",
      "fill": _vm.fill,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "click": _vm.click
    }
  }, [_c('path', {
    attrs: {
      "d": "M604.157933 512l204.484208 204.484208 82.942037-82.942037c10.364045-10.952446 26.498514-13.83817 40.309054-8.067746 13.249769 5.742794 22.465664 18.99154 22.465664 33.977859l0 258.042008c0 20.168342-16.695241 36.863582-36.863582 36.863582L659.452283 954.357873c-14.986319 0-28.236088-9.215896-33.977859-23.025413-5.770424-13.249769-2.885723-29.384237 8.067746-39.748283l82.942037-82.942037L512 604.157933 307.515792 808.642141l82.942037 82.942037c10.952446 10.364045 13.83817 26.498514 8.067746 39.748283-5.742794 13.809517-18.99154 23.025413-33.977859 23.025413L106.504686 954.357873c-20.168342 0-36.863582-16.695241-36.863582-36.863582L69.641103 659.452283c0-14.986319 9.215896-28.236088 23.025413-33.977859 13.249769-5.770424 29.384237-2.8847 39.748283 8.067746l82.942037 82.942037 204.484208-204.484208L215.357859 307.515792l-82.942037 82.942037c-6.890944 6.918573-16.10684 10.952446-25.911136 10.952446-4.593622 0-9.804297-1.14815-13.83817-2.8847-13.809517-5.742794-23.025413-18.99154-23.025413-33.977859L69.641103 106.504686c0-20.168342 16.695241-36.863582 36.863582-36.863582L364.546693 69.641103c14.986319 0 28.236088 9.215896 33.977859 23.025413 5.770424 13.249769 2.8847 29.384237-8.067746 39.748283l-82.942037 82.942037 204.484208 204.484208L716.484208 215.357859l-82.942037-82.942037c-10.952446-10.364045-13.83817-26.498514-8.067746-39.748283 5.742794-13.809517 18.99154-23.025413 33.977859-23.025413l258.042008 0c20.168342 0 36.863582 16.695241 36.863582 36.863582l0 258.042008c0 14.986319-9.215896 28.236088-22.465664 33.977859-4.593622 1.736551-9.804297 2.8847-14.397918 2.8847-9.804297 0-19.020192-4.033873-25.911136-10.952446l-82.942037-82.942037L604.157933 512z",
      "p-id": "4110"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7bd3b246", module.exports)
  }
}

/***/ }),

/***/ "sG7e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+BSC");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e11b04ce", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2320244c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2320244c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "srSI":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-badge', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "is-dot": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTableVisible = true
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('svg', {
    staticClass: "bug-svg",
    attrs: {
      "t": "1492682037685",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1863",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    }
  }, [_c('path', {
    attrs: {
      "d": "M969.142857 548.571429q0 14.848-10.861714 25.709714t-25.709714 10.861714l-128 0q0 97.718857-38.290286 165.705143l118.857143 119.442286q10.861714 10.861714 10.861714 25.709714t-10.861714 25.709714q-10.276571 10.861714-25.709714 10.861714t-25.709714-10.861714l-113.152-112.566857q-2.852571 2.852571-8.557714 7.424t-23.990857 16.274286-37.156571 20.845714-46.848 16.566857-55.442286 7.424l0-512-73.142857 0 0 512q-29.147429 0-58.002286-7.716571t-49.700571-18.870857-37.705143-22.272-24.868571-18.578286l-8.557714-8.009143-104.557714 118.272q-11.446857 11.995429-27.428571 11.995429-13.714286 0-24.576-9.142857-10.861714-10.276571-11.702857-25.417143t8.850286-26.587429l115.419429-129.718857q-33.133714-65.133714-33.133714-156.562286l-128 0q-14.848 0-25.709714-10.861714t-10.861714-25.709714 10.861714-25.709714 25.709714-10.861714l128 0 0-168.009143-98.852571-98.852571q-10.861714-10.861714-10.861714-25.709714t10.861714-25.709714 25.709714-10.861714 25.709714 10.861714l98.852571 98.852571 482.304 0 98.852571-98.852571q10.861714-10.861714 25.709714-10.861714t25.709714 10.861714 10.861714 25.709714-10.861714 25.709714l-98.852571 98.852571 0 168.009143 128 0q14.848 0 25.709714 10.861714t10.861714 25.709714zM694.857143 219.428571l-365.714286 0q0-75.995429 53.430857-129.426286t129.426286-53.430857 129.426286 53.430857 53.430857 129.426286z",
      "p-id": "1864"
    }
  })])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "bug日志",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.logsList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "message"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("msg:" + _vm._s(scope.row.err.message))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("url: " + _vm._s(scope.row.url))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "stack"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.err.stack) + "\n\t\t\t\t")]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fd14bea", module.exports)
  }
}

/***/ }),

/***/ "t1CJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var errLog = {
  state: {
    errLog: []
  },
  pushLog: function pushLog(log) {
    this.state.errLog.unshift(log);
  },
  clearLog: function clearLog() {
    this.state.errLog = [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (errLog);

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHhr":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2gkk"),
  /* template */
  __webpack_require__("Z3Wo"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\components\\Sticky\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fc9bdb4", Component.options)
  } else {
    hotAPI.reload("data-v-1fc9bdb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "vQmt":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("45On");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("de04c4b6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bd3b246\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bd3b246\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vuLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__("N2mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  },
  name: 'AppMain',
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
});

/***/ }),

/***/ "wCnr":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "unique-opened": "",
      "default-active": _vm.$route.path
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c422f19", module.exports)
  }
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'APP'

});

/***/ }),

/***/ "xNsp":
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("6HNQ"),
  /* template */
  __webpack_require__("kxI1"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\QBT-project\\QBT-V2.21\\src\\components\\Icon-svg\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e2c53ca", Component.options)
  } else {
    hotAPI.reload("data-v-6e2c53ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ "yfw2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5ipy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("35ba2a5e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ecfcee3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ecfcee3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.76d90c4c8c2f6f411ac1.js